import './style.css';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a;
import { C as Capacitor, a as api, b as axios, f as firebase$1, u as useFavicon, s as setOptions, c as bootstrap, e as event, y, d as c, $, r as render, q, T, B, p, V, P, l as lodash, m as momentTimezone, g as create$6, I, h as y$1, i as c$1, K, j as p$1, k as render$1, n as g, o as c$2, t as render$2, v as f, _, w as parsePhoneNumber, x as render$3, z as render$4, A as _$1, D as d, E as render$5, F as render$6, G as uuid_1, H as PushNotifications, J as FCM, L as render$7, M as render$8, N as render$9, O as render$a, Q as I$1, R as p$2, S as render$b, U as render$c, W as render$d, X as render$e, Y as p$3, Z as render$f, a0 as $$1, a1 as Browser, a2 as hooks, a3 as _$2, a4 as g$1, a5 as l, a6 as render$g, a7 as h$1, a8 as p$4, a9 as _$3, aa as moment, ab as render$h, ac as entry_esm, ad as c$3, ae as Recaptcha, af as Re, ag as p$5, ah as render$i, ai as h$2, aj as render$j, ak as g$2, al as render$k, am as o, an as render$l, ao as render$m, ap as render$n, aq as render$o, ar as render$p, as as vOnClickOutside, at as f$1, au as B$1, av as render$q, aw as c$4, ax as z, ay as Z, az as x, aA as render$r, aB as render$s, aC as Q, aD as render$t, aE as k, aF as z$1, aG as D, aH as d$1, aI as registerPlugin, aJ as V$1, aK as render$u, aL as SafeArea } from "./vendor.js";
import { reactive, computed, defineComponent, openBlock, createBlock, unref, withCtx, createElementVNode, toDisplayString, renderSlot, ref, onBeforeMount, watchEffect, createElementBlock, createVNode, createTextVNode, pushScopeId, popScopeId, resolveDirective, withDirectives, vModelText, Fragment, renderList, createCommentVNode, normalizeClass, resolveDynamicComponent, createStaticVNode, h, onMounted, Transition, withModifiers, normalizeStyle, watch, nextTick, useSlots, inject, onBeforeUnmount, provide, resolveComponent, withKeys } from "vue";
import { useRoute } from "vue-router";
import { DateTime } from "luxon";
const firebaseStagingConfig = {
  apiKey: "AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo",
  authDomain: "highlevel-staging.firebaseapp.com",
  databaseURL: "https://highlevel-staging.firebaseio.com",
  projectId: "highlevel-staging",
  storageBucket: "highlevel-staging.appspot.com",
  messagingSenderId: "85350210461",
  appId: "1:85350210461:web:d3728d34bf8bd6b5",
  cdnUrl: "https://staging.cdn.apisystem.tech",
  assetsUrl: "https://staging.cdn.apisystem.tech",
  oldCdnUrl: "https://staging.cdn.msgsndr.com",
  membershipCdnUrl: "https://staging.cdnmembership.apisystem.tech",
  membershipStorageBucket: "revex-membership-staging"
};
const firebaseProductionConfig = {
  apiKey: "AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE",
  authDomain: "highlevel-backend.firebaseapp.com",
  databaseURL: "https://highlevel-backend.firebaseio.com",
  projectId: "highlevel-backend",
  storageBucket: "highlevel-backend.appspot.com",
  messagingSenderId: "439472444885",
  appId: "1:439472444885:web:6fa4c26d1bcbeb87",
  cdnUrl: "https://cdn.apisystem.tech",
  assetsUrl: "https://staging.cdn.apisystem.tech",
  oldCdnUrl: "https://cdn.msgsndr.com",
  membershipCdnUrl: "https://cdn.courses.apisystem.tech",
  membershipStorageBucket: "revex-membership-production"
};
const config = {
  development: {
    mode: "dev",
    REST_API_URLS: "https://staging.services.leadconnectorhq.com",
    INTERNAL_URL: "https://staging.services.leadconnectorhq.com/clientclub",
    CLIENT_PORTAL_SSO_URL: "https://staging.sso.clientclub.net",
    firebase: firebaseStagingConfig,
    ASSETS_URL: "https://storage.googleapis.com/revex-client-portal-staging",
    domain: "communities.staging.clientclub.net",
    reCaptchaDomain: "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
    certificatesRegistryDomain: "staging.my-certificates.com",
    webPushCertificate: "BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4"
  },
  staging: {
    mode: "staging",
    REST_API_URLS: "https://staging.services.leadconnectorhq.com",
    INTERNAL_URL: "https://staging.services.leadconnectorhq.com/clientclub",
    CLIENT_PORTAL_SSO_URL: "https://staging.sso.clientclub.net",
    firebase: firebaseStagingConfig,
    ASSETS_URL: "https://storage.googleapis.com/revex-client-portal-staging",
    domain: "communities.staging.clientclub.net",
    reCaptchaDomain: "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
    certificatesRegistryDomain: "staging.my-certificates.com",
    webPushCertificate: "BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4"
  },
  production: {
    mode: "production",
    REST_API_URLS: "https://services.leadconnectorhq.com",
    INTERNAL_URL: "https://services.leadconnectorhq.com/clientclub",
    CLIENT_PORTAL_SSO_URL: "https://sso.clientclub.net",
    firebase: firebaseProductionConfig,
    ASSETS_URL: "https://storage.googleapis.com/revex-client-portal-staging",
    reCaptchaDomain: "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
    certificatesRegistryDomain: "staging.my-certificates.com"
  }
};
class AppsState {
  constructor() {
    __publicField(this, "state", reactive({
      processing: false,
      loading: true,
      locationData: [],
      redirectUrl: "",
      NODE_ENV: "production",
      isTitleEnabled: false,
      billingId: "",
      isSubscription: true,
      isSSODisabled: false,
      isMobile: window.innerWidth <= 820,
      authButtonStyle: computed(() => {
        var _a2, _b, _c;
        return `background: ${((_c = (_b = (_a2 = this.state) == null ? void 0 : _a2.locationData) == null ? void 0 : _b.branding) == null ? void 0 : _c.brandColor1) + "!important" || "#323076!important"} ; 
        color: white !important;
        border: none !important;
        }`;
      }),
      secondaryButtonStyle: computed(() => {
        return `background-color: white !important; 
        color: "#475467" !important;
        border: none !important;
        }`;
      })
    }));
    this.addWindowResizeListener();
  }
  addWindowResizeListener() {
    window.addEventListener("resize", () => {
      this.state.isMobile = window.innerWidth <= 768;
    });
  }
  getConfig() {
    return config[this.state.NODE_ENV];
  }
  setRouterInstance(router) {
    this.state.routerInstance = router;
  }
  getRouterInstance() {
    if (!this.state.routerInstance) {
      return false;
    }
    return this.state.routerInstance;
  }
  setAppLoading(value) {
    this.state.loading = value;
  }
  isAppLoading() {
    return this.state.loading;
  }
}
var LoginEvents;
(function(LoginEvents2) {
  LoginEvents2["LOGIN_CALLBACK"] = "loginCallback";
  LoginEvents2["LOGIN_SUCCESSFUL"] = "loginSuccessful";
  LoginEvents2["LOGIN_FAILED"] = "loginFailed";
  LoginEvents2["CHANGE_SCREEN"] = "changeScreen";
})(LoginEvents || (LoginEvents = {}));
const AppState = new AppsState();
const setAppLoading = (value) => {
  AppState.setAppLoading(value);
};
const isAppLoading = () => {
  return AppState.isAppLoading();
};
const crypto = window.crypto || window.msCrypto;
const deviceId = (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c2) => {
  const randomChars = crypto.getRandomValues(new Uint8Array(1));
  return (Number(c2) ^ randomChars[0] & 15 >> Number(c2) / 4).toString(16);
});
function isMobileTablet() {
  let check = false;
  (function(a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
function isMobileOs() {
  const isAndroid = /Android/.test(navigator.userAgent);
  const isIOS = /iPhone|iPad/.test(navigator.userAgent);
  if (isAndroid || isIOS) {
    return true;
  } else {
    return false;
  }
}
function isWebKit() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isSafari || isIOS) {
    return true;
  } else {
    return false;
  }
}
function isPwa() {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  if (window.navigator.standalone || isStandalone) {
    return true;
  } else if (Capacitor.isNativePlatform()) {
    return true;
  }
  return false;
}
const getHeader = () => {
  const headers = {
    channel: "APP",
    source: "PORTAL_USER",
    version: "2021-04-15"
  };
  return headers;
};
async function generateToken() {
  var _a2;
  try {
    const cat = await api.get("cat") || window.localStorage.getItem("cat");
    const firebaseToken = cat ? JSON.parse(window.atob(cat)) : null;
    if (firebaseToken && !firebase$1.auth().currentUser) {
      await firebase$1.auth().signInWithCustomToken(firebaseToken.token).catch(function(error) {
        console.error(error);
      });
    }
    const keyToken = await ((_a2 = firebase$1.auth().currentUser) == null ? void 0 : _a2.getIdToken(true));
    if (keyToken && firebaseToken) {
      firebaseToken["tokenId"] = keyToken;
      firebaseToken["tokenExpirationTime"] = Date.now() + 60 * 55 * 1e3;
      await api.set("cat", window.btoa(JSON.stringify(firebaseToken)), {
        expires: 365,
        sameSite: "None",
        secure: true
      });
    }
    return keyToken;
  } catch (error) {
    console.log(error);
  }
}
async function getToken() {
  const cat = api.get("cat") || window.localStorage.getItem("cat");
  const firebaseToken = cat ? JSON.parse(window.atob(cat)) : null;
  if ((firebaseToken == null ? void 0 : firebaseToken.tokenId) && parseInt(firebaseToken.tokenExpirationTime) > Date.now()) {
    return firebaseToken.tokenId;
  } else {
    return await generateToken();
  }
}
const requests = (host) => {
  const baseUrl2 = host || AppState.getConfig().REST_API_URLS;
  const axiosInstance = axios.create({
    baseURL: baseUrl2,
    headers: getHeader()
  });
  axiosInstance.interceptors.request.use(async (requestConfig) => {
    try {
      if (requestConfig && requestConfig.headers) {
        const keyToken = await getToken();
        if (keyToken) {
          requestConfig.headers["token-id"] = keyToken;
        }
      }
    } catch (e) {
      console.error(e);
    }
    return requestConfig;
  });
  axiosInstance.interceptors.response.use(function handleSuccess(res) {
    return res;
  }, async function handleError(error) {
    if (error.config && error.response && error.response.status === 401)
      ;
    return Promise.reject(error);
  });
  return axiosInstance;
};
const UserService = {
  signUp: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users`, {
    email: payload.email,
    password: payload.password,
    fullName: payload.username,
    locationId: payload.locationId,
    userId: payload.userId || "",
    token: payload.token || "",
    otp: payload.otp || null,
    deviceName: navigator.userAgent,
    deviceId,
    deviceType: isMobileTablet() ? "mobile" : "desktop",
    domainName: `${window.location.host}`,
    ipAddress: "0.0.0.1",
    redirectUrl: payload.redirectUrl || null,
    captchaToken: payload.captchaToken
  }),
  login: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/email`, {
    email: payload.email,
    password: payload.password,
    userId: payload.userId || "",
    deviceName: navigator.userAgent,
    deviceId,
    deviceType: isMobileTablet() ? "mobile" : "desktop",
    domainName: `${window.location.host}`,
    locationId: payload.locationId,
    ipAddress: "0.0.0.1",
    redirectUrl: payload.redirectUrl || null,
    captchaToken: payload.captchaToken
  }),
  portalSetting: (domain) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/portal-settings?domain=${domain}`),
  loginWithSecureEmail: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/otp`, {
    email: payload.email,
    userId: payload.userId || "",
    token: payload.token || "",
    otp: payload.otp || null,
    deviceName: navigator.userAgent,
    deviceId,
    deviceType: isMobileTablet() ? "mobile" : "desktop",
    domainName: `${window.location.host}`,
    locationId: payload.locationId,
    ipAddress: "0.0.0.1",
    redirectUrl: payload.redirectUrl || null,
    action: (payload == null ? void 0 : payload.action) || null,
    fullName: (payload == null ? void 0 : payload.fullName) || null,
    captchaToken: payload.captchaToken
  }),
  loginWithLoginCode: (payload) => {
    return requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/loginCode`, {
      email: payload.email,
      loginCode: payload.loginCode,
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: isMobileTablet() ? "mobile" : "desktop",
      domainName: payload.domainName,
      locationId: payload.locationId,
      ipAddress: "0.0.0.1",
      redirectUrl: payload.redirectUrl || null
    });
  },
  changePassword: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/change-password`, {
    currentPassword: payload.currentPassword,
    newPassword: payload.newPassword,
    confirmPassword: payload.confirmPassword
  }),
  setPassword: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/set-password`, {
    passwordResetToken: payload.passwordResetToken,
    contactId: payload.contactId,
    newPassword: payload.newPassword,
    confirmPassword: payload.confirmPassword,
    captchaToken: payload.captchaToken
  }),
  resetPassword: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/reset-password`, {
    userId: payload.userId,
    token: payload.token,
    password: payload.password,
    locationId: payload.locationId,
    isPwa: isPwa()
  }),
  forgotPassword: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/forgot-password`, {
    locationId: payload.locationId,
    email: payload.email,
    userId: payload.userId || "",
    captchaToken: payload.captchaToken
  }),
  validateResetLink: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/validate-link`, {
    token: payload.token,
    userId: payload.userId,
    locationId: payload.locationId
  }),
  updateUser: async (payload) => {
    const response = await requests().put(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/${payload.userId}`, {
      email: payload.email,
      fullName: payload.fullName,
      termsConsent: payload.termsConsent,
      title: payload.title,
      bio: payload.bio,
      avatar: payload.avatar,
      profileCover: payload.profileCover,
      timeZone: payload.timeZone,
      password: payload.password,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword,
      location: payload.location,
      socials: payload.socials
    });
    return response.data;
  },
  loginWithSocialID: (payload) => {
    return requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/auth/login/socialLogin`, {
      email: payload.email,
      idToken: payload.idToken,
      userId: payload.userId,
      authProvider: payload.authProvider,
      fullName: payload.fullName,
      deviceName: navigator.userAgent,
      deviceId,
      deviceType: isMobileTablet() ? "mobile" : "desktop",
      domainName: payload.domainName,
      locationId: payload.locationId,
      ipAddress: "0.0.0.1",
      redirectUrl: payload.redirectUrl || null
    });
  },
  fetchUserDetails: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/${payload.userId}`),
  getUserAnalytics: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users-analytics/${payload.contactId}`),
  getUserDomains: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/na/users/domains`, {
    email: payload.email
  }),
  updateSession: (payload) => {
    return requests().put(`${AppState.getConfig().REST_API_URLS}/clientclub/auth/session`, {
      loggedIn: payload.loggedIn,
      pushToken: payload.token,
      brandedAppId: payload.brandedAppId
    });
  },
  getContactDetails: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/users/contact/${payload.contactId}`)
};
const currentFavicon = useFavicon();
const routerInstance = AppState.getRouterInstance();
const page = JSON.parse(localStorage.getItem("event"));
class LocationsState {
  constructor() {
    __publicField(this, "state", reactive({
      locationId: "",
      currencySymbol: "",
      subDomain: "",
      customDomain: "",
      branding: {
        brandColor2: null,
        brandColor1: null,
        portalBannerText: null,
        portalDescription: null,
        portalBackgroundImage: null,
        portalBannerImage: null,
        logo: null,
        portalIcon: null,
        favicon: null,
        copyRight: null,
        supportEmail: null
      },
      locationPermissions: {
        membershipEnabled: false,
        affiliateManagerEnabled: false,
        communitiesEnabled: false,
        subscriptionsEnabled: false
      }
    }));
  }
  async getBrandingDetails() {
    var _a2;
    try {
      if (window.location.hostname.includes((_a2 = AppState == null ? void 0 : AppState.getConfig()) == null ? void 0 : _a2.certificatesRegistryDomain)) {
        return;
      }
      let domain = (page == null ? void 0 : page.domain) || window.location.hostname;
      if (domain === "localhost") {
        const urlParams = new URLSearchParams(window.location.search);
        const domainname = urlParams.get("domain");
        domain = domainname || AppState.getConfig().domain;
      }
      if (!domain)
        throw Error("Domain not found, please setup in config for local setup");
      await UserService.portalSetting(domain).then(({ data }) => {
        var _a3, _b, _c, _d, _e, _f, _g;
        if ((_a3 = data.branding) == null ? void 0 : _a3.favicon) {
          currentFavicon.value = (_b = data.branding) == null ? void 0 : _b.favicon;
        }
        if (data == null ? void 0 : data.portalBannerText) {
          window.document.title = data == null ? void 0 : data.portalBannerText;
        }
        if (data == null ? void 0 : data.locationId) {
          this.state.locationId = data.locationId;
        }
        if (data == null ? void 0 : data.currencySymbol) {
          this.state.currencySymbol = data.currencySymbol;
        }
        if (data == null ? void 0 : data.subDomain) {
          this.state.subDomain = data.subDomain;
        }
        if (data == null ? void 0 : data.customDomain) {
          this.state.customDomain = data.customDomain;
        }
        this.setBrandingValue({
          brandColor1: ((_c = data == null ? void 0 : data.branding) == null ? void 0 : _c.brandColor1) || null,
          brandColor2: ((_d = data == null ? void 0 : data.branding) == null ? void 0 : _d.brandColor2) || null,
          portalBannerText: (data == null ? void 0 : data.portalBannerText) || null,
          portalDescription: (data == null ? void 0 : data.portalDescription) || null,
          portalIcon: (_e = data == null ? void 0 : data.branding) == null ? void 0 : _e.logo,
          favicon: (_f = data == null ? void 0 : data.branding) == null ? void 0 : _f.favicon,
          copyRight: data == null ? void 0 : data.copyRight,
          supportEmail: data == null ? void 0 : data.supportEmail,
          portalBackgroundImage: ((_g = data == null ? void 0 : data.branding) == null ? void 0 : _g.portalImage) || null,
          portalBannerImage: (data == null ? void 0 : data.branding.bannerImage) || null,
          logo: (data == null ? void 0 : data.branding.logo) || null
        });
        this.setPermissions(data);
      }).catch((err) => {
        console.error(err);
        if (routerInstance) {
          routerInstance.push({ name: "notFound" });
        }
      });
    } catch (error) {
      console.error(error);
      if (!this.state.locationId) {
        if (routerInstance) {
          routerInstance.push({ name: "notFound" });
        }
      } else {
        if (routerInstance) {
          routerInstance.push({ name: "Login" });
        }
      }
    }
  }
  setBrandingValue(value) {
    this.state.branding.portalBannerText = value.portalBannerText;
    this.state.branding.portalDescription = value.portalDescription;
    this.state.branding.brandColor1 = value.brandColor1;
    this.state.branding.brandColor2 = value.brandColor2;
    this.state.branding.portalIcon = value.portalIcon;
    this.state.branding.favicon = value.favicon;
    this.state.branding.copyRight = value.copyRight;
    this.state.branding.supportEmail = value.supportEmail;
    this.state.branding.portalBackgroundImage = value.portalBackgroundImage;
    this.state.branding.portalBannerImage = value.portalBannerImage;
    this.state.branding.logo = value.logo;
  }
  setPermissions(payload) {
    var _a2, _b, _c, _d;
    this.state.locationPermissions.membershipEnabled = (_a2 = payload.locationPermissions) == null ? void 0 : _a2.membershipEnabled;
    this.state.locationPermissions.affiliateManagerEnabled = (_b = payload.locationPermissions) == null ? void 0 : _b.affiliateManagerEnabled;
    this.state.locationPermissions.communitiesEnabled = (_c = payload.locationPermissions) == null ? void 0 : _c.communitiesEnabled;
    this.state.locationPermissions.subscriptionsEnabled = (_d = payload.locationPermissions) == null ? void 0 : _d.subscriptionsEnabled;
  }
}
const getHostName = () => {
  var _a2, _b, _c, _d, _e;
  if (((_a2 = LocationState.state) == null ? void 0 : _a2.subDomain) || ((_b = LocationState.state) == null ? void 0 : _b.customDomain) && isPwa()) {
    const suffixDomain = AppState.state.NODE_ENV === "production" ? ".app" : ".staging";
    return ((_c = LocationState.state) == null ? void 0 : _c.customDomain) ? (_d = LocationState.state) == null ? void 0 : _d.customDomain : ((_e = LocationState.state) == null ? void 0 : _e.subDomain) + suffixDomain + ".clientclub.net";
  } else {
    return window.location.hostname;
  }
};
const getLocationId = () => {
  return LocationState.state.locationId;
};
const LocationState = new LocationsState();
const CLOUD_ASSETS_URL = `${config.development.ASSETS_URL}/assets`;
const LANDING_PAGE_IMAGE = `${CLOUD_ASSETS_URL}/landing_page_image.svg`;
const GROUP_BRANDING_ICON = `${CLOUD_ASSETS_URL}/group_branding.svg`;
const FACEBOOK_ICON = `${CLOUD_ASSETS_URL}/facebook.svg`;
const INSTAGRAM_ICON = `${CLOUD_ASSETS_URL}/instagram.svg`;
const LINKEDIN_ICON = `${CLOUD_ASSETS_URL}/linkedin.svg`;
const TWITTER_ICON = `${CLOUD_ASSETS_URL}/x-twitter.svg`;
const YOUTUBE_ICON = `${CLOUD_ASSETS_URL}/youtube.svg`;
const ARROW_ICON = `${CLOUD_ASSETS_URL}/arrow_icon.svg`;
const TEAM_MEETING = `${CLOUD_ASSETS_URL}/team_meeting.svg`;
const GROUP_BOOK = `${CLOUD_ASSETS_URL}/group_book.svg`;
const COMMUNITIES_PEOPLE = `${CLOUD_ASSETS_URL}/communities_people.svg`;
const GROUPS_CONNECTIONS = `${CLOUD_ASSETS_URL}/groups_connections.svg`;
const COURSES_CAP = `${CLOUD_ASSETS_URL}/courses_cap.svg`;
const MONEY_BAG = `${CLOUD_ASSETS_URL}/money_bag.svg`;
const ALLOWED_FILE_TYPES = [
  "image/svg+xml",
  "image/png",
  "image/webp",
  "image/jpg",
  "image/jpeg"
];
const GTagID = "G-91CZG6XDY5";
var Screens;
(function(Screens2) {
  Screens2["LOGIN"] = "LOGIN";
  Screens2["LOGIN_WITH_SECURE_CODE"] = "LOGIN_WITH_SECURE_CODE";
  Screens2["SET_PASSWORD_WITH_SECURE_CODE"] = "SET_PASSWORD_WITH_SECURE_CODE";
  Screens2["VERIFY_SECURE_CODE"] = "VERIFY_SECURE_CODE";
  Screens2["SELECT_USER_MULTI_USER"] = "SELECT_USER_MULTI_USER";
  Screens2["SIGN_UP"] = "SIGN_UP";
  Screens2["SET_PASSWORD"] = "SET_PASSWORD";
  Screens2["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
  Screens2["PROCEED_TO_LOGIN"] = "PROCEED_TO_LOGIN";
  Screens2["TERMS_CONSENT"] = "TERMS_CONSENT";
})(Screens || (Screens = {}));
const DEFAULT_GROUP_COVER_IMAGE = "https://storage.googleapis.com/highlevel-staging.appspot.com/communities/sTPu59jO68qjLE5h10Ny/groups/02571fec-cf90-4db9-8bce-e0b4a6669c57";
const DEFAULT_GROUP_LOGO = "https://storage.googleapis.com/highlevel-staging.appspot.com/communities/sTPu59jO68qjLE5h10Ny/groups/255f2156-6614-4f6c-9229-b014960fd2aa";
const GROUP_BRANDING_NAVBAR = `${CLOUD_ASSETS_URL}/group_branding_navbar.svg`;
const FRAME1 = `${CLOUD_ASSETS_URL}/frame1.svg`;
const FRAME2 = `${CLOUD_ASSETS_URL}/frame2.svg`;
const FRAME3 = `${CLOUD_ASSETS_URL}/frame3.svg`;
const FRAME4 = `${CLOUD_ASSETS_URL}/frame4.svg`;
const GROUP_MOBILE_ICON = `${CLOUD_ASSETS_URL}/group_mobile.svg`;
const MAIL_MOBILE_ICON = `${CLOUD_ASSETS_URL}/mail_mobile.svg`;
const TEST_LOCATION_ID = "hMDUTOU6bIG4hXRzXQKm";
const TEST_EMAIL_ID = "appletestkb@gmail.com";
var GAEventTypes;
(function(GAEventTypes2) {
  GAEventTypes2["CUSTOM_LOGIN_EVENT"] = "custom-login-event";
  GAEventTypes2["CREATE_REACTIONS"] = "create-reactions-event";
  GAEventTypes2["DELETE_REACTIONS"] = "delete-reactions-event";
  GAEventTypes2["POST_CREATED"] = "post-created-event";
  GAEventTypes2["COMMENT_CREATED"] = "comment-created-event";
  GAEventTypes2["LESSON_OPENED"] = "lesson-opened-event";
  GAEventTypes2["LESSON_COMPLETED"] = "lesson-completed-event";
  GAEventTypes2["NEXT_LESSON"] = "next-lesson-event";
  GAEventTypes2["LOGOUT"] = "logout-event";
  GAEventTypes2["CERTIFICATE_DOWNLOAD"] = "certificate-download-event";
})(GAEventTypes || (GAEventTypes = {}));
function enableAnalytics(contactId, appName = `Client Portal`) {
  if (!contactId)
    return;
  setOptions({
    appName,
    config: {
      id: GTagID,
      params: {
        send_page_view: true,
        user_id: contactId
      }
    }
  });
  bootstrap();
  event(GAEventTypes.CUSTOM_LOGIN_EVENT, {
    appName,
    user_id: contactId
  });
}
function trackCustomGAEvents(eventName, eventParams = {}) {
  try {
    if (!eventName)
      return;
    const cat = api.get("cat") || window.localStorage.getItem("cat");
    const cookie = cat ? JSON.parse(window.atob(cat)) : null;
    if (!(cookie == null ? void 0 : cookie.contactId)) {
      return;
    }
    event(eventName, __spreadProps(__spreadValues({}, eventParams), {
      user_id: cookie.contactId
    }));
  } catch (e) {
    console.error(e);
  }
}
const formatNameForAvatar = (name) => {
  const nameArr = name == null ? void 0 : name.split(" ");
  return nameArr == null ? void 0 : nameArr.map((item) => item[0]).join("").toUpperCase();
};
const capitalizeFirstLetterName = (name) => {
  return name == null ? void 0 : name.split(" ").map((item) => {
    var _a2;
    return `${(_a2 = item[0]) == null ? void 0 : _a2.toUpperCase()}${item == null ? void 0 : item.slice(1)}`;
  }).join(" ");
};
const capitalizeLetterRemoveUnderscored = (name) => {
  return name == null ? void 0 : name.split("_").map((part) => part.split(" ").map((item) => {
    var _a2;
    return `${(_a2 = item[0]) == null ? void 0 : _a2.toUpperCase()}${item == null ? void 0 : item.slice(1)}`;
  }).join(" ")).join(" ");
};
function getShortName(name) {
  if (name) {
    const nameArray = name == null ? void 0 : name.split(" ");
    if (nameArray.length > 1) {
      return (nameArray[0][0] + nameArray[1][0]).toUpperCase();
    } else {
      return nameArray[0][0].toUpperCase();
    }
  }
  return "";
}
function timestampFormat(originalTimestamp) {
  const date = new Date(originalTimestamp);
  const options = {
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric"
  };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
  return formattedDate;
}
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
class UsersState {
  constructor() {
    __publicField(this, "state", reactive({
      email: "",
      userId: "",
      locationId: "",
      fullName: "",
      title: "",
      bio: "",
      avatar: "",
      profileCover: "",
      role: "",
      timeZone: "",
      location: "",
      slug: "",
      termsConsent: "",
      billingTokenExpiry: null,
      permissions: {
        affiliates: false,
        courses: false,
        communities: false
      },
      socials: {
        email: "",
        phoneNumber: "",
        facebook: "",
        twitter: "",
        instagram: "",
        linkedin: "",
        youtube: "",
        emailVisibility: "",
        phoneVisibility: ""
      },
      analytics: {
        groups: {
          joinedGroups: ""
        },
        affiliates: {
          earnings: ""
        },
        course: {
          coursesCompleted: ""
        }
      }
    }));
  }
  async getUserDetails() {
    try {
      const cat = await api.get("cat") || window.localStorage.getItem("cat");
      const cookie = cat ? JSON.parse(window.atob(cat)) : null;
      if ((cookie == null ? void 0 : cookie.locationId) && (cookie == null ? void 0 : cookie.contactId)) {
        const userData = await UserService.fetchUserDetails({
          userId: cookie.contactId,
          locationId: cookie.locationId
        });
        enableAnalytics(cookie.contactId);
        this.setProfileDetails(__spreadValues({}, userData.data));
      } else {
        if (!isEmptyObject(cookie)) {
          localStorage.removeItem("cat");
          document.cookie = "cat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.reload();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  setProfileDetails(value) {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    this.state.userId = value == null ? void 0 : value.contactId;
    this.state.locationId = value == null ? void 0 : value.locationId;
    this.state.email = value == null ? void 0 : value.email;
    this.state.fullName = value == null ? void 0 : value.fullName;
    this.state.title = value == null ? void 0 : value.title;
    this.state.bio = value == null ? void 0 : value.bio;
    this.state.avatar = value == null ? void 0 : value.avatar;
    this.state.profileCover = value == null ? void 0 : value.profileCover;
    this.state.timeZone = value == null ? void 0 : value.timeZone;
    this.state.location = value == null ? void 0 : value.location;
    this.state.slug = value == null ? void 0 : value.slug;
    this.state.termsConsent = value == null ? void 0 : value.termsConsent;
    this.state.permissions.affiliates = ((_a2 = value == null ? void 0 : value.permissions) == null ? void 0 : _a2.affiliates) || false;
    this.state.permissions.courses = ((_b = value == null ? void 0 : value.permissions) == null ? void 0 : _b.courses) || false;
    this.state.billingTokenExpiry = (value == null ? void 0 : value.billingTokenExpiry) || null;
    this.state.permissions.communities = ((_c = value == null ? void 0 : value.permissions) == null ? void 0 : _c.communities) || false;
    this.state.socials.phoneNumber = (_d = value == null ? void 0 : value.socials) == null ? void 0 : _d.phoneNumber;
    this.state.socials.facebook = (_e = value == null ? void 0 : value.socials) == null ? void 0 : _e.facebook;
    this.state.socials.twitter = (_f = value == null ? void 0 : value.socials) == null ? void 0 : _f.twitter;
    this.state.socials.instagram = (_g = value == null ? void 0 : value.socials) == null ? void 0 : _g.instagram;
    this.state.socials.youtube = (_h = value == null ? void 0 : value.socials) == null ? void 0 : _h.youtube;
    this.state.socials.linkedin = (_i = value == null ? void 0 : value.socials) == null ? void 0 : _i.linkedin;
    this.state.socials.email = (_j = value == null ? void 0 : value.socials) == null ? void 0 : _j.email;
    this.state.socials.emailVisibility = (_k = value == null ? void 0 : value.socials) == null ? void 0 : _k.emailVisibility;
    this.state.socials.phoneVisibility = (_l = value == null ? void 0 : value.socials) == null ? void 0 : _l.phoneVisibility;
  }
  setAnalytics(value) {
    var _a2, _b, _c;
    this.state.analytics.affiliates.earnings = (_a2 = value == null ? void 0 : value.affiliates) == null ? void 0 : _a2.earnings;
    this.state.analytics.course.coursesCompleted = (_b = value == null ? void 0 : value.course) == null ? void 0 : _b.coursesCompleted;
    this.state.analytics.groups.joinedGroups = (_c = value == null ? void 0 : value.groups) == null ? void 0 : _c.joinedGroups;
  }
  async updateUserProfile(userData) {
    try {
      const user = await UserService.updateUser(__spreadValues({}, userData));
      this.setProfileDetails(user);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async changePassword(dataPayload) {
    try {
      await UserService.changePassword(__spreadValues({}, dataPayload));
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getUserAnalytics(contactId, locationId) {
    try {
      const userAnalyticsData = await UserService.getUserAnalytics({
        contactId,
        locationId
      });
      this.setAnalytics(userAnalyticsData.data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
const UserState = new UsersState();
const _hoisted_1$14 = { class: "max-w-xs" };
const _hoisted_2$11 = { class: "text-gray-800" };
const _hoisted_3$V = { class: "text-gray-600" };
const _sfc_main$1a = defineComponent({
  __name: "SpaceComponent",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(y), {
        align: "center",
        justify: "space-between"
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$14, [
            createElementVNode("div", _hoisted_2$11, toDisplayString(props.title), 1),
            createElementVNode("div", _hoisted_3$V, toDisplayString(props.description), 1)
          ]),
          renderSlot(_ctx.$slots, "space-slot")
        ]),
        _: 3
      });
    };
  }
});
var EditAccount_vue_vue_type_style_index_0_scoped_true_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _withScopeId$f = (n) => (pushScopeId("data-v-0f4173f8"), n = n(), popScopeId(), n);
const _hoisted_1$13 = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$10 = {
  id: "edit-account-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$U = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$C = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$t = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$q = /* @__PURE__ */ _withScopeId$f(() => /* @__PURE__ */ createElementVNode("div", { class: "flex items-start justify-start gap-1" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "inline-flex flex-col items-start justify-start" }, [
    /* @__PURE__ */ createElementVNode("div", { class: "text-lg font-medium leading-7 text-slate-700" }, " Edit Account ")
  ])
], -1));
const _hoisted_7$j = { class: "flex grow items-center justify-end" };
const _hoisted_8$g = { class: "flex items-start justify-start gap-4" };
const _hoisted_9$f = {
  class: "relative cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_10$b = { class: "w-full col-span-3" };
const _sfc_main$19 = defineComponent({
  __name: "EditAccount",
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const boxRef = ref(null);
    const loadingRef = ref(null);
    onBeforeMount(async () => {
      var _a2;
      loginEmail.value = (_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.email;
    });
    const isLoading = ref(false);
    const loginEmail = ref("");
    const isFieldRequired = ref(false);
    const accountForm = reactive({
      currentPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    watchEffect(() => {
      isFieldRequired.value = !accountForm.currentPassword.trim() && !accountForm.newPassword.trim() && !accountForm.confirmPassword.trim();
    });
    const rules = {
      currentPassword: {
        required: !isFieldRequired.value,
        message: "Password is required",
        trigger: ["input", "blur"]
      },
      newPassword: {
        min: 8,
        required: !isFieldRequired.value,
        message: "Please enter a password of mininum 8 character",
        trigger: ["input", "blur"]
      },
      confirmPassword: {
        min: 8,
        required: !isFieldRequired.value,
        message: "Please enter a password of mininum 8 character",
        trigger: ["input", "blur"]
      }
    };
    const root = ref();
    async function validateForm() {
      return new Promise((resolve, reject) => {
        root.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.error("error", e);
          reject(e);
        });
      });
    }
    async function updatePassword() {
      var _a2, _b, _c, _d;
      await validateForm();
      try {
        (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
        isLoading.value = true;
        await UserState.changePassword(__spreadProps(__spreadValues({}, accountForm), {
          locationId: (_b = LocationState == null ? void 0 : LocationState.state) == null ? void 0 : _b.locationId
        }));
        (_c = loadingRef.value) == null ? void 0 : _c.stopLoadBar();
        setTimeout(() => {
          if (routerInstance2) {
            routerInstance2.back();
          }
        }, 300);
      } catch (error) {
        console.error(error);
        (_d = loadingRef.value) == null ? void 0 : _d.errorLoadBar();
        if (error.response.data.message == "Invalid Password") {
          notificationAlert("Invalid Password", "");
        } else {
          notificationAlert("Something went wrong", "Please try again later");
        }
      } finally {
        isLoading.value = false;
      }
    }
    const changePasswordSubmitButton = computed(() => {
      return (accountForm == null ? void 0 : accountForm.newPassword) && (accountForm == null ? void 0 : accountForm.currentPassword) && (accountForm == null ? void 0 : accountForm.confirmPassword) && accountForm.newPassword == accountForm.confirmPassword ? false : true;
    });
    const notification = c();
    function notificationAlert(title, content) {
      notification.create({
        title,
        content,
        duration: 5e3
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$13, [
        createElementVNode("div", _hoisted_2$10, [
          createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$U, [
                createElementVNode("div", _hoisted_4$C, [
                  createElementVNode("div", _hoisted_5$t, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance2)) {
                          unref(routerInstance2).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render))
                    ])
                  ]),
                  _hoisted_6$q
                ]),
                createElementVNode("div", _hoisted_7$j, [
                  createElementVNode("div", _hoisted_8$g, [
                    createElementVNode("div", _hoisted_9$f, [
                      createVNode(unref(q), {
                        id: "basic-info-save-btn",
                        onClick: updatePassword,
                        disabled: changePasswordSubmitButton.value,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode("Save ")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] py-6 grid grid-cols-3 row-span-1 px-4"
        }, [
          createVNode(unref(T), {
            ref_key: "loadingRef",
            ref: loadingRef,
            to: boxRef.value
          }, null, 8, ["to"]),
          createElementVNode("div", _hoisted_10$b, [
            createVNode(unref(B), {
              ref_key: "root",
              ref: root,
              model: accountForm,
              rules,
              id: "account-form"
            }, {
              default: withCtx(() => [
                createVNode(unref(p), { class: "text-black" }, {
                  default: withCtx(() => [
                    createTextVNode("Login information")
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Login email",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true,
                  class: "mt-6"
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "login-email" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: loginEmail.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => loginEmail.value = $event),
                          id: "account-input",
                          placeholder: "Email Id",
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(unref(p), { class: "text-black mt-2" }, {
                  default: withCtx(() => [
                    createTextVNode("Change Password")
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Current password",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true,
                  class: "mt-6"
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "currentPassword" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: accountForm.currentPassword,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => accountForm.currentPassword = $event),
                          type: "password",
                          id: "account-input",
                          "show-password-on": "click",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "New password",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "newPassword" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: accountForm.newPassword,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => accountForm.newPassword = $event),
                          type: "password",
                          id: "account-input",
                          "show-password-on": "click",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Retype password",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "confirmPassword" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: accountForm.confirmPassword,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => accountForm.confirmPassword = $event),
                          type: "password",
                          id: "account-input",
                          "show-password-on": "click",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ], 512)
      ]);
    };
  }
});
var EditAccount = /* @__PURE__ */ _export_sfc(_sfc_main$19, [["__scopeId", "data-v-0f4173f8"]]);
var EditBasicInfo_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$e = (n) => (pushScopeId("data-v-52f2e72e"), n = n(), popScopeId(), n);
const _hoisted_1$12 = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$$ = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$T = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$B = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$s = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$p = /* @__PURE__ */ _withScopeId$e(() => /* @__PURE__ */ createElementVNode("div", { class: "flex items-start justify-start gap-1" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "inline-flex flex-col items-start justify-start" }, [
    /* @__PURE__ */ createElementVNode("div", { class: "text-lg font-medium leading-7 text-slate-700" }, " Edit Basic Information ")
  ])
], -1));
const _hoisted_7$i = { class: "flex grow items-center justify-end" };
const _hoisted_8$f = { class: "flex items-start justify-start gap-4" };
const _hoisted_9$e = { class: "relative cursor-pointer" };
const _hoisted_10$a = { class: "w-full col-span-3" };
const _sfc_main$18 = defineComponent({
  __name: "EditBasicInfo",
  setup(__props) {
    onBeforeMount(async () => {
      setFormData();
    });
    function setFormData() {
      var _a2, _b, _c, _d;
      profileForm.value.fullName = (_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.fullName;
      profileForm.value.title = (_b = UserState == null ? void 0 : UserState.state) == null ? void 0 : _b.title;
      profileForm.value.slug = (_c = UserState == null ? void 0 : UserState.state) == null ? void 0 : _c.slug;
      profileForm.value.bio = (_d = UserState == null ? void 0 : UserState.state) == null ? void 0 : _d.bio;
    }
    const routerInstance2 = AppState.getRouterInstance();
    const boxRef = ref(null);
    const loadingRef = ref(null);
    const profileForm = ref({
      fullName: "",
      title: "",
      slug: "",
      bio: ""
    });
    const rules = {
      fullName: {
        required: true,
        message: "Name is required",
        trigger: ["input"]
      }
    };
    const updatingProfileSetting = ref(false);
    const root = ref();
    async function validateForm() {
      return new Promise((resolve, reject) => {
        root.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.error("error", e);
          reject(e);
        });
      });
    }
    async function saveProfile() {
      var _a2, _b, _c, _d, _e;
      await validateForm();
      try {
        (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
        updatingProfileSetting.value = true;
        await UserState.updateUserProfile(__spreadProps(__spreadValues({}, profileForm.value), {
          locationId: (_b = LocationState == null ? void 0 : LocationState.state) == null ? void 0 : _b.locationId,
          userId: (_c = UserState == null ? void 0 : UserState.state) == null ? void 0 : _c.userId
        }));
        updatingProfileSetting.value = false;
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        setTimeout(() => {
          if (routerInstance2) {
            routerInstance2.back();
          }
        }, 300);
      } catch (error) {
        (_e = loadingRef.value) == null ? void 0 : _e.errorLoadBar();
        console.error(error);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$12, [
        createElementVNode("div", _hoisted_2$$, [
          createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$T, [
                createElementVNode("div", _hoisted_4$B, [
                  createElementVNode("div", _hoisted_5$s, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance2)) {
                          unref(routerInstance2).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render))
                    ])
                  ]),
                  _hoisted_6$p
                ]),
                createElementVNode("div", _hoisted_7$i, [
                  createElementVNode("div", _hoisted_8$f, [
                    createElementVNode("div", _hoisted_9$e, [
                      createVNode(unref(q), {
                        id: "basic-info-save-btn",
                        onClick: saveProfile,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode("Save ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] py-6 grid grid-cols-3 row-span-1 px-4"
        }, [
          createVNode(unref(T), {
            ref_key: "loadingRef",
            ref: loadingRef,
            to: boxRef.value
          }, null, 8, ["to"]),
          createElementVNode("div", _hoisted_10$a, [
            createVNode(unref(B), {
              ref_key: "root",
              ref: root,
              model: profileForm.value,
              rules,
              id: "profile-form"
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$1a, {
                  title: "Full Name",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "fullName" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: profileForm.value.fullName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => profileForm.value.fullName = $event),
                          id: "basic-info-input",
                          maxlength: 50,
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Title",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "title" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: profileForm.value.title,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => profileForm.value.title = $event),
                          id: "basic-info-input",
                          maxlength: 50,
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Profile slug",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "slug" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: profileForm.value.slug,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => profileForm.value.slug = $event),
                          id: "basic-info-input",
                          maxlength: 50,
                          placeholder: "",
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Bio",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "bio" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: profileForm.value.bio,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => profileForm.value.bio = $event),
                          type: "textarea",
                          readonly: false,
                          rows: 5,
                          cols: 100,
                          maxlength: 200,
                          clearable: false,
                          size: "large",
                          showCount: true,
                          disabled: void 0,
                          id: "basic-info-input",
                          placeholder: "Write something about yourself..."
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ], 512)
      ]);
    };
  }
});
var EditBasicInfo = /* @__PURE__ */ _export_sfc(_sfc_main$18, [["__scopeId", "data-v-52f2e72e"]]);
const timezonesWhiteList = [
  "Etc/GMT+12",
  "Pacific/Midway",
  "Pacific/Honolulu",
  "America/Juneau",
  "US/Alaska",
  "America/Dawson",
  "America/Los_Angeles",
  "America/Phoenix",
  "America/Tijuana",
  "US/Arizona",
  "America/Belize",
  "America/Boise",
  "America/Chihuahua",
  "America/Denver",
  "America/Edmonton",
  "America/Guatemala",
  "America/Managua",
  "America/Regina",
  "Canada/Saskatchewan",
  "US/Mountain",
  "America/Bahia_Banderas",
  "America/Bogota",
  "America/Cancun",
  "America/Chicago",
  "America/Mexico_City",
  "US/Central",
  "America/Caracas",
  "America/Detroit",
  "America/Indiana/Indianapolis",
  "America/Louisville",
  "America/Manaus",
  "America/New_York",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Toronto",
  "US/East-Indiana",
  "US/Eastern",
  "America/Argentina/Buenos_Aires",
  "America/Glace_Bay",
  "America/Montevideo",
  "America/Sao_Paulo",
  "Canada/Atlantic",
  "America/St_Johns",
  "Canada/Newfoundland",
  "America/Godthab",
  "America/Noronha",
  "Etc/GMT+2",
  "Atlantic/Cape_Verde",
  "Atlantic/Azores",
  "UTC",
  "Africa/Algiers",
  "Africa/Casablanca",
  "Africa/Lagos",
  "Atlantic/Canary",
  "Europe/London",
  "Africa/Cairo",
  "Africa/Harare",
  "Europe/Amsterdam",
  "Europe/Belgrade",
  "Europe/Brussels",
  "Europe/Madrid",
  "Europe/Oslo",
  "Europe/Sarajevo",
  "Africa/Nairobi",
  "Asia/Amman",
  "Asia/Baghdad",
  "Asia/Jerusalem",
  "Asia/Kuwait",
  "Asia/Qatar",
  "Europe/Athens",
  "Europe/Bucharest",
  "Europe/Helsinki",
  "Europe/Moscow",
  "Asia/Baku",
  "Asia/Dubai",
  "Asia/Kabul",
  "Asia/Tehran",
  "Asia/Karachi",
  "Asia/Yekaterinburg",
  "Asia/Colombo",
  "Asia/Kolkata",
  "Asia/Calcutta",
  "Asia/Kathmandu",
  "Asia/Almaty",
  "Asia/Dhaka",
  "Asia/Rangoon",
  "Asia/Bangkok",
  "Asia/Krasnoyarsk",
  "Asia/Irkutsk",
  "Asia/Kuala_Lumpur",
  "Asia/Shanghai",
  "Asia/Taipei",
  "Australia/Perth",
  "Asia/Seoul",
  "Asia/Tokyo",
  "Asia/Yakutsk",
  "Australia/Adelaide",
  "Australia/Darwin",
  "Asia/Vladivostok",
  "Australia/Brisbane",
  "Australia/Canberra",
  "Australia/Hobart",
  "Australia/Sydney",
  "Pacific/Guam",
  "Asia/Magadan",
  "Pacific/Auckland",
  "Pacific/Fiji",
  "Pacific/Tongatapu"
];
const timezones = lodash.exports.sortBy(momentTimezone.exports.tz.names().filter((tz) => {
  return timezonesWhiteList.includes(tz);
}).map((zone) => {
  const now = momentTimezone.exports.tz(zone);
  return {
    label: `GMT${now.format("Z")} ${zone} (${now.format("z")})`,
    value: zone,
    currentTime: now.format("hh:mm A")
  };
}), (m) => {
  return momentTimezone.exports.tz(m.value).utcOffset();
});
var EditDetails_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$d = (n) => (pushScopeId("data-v-c1b53b1c"), n = n(), popScopeId(), n);
const _hoisted_1$11 = { class: "flex flex-col h-screen w-full fixed bg-white z-[100]" };
const _hoisted_2$_ = {
  id: "edit-details-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$S = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$A = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$r = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$o = /* @__PURE__ */ _withScopeId$d(() => /* @__PURE__ */ createElementVNode("div", { class: "flex items-start justify-start gap-1" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "inline-flex flex-col items-start justify-start" }, [
    /* @__PURE__ */ createElementVNode("div", { class: "text-lg font-medium leading-7 text-slate-700" }, " Edit Details ")
  ])
], -1));
const _hoisted_7$h = { class: "flex grow items-center justify-end" };
const _hoisted_8$e = { class: "flex items-start justify-start gap-4" };
const _hoisted_9$d = { class: "relative cursor-pointer" };
const _hoisted_10$9 = { class: "w-full col-span-3" };
const _hoisted_11$9 = { class: "flex w-full place-content-end" };
const _hoisted_12$8 = { class: "flex w-full place-content-end" };
const _hoisted_13$7 = { class: "flex flex-col items-center px-4" };
const _hoisted_14$4 = { class: "flex flex-col w-full sticky pb-2 z-50 bg-white top-0 items-center" };
const _hoisted_15$4 = { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" };
const _hoisted_16$4 = { class: "flex border- w-full border-b-2 border-gray-500 px-2 mt-6" };
const _hoisted_17$4 = { class: "py-1" };
const _hoisted_18$3 = { class: "flex flex-col w-full" };
const _hoisted_19$3 = {
  key: 0,
  class: "w-full flex flex-col overflow-auto h-full"
};
const _hoisted_20$3 = { class: "w-full flex justify-center items-center" };
const _hoisted_21$3 = { class: "h-[41px] w-[57px] bg-[#ECF0FF] flex items-center justify-center rounded-md" };
const _hoisted_22$3 = { class: "ml-4 flex flex-col w-full" };
const _sfc_main$17 = defineComponent({
  __name: "EditDetails",
  setup(__props) {
    onBeforeMount(async () => {
      setFormData();
    });
    const boxRef = ref(null);
    const loadingRef = ref(null);
    const searchText = ref("");
    const showTimezones = ref(false);
    const routerInstance2 = AppState.getRouterInstance();
    const socialMediaForm = ref({
      location: "",
      timeZone: "",
      email: "",
      phoneNumber: "",
      facebook: "",
      instagram: "",
      twitter: "",
      youtube: "",
      linkedin: "",
      emailVisibility: "private",
      phoneVisibility: "private"
    });
    function setFormData() {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
      socialMediaForm.value.location = (_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.location;
      socialMediaForm.value.timeZone = (_b = UserState == null ? void 0 : UserState.state) == null ? void 0 : _b.timeZone;
      socialMediaForm.value.phoneNumber = (_d = (_c = UserState == null ? void 0 : UserState.state) == null ? void 0 : _c.socials) == null ? void 0 : _d.phoneNumber;
      socialMediaForm.value.email = (_f = (_e = UserState == null ? void 0 : UserState.state) == null ? void 0 : _e.socials) == null ? void 0 : _f.email;
      socialMediaForm.value.facebook = (_h = (_g = UserState == null ? void 0 : UserState.state) == null ? void 0 : _g.socials) == null ? void 0 : _h.facebook;
      socialMediaForm.value.twitter = (_j = (_i = UserState == null ? void 0 : UserState.state) == null ? void 0 : _i.socials) == null ? void 0 : _j.twitter;
      socialMediaForm.value.instagram = (_l = (_k = UserState == null ? void 0 : UserState.state) == null ? void 0 : _k.socials) == null ? void 0 : _l.instagram;
      socialMediaForm.value.youtube = (_n = (_m = UserState == null ? void 0 : UserState.state) == null ? void 0 : _m.socials) == null ? void 0 : _n.youtube;
      socialMediaForm.value.linkedin = (_p = (_o = UserState == null ? void 0 : UserState.state) == null ? void 0 : _o.socials) == null ? void 0 : _p.linkedin;
      socialMediaForm.value.emailVisibility = (_r = (_q = UserState == null ? void 0 : UserState.state) == null ? void 0 : _q.socials) == null ? void 0 : _r.emailVisibility;
      socialMediaForm.value.phoneVisibility = (_t = (_s = UserState == null ? void 0 : UserState.state) == null ? void 0 : _s.socials) == null ? void 0 : _t.phoneVisibility;
    }
    const urlValidationSchema = create$6().test("is-url", "Invalid URL", (value) => {
      if (!value)
        return true;
      const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
      return urlRegex.test(value);
    });
    const urlValidationRule = {
      validator: (_2, value) => {
        return urlValidationSchema.validate(value);
      },
      message: "Please enter a valid url",
      trigger: ["input", "blur"]
    };
    const rules = {
      email: {
        validator: (_2, value) => {
          return create$6().email().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["input", "blur"]
      },
      phoneNumber: {
        trigger: ["input", "blur"],
        validator: (_2, value) => {
          if (!value)
            return true;
          const phoneNumberObj = parsePhoneNumber(value);
          if (phoneNumberObj && phoneNumberObj.isValid()) {
            return true;
          } else {
            return false;
          }
        },
        message: "Please enter a valid phone number with an appropriate country code "
      },
      facebook: urlValidationRule,
      instagram: urlValidationRule,
      twitter: urlValidationRule,
      youtube: urlValidationRule,
      linkedin: urlValidationRule
    };
    const updatingSocialMediaDetails = ref(false);
    async function saveSocialMediaDetails(e) {
      var _a2, _b, _c, _d, _e;
      await validateForm();
      try {
        (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
        updatingSocialMediaDetails.value = true;
        await UserState.updateUserProfile({
          socials: {
            facebook: socialMediaForm.value.facebook,
            instagram: socialMediaForm.value.instagram,
            linkedin: socialMediaForm.value.linkedin,
            youtube: socialMediaForm.value.youtube,
            twitter: socialMediaForm.value.twitter,
            email: socialMediaForm.value.email,
            emailVisibility: socialMediaForm.value.emailVisibility,
            phoneNumber: socialMediaForm.value.phoneNumber,
            phoneVisibility: socialMediaForm.value.phoneVisibility
          },
          location: socialMediaForm.value.location,
          timeZone: socialMediaForm.value.timeZone,
          locationId: (_b = LocationState == null ? void 0 : LocationState.state) == null ? void 0 : _b.locationId,
          userId: (_c = UserState == null ? void 0 : UserState.state) == null ? void 0 : _c.userId
        });
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        setTimeout(() => {
          if (routerInstance2) {
            routerInstance2.back();
          }
        }, 300);
      } catch (e2) {
        (_e = loadingRef.value) == null ? void 0 : _e.errorLoadBar();
        console.error(e2);
      } finally {
        updatingSocialMediaDetails.value = false;
      }
    }
    const root = ref();
    async function validateForm() {
      return new Promise((resolve, reject) => {
        root.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.error("error", e);
          reject(e);
        });
      });
    }
    const filteredTimezones = ref([]);
    watchEffect(() => {
      filteredTimezones.value = timezones.filter((timezone) => {
        return timezone.value.toLowerCase().includes(searchText.value.toLowerCase());
      });
    });
    function handleTimeZone(timezone) {
      socialMediaForm.value.timeZone = timezone;
      showTimezones.value = !showTimezones.value;
      searchText.value = "";
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", _hoisted_1$11, [
        createElementVNode("div", _hoisted_2$_, [
          createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$S, [
                createElementVNode("div", _hoisted_4$A, [
                  createElementVNode("div", _hoisted_5$r, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance2)) {
                          unref(routerInstance2).back();
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render))
                    ])
                  ]),
                  _hoisted_6$o
                ]),
                createElementVNode("div", _hoisted_7$h, [
                  createElementVNode("div", _hoisted_8$e, [
                    createElementVNode("div", _hoisted_9$d, [
                      createVNode(unref(q), {
                        id: "details-save-btn",
                        onClick: saveSocialMediaDetails,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode("Save ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] py-6 grid grid-cols-3 row-span-1 px-4 overflow-y-auto content"
        }, [
          createVNode(unref(T), {
            ref_key: "loadingRef",
            ref: loadingRef,
            to: boxRef.value
          }, null, 8, ["to"]),
          createElementVNode("div", _hoisted_10$9, [
            createVNode(unref(B), {
              ref_key: "root",
              ref: root,
              model: socialMediaForm.value,
              rules,
              id: "social-media-form"
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$1a, {
                  title: "Location",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "location" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.location,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => socialMediaForm.value.location = $event),
                          id: "details-input",
                          maxlength: 40,
                          placeholder: "",
                          showCount: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Timezone",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(I), {
                      id: "details-select",
                      value: socialMediaForm.value.timeZone,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event) => socialMediaForm.value.timeZone = $event),
                      show: false,
                      onClick: _cache[3] || (_cache[3] = () => showTimezones.value = !showTimezones.value),
                      placeholder: "Select Timezone"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Phone number",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true,
                  class: "mt-6"
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "phoneNumber" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.phoneNumber,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => socialMediaForm.value.phoneNumber = $event),
                          id: "details-input",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    createElementVNode("div", _hoisted_11$9, [
                      createVNode(unref(y$1), {
                        "onUpdate:checked": _cache[5] || (_cache[5] = (c2) => c2 ? socialMediaForm.value.phoneVisibility = "public" : socialMediaForm.value.phoneVisibility = "private"),
                        checked: socialMediaForm.value.phoneVisibility === "public" ? true : false,
                        id: "checkbox",
                        src: "",
                        fallbackSrc: "",
                        type: "default",
                        class: "place-content-end"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(" Publicly visible ")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ])
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Email",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true,
                  class: "mt-6"
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "email" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.email,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => socialMediaForm.value.email = $event),
                          id: "details-input",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    createElementVNode("div", _hoisted_12$8, [
                      createVNode(unref(y$1), {
                        "onUpdate:checked": _cache[7] || (_cache[7] = (c2) => c2 ? socialMediaForm.value.emailVisibility = "public" : socialMediaForm.value.emailVisibility = "private"),
                        checked: socialMediaForm.value.emailVisibility === "public" ? true : false,
                        id: "checkbox",
                        src: "",
                        fallbackSrc: "",
                        type: "default",
                        class: "place-content-end"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(" Publicly visible ")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ])
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Twitter",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "twitter" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.twitter,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => socialMediaForm.value.twitter = $event),
                          id: "details-input",
                          maxlength: 50,
                          placeholder: "https://twitter.com/marketing"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Instagram",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "instagram" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.instagram,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => socialMediaForm.value.instagram = $event),
                          id: "details-input",
                          maxlength: 50,
                          placeholder: "https://instagram.com/marketing"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Facebook",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "facebook" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.facebook,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => socialMediaForm.value.facebook = $event),
                          id: "details-input",
                          maxlength: 50,
                          placeholder: "https://facebook.com/marketing"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Youtube",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "youtube" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.youtube,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => socialMediaForm.value.youtube = $event),
                          id: "details-input",
                          placeholder: "https://youtube.com/marketing"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_sfc_main$1a, {
                  title: "Linkedin",
                  align: void 0,
                  inline: false,
                  wrapItem: true,
                  justify: "start",
                  size: "medium",
                  vertical: true,
                  wrap: true
                }, {
                  "space-slot": withCtx(() => [
                    createVNode(unref(V), { path: "linkedin" }, {
                      default: withCtx(() => [
                        createVNode(unref(P), {
                          modelValue: socialMediaForm.value.linkedin,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => socialMediaForm.value.linkedin = $event),
                          id: "details-input",
                          placeholder: "https://linkedin.com/marketing"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ], 512),
        createVNode(unref(c$1), {
          class: "rounded-t-xl p-0 !h-[110vw]",
          show: showTimezones.value,
          "onUpdate:show": _cache[15] || (_cache[15] = ($event) => showTimezones.value = $event),
          placement: "bottom",
          id: "timezones-options-drawer",
          "auto-focus": false
        }, {
          default: withCtx(() => [
            createVNode(unref(K), {
              id: "timezones-options-drawer-menu",
              class: "p-0 timezone",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_13$7, [
                  createElementVNode("div", _hoisted_14$4, [
                    withDirectives(createElementVNode("div", _hoisted_15$4, null, 512), [
                      [_directive_swipe, {
                        direction: "down",
                        callback: () => {
                          showTimezones.value = !showTimezones.value;
                        }
                      }]
                    ]),
                    createVNode(unref(p), { class: "text-black mt-4 mb-4" }, {
                      default: withCtx(() => [
                        createTextVNode("Select Timezone")
                      ]),
                      _: 1
                    }),
                    createVNode(unref(p$1), { class: "w-full" }),
                    createElementVNode("div", _hoisted_16$4, [
                      withDirectives(createElementVNode("input", {
                        id: "search",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => searchText.value = $event),
                        "aria-label": "Search",
                        name: "search",
                        type: "text",
                        maxlength: "64",
                        class: "border-0 appearance-none border-gray-400 rounded-none relative block w-full px-3 pb-2 focus:outline-none placeholder-gray-400 text-gray-900 sm:text-sm sm:leading-5",
                        placeholder: "Search timezones"
                      }, null, 512), [
                        [
                          vModelText,
                          searchText.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      createElementVNode("div", _hoisted_17$4, [
                        createVNode(unref(render$1), {
                          name: "search",
                          class: "w-5 h-5 text-gray-400"
                        })
                      ])
                    ]),
                    createVNode(unref(p$1), {
                      id: "searchDivider",
                      class: "w-full"
                    })
                  ]),
                  createElementVNode("div", _hoisted_18$3, [
                    createVNode(unref(g), {
                      value: socialMediaForm.value.timeZone,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event) => socialMediaForm.value.timeZone = $event),
                      name: "radioButtonGroup1",
                      disabled: false,
                      id: "search-timezone-radio",
                      size: "medium",
                      "default-value": socialMediaForm.value.timeZone
                    }, {
                      default: withCtx(() => {
                        var _a2;
                        return [
                          ((_a2 = filteredTimezones.value) == null ? void 0 : _a2.length) > 0 ? (openBlock(), createElementBlock("div", _hoisted_19$3, [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(filteredTimezones.value, (timeZone) => {
                              return openBlock(), createBlock(unref(c$2), {
                                id: timeZone.value,
                                key: timeZone.value,
                                value: timeZone.value,
                                label: timeZone.value,
                                onChange: ($event) => handleTimeZone(timeZone.value),
                                class: "py-6 w-full items-center !border-b-2 !border-gray-400"
                              }, {
                                default: withCtx(() => [
                                  createElementVNode("div", _hoisted_20$3, [
                                    createElementVNode("div", _hoisted_21$3, [
                                      createVNode(unref(render$2), { class: "text-primary-500 h-5 w-5" })
                                    ]),
                                    createElementVNode("div", _hoisted_22$3, [
                                      createVNode(unref(p), null, {
                                        default: withCtx(() => [
                                          createTextVNode(toDisplayString(timeZone == null ? void 0 : timeZone.value), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      createVNode(unref(f), null, {
                                        default: withCtx(() => [
                                          createTextVNode(toDisplayString((timeZone == null ? void 0 : timeZone.label.split(" ")[0]) + " " + (timeZone == null ? void 0 : timeZone.label.split(" ")[2]) + " | " + (timeZone == null ? void 0 : timeZone.currentTime)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["id", "value", "label", "onChange"]);
                            }), 128))
                          ])) : (openBlock(), createBlock(unref(_), {
                            key: 1,
                            class: "text-gray-400 mt-4 text-center"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("No timezones found")
                            ]),
                            _: 1
                          }))
                        ];
                      }),
                      _: 1
                    }, 8, ["value", "default-value"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"])
      ]);
    };
  }
});
var EditDetails = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["__scopeId", "data-v-c1b53b1c"]]);
function loadImage(image) {
  return new Promise((resolve, reject) => {
    image.addEventListener("load", () => {
      resolve(image);
    });
    image.addEventListener("error", (error) => {
      reject(error);
    });
  });
}
const http$1 = requests((_a = AppState == null ? void 0 : AppState.getConfig()) == null ? void 0 : _a.INTERNAL_URL);
class MediaService$1 {
  constructor(locationId) {
    __publicField(this, "subdomain", "");
    __publicField(this, "locationId", "");
    this.locationId = locationId;
    this.subdomain = `${locationId}/medias`;
  }
  async generateSignedUrl(data) {
    return http$1.post(`${this.subdomain}/signed-url`, data);
  }
}
const http = requests(AppState.getConfig().INTERNAL_URL);
class NotificationsService$1 {
  constructor() {
    __publicField(this, "basePath", "");
  }
  async getNotifications(read, paginationObject) {
    const response = await http.get(`${this.basePath}/notifications`, {
      params: __spreadValues({ read }, paginationObject)
    });
    return response.data;
  }
  async markNotificationAsRead(notificationId, refId) {
    let params = {};
    if (notificationId) {
      params = { notificationId };
    } else if (refId) {
      params = { refId };
    }
    const response = await http.post(`${this.basePath}/notifications/read`, null, {
      params
    });
    return response.data;
  }
}
const BillingService = {
  verifyBillingOtp: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/auth/billing/otp`, {
    email: payload.email,
    userId: payload.userId || "",
    token: payload.token || "",
    otp: payload.otp || null,
    deviceName: navigator.userAgent,
    deviceId,
    deviceType: isMobileTablet() ? "mobile" : "desktop",
    domainName: `${window.location.host}`,
    locationId: payload.locationId,
    ipAddress: "0.0.0.1",
    redirectUrl: payload.redirectUrl || null,
    action: (payload == null ? void 0 : payload.action) || null,
    fullName: (payload == null ? void 0 : payload.fullName) || null,
    captchaToken: payload.captchaToken
  }),
  getSubscriptions: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/subscriptions`, {
    params: {
      contactId: payload.contactId,
      endAt: payload.endAt,
      entityId: payload.entityId,
      entitySourceType: payload.entitySourceType,
      id: payload.id,
      limit: payload.limit || 10,
      offset: payload.offset || 0,
      paymentMode: payload.paymentMode,
      status: payload.status,
      startAt: payload.startAt,
      altId: payload.locationId
    }
  }),
  getInvoices: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/invoices`, {
    params: {
      contactId: payload.contactId,
      endAt: payload.endAt,
      entityId: payload.entityId,
      entitySourceType: payload.entitySourceType,
      id: payload.id,
      limit: payload.limit || 10,
      offset: payload.offset || 0,
      paymentMode: payload.paymentMode,
      status: payload.status,
      startAt: payload.startAt,
      altId: payload.locationId
    }
  }),
  getTransactions: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/transactions`, {
    params: {
      contactId: payload.contactId,
      endAt: payload.endAt,
      entityId: payload.entityId,
      entitySourceType: payload.entitySourceType,
      id: payload.id,
      limit: payload.limit || 10,
      offset: payload.offset || 0,
      paymentMode: payload.paymentMode,
      status: payload.status,
      startAt: payload.startAt,
      altId: payload.locationId
    }
  }),
  getSubscriptionsById: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/subscriptions/${payload.subscriptionId}`, {
    params: {
      altId: payload.locationId
    }
  }),
  getTransactionsById: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/transactions/${payload.transactionId}`, {
    params: {
      altId: payload.locationId
    }
  }),
  getInvoiceById: (payload) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/invoices/gen-url/${payload.invoiceId}/${payload.type}`, {
    params: {
      altId: payload.locationId
    }
  }),
  cancelSubscription: (payload) => requests().post(`${AppState.getConfig().REST_API_URLS}/clientclub/${payload.locationId}/billing/subscriptions/cancel`, {
    id: payload.subscriptionId,
    altId: payload.locationId,
    altType: "location"
  })
};
let MediaService;
let NotificationsService;
function initializeServices(locationId) {
  MediaService = new MediaService$1(locationId);
  NotificationsService = new NotificationsService$1();
}
var EditProfile_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$c = (n) => (pushScopeId("data-v-78b5f5e4"), n = n(), popScopeId(), n);
const _hoisted_1$10 = { class: "flex flex-col h-screen w-full fixed bg-white z-[100]" };
const _hoisted_2$Z = {
  id: "edit-profile-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$R = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$z = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$q = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$n = /* @__PURE__ */ _withScopeId$c(() => /* @__PURE__ */ createElementVNode("div", { class: "flex items-start justify-start gap-1" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "inline-flex flex-col items-start justify-start" }, [
    /* @__PURE__ */ createElementVNode("div", { class: "text-lg font-medium text-slate-700" }, " Edit profile ")
  ])
], -1));
const _hoisted_7$g = { class: "flex grow items-center justify-end" };
const _hoisted_8$d = { class: "flex items-start justify-start gap-4" };
const _hoisted_9$c = {
  class: "relative cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_10$8 = { class: "w-full col-span-3" };
const _hoisted_11$8 = { class: "flex place-content-between" };
const _hoisted_12$7 = { class: "flex mt-4 place-content-center" };
const _hoisted_13$6 = ["src"];
const _hoisted_14$3 = { class: "mt-10 w-full col-span-3" };
const _hoisted_15$3 = { class: "flex place-content-between" };
const _hoisted_16$3 = { class: "flex mt-4 place-content-center" };
const _hoisted_17$3 = {
  key: 0,
  class: "flex flex-col items-center"
};
const _hoisted_18$2 = ["src"];
const _hoisted_19$2 = { class: "mt-10 w-full col-span-3" };
const _hoisted_20$2 = { class: "flex place-content-between" };
const _hoisted_21$2 = { class: "flex flex-col w-full mt-4 place-content-center gap-4 overflow-hidden" };
const _hoisted_22$2 = { class: "mt-10 w-full col-span-3" };
const _hoisted_23$2 = { class: "flex place-content-between" };
const _hoisted_24$2 = { class: "flex flex-col w-full mt-4 place-content-center gap-4 overflow-hidden" };
const _hoisted_25$1 = { class: "mt-10 w-full col-span-3" };
const _hoisted_26$1 = { class: "flex place-content-between" };
const _hoisted_27$1 = { class: "flex flex-col w-full mt-4 place-content-center gap-4 overflow-hidden" };
const _hoisted_28$1 = { class: "flex flex-col" };
const _hoisted_29$1 = /* @__PURE__ */ _withScopeId$c(() => /* @__PURE__ */ createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1));
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  key: 0,
  class: "hover inline-flex h-full w-[95%] items-center justify-start gap-2 rounded-lg"
};
const _hoisted_32 = { class: "inline-flex flex-col items-start justify-center gap-4" };
const _hoisted_33 = { class: "inline-flex items-center justify-start gap-4" };
const _hoisted_34 = { class: "relative h-10 w-10" };
const _hoisted_35 = { class: "h-10 w-10 rounded-md bg-gray-200" };
const _hoisted_36 = { class: "flex h-10 w-10 items-center justify-center rounded-full" };
const _hoisted_37 = { class: "flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200 text-gray-600" };
const _hoisted_38 = { class: "inline-flex flex-col items-start justify-start" };
const _sfc_main$16 = defineComponent({
  __name: "EditProfile",
  emits: ["update:show", "update:save", "update:edited"],
  setup(__props, { emit: __emit }) {
    const routerInstance2 = AppState.getRouterInstance();
    const boxRef = ref(null);
    const loadingRef = ref(null);
    onBeforeMount(async () => {
      setFormData();
    });
    function setFormData() {
      var _a2, _b, _c, _d;
      profileForm.value.avatar = ((_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.avatar) ? [
        {
          status: "finished",
          name: "Profile picture",
          type: "image/jpeg",
          url: (_b = UserState == null ? void 0 : UserState.state) == null ? void 0 : _b.avatar
        }
      ] : [];
      profileForm.value.profileCover = ((_c = UserState == null ? void 0 : UserState.state) == null ? void 0 : _c.profileCover) ? [
        {
          status: "finished",
          name: "Profile cover",
          type: "image/jpeg",
          url: (_d = UserState == null ? void 0 : UserState.state) == null ? void 0 : _d.profileCover
        }
      ] : [];
    }
    const showImageDrawer = ref(false);
    const fileUpload = ref(null);
    const uploadType = ref("");
    const avatarLoading = ref(false);
    const profileCoverLoading = ref(false);
    const openDrawer = (value, type) => {
      if (!value) {
        imageDrawerOptions[1].showOnMobile = false;
      } else {
        imageDrawerOptions[1].showOnMobile = true;
      }
      uploadType.value = type;
      showImageDrawer.value = !showImageDrawer.value;
    };
    const imageDrawerOptions = [
      {
        id: "upload-photo",
        title: "Upload photo",
        component: render$5,
        showOnMobile: true,
        reaction: () => {
          fileUpload.value.click();
          showImageDrawer.value = !showImageDrawer.value;
        }
      },
      {
        id: "remove-photo",
        title: "Remove photo",
        component: render$6,
        showOnMobile: true,
        reaction: () => {
          profileForm.value[uploadType.value] = [];
          showImageDrawer.value = !showImageDrawer.value;
        }
      }
    ];
    function handleFileInputChange(event2) {
      const { files } = event2.target;
      if (!files || !files.length)
        return;
      for (let i = 0; i < files.length; i++) {
        files[i].status = "not-started";
        files[i].id = uuid_1.v4();
        beforeUpload(uploadType.value, files[i]);
      }
      event2.target.value = "";
    }
    const uploadedUrl = reactive({
      avatar: {},
      profileCover: {}
    });
    const actionUrl = reactive({
      avatar: {},
      profileCover: {}
    });
    const profileBasicInformation = computed(() => {
      var _a2, _b, _c, _d;
      return [
        {
          title: "Full name",
          value: (_a2 = UserState.state) == null ? void 0 : _a2.fullName
        },
        {
          title: "Title",
          value: (_b = UserState.state) == null ? void 0 : _b.title
        },
        {
          title: "Profile slug",
          value: (_c = UserState.state) == null ? void 0 : _c.slug
        },
        {
          title: "Bio",
          value: (_d = UserState.state) == null ? void 0 : _d.bio
        }
      ];
    });
    const hasProfileBasicInformation = computed(() => {
      return !profileBasicInformation.value.every((item) => !item.value);
    });
    const profileDetails = computed(() => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
      return [
        {
          title: "Location",
          value: (_a2 = UserState.state) == null ? void 0 : _a2.location
        },
        {
          title: "Timezone",
          value: (_b = UserState.state) == null ? void 0 : _b.timeZone
        },
        {
          title: "Phone number",
          value: (_c = UserState.state) == null ? void 0 : _c.socials.phoneNumber
        },
        {
          title: "Email",
          value: (_d = UserState.state) == null ? void 0 : _d.socials.email
        },
        {
          title: "Twitter",
          value: (_e = UserState.state) == null ? void 0 : _e.socials.twitter
        },
        {
          title: "Instagram",
          value: (_f = UserState.state) == null ? void 0 : _f.socials.instagram
        },
        {
          title: "Facebook",
          value: (_g = UserState.state) == null ? void 0 : _g.socials.facebook
        },
        {
          title: "Youtube",
          value: (_h = UserState.state) == null ? void 0 : _h.socials.youtube
        },
        {
          title: "Linkedin",
          value: (_i = UserState.state) == null ? void 0 : _i.socials.linkedin
        }
      ];
    });
    const hasProfileDetails = computed(() => {
      return !profileDetails.value.every((item) => !item.value);
    });
    const userAccount = computed(() => {
      var _a2;
      return [
        {
          title: "Login Email",
          value: (_a2 = UserState.state) == null ? void 0 : _a2.email
        },
        {
          title: "Password",
          value: "**********"
        }
      ];
    });
    const handleEditRoutes = (queryValue) => {
      const currentPath = window.location.pathname;
      if (routerInstance2) {
        routerInstance2.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    const profileForm = ref({
      avatar: [],
      profileCover: []
    });
    const state = ref({
      file: null,
      avatar: { aspectRatioError: false, aspectRatio: 1 },
      profileCover: { aspectRatioError: false, aspectRatio: 1.78 }
    });
    const notification = c();
    function notificationAlert(title, content) {
      notification.create({
        title,
        content,
        duration: 5e3
      });
    }
    function handleRemoveUploadedImage(data, type) {
      profileForm.value[type] = [];
    }
    async function beforeUpload(type, data) {
      try {
        const file = data;
        state.value.file = file;
        if (file && ALLOWED_FILE_TYPES.includes(data.type)) {
          const img = new Image();
          const blobedFile = new File([file], file.name, {
            type: file.type
          });
          img.src = URL.createObjectURL(blobedFile);
          await loadImage(img);
          state.value[type].aspectRatioError = false;
          await getSignedUrlAndUpload(type, data);
          return true;
        } else {
          notificationAlert("Image type not supported", "");
          await handleRemoveUploadedImage(data, type);
          return false;
        }
      } catch (error) {
        if (error === "Invalid Aspect Ratio") {
          state.value[type].aspectRatioError = true;
          if (type === "avatar") {
            notificationAlert("Recommended aspect ratio 1:1", "");
          } else if (type === "profileCover") {
            notificationAlert("Recommended aspect ratio 16:9", "");
          } else {
            notificationAlert("Invalid aspect ratio", "");
          }
        } else {
          notificationAlert("Oops! Unable to upload image.", "Please try again later");
        }
        console.error(error);
        return false;
      }
    }
    async function getSignedUrlAndUpload(type, data) {
      if (!ALLOWED_FILE_TYPES.includes(data.type)) {
        notificationAlert("Image type not supported", "");
        return false;
      }
      const name = uuid_1.v4();
      const { url, signedUrl } = (await MediaService.generateSignedUrl({
        name,
        folder: "users",
        type: data.type
      })).data;
      actionUrl[type].value = signedUrl;
      uploadedUrl[type].value = url;
      if (type === "avatar") {
        avatarLoading.value = true;
      } else if (type === "profileCover") {
        profileCoverLoading.value = true;
      }
      const { uploadPromise } = await uploadFile(data, name, signedUrl, url);
      profileForm.value[type] = [];
      profileForm.value[type].push({
        name: (await uploadPromise).name,
        status: (await uploadPromise).status,
        url: (await uploadPromise).url,
        type: (await uploadPromise).type
      });
      avatarLoading.value = false;
      profileCoverLoading.value = false;
    }
    async function uploadFile(file, name, signedUrl, url) {
      const blobedFile = new File([file], name);
      const xhr = new XMLHttpRequest();
      const uploadPromise = new Promise(function(resolve, reject) {
        const formData = new FormData();
        formData.append("file", blobedFile);
        xhr.open("PUT", signedUrl, true);
        xhr.onload = () => {
          const status = xhr.status;
          if (status === 200) {
            resolve({
              id: file.id,
              url,
              name: file.name,
              type: file.type,
              size: file.size,
              status: "completed"
            });
          } else {
            reject("Something went wrong");
            notificationAlert("Something went wrong", "Please try again later");
          }
        };
        xhr.onerror = () => {
          reject("Something went wrong");
          notificationAlert("Something went wrong", "Please try again later");
        };
        xhr.setRequestHeader("Content-Type", file.type);
        if (file.progressUpdate) {
          xhr.upload.onprogress = function(event2) {
            if (event2.lengthComputable) {
              const percentComplete = Number((event2.loaded / event2.total * 100).toFixed());
              file.progressUpdate(percentComplete);
            }
          };
        }
        xhr.send(blobedFile);
      });
      return { uploadPromise };
    }
    const root = ref();
    async function validateForm() {
      return new Promise((resolve, reject) => {
        root.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.error("error", e);
          reject(e);
        });
      });
    }
    const updatingProfileSetting = ref(false);
    async function saveProfile() {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
      await validateForm();
      try {
        (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
        updatingProfileSetting.value = true;
        await (UserState == null ? void 0 : UserState.updateUserProfile({
          avatar: ((_c = (_b = profileForm.value) == null ? void 0 : _b.avatar[0]) == null ? void 0 : _c.url) || "",
          profileCover: ((_e = (_d = profileForm.value) == null ? void 0 : _d.profileCover[0]) == null ? void 0 : _e.url) || "",
          locationId: (_f = LocationState == null ? void 0 : LocationState.state) == null ? void 0 : _f.locationId,
          userId: (_g = UserState == null ? void 0 : UserState.state) == null ? void 0 : _g.userId
        }));
        updatingProfileSetting.value = false;
        (_h = loadingRef.value) == null ? void 0 : _h.stopLoadBar();
        setTimeout(() => {
          if (routerInstance2) {
            routerInstance2.back();
          }
        }, 300);
      } catch (e) {
        (_i = loadingRef.value) == null ? void 0 : _i.errorLoadBar();
        console.error(e);
      }
    }
    return (_ctx, _cache) => {
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", _hoisted_1$10, [
        createElementVNode("div", _hoisted_2$Z, [
          createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$R, [
                createElementVNode("div", _hoisted_4$z, [
                  createElementVNode("div", _hoisted_5$q, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance2)) {
                          unref(routerInstance2).back();
                        }
                      }),
                      class: "relative h-5 w-5 cursor-pointer"
                    }, [
                      createVNode(unref(render))
                    ])
                  ]),
                  _hoisted_6$n
                ]),
                createElementVNode("div", _hoisted_7$g, [
                  createElementVNode("div", _hoisted_8$d, [
                    createElementVNode("div", _hoisted_9$c, [
                      createVNode(unref(q), {
                        id: "details-save-btn",
                        onClick: saveProfile,
                        class: "text-primary-500 text-lg",
                        text: true
                      }, {
                        default: withCtx(() => [
                          createTextVNode("Save ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] py-6 grid grid-cols-3 row-span-1 px-4 overflow-y-auto content"
        }, [
          createVNode(unref(T), {
            ref_key: "loadingRef",
            ref: loadingRef,
            to: boxRef.value
          }, null, 8, ["to"]),
          createVNode(unref(B), {
            class: "w-full col-span-3",
            ref_key: "root",
            ref: root,
            model: profileForm.value,
            id: "profile-form"
          }, {
            default: withCtx(() => [
              createElementVNode("input", {
                class: "hidden",
                accept: "image/*",
                type: "file",
                ref_key: "fileUpload",
                ref: fileUpload,
                onChange: handleFileInputChange
              }, null, 544),
              createElementVNode("div", _hoisted_10$8, [
                createElementVNode("div", _hoisted_11$8, [
                  createVNode(unref(p), { class: "text-black" }, {
                    default: withCtx(() => [
                      createTextVNode("Profile picture")
                    ]),
                    _: 1
                  }),
                  createVNode(unref(p), {
                    onClick: _cache[1] || (_cache[1] = ($event) => {
                      var _a2;
                      return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0], "avatar");
                    }),
                    class: "text-primary-500 cursor-pointer"
                  }, {
                    default: withCtx(() => {
                      var _a2;
                      return [
                        createTextVNode(toDisplayString(((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0]) ? "Edit" : "Add"), 1)
                      ];
                    }),
                    _: 1
                  })
                ]),
                createElementVNode("div", _hoisted_12$7, [
                  !profileForm.value.avatar[0] ? (openBlock(), createBlock(unref(q), {
                    key: 0,
                    class: "!bg-gray-50 rounded-full w-[141px] h-[141px]",
                    id: void 0,
                    type: "tertiary",
                    size: "large",
                    disabled: false,
                    loading: avatarLoading.value,
                    ghost: false,
                    quaternary: true,
                    circle: true,
                    text: false,
                    onClick: _cache[2] || (_cache[2] = ($event) => {
                      var _a2;
                      return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0], "avatar");
                    })
                  }, {
                    default: withCtx(() => [
                      !avatarLoading.value ? (openBlock(), createBlock(unref(render$3), {
                        key: 0,
                        class: "w-16 h-16 text-gray-300"
                      })) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["loading"])) : (openBlock(), createBlock(unref(q), {
                    key: 1,
                    class: "!bg-gray-50 rounded-full w-[141px] h-[141px]",
                    id: void 0,
                    type: "tertiary",
                    size: "large",
                    disabled: false,
                    loading: false,
                    ghost: false,
                    quaternary: true,
                    circle: true,
                    text: false,
                    onClick: _cache[3] || (_cache[3] = ($event) => {
                      var _a2;
                      return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0], "avatar");
                    })
                  }, {
                    default: withCtx(() => {
                      var _a2, _b;
                      return [
                        createElementVNode("img", {
                          src: (_b = (_a2 = profileForm.value) == null ? void 0 : _a2.avatar[0]) == null ? void 0 : _b.url,
                          class: "rounded-full w-[141px] h-[141px] object-cover"
                        }, null, 8, _hoisted_13$6)
                      ];
                    }),
                    _: 1
                  }))
                ])
              ]),
              createElementVNode("div", _hoisted_14$3, [
                createElementVNode("div", _hoisted_15$3, [
                  createVNode(unref(p), { class: "text-black" }, {
                    default: withCtx(() => [
                      createTextVNode("Profile cover")
                    ]),
                    _: 1
                  }),
                  createVNode(unref(p), {
                    onClick: _cache[4] || (_cache[4] = ($event) => {
                      var _a2;
                      return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0], "profileCover");
                    }),
                    class: "text-primary-500 cursor-pointer"
                  }, {
                    default: withCtx(() => {
                      var _a2;
                      return [
                        createTextVNode(toDisplayString(((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0]) ? "Edit" : "Add"), 1)
                      ];
                    }),
                    _: 1
                  })
                ]),
                createElementVNode("div", _hoisted_16$3, [
                  !profileForm.value.profileCover[0] ? (openBlock(), createBlock(unref(q), {
                    key: 0,
                    class: "!bg-gray-50 rounded-md w-full h-[153px]",
                    id: void 0,
                    type: "tertiary",
                    size: "large",
                    disabled: false,
                    loading: profileCoverLoading.value,
                    ghost: false,
                    quaternary: true,
                    circle: false,
                    text: false,
                    onClick: _cache[5] || (_cache[5] = ($event) => {
                      var _a2;
                      return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0], "profileCover");
                    })
                  }, {
                    default: withCtx(() => [
                      !profileCoverLoading.value ? (openBlock(), createElementBlock("div", _hoisted_17$3, [
                        createVNode(unref(render$4), { class: "w-10 h-10 text-gray-300" })
                      ])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["loading"])) : (openBlock(), createBlock(unref(q), {
                    key: 1,
                    class: "!bg-gray-50 block rounded-md w-full !h-[153px]",
                    id: void 0,
                    type: "tertiary",
                    size: "large",
                    disabled: false,
                    loading: false,
                    ghost: false,
                    quaternary: true,
                    circle: true,
                    text: false,
                    onClick: _cache[6] || (_cache[6] = ($event) => {
                      var _a2;
                      return openDrawer((_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0], "profileCover");
                    })
                  }, {
                    default: withCtx(() => {
                      var _a2, _b;
                      return [
                        createElementVNode("img", {
                          src: (_b = (_a2 = profileForm.value) == null ? void 0 : _a2.profileCover[0]) == null ? void 0 : _b.url,
                          class: "rounded-md w-full !h-[153px] object-cover"
                        }, null, 8, _hoisted_18$2)
                      ];
                    }),
                    _: 1
                  }))
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          createElementVNode("div", _hoisted_19$2, [
            createElementVNode("div", _hoisted_20$2, [
              createVNode(unref(p), { class: "text-black" }, {
                default: withCtx(() => [
                  createTextVNode("Basic information")
                ]),
                _: 1
              }),
              createVNode(unref(p), {
                onClick: _cache[7] || (_cache[7] = ($event) => handleEditRoutes("EditBasicInfo")),
                class: "text-primary-500 cursor-pointer"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(hasProfileBasicInformation.value ? "Edit" : "Add"), 1)
                ]),
                _: 1
              })
            ]),
            createElementVNode("div", _hoisted_21$2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(profileBasicInformation.value, (item) => {
                return openBlock(), createElementBlock("div", {
                  class: "flex flex-col w-full gap-1",
                  key: item.title
                }, [
                  createVNode(unref(f), { class: "text-black w-full" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(_$1), {
                    onClick: () => {
                      if (!item.value) {
                        handleEditRoutes("EditBasicInfo");
                      }
                    },
                    class: normalizeClass(["w-full", item.value ? "text-gray-400" : "text-primary-500"])
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.value ? item.value : "Add " + item.title[0].toLowerCase() + item.title.substring(1)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class"])
                ]);
              }), 128))
            ])
          ]),
          createElementVNode("div", _hoisted_22$2, [
            createElementVNode("div", _hoisted_23$2, [
              createVNode(unref(p), { class: "text-black" }, {
                default: withCtx(() => [
                  createTextVNode("Details")
                ]),
                _: 1
              }),
              createVNode(unref(p), {
                onClick: _cache[8] || (_cache[8] = ($event) => handleEditRoutes("EditDetails")),
                class: "text-primary-500 cursor-pointer"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(hasProfileDetails.value ? "Edit" : "Add"), 1)
                ]),
                _: 1
              })
            ]),
            createElementVNode("div", _hoisted_24$2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(profileDetails.value, (item) => {
                return openBlock(), createElementBlock("div", {
                  class: "flex flex-col w-full gap-1",
                  key: item.title
                }, [
                  createVNode(unref(f), { class: "text-black w-full" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(_$1), {
                    onClick: () => {
                      if (!item.value) {
                        handleEditRoutes("EditDetails");
                      }
                    },
                    class: normalizeClass(["w-full", item.value ? "text-gray-400" : "text-primary-500"])
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.value ? item.value : "Add " + item.title[0].toLowerCase() + item.title.substring(1)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class"])
                ]);
              }), 128))
            ])
          ]),
          createElementVNode("div", _hoisted_25$1, [
            createElementVNode("div", _hoisted_26$1, [
              createVNode(unref(p), { class: "text-black" }, {
                default: withCtx(() => [
                  createTextVNode("Account")
                ]),
                _: 1
              }),
              createVNode(unref(p), {
                onClick: _cache[9] || (_cache[9] = ($event) => handleEditRoutes("EditAccount")),
                class: "text-primary-500 cursor-pointer"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString("Edit"))
                ]),
                _: 1
              })
            ]),
            createElementVNode("div", _hoisted_27$1, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(userAccount.value, (item) => {
                return openBlock(), createElementBlock("div", {
                  class: "flex flex-col w-full gap-1",
                  key: item.title
                }, [
                  createVNode(unref(f), { class: "text-black w-full" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(_$1), { class: "w-full text-gray-400" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.value), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]);
              }), 128))
            ])
          ])
        ], 512),
        createVNode(unref(c$1), {
          class: "rounded-t-xl bg-white",
          show: showImageDrawer.value,
          "onUpdate:show": _cache[10] || (_cache[10] = ($event) => showImageDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: imageDrawerOptions.filter((i) => i.showOnMobile).length > 1 ? imageDrawerOptions.filter((i) => i.showOnMobile).length * 76 : imageDrawerOptions.filter((i) => i.showOnMobile).length * 96
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(K), {
              id: "image-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_28$1, [
                  _hoisted_29$1,
                  createElementVNode("div", {
                    class: normalizeClass([
                      "flex flex-col",
                      imageDrawerOptions.filter((i) => i.showOnMobile).length > 1 ? "gap-4" : "gap-0"
                    ])
                  }, [
                    (openBlock(), createElementBlock(Fragment, null, renderList(imageDrawerOptions, (option) => {
                      return createElementVNode("div", {
                        key: option.id,
                        id: "image-button",
                        class: "hover:cursor-pointer",
                        onClick: option.reaction
                      }, [
                        option.showOnMobile ? (openBlock(), createElementBlock("div", _hoisted_31, [
                          createElementVNode("div", _hoisted_32, [
                            createElementVNode("div", _hoisted_33, [
                              createElementVNode("div", _hoisted_34, [
                                createElementVNode("div", _hoisted_35, [
                                  createElementVNode("div", _hoisted_36, [
                                    createElementVNode("div", _hoisted_37, [
                                      (openBlock(), createBlock(resolveDynamicComponent(option.component), { class: "h-5 w-5" }))
                                    ])
                                  ])
                                ])
                              ]),
                              createElementVNode("div", _hoisted_38, [
                                createVNode(unref(d), { class: "leading-tight text-slate-700" }, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(option.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ])
                        ])) : createCommentVNode("", true)
                      ], 8, _hoisted_30);
                    }), 64))
                  ], 2)
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showImageDrawer.value = !showImageDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show", "height"])
      ]);
    };
  }
});
var EditProfile = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["__scopeId", "data-v-78b5f5e4"]]);
const getProgress = (store) => {
  const { fullName, avatar, bio, title, timeZone, location, socials } = store;
  const SOCIAL_PERCENTAGE = 5;
  const PROFILE_PERCENTAGE = 10;
  const {
    email,
    phoneNumber,
    instagram,
    facebook,
    linkedin,
    youtube,
    twitter
  } = socials;
  let percentage = 0;
  if (fullName) {
    percentage += PROFILE_PERCENTAGE;
  }
  if (avatar) {
    percentage += PROFILE_PERCENTAGE;
  }
  if (bio) {
    percentage += PROFILE_PERCENTAGE;
  }
  if (title) {
    percentage += PROFILE_PERCENTAGE;
  }
  if (location) {
    percentage += PROFILE_PERCENTAGE;
  }
  if (timeZone) {
    percentage += SOCIAL_PERCENTAGE;
  }
  if (email) {
    percentage += PROFILE_PERCENTAGE;
  }
  if (phoneNumber) {
    percentage += PROFILE_PERCENTAGE;
  }
  if (instagram) {
    percentage += SOCIAL_PERCENTAGE;
  }
  if (facebook) {
    percentage += SOCIAL_PERCENTAGE;
  }
  if (linkedin) {
    percentage += SOCIAL_PERCENTAGE;
  }
  if (twitter) {
    percentage += SOCIAL_PERCENTAGE;
  }
  if (youtube) {
    percentage += SOCIAL_PERCENTAGE;
  }
  return percentage;
};
const getShortenedURL = (url) => {
  if (url.includes("https")) {
    return url.slice(8, url.length);
  } else if (url.includes("http")) {
    return url.slice(7, url.length);
  } else {
    return url;
  }
};
const BrandedAppService = {
  getAppDetails: (locationId) => requests().get(`${AppState.getConfig().REST_API_URLS}/clientclub/branded-app/${locationId}`)
};
class BrandedAppsState {
  constructor() {
    __publicField(this, "state", reactive({
      id: "",
      locationId: "",
      appName: "",
      primaryColor: "",
      appIconImage: "",
      appCarouselImage1: "",
      appCarouselDescription1: "",
      appCarouselImage2: "",
      appCarouselDescription2: "",
      appCarouselImage3: "",
      appCarouselDescription3: "",
      appCarouselImage4: "",
      appCarouselDescription4: "",
      privacyPolicyUrl: "",
      termsConditionsUrl: ""
    }));
  }
  setBrandedAppDetails(data) {
    this.state.appName = data == null ? void 0 : data.appName;
    this.state.primaryColor = data == null ? void 0 : data.primaryColor;
    this.state.appIconImage = data == null ? void 0 : data.appIconImage;
    this.state.appCarouselImage1 = data == null ? void 0 : data.appCarouselImage1;
    this.state.appCarouselDescription1 = data == null ? void 0 : data.appCarouselDescription1;
    this.state.appCarouselImage2 = data == null ? void 0 : data.appCarouselImage2;
    this.state.appCarouselDescription2 = data == null ? void 0 : data.appCarouselDescription2;
    this.state.appCarouselImage3 = data == null ? void 0 : data.appCarouselImage3;
    this.state.appCarouselDescription3 = data == null ? void 0 : data.appCarouselDescription3;
    this.state.appCarouselImage4 = data == null ? void 0 : data.appCarouselImage4;
    this.state.appCarouselDescription4 = data == null ? void 0 : data.appCarouselDescription4;
    this.state.privacyPolicyUrl = data == null ? void 0 : data.privacyPolicyUrl;
    this.state.termsConditionsUrl = data == null ? void 0 : data.termsConditionsUrl;
  }
  async getBrandedAppDetails(locationId) {
    var _a2, _b;
    try {
      const response = await BrandedAppService.getAppDetails(locationId);
      this.state.id = (_a2 = response.data) == null ? void 0 : _a2._id;
      this.setBrandedAppDetails((_b = response.data) == null ? void 0 : _b.appDetails);
    } catch (error) {
      console.error(error);
    }
  }
}
const BrandedAppState = new BrandedAppsState();
function convertToRelativeTime(isoDate) {
  const currentDateTime = DateTime.now();
  const givenDateTime = DateTime.fromISO(isoDate);
  const timeDifference = currentDateTime.diff(givenDateTime);
  const seconds = timeDifference.as("seconds");
  const intervals = [
    ["y", 31536e3],
    ["mo", 2592e3],
    ["w", 604800],
    ["d", 86400],
    ["h", 3600],
    ["m", 60],
    ["s", 1]
  ];
  let output = "";
  for (const [intervalName, intervalSeconds] of intervals) {
    if (seconds < 1) {
      output = "Just now";
      break;
    }
    if (seconds >= intervalSeconds) {
      const intervalValue = Math.floor(seconds / intervalSeconds);
      output += `${intervalValue}${intervalName} ago`;
      break;
    }
  }
  return output;
}
class NotificationsState {
  constructor() {
    __publicField(this, "state", reactive({
      isLoading: false,
      notifications: new Array(),
      isNextPageAvailable: true,
      unReadNotificationCount: 0
    }));
  }
  clearNotifications() {
    this.state.notifications = [];
    this.state.isNextPageAvailable = true;
  }
  async markNotificationAsRead(notificationId, refId) {
    try {
      await NotificationsService.markNotificationAsRead(notificationId, refId);
      if (!notificationId && !refId) {
        this.state.notifications.forEach((n) => n.isRead = true);
        this.state.unReadNotificationCount = 0;
      } else {
        const notification = this.state.notifications.find((n) => n._id === notificationId);
        if (notification) {
          notification.isRead = true;
        }
        if (this.state.unReadNotificationCount > 0) {
          this.state.unReadNotificationCount -= 1;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getNotifications(read, paginationObject) {
    try {
      if (!this.state.isNextPageAvailable) {
        return;
      }
      if (!(paginationObject == null ? void 0 : paginationObject.previousId) && this.state.notifications.length > 0) {
        return;
      } else {
        const previousIdIndex = this.state.notifications.findIndex((notification) => notification._id === (paginationObject == null ? void 0 : paginationObject.previousId));
        if (previousIdIndex != this.state.notifications.length - 1) {
          return;
        }
      }
      this.state.isLoading = true;
      const notifications = await NotificationsService.getNotifications(read, paginationObject);
      notifications.forEach((n) => {
        if (!this.state.notifications.find((notification) => notification._id == n._id)) {
          n.relativeTime = convertToRelativeTime(n.createdAt);
          this.state.notifications.push(n);
        }
      });
      this.state.isLoading = false;
      if (paginationObject == null ? void 0 : paginationObject.limit) {
        if (notifications.length < paginationObject.limit) {
          this.state.isNextPageAvailable = false;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async getUnreadNotificationsCount() {
    try {
      const notifications = await NotificationsService.getNotifications(false, {
        limit: 21
      });
      this.state.unReadNotificationCount = notifications.length;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
const NotificationState = new NotificationsState();
async function sendNotificationToken(fcmToken) {
  var _a2, _b;
  try {
    const cat = api.get("cat") || window.localStorage.getItem("cat");
    const cookie = cat ? JSON.parse(window.atob(cat)) : null;
    if (cookie == null ? void 0 : cookie.contactId) {
      const payload = {
        token: fcmToken
      };
      if (((_a2 = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _a2.id) && Capacitor.getPlatform() === "ios") {
        payload["brandedAppId"] = (_b = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _b.id;
      }
      await UserService.updateSession(payload);
    }
  } catch (error) {
    console.error("Error sending FCM token", error);
  }
}
async function deleteFCMToken() {
  try {
    if (Capacitor.isNativePlatform()) {
      if (FCM) {
        await FCM.refreshToken().catch((err) => console.log(err));
        await FCM.deleteInstance().catch((err) => console.error(err));
      }
      await PushNotifications.unregister();
      await PushNotifications.removeAllListeners();
    }
  } catch (error) {
    console.error("Error deleting FCM token", error);
  }
}
async function requestNotificationPermission() {
  try {
    if (Capacitor.isNativePlatform()) {
      let status = await PushNotifications.checkPermissions();
      if (status.receive === "prompt") {
        status = await PushNotifications.requestPermissions();
      }
      if (status.receive !== "granted") {
        throw new Error("User denied permissions!");
      }
      await PushNotifications.register();
      await FCM.getToken().then(async (res) => {
        if (res.token) {
          await sendNotificationToken(res.token);
        }
      }).catch((err) => console.error(err));
      await FCM.setAutoInit({ enabled: true }).catch((err) => console.log(err));
      await PushNotifications.addListener("pushNotificationReceived", (notification) => {
        console.log("Push notification received: ", notification);
      });
      await PushNotifications.addListener("pushNotificationActionPerformed", async (res) => {
        var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
        if ((_a2 = res.notification) == null ? void 0 : _a2.data) {
          if ((_c = (_b = res.notification) == null ? void 0 : _b.data) == null ? void 0 : _c.refId) {
            setAppLoading(true);
            await NotificationState.markNotificationAsRead(void 0, (_e = (_d = res.notification) == null ? void 0 : _d.data) == null ? void 0 : _e.refId);
            NotificationState.clearNotifications();
            await NotificationState.getNotifications();
            setAppLoading(false);
          }
          if ((_g = (_f = res.notification) == null ? void 0 : _f.data) == null ? void 0 : _g.redirectPath) {
            window.location.href = `${window.location.origin}/${(_i = (_h = res.notification) == null ? void 0 : _h.data) == null ? void 0 : _i.redirectPath}`;
          }
        }
      });
    }
  } catch (e) {
    console.error(e);
  }
}
function baseUrl() {
  return window.location.origin;
}
function externalPathRedirect(path, query = "", newTab) {
  const domain = baseUrl();
  if (newTab) {
    if (query) {
      window.open(`${domain}/${path}?${query}`, "_blank");
    } else {
      window.open(`${domain}/${path}`, "_blank");
    }
  } else {
    if (query) {
      window.location.href = `${domain}/${path}?${query}`;
    } else {
      window.location.href = `${domain}/${path}`;
    }
  }
}
async function postLogin(data) {
  api.set("cat", window.btoa(JSON.stringify(data)), {
    expires: 365,
    sameSite: "None",
    secure: true
  });
  await firebase$1.auth().signInWithCustomToken(data.token).catch(function(error) {
    console.error(error);
  });
  await generateToken();
  enableAnalytics(data.contactId);
}
const logoutUser$1 = async (redirect = true) => {
  trackCustomGAEvents(GAEventTypes.LOGOUT, {});
  api.remove("cat");
  await firebase$1.auth().signOut();
  if (redirect) {
    externalPathRedirect("login", "");
  }
};
const logoutUser = async () => {
  try {
    localStorage.removeItem("event");
    localStorage.removeItem("cat");
    await deleteFCMToken();
    await UserService.updateSession({
      loggedIn: false
    });
    await logoutUser$1();
  } catch (error) {
    console.error("Error logging out user");
  }
};
const _sfc_main$15 = {};
const _hoisted_1$$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$Y = /* @__PURE__ */ createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10.5",
  fill: "#98A2B3"
}, null, -1);
const _hoisted_3$Q = /* @__PURE__ */ createElementVNode("path", {
  d: "M15.9103 15.2112L16.3767 12.2476H13.4589V10.3252C13.4589 9.51428 13.8657 8.7233 15.1726 8.7233H16.5V6.20024C16.5 6.20024 15.2959 6 14.1452 6C11.7411 6 10.1712 7.4197 10.1712 9.98883V12.2476H7.5V15.2112H10.1712V22.3759C10.7075 22.458 11.2562 22.5 11.8151 22.5C12.374 22.5 12.9226 22.458 13.4589 22.3759V15.2112H15.9103Z",
  fill: "white"
}, null, -1);
const _hoisted_4$y = [
  _hoisted_2$Y,
  _hoisted_3$Q
];
function _sfc_render$i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$$, _hoisted_4$y);
}
var SocialGrayedFacebook = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["render", _sfc_render$i]]);
const _sfc_main$14 = {};
const _hoisted_1$_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$X = /* @__PURE__ */ createStaticVNode('<rect x="1.5" y="1.5" width="21" height="21" rx="4.5" fill="url(#paint0_radial_8754_11394)"></rect><rect x="1.5" y="1.5" width="21" height="21" rx="4.5" fill="url(#paint1_radial_8754_11394)"></rect><rect x="1.5" y="1.5" width="21" height="21" rx="4.5" fill="#98A2B3"></rect><path d="M17.25 7.875C17.25 8.49632 16.7463 9 16.125 9C15.5037 9 15 8.49632 15 7.875C15 7.25368 15.5037 6.75 16.125 6.75C16.7463 6.75 17.25 7.25368 17.25 7.875Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75ZM12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z" fill="white"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 11.7C4.5 9.17976 4.5 7.91965 4.99047 6.95704C5.4219 6.11031 6.11031 5.4219 6.95704 4.99047C7.91965 4.5 9.17976 4.5 11.7 4.5H12.3C14.8202 4.5 16.0804 4.5 17.043 4.99047C17.8897 5.4219 18.5781 6.11031 19.0095 6.95704C19.5 7.91965 19.5 9.17976 19.5 11.7V12.3C19.5 14.8202 19.5 16.0804 19.0095 17.043C18.5781 17.8897 17.8897 18.5781 17.043 19.0095C16.0804 19.5 14.8202 19.5 12.3 19.5H11.7C9.17976 19.5 7.91965 19.5 6.95704 19.0095C6.11031 18.5781 5.4219 17.8897 4.99047 17.043C4.5 16.0804 4.5 14.8202 4.5 12.3V11.7ZM11.7 6H12.3C13.5849 6 14.4583 6.00117 15.1334 6.05633C15.7911 6.11006 16.1274 6.20745 16.362 6.32698C16.9265 6.6146 17.3854 7.07354 17.673 7.63803C17.7926 7.87263 17.8899 8.20893 17.9437 8.86656C17.9988 9.54169 18 10.4151 18 11.7V12.3C18 13.5849 17.9988 14.4583 17.9437 15.1334C17.8899 15.7911 17.7926 16.1274 17.673 16.362C17.3854 16.9265 16.9265 17.3854 16.362 17.673C16.1274 17.7926 15.7911 17.8899 15.1334 17.9437C14.4583 17.9988 13.5849 18 12.3 18H11.7C10.4151 18 9.54169 17.9988 8.86656 17.9437C8.20893 17.8899 7.87263 17.7926 7.63803 17.673C7.07354 17.3854 6.6146 16.9265 6.32698 16.362C6.20745 16.1274 6.11006 15.7911 6.05633 15.1334C6.00117 14.4583 6 13.5849 6 12.3V11.7C6 10.4151 6.00117 9.54169 6.05633 8.86656C6.11006 8.20893 6.20745 7.87263 6.32698 7.63803C6.6146 7.07354 7.07354 6.6146 7.63803 6.32698C7.87263 6.20745 8.20893 6.11006 8.86656 6.05633C9.54169 6.00117 10.4151 6 11.7 6Z" fill="white"></path><defs><radialGradient id="paint0_radial_8754_11394" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(9 17.25) rotate(-55.3758) scale(19.1397)"><stop stop-color="#B13589"></stop><stop offset="0.79309" stop-color="#C62F94"></stop><stop offset="1" stop-color="#8A3AC8"></stop></radialGradient><radialGradient id="paint1_radial_8754_11394" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.25 23.25) rotate(-65.1363) scale(16.9457)"><stop stop-color="#E0E8B7"></stop><stop offset="0.444662" stop-color="#FB8A2E"></stop><stop offset="0.71474" stop-color="#E2425C"></stop><stop offset="1" stop-color="#E2425C" stop-opacity="0"></stop></radialGradient></defs>', 7);
const _hoisted_9$b = [
  _hoisted_2$X
];
function _sfc_render$h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$_, _hoisted_9$b);
}
var SocialGrayedInstagram = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["render", _sfc_render$h]]);
const _sfc_main$13 = {};
const _hoisted_1$Z = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$W = /* @__PURE__ */ createElementVNode("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  rx: "10.5",
  fill: "#98A2B3"
}, null, -1);
const _hoisted_3$P = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.46392 7.26911C9.46392 7.97002 8.85639 8.53822 8.10696 8.53822C7.35753 8.53822 6.75 7.97002 6.75 7.26911C6.75 6.5682 7.35753 6 8.10696 6C8.85639 6 9.46392 6.5682 9.46392 7.26911Z",
  fill: "white"
}, null, -1);
const _hoisted_4$x = /* @__PURE__ */ createElementVNode("path", {
  d: "M6.93557 9.47107H9.25515V16.5H6.93557V9.47107Z",
  fill: "white"
}, null, -1);
const _hoisted_5$p = /* @__PURE__ */ createElementVNode("path", {
  d: "M12.9897 9.47107H10.6701V16.5H12.9897C12.9897 16.5 12.9897 14.2872 12.9897 12.9036C12.9897 12.0732 13.2732 11.2392 14.4046 11.2392C15.6833 11.2392 15.6756 12.3259 15.6696 13.1678C15.6618 14.2683 15.6804 15.3914 15.6804 16.5H18V12.7903C17.9804 10.4215 17.3631 9.33006 15.3325 9.33006C14.1265 9.33006 13.379 9.87754 12.9897 10.3729V9.47107Z",
  fill: "white"
}, null, -1);
const _hoisted_6$m = [
  _hoisted_2$W,
  _hoisted_3$P,
  _hoisted_4$x,
  _hoisted_5$p
];
function _sfc_render$g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$Z, _hoisted_6$m);
}
var SocialGrayedLinkedin = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["render", _sfc_render$g]]);
const _sfc_main$12 = {};
const _hoisted_1$Y = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
};
const _hoisted_2$V = /* @__PURE__ */ createElementVNode("path", {
  d: "M17.1558 17.3914L10.4468 7.61053L10.4583 7.61968L16.5074 0.609375H14.4859L9.55812 6.31526L5.64486 0.609375H0.343269L6.60678 9.74108L6.60601 9.74032L0 17.3914H2.02147L7.50004 11.0432L11.8542 17.3914H17.1558ZM4.8439 2.13501L14.2571 15.8658H12.6552L3.23435 2.13501H4.8439Z",
  fill: "#98A2B3"
}, null, -1);
const _hoisted_3$O = [
  _hoisted_2$V
];
function _sfc_render$f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$Y, _hoisted_3$O);
}
var SocialGrayedTwitter = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["render", _sfc_render$f]]);
const _sfc_main$11 = {};
const _hoisted_1$X = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$U = /* @__PURE__ */ createElementVNode("path", {
  d: "M1.68338 7.45583C1.77978 5.97175 2.97296 4.80867 4.45835 4.73508C6.60929 4.62852 9.6836 4.5 12 4.5C14.3164 4.5 17.3907 4.62852 19.5417 4.73508C21.027 4.80867 22.2202 5.97175 22.3166 7.45583C22.409 8.87769 22.5 10.6272 22.5 12C22.5 13.3728 22.409 15.1223 22.3166 16.5442C22.2202 18.0283 21.027 19.1913 19.5417 19.2649C17.3907 19.3715 14.3164 19.5 12 19.5C9.6836 19.5 6.60929 19.3715 4.45835 19.2649C2.97296 19.1913 1.77978 18.0283 1.68338 16.5442C1.59102 15.1223 1.5 13.3728 1.5 12C1.5 10.6272 1.59102 8.87769 1.68338 7.45583Z",
  fill: "#98A2B3"
}, null, -1);
const _hoisted_3$N = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.75 9V15L15.75 12L9.75 9Z",
  fill: "white"
}, null, -1);
const _hoisted_4$w = [
  _hoisted_2$U,
  _hoisted_3$N
];
function _sfc_render$e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$X, _hoisted_4$w);
}
var SocialGrayedYoutube = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["render", _sfc_render$e]]);
var MobileProfile_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$b = (n) => (pushScopeId("data-v-146935c7"), n = n(), popScopeId(), n);
const _hoisted_1$W = { class: "flex flex-col h-screen w-full fixed bg-white overflow-y-auto" };
const _hoisted_2$T = {
  id: "profile-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$M = { class: "relative w-full z-50 inline-flex justify-center gap-[13px] bg-white" };
const _hoisted_4$v = /* @__PURE__ */ _withScopeId$b(() => /* @__PURE__ */ createElementVNode("div", { class: "flex items-start justify-start gap-1" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "inline-flex flex-col items-start justify-start" }, [
    /* @__PURE__ */ createElementVNode("div", { class: "text-lg font-medium leading-7 text-slate-700" }, " Profile ")
  ])
], -1));
const _hoisted_5$o = { class: "flex grow items-center justify-end" };
const _hoisted_6$l = { class: "flex w-6 items-start justify-start gap-4" };
const _hoisted_7$f = {
  class: "relative h-6 w-6 cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_8$c = {
  ref: "boxRef",
  class: "grid grid-cols-3 row-span-1 place-items-center px-4 mt-10"
};
const _hoisted_9$a = { class: "mt-10 col-span-3" };
const _hoisted_10$7 = { class: "mt-4 col-span-3" };
const _hoisted_11$7 = { class: "flex col-span-3 mt-2 gap-4 items-center justify-center text-gray-400" };
const _hoisted_12$6 = ["onClick"];
const _hoisted_13$5 = ["src"];
const _hoisted_14$2 = { class: "col-span-3 w-full" };
const _hoisted_15$2 = /* @__PURE__ */ _withScopeId$b(() => /* @__PURE__ */ createElementVNode("div", { class: "w-full bg-gray-100 h-2 mt-6" }, null, -1));
const _hoisted_16$2 = { class: "mt-4 mb-20 pl-4" };
const _hoisted_17$2 = { class: "flex flex-col mt-4 gap-6" };
const _hoisted_18$1 = ["onClick"];
const _hoisted_19$1 = { class: "flex flex-col" };
const _hoisted_20$1 = /* @__PURE__ */ _withScopeId$b(() => /* @__PURE__ */ createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1));
const _hoisted_21$1 = ["onClick"];
const _hoisted_22$1 = {
  key: 0,
  class: "hover inline-flex h-full w-[95%] items-center justify-start gap-2 rounded-lg"
};
const _hoisted_23$1 = { class: "inline-flex flex-col items-start justify-center gap-4" };
const _hoisted_24$1 = { class: "inline-flex items-center justify-start gap-4" };
const _hoisted_25 = { class: "relative h-10 w-10" };
const _hoisted_26 = { class: "h-10 w-10 rounded-md bg-gray-200" };
const _hoisted_27 = { class: "flex h-10 w-10 items-center justify-center rounded-full" };
const _hoisted_28 = { class: "flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-gray-200 text-gray-600" };
const _hoisted_29 = { class: "inline-flex flex-col items-start justify-start" };
const _sfc_main$10 = defineComponent({
  __name: "MobileProfile",
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const showProfileDrawer = ref(false);
    const handleRoutes = (queryValue) => {
      const currentPath = window.location.pathname;
      if (routerInstance2) {
        routerInstance2.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    const profileDetailsInfo = computed(() => {
      var _a2, _b, _c, _d;
      return [
        {
          icon: render$2,
          value: (_a2 = UserState.state) == null ? void 0 : _a2.timeZone,
          slug: "timezone",
          isSocialMedia: false
        },
        {
          icon: render$7,
          value: (_b = UserState.state) == null ? void 0 : _b.location,
          slug: "location",
          isSocialMedia: false
        },
        {
          icon: render$8,
          value: (_c = UserState.state) == null ? void 0 : _c.socials.email,
          slug: "email",
          isSocialMedia: false
        },
        {
          icon: render$9,
          value: (_d = UserState.state) == null ? void 0 : _d.socials.phoneNumber,
          slug: "phone number",
          isSocialMedia: false
        }
      ];
    });
    const profileSocialsInfo = computed(() => {
      var _a2, _b, _c, _d, _e;
      return [
        {
          icon: FACEBOOK_ICON,
          value: (_a2 = UserState.state) == null ? void 0 : _a2.socials.facebook,
          slug: "facebook",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedFacebook)
        },
        {
          icon: INSTAGRAM_ICON,
          value: (_b = UserState.state) == null ? void 0 : _b.socials.instagram,
          slug: "instagram",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedInstagram)
        },
        {
          icon: LINKEDIN_ICON,
          value: (_c = UserState.state) == null ? void 0 : _c.socials.linkedin,
          slug: "linkedin",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedLinkedin)
        },
        {
          icon: TWITTER_ICON,
          value: (_d = UserState.state) == null ? void 0 : _d.socials.twitter,
          slug: "twitter",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedTwitter)
        },
        {
          icon: YOUTUBE_ICON,
          value: (_e = UserState.state) == null ? void 0 : _e.socials.youtube,
          slug: "youtube",
          isSocialMedia: true,
          grayIcon: h(SocialGrayedYoutube)
        }
      ];
    });
    const profileDrawerOptions = [
      {
        id: "logout",
        title: "Logout",
        component: render$c,
        showOnMobile: true,
        reaction: async () => {
          setAppLoading(true);
          await logoutUser().catch(() => {
            console.error("Error logging out");
          });
          setTimeout(() => setAppLoading(false), 4e3);
        }
      }
    ];
    function handleSocials(value) {
      if (value) {
        window.open(value, "_blank");
      }
    }
    return (_ctx, _cache) => {
      var _a2, _b;
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock("div", _hoisted_1$W, [
        createElementVNode("div", _hoisted_2$T, [
          createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$M, [
                _hoisted_4$v,
                createElementVNode("div", _hoisted_5$o, [
                  createElementVNode("div", _hoisted_6$l, [
                    createElementVNode("div", _hoisted_7$f, [
                      createVNode(unref(render$a), {
                        onClick: _cache[0] || (_cache[0] = ($event) => showProfileDrawer.value = !showProfileDrawer.value)
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_8$c, [
          createElementVNode("div", _hoisted_9$a, [
            ((_a2 = unref(UserState).state) == null ? void 0 : _a2.avatar) ? (openBlock(), createBlock(unref(I$1), {
              key: 0,
              class: "z-20 cursor-pointer text-base",
              size: 120,
              src: (_b = unref(UserState).state) == null ? void 0 : _b.avatar,
              ref: "ignoreElACRef"
            }, null, 8, ["src"])) : (openBlock(), createBlock(unref(I$1), {
              key: 1,
              class: "z-20 cursor-pointer bg-gray-100 font-medium text-gray-600 text-4xl",
              size: 120,
              ref: "ignoreElACRef"
            }, {
              default: withCtx(() => {
                var _a3;
                return [
                  createTextVNode(toDisplayString(unref(formatNameForAvatar)((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName)), 1)
                ];
              }),
              _: 1
            }, 512))
          ]),
          createElementVNode("div", _hoisted_10$7, [
            createVNode(unref(p$2), { class: "text-black" }, {
              default: withCtx(() => {
                var _a3;
                return [
                  createTextVNode(toDisplayString((_a3 = unref(UserState)) == null ? void 0 : _a3.state.fullName), 1)
                ];
              }),
              _: 1
            })
          ]),
          createElementVNode("div", _hoisted_11$7, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(profileSocialsInfo.value, (socialItem) => {
              return openBlock(), createElementBlock("div", {
                key: socialItem == null ? void 0 : socialItem.slug
              }, [
                (socialItem == null ? void 0 : socialItem.isSocialMedia) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  onClick: ($event) => handleSocials(socialItem == null ? void 0 : socialItem.value)
                }, [
                  (socialItem == null ? void 0 : socialItem.value) ? (openBlock(), createElementBlock("img", {
                    key: 0,
                    class: normalizeClass(!(socialItem == null ? void 0 : socialItem.value) ? "" : "cursor-pointer"),
                    src: socialItem == null ? void 0 : socialItem.icon
                  }, null, 10, _hoisted_13$5)) : (openBlock(), createBlock(resolveDynamicComponent(socialItem == null ? void 0 : socialItem.grayIcon), {
                    key: 1,
                    class: "h-[20px] w-[20px]"
                  }))
                ], 8, _hoisted_12$6)) : createCommentVNode("", true)
              ]);
            }), 128))
          ]),
          createElementVNode("div", _hoisted_14$2, [
            createVNode(unref(q), {
              id: "edit_profile_btn",
              type: "primary",
              color: "#000",
              class: "mt-6 gap-2 w-full",
              onClick: _cache[1] || (_cache[1] = ($event) => handleRoutes("SettingsMenu"))
            }, {
              default: withCtx(() => [
                createVNode(unref(render$b), { class: "!h-5 !w-5 mr-2" }),
                createTextVNode(" Settings")
              ]),
              _: 1
            })
          ])
        ], 512),
        _hoisted_15$2,
        createElementVNode("div", _hoisted_16$2, [
          createVNode(unref(d), { class: "text-black" }, {
            default: withCtx(() => [
              createTextVNode("Details")
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_17$2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(profileDetailsInfo.value, (profileInfo) => {
              return openBlock(), createElementBlock("div", {
                class: "flex items-center",
                key: profileInfo == null ? void 0 : profileInfo.slug,
                onClick: () => {
                  if (!(profileInfo == null ? void 0 : profileInfo.value)) {
                    handleRoutes("EditDetails");
                  }
                }
              }, [
                (openBlock(), createBlock(resolveDynamicComponent(profileInfo == null ? void 0 : profileInfo.icon), {
                  class: normalizeClass(["h-4 w-4", (profileInfo == null ? void 0 : profileInfo.value) ? "text-gray-900" : "text-gray-500"])
                }, null, 8, ["class"])),
                createVNode(unref(d), {
                  class: normalizeClass([(profileInfo == null ? void 0 : profileInfo.value) ? "text-gray-900" : "text-gray-500", "ml-2 truncate"])
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString((profileInfo == null ? void 0 : profileInfo.value) ? unref(getShortenedURL)(profileInfo == null ? void 0 : profileInfo.value) : profileInfo.slug[0].toUpperCase() + profileInfo.slug.substring(1)), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ], 8, _hoisted_18$1);
            }), 128))
          ])
        ]),
        createVNode(unref(c$1), {
          class: "rounded-t-xl bg-white",
          show: showProfileDrawer.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showProfileDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: profileDrawerOptions.filter((i) => i.showOnMobile).length * 96
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(K), {
              id: "image-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_19$1, [
                  _hoisted_20$1,
                  (openBlock(), createElementBlock(Fragment, null, renderList(profileDrawerOptions, (option) => {
                    return createElementVNode("div", {
                      key: option.id,
                      id: "image-button",
                      class: "hover:cursor-pointer",
                      onClick: option.reaction
                    }, [
                      option.showOnMobile ? (openBlock(), createElementBlock("div", _hoisted_22$1, [
                        createElementVNode("div", _hoisted_23$1, [
                          createElementVNode("div", _hoisted_24$1, [
                            createElementVNode("div", _hoisted_25, [
                              createElementVNode("div", _hoisted_26, [
                                createElementVNode("div", _hoisted_27, [
                                  createElementVNode("div", _hoisted_28, [
                                    (openBlock(), createBlock(resolveDynamicComponent(option.component), { class: "h-5 w-5" }))
                                  ])
                                ])
                              ])
                            ]),
                            createElementVNode("div", _hoisted_29, [
                              createVNode(unref(d), { class: "leading-tight text-slate-700" }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(option.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ])
                        ])
                      ])) : createCommentVNode("", true)
                    ], 8, _hoisted_21$1);
                  }), 64))
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showProfileDrawer.value = !showProfileDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show", "height"])
      ]);
    };
  }
});
var Profile = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["__scopeId", "data-v-146935c7"]]);
var SettingsMenu_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$V = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$S = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$L = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$u = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$n = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$k = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$e = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$b = { class: "w-full col-span-8" };
const _hoisted_9$9 = ["onClick"];
const _hoisted_10$6 = { class: "flex items-center justify-center col-span-1 w-10 h-10 bg-clientportal-liteBackground" };
const _hoisted_11$6 = { class: "col-span-6" };
const _sfc_main$$ = defineComponent({
  __name: "SettingsMenu",
  setup(__props) {
    var _a2, _b;
    const boxRef = ref(null);
    const routerInstance2 = AppState.getRouterInstance();
    const isSecure = ref(false);
    const settingsOptions = [
      {
        title: "Edit profile",
        description: "Manage your group details here",
        icon: render$d,
        path: "EditProfile",
        isVisible: true
      },
      {
        title: "Billing & subscription",
        description: "Manage subscriptions, invoices & transactions",
        icon: render$e,
        path: "BillingSubscription",
        isVisible: ((_b = (_a2 = LocationState.state) == null ? void 0 : _a2.locationPermissions) == null ? void 0 : _b.subscriptionsEnabled) !== false
      }
    ];
    const menuOptionsFilter = computed(() => {
      return settingsOptions.filter((card) => card.isVisible);
    });
    onBeforeMount(async () => {
      await UserState.getUserDetails();
      isSecure.value = await isTokenExpired();
    });
    async function isTokenExpired() {
      var _a3;
      const expiryDate = await ((_a3 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a3.billingTokenExpiry);
      if (!expiryDate) {
        return true;
      }
      return Date.now() - new Date(expiryDate).getTime() > 0;
    }
    const handleRoutes = (queryValue) => {
      if (isSecure.value && queryValue === "BillingSubscription") {
        queryValue = "AuthPage";
      }
      const currentPath = window.location.pathname;
      if (routerInstance2) {
        routerInstance2.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$V, [
        createElementVNode("div", _hoisted_2$S, [
          createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$L, [
                createElementVNode("div", _hoisted_4$u, [
                  createElementVNode("div", _hoisted_5$n, [
                    createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = () => {
                        if (unref(routerInstance2)) {
                          unref(routerInstance2).push("Profile");
                        }
                      }),
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$k, [
                    createElementVNode("div", _hoisted_7$e, [
                      createVNode(unref(p$2), { class: "text-fontPrimary" }, {
                        default: withCtx(() => [
                          createTextVNode(" Settings ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", {
          ref_key: "boxRef",
          ref: boxRef,
          class: "mt-[50px] py-6 grid grid-cols-8 row-span-1 px-4"
        }, [
          createVNode(unref(T), {
            ref: "loadingRef",
            to: boxRef.value
          }, null, 8, ["to"]),
          createElementVNode("div", _hoisted_8$b, [
            createVNode(unref(p), { class: "text-clientportal-font-primary" }, {
              default: withCtx(() => [
                createTextVNode("Settings")
              ]),
              _: 1
            }),
            (openBlock(true), createElementBlock(Fragment, null, renderList(menuOptionsFilter.value, (option) => {
              return openBlock(), createElementBlock("div", {
                key: option.title
              }, [
                createElementVNode("div", {
                  class: "mt-4 grid items-center gap-2 grid-cols-8",
                  onClick: ($event) => handleRoutes(option.path)
                }, [
                  createElementVNode("div", _hoisted_10$6, [
                    (openBlock(), createBlock(resolveDynamicComponent(option.icon), { class: "w-5 h-5" }))
                  ]),
                  createElementVNode("div", _hoisted_11$6, [
                    createVNode(unref(d), { class: "text-clientportal-font-primary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(option.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(unref(p$3), { class: "text-clientportal-font-secondary" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(option.description), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  createVNode(unref(render$f), { class: "col-span-1 w-6 h-6 text-clientportal-font-secondary" })
                ], 8, _hoisted_9$9)
              ]);
            }), 128))
          ])
        ], 512)
      ]);
    };
  }
});
var SettingsMenu = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["__scopeId", "data-v-ce5fa218"]]);
const currency = {
  USD: {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars"
  },
  CAD: {
    symbol: "CA$",
    name: "Canadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "CAD",
    name_plural: "Canadian dollars"
  },
  EUR: {
    symbol: "\u20AC",
    name: "Euro",
    symbol_native: "\u20AC",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros"
  },
  AED: {
    symbol: "AED",
    name: "United Arab Emirates Dirham",
    symbol_native: "\u062F.\u0625.",
    decimal_digits: 2,
    rounding: 0,
    code: "AED",
    name_plural: "UAE dirhams"
  },
  AFN: {
    symbol: "Af",
    name: "Afghan Afghani",
    symbol_native: "\u060B",
    decimal_digits: 0,
    rounding: 0,
    code: "AFN",
    name_plural: "Afghan Afghanis"
  },
  ALL: {
    symbol: "ALL",
    name: "Albanian Lek",
    symbol_native: "Lek",
    decimal_digits: 0,
    rounding: 0,
    code: "ALL",
    name_plural: "Albanian lek\xEB"
  },
  AMD: {
    symbol: "AMD",
    name: "Armenian Dram",
    symbol_native: "\u0564\u0580.",
    decimal_digits: 0,
    rounding: 0,
    code: "AMD",
    name_plural: "Armenian drams"
  },
  ARS: {
    symbol: "AR$",
    name: "Argentine Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "ARS",
    name_plural: "Argentine pesos"
  },
  AUD: {
    symbol: "AU$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars"
  },
  AZN: {
    symbol: "man.",
    name: "Azerbaijani Manat",
    symbol_native: "\u043C\u0430\u043D.",
    decimal_digits: 2,
    rounding: 0,
    code: "AZN",
    name_plural: "Azerbaijani manats"
  },
  BAM: {
    symbol: "KM",
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol_native: "KM",
    decimal_digits: 2,
    rounding: 0,
    code: "BAM",
    name_plural: "Bosnia-Herzegovina convertible marks"
  },
  BBD: {
    symbol: "Bds$",
    name: "Barbados Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BBD",
    name_plural: "Barbados dollars"
  },
  BDT: {
    symbol: "Tk",
    name: "Bangladeshi Taka",
    symbol_native: "\u09F3",
    decimal_digits: 2,
    rounding: 0,
    code: "BDT",
    name_plural: "Bangladeshi takas"
  },
  BGN: {
    symbol: "BGN",
    name: "Bulgarian Lev",
    symbol_native: "\u043B\u0432.",
    decimal_digits: 2,
    rounding: 0,
    code: "BGN",
    name_plural: "Bulgarian leva"
  },
  BHD: {
    symbol: "BD",
    name: "Bahraini Dinar",
    symbol_native: "\u062F.\u0628.",
    decimal_digits: 3,
    rounding: 0,
    code: "BHD",
    name_plural: "Bahraini dinars"
  },
  BIF: {
    symbol: "FBu",
    name: "Burundian Franc",
    symbol_native: "FBu",
    decimal_digits: 0,
    rounding: 0,
    code: "BIF",
    name_plural: "Burundian francs"
  },
  BMD: {
    symbol: "BM$",
    name: "Bermudian Dollar",
    symbol_native: "",
    decimal_digits: 0,
    rounding: 0,
    code: "BMD",
    name_plural: "Bermudian dollars"
  },
  BND: {
    symbol: "BN$",
    name: "Brunei Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BND",
    name_plural: "Brunei dollars"
  },
  BOB: {
    symbol: "Bs",
    name: "Bolivian Boliviano",
    symbol_native: "Bs",
    decimal_digits: 2,
    rounding: 0,
    code: "BOB",
    name_plural: "Bolivian bolivianos"
  },
  BRL: {
    symbol: "R$",
    name: "Brazilian Real",
    symbol_native: "R$",
    decimal_digits: 2,
    rounding: 0,
    code: "BRL",
    name_plural: "Brazilian reals"
  },
  BWP: {
    symbol: "BWP",
    name: "Botswanan Pula",
    symbol_native: "P",
    decimal_digits: 2,
    rounding: 0,
    code: "BWP",
    name_plural: "Botswanan pulas"
  },
  BYR: {
    symbol: "BYR",
    name: "Belarusian Ruble",
    symbol_native: "BYR",
    decimal_digits: 0,
    rounding: 0,
    code: "BYR",
    name_plural: "Belarusian rubles"
  },
  BZD: {
    symbol: "BZ$",
    name: "Belize Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BZD",
    name_plural: "Belize dollars"
  },
  CDF: {
    symbol: "CDF",
    name: "Congolese Franc",
    symbol_native: "FrCD",
    decimal_digits: 2,
    rounding: 0,
    code: "CDF",
    name_plural: "Congolese francs"
  },
  CHF: {
    symbol: "CHF",
    name: "Swiss Franc",
    symbol_native: "CHF",
    decimal_digits: 2,
    rounding: 0.05,
    code: "CHF",
    name_plural: "Swiss francs"
  },
  CLP: {
    symbol: "CL$",
    name: "Chilean Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "CLP",
    name_plural: "Chilean pesos"
  },
  CNY: {
    symbol: "CN\xA5",
    name: "Chinese Yuan",
    symbol_native: "CN\xA5",
    decimal_digits: 2,
    rounding: 0,
    code: "CNY",
    name_plural: "Chinese yuan"
  },
  COP: {
    symbol: "CO$",
    name: "Colombian Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "COP",
    name_plural: "Colombian pesos"
  },
  CRC: {
    symbol: "\u20A1",
    name: "Costa Rican Col\xF3n",
    symbol_native: "\u20A1",
    decimal_digits: 0,
    rounding: 0,
    code: "CRC",
    name_plural: "Costa Rican col\xF3ns"
  },
  CVE: {
    symbol: "CV$",
    name: "Cape Verdean Escudo",
    symbol_native: "CV$",
    decimal_digits: 2,
    rounding: 0,
    code: "CVE",
    name_plural: "Cape Verdean escudos"
  },
  CZK: {
    symbol: "K\u010D",
    name: "Czech Republic Koruna",
    symbol_native: "K\u010D",
    decimal_digits: 2,
    rounding: 0,
    code: "CZK",
    name_plural: "Czech Republic korunas"
  },
  DJF: {
    symbol: "Fdj",
    name: "Djiboutian Franc",
    symbol_native: "Fdj",
    decimal_digits: 0,
    rounding: 0,
    code: "DJF",
    name_plural: "Djiboutian francs"
  },
  DKK: {
    symbol: "Dkr",
    name: "Danish Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "DKK",
    name_plural: "Danish kroner"
  },
  DOP: {
    symbol: "RD$",
    name: "Dominican Peso",
    symbol_native: "RD$",
    decimal_digits: 2,
    rounding: 0,
    code: "DOP",
    name_plural: "Dominican pesos"
  },
  DZD: {
    symbol: "DA",
    name: "Algerian Dinar",
    symbol_native: "\u062F.\u062C.",
    decimal_digits: 2,
    rounding: 0,
    code: "DZD",
    name_plural: "Algerian dinars"
  },
  EEK: {
    symbol: "Ekr",
    name: "Estonian Kroon",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "EEK",
    name_plural: "Estonian kroons"
  },
  EGP: {
    symbol: "EGP",
    name: "Egyptian Pound",
    symbol_native: "\u062C.\u0645.",
    decimal_digits: 2,
    rounding: 0,
    code: "EGP",
    name_plural: "Egyptian pounds"
  },
  ERN: {
    symbol: "Nfk",
    name: "Eritrean Nakfa",
    symbol_native: "Nfk",
    decimal_digits: 2,
    rounding: 0,
    code: "ERN",
    name_plural: "Eritrean nakfas"
  },
  ETB: {
    symbol: "Br",
    name: "Ethiopian Birr",
    symbol_native: "Br",
    decimal_digits: 2,
    rounding: 0,
    code: "ETB",
    name_plural: "Ethiopian birrs"
  },
  GBP: {
    symbol: "\xA3",
    name: "British Pound Sterling",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "GBP",
    name_plural: "British pounds sterling"
  },
  GEL: {
    symbol: "GEL",
    name: "Georgian Lari",
    symbol_native: "GEL",
    decimal_digits: 2,
    rounding: 0,
    code: "GEL",
    name_plural: "Georgian laris"
  },
  GHS: {
    symbol: "GH\u20B5",
    name: "Ghanaian Cedi",
    symbol_native: "GH\u20B5",
    decimal_digits: 2,
    rounding: 0,
    code: "GHS",
    name_plural: "Ghanaian cedis"
  },
  GNF: {
    symbol: "FG",
    name: "Guinean Franc",
    symbol_native: "FG",
    decimal_digits: 0,
    rounding: 0,
    code: "GNF",
    name_plural: "Guinean francs"
  },
  GTQ: {
    symbol: "GTQ",
    name: "Guatemalan Quetzal",
    symbol_native: "Q",
    decimal_digits: 2,
    rounding: 0,
    code: "GTQ",
    name_plural: "Guatemalan quetzals"
  },
  HKD: {
    symbol: "HK$",
    name: "Hong Kong Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "HKD",
    name_plural: "Hong Kong dollars"
  },
  HNL: {
    symbol: "HNL",
    name: "Honduran Lempira",
    symbol_native: "L",
    decimal_digits: 2,
    rounding: 0,
    code: "HNL",
    name_plural: "Honduran lempiras"
  },
  HRK: {
    symbol: "kn",
    name: "Croatian Kuna",
    symbol_native: "kn",
    decimal_digits: 2,
    rounding: 0,
    code: "HRK",
    name_plural: "Croatian kunas"
  },
  HUF: {
    symbol: "Ft",
    name: "Hungarian Forint",
    symbol_native: "Ft",
    decimal_digits: 0,
    rounding: 0,
    code: "HUF",
    name_plural: "Hungarian forints"
  },
  IDR: {
    symbol: "Rp",
    name: "Indonesian Rupiah",
    symbol_native: "Rp",
    decimal_digits: 0,
    rounding: 0,
    code: "IDR",
    name_plural: "Indonesian rupiahs"
  },
  ILS: {
    symbol: "\u20AA",
    name: "Israeli New Sheqel",
    symbol_native: "\u20AA",
    decimal_digits: 2,
    rounding: 0,
    code: "ILS",
    name_plural: "Israeli new sheqels"
  },
  INR: {
    symbol: "\u20B9",
    name: "Indian Rupee",
    symbol_native: "\u099F\u0995\u09BE",
    decimal_digits: 2,
    rounding: 0,
    code: "INR",
    name_plural: "Indian rupees"
  },
  IQD: {
    symbol: "IQD",
    name: "Iraqi Dinar",
    symbol_native: "\u062F.\u0639.",
    decimal_digits: 0,
    rounding: 0,
    code: "IQD",
    name_plural: "Iraqi dinars"
  },
  IRR: {
    symbol: "IRR",
    name: "Iranian Rial",
    symbol_native: "\uFDFC",
    decimal_digits: 0,
    rounding: 0,
    code: "IRR",
    name_plural: "Iranian rials"
  },
  ISK: {
    symbol: "Ikr",
    name: "Icelandic Kr\xF3na",
    symbol_native: "kr",
    decimal_digits: 0,
    rounding: 0,
    code: "ISK",
    name_plural: "Icelandic kr\xF3nur"
  },
  JMD: {
    symbol: "J$",
    name: "Jamaican Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "JMD",
    name_plural: "Jamaican dollars"
  },
  JOD: {
    symbol: "JD",
    name: "Jordanian Dinar",
    symbol_native: "\u062F.\u0623.",
    decimal_digits: 3,
    rounding: 0,
    code: "JOD",
    name_plural: "Jordanian dinars"
  },
  JPY: {
    symbol: "\xA5",
    name: "Japanese Yen",
    symbol_native: "\uFFE5",
    decimal_digits: 0,
    rounding: 0,
    code: "JPY",
    name_plural: "Japanese yen"
  },
  KGS: {
    symbol: "som ",
    name: "Kyrgyzstani som",
    symbol_native: "som",
    decimal_digits: 2,
    rounding: 0,
    code: "KGS",
    name_plural: "Kyrgyzstani som"
  },
  KES: {
    symbol: "Ksh",
    name: "Kenyan Shilling",
    symbol_native: "Ksh",
    decimal_digits: 2,
    rounding: 0,
    code: "KES",
    name_plural: "Kenyan shillings"
  },
  KHR: {
    symbol: "KHR",
    name: "Cambodian Riel",
    symbol_native: "\u17DB",
    decimal_digits: 2,
    rounding: 0,
    code: "KHR",
    name_plural: "Cambodian riels"
  },
  KMF: {
    symbol: "CF",
    name: "Comorian Franc",
    symbol_native: "FC",
    decimal_digits: 0,
    rounding: 0,
    code: "KMF",
    name_plural: "Comorian francs"
  },
  KRW: {
    symbol: "\u20A9",
    name: "South Korean Won",
    symbol_native: "\u20A9",
    decimal_digits: 0,
    rounding: 0,
    code: "KRW",
    name_plural: "South Korean won"
  },
  KWD: {
    symbol: "KD",
    name: "Kuwaiti Dinar",
    symbol_native: "\u062F.\u0643.",
    decimal_digits: 3,
    rounding: 0,
    code: "KWD",
    name_plural: "Kuwaiti dinars"
  },
  KZT: {
    symbol: "KZT",
    name: "Kazakhstani Tenge",
    symbol_native: "\u0442\u04A3\u0433.",
    decimal_digits: 2,
    rounding: 0,
    code: "KZT",
    name_plural: "Kazakhstani tenges"
  },
  LBP: {
    symbol: "LB\xA3",
    name: "Lebanese Pound",
    symbol_native: "\u0644.\u0644.",
    decimal_digits: 0,
    rounding: 0,
    code: "LBP",
    name_plural: "Lebanese pounds"
  },
  LKR: {
    symbol: "SLRs",
    name: "Sri Lankan Rupee",
    symbol_native: "SL Re",
    decimal_digits: 2,
    rounding: 0,
    code: "LKR",
    name_plural: "Sri Lankan rupees"
  },
  LTL: {
    symbol: "Lt",
    name: "Lithuanian Litas",
    symbol_native: "Lt",
    decimal_digits: 2,
    rounding: 0,
    code: "LTL",
    name_plural: "Lithuanian litai"
  },
  LVL: {
    symbol: "Ls",
    name: "Latvian Lats",
    symbol_native: "Ls",
    decimal_digits: 2,
    rounding: 0,
    code: "LVL",
    name_plural: "Latvian lati"
  },
  LYD: {
    symbol: "LD",
    name: "Libyan Dinar",
    symbol_native: "\u062F.\u0644.",
    decimal_digits: 3,
    rounding: 0,
    code: "LYD",
    name_plural: "Libyan dinars"
  },
  MAD: {
    symbol: "MAD",
    name: "Moroccan Dirham",
    symbol_native: "\u062F.\u0645.",
    decimal_digits: 2,
    rounding: 0,
    code: "MAD",
    name_plural: "Moroccan dirhams"
  },
  MDL: {
    symbol: "MDL",
    name: "Moldovan Leu",
    symbol_native: "MDL",
    decimal_digits: 2,
    rounding: 0,
    code: "MDL",
    name_plural: "Moldovan lei"
  },
  MGA: {
    symbol: "MGA",
    name: "Malagasy Ariary",
    symbol_native: "MGA",
    decimal_digits: 0,
    rounding: 0,
    code: "MGA",
    name_plural: "Malagasy Ariaries"
  },
  MKD: {
    symbol: "MKD",
    name: "Macedonian Denar",
    symbol_native: "MKD",
    decimal_digits: 2,
    rounding: 0,
    code: "MKD",
    name_plural: "Macedonian denari"
  },
  MMK: {
    symbol: "MMK",
    name: "Myanma Kyat",
    symbol_native: "K",
    decimal_digits: 0,
    rounding: 0,
    code: "MMK",
    name_plural: "Myanma kyats"
  },
  MOP: {
    symbol: "MOP$",
    name: "Macanese Pataca",
    symbol_native: "MOP$",
    decimal_digits: 2,
    rounding: 0,
    code: "MOP",
    name_plural: "Macanese patacas"
  },
  MUR: {
    symbol: "MURs",
    name: "Mauritian Rupee",
    symbol_native: "MURs",
    decimal_digits: 0,
    rounding: 0,
    code: "MUR",
    name_plural: "Mauritian rupees"
  },
  MXN: {
    symbol: "MX$",
    name: "Mexican Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "MXN",
    name_plural: "Mexican pesos"
  },
  MYR: {
    symbol: "RM",
    name: "Malaysian Ringgit",
    symbol_native: "RM",
    decimal_digits: 2,
    rounding: 0,
    code: "MYR",
    name_plural: "Malaysian ringgits"
  },
  MZN: {
    symbol: "MTn",
    name: "Mozambican Metical",
    symbol_native: "MTn",
    decimal_digits: 2,
    rounding: 0,
    code: "MZN",
    name_plural: "Mozambican meticals"
  },
  NAD: {
    symbol: "N$",
    name: "Namibian Dollar",
    symbol_native: "N$",
    decimal_digits: 2,
    rounding: 0,
    code: "NAD",
    name_plural: "Namibian dollars"
  },
  NGN: {
    symbol: "\u20A6",
    name: "Nigerian Naira",
    symbol_native: "\u20A6",
    decimal_digits: 2,
    rounding: 0,
    code: "NGN",
    name_plural: "Nigerian nairas"
  },
  NIO: {
    symbol: "C$",
    name: "Nicaraguan C\xF3rdoba",
    symbol_native: "C$",
    decimal_digits: 2,
    rounding: 0,
    code: "NIO",
    name_plural: "Nicaraguan c\xF3rdobas"
  },
  NOK: {
    symbol: "Nkr",
    name: "Norwegian Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "NOK",
    name_plural: "Norwegian kroner"
  },
  NPR: {
    symbol: "NPRs",
    name: "Nepalese Rupee",
    symbol_native: "\u0928\u0947\u0930\u0942",
    decimal_digits: 2,
    rounding: 0,
    code: "NPR",
    name_plural: "Nepalese rupees"
  },
  NZD: {
    symbol: "NZ$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars"
  },
  OMR: {
    symbol: "OMR",
    name: "Omani Rial",
    symbol_native: "\u0631.\u0639.",
    decimal_digits: 3,
    rounding: 0,
    code: "OMR",
    name_plural: "Omani rials"
  },
  PAB: {
    symbol: "B/.",
    name: "Panamanian Balboa",
    symbol_native: "B/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PAB",
    name_plural: "Panamanian balboas"
  },
  PEN: {
    symbol: "S/.",
    name: "Peruvian Nuevo Sol",
    symbol_native: "S/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PEN",
    name_plural: "Peruvian nuevos soles"
  },
  PHP: {
    symbol: "\u20B1",
    name: "Philippine Peso",
    symbol_native: "\u20B1",
    decimal_digits: 2,
    rounding: 0,
    code: "PHP",
    name_plural: "Philippine pesos"
  },
  PKR: {
    symbol: "PKRs",
    name: "Pakistani Rupee",
    symbol_native: "\u20A8",
    decimal_digits: 0,
    rounding: 0,
    code: "PKR",
    name_plural: "Pakistani rupees"
  },
  PLN: {
    symbol: "z\u0142",
    name: "Polish Zloty",
    symbol_native: "z\u0142",
    decimal_digits: 2,
    rounding: 0,
    code: "PLN",
    name_plural: "Polish zlotys"
  },
  PYG: {
    symbol: "\u20B2",
    name: "Paraguayan Guarani",
    symbol_native: "\u20B2",
    decimal_digits: 0,
    rounding: 0,
    code: "PYG",
    name_plural: "Paraguayan guaranis"
  },
  QAR: {
    symbol: "QR",
    name: "Qatari Rial",
    symbol_native: "\u0631.\u0642.",
    decimal_digits: 2,
    rounding: 0,
    code: "QAR",
    name_plural: "Qatari rials"
  },
  RON: {
    symbol: "RON",
    name: "Romanian Leu",
    symbol_native: "RON",
    decimal_digits: 2,
    rounding: 0,
    code: "RON",
    name_plural: "Romanian lei"
  },
  RSD: {
    symbol: "din.",
    name: "Serbian Dinar",
    symbol_native: "\u0434\u0438\u043D.",
    decimal_digits: 0,
    rounding: 0,
    code: "RSD",
    name_plural: "Serbian dinars"
  },
  RUB: {
    symbol: "RUB",
    name: "Russian Ruble",
    symbol_native: "\u0440\u0443\u0431.",
    decimal_digits: 2,
    rounding: 0,
    code: "RUB",
    name_plural: "Russian rubles"
  },
  RWF: {
    symbol: "RWF",
    name: "Rwandan Franc",
    symbol_native: "FR",
    decimal_digits: 0,
    rounding: 0,
    code: "RWF",
    name_plural: "Rwandan francs"
  },
  SAR: {
    symbol: "SR",
    name: "Saudi Riyal",
    symbol_native: "\u0631.\u0633.",
    decimal_digits: 2,
    rounding: 0,
    code: "SAR",
    name_plural: "Saudi riyals"
  },
  SDG: {
    symbol: "SDG",
    name: "Sudanese Pound",
    symbol_native: "SDG",
    decimal_digits: 2,
    rounding: 0,
    code: "SDG",
    name_plural: "Sudanese pounds"
  },
  SEK: {
    symbol: "kr",
    name: "Swedish Krona",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "SEK",
    name_plural: "Swedish kronor"
  },
  SGD: {
    symbol: "S$",
    name: "Singapore Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SGD",
    name_plural: "Singapore dollars"
  },
  SOS: {
    symbol: "Ssh",
    name: "Somali Shilling",
    symbol_native: "Ssh",
    decimal_digits: 0,
    rounding: 0,
    code: "SOS",
    name_plural: "Somali shillings"
  },
  SRD: {
    symbol: "Sr$",
    name: "Surinamese Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SRD",
    name_plural: "Surinamese dollars"
  },
  SYP: {
    symbol: "SY\xA3",
    name: "Syrian Pound",
    symbol_native: "\u0644.\u0633.",
    decimal_digits: 0,
    rounding: 0,
    code: "SYP",
    name_plural: "Syrian pounds"
  },
  THB: {
    symbol: "\u0E3F",
    name: "Thai Baht",
    symbol_native: "\u0E3F",
    decimal_digits: 2,
    rounding: 0,
    code: "THB",
    name_plural: "Thai baht"
  },
  TND: {
    symbol: "DT",
    name: "Tunisian Dinar",
    symbol_native: "\u062F.\u062A.",
    decimal_digits: 3,
    rounding: 0,
    code: "TND",
    name_plural: "Tunisian dinars"
  },
  TOP: {
    symbol: "T$",
    name: "Tongan Pa\u02BBanga",
    symbol_native: "T$",
    decimal_digits: 2,
    rounding: 0,
    code: "TOP",
    name_plural: "Tongan pa\u02BBanga"
  },
  TRY: {
    symbol: "TL",
    name: "Turkish Lira",
    symbol_native: "TL",
    decimal_digits: 2,
    rounding: 0,
    code: "TRY",
    name_plural: "Turkish Lira"
  },
  TTD: {
    symbol: "TT$",
    name: "Trinidad and Tobago Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "TTD",
    name_plural: "Trinidad and Tobago dollars"
  },
  TWD: {
    symbol: "NT$",
    name: "New Taiwan Dollar",
    symbol_native: "NT$",
    decimal_digits: 2,
    rounding: 0,
    code: "TWD",
    name_plural: "New Taiwan dollars"
  },
  TZS: {
    symbol: "TSh",
    name: "Tanzanian Shilling",
    symbol_native: "TSh",
    decimal_digits: 0,
    rounding: 0,
    code: "TZS",
    name_plural: "Tanzanian shillings"
  },
  UAH: {
    symbol: "\u20B4",
    name: "Ukrainian Hryvnia",
    symbol_native: "\u20B4",
    decimal_digits: 2,
    rounding: 0,
    code: "UAH",
    name_plural: "Ukrainian hryvnias"
  },
  UGX: {
    symbol: "USh",
    name: "Ugandan Shilling",
    symbol_native: "USh",
    decimal_digits: 0,
    rounding: 0,
    code: "UGX",
    name_plural: "Ugandan shillings"
  },
  UYU: {
    symbol: "$U",
    name: "Uruguayan Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "UYU",
    name_plural: "Uruguayan pesos"
  },
  UZS: {
    symbol: "UZS",
    name: "Uzbekistan Som",
    symbol_native: "UZS",
    decimal_digits: 0,
    rounding: 0,
    code: "UZS",
    name_plural: "Uzbekistan som"
  },
  VEF: {
    symbol: "Bs.F.",
    name: "Venezuelan Bol\xEDvar",
    symbol_native: "Bs.F.",
    decimal_digits: 2,
    rounding: 0,
    code: "VEF",
    name_plural: "Venezuelan bol\xEDvars"
  },
  VND: {
    symbol: "\u20AB",
    name: "Vietnamese Dong",
    symbol_native: "\u20AB",
    decimal_digits: 0,
    rounding: 0,
    code: "VND",
    name_plural: "Vietnamese dong"
  },
  VUV: {
    symbol: "VT",
    name: "Vatu",
    symbol_native: "VT",
    decimal_digits: 0,
    rounding: 0,
    code: "VUV",
    name_plural: "Vatu"
  },
  XAF: {
    symbol: "FCFA",
    name: "CFA Franc BEAC",
    symbol_native: "FCFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XAF",
    name_plural: "CFA francs BEAC"
  },
  XCD: {
    symbol: "EC$",
    name: "East Caribbean Dollar",
    symbol_native: "EC$",
    decimal_digits: 0,
    rounding: 0,
    code: "XCD",
    name_plural: "East caribbean dollars"
  },
  XOF: {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO"
  },
  YER: {
    symbol: "YR",
    name: "Yemeni Rial",
    symbol_native: "\u0631.\u064A.",
    decimal_digits: 0,
    rounding: 0,
    code: "YER",
    name_plural: "Yemeni rials"
  },
  ZAR: {
    symbol: "R",
    name: "South African Rand",
    symbol_native: "R",
    decimal_digits: 2,
    rounding: 0,
    code: "ZAR",
    name_plural: "South African rand"
  },
  ZMK: {
    symbol: "ZK",
    name: "Zambian Kwacha",
    symbol_native: "ZK",
    decimal_digits: 0,
    rounding: 0,
    code: "ZMK",
    name_plural: "Zambian kwachas"
  }
};
const currencyCode = {
  US: "USD",
  CA: "CAD",
  DE: "EUR",
  AU: "AUD",
  GB: "GBP",
  KE: "KES",
  IE: "EUR",
  PH: "PHP",
  IT: "EUR",
  HK: "HKD",
  AF: "AFN",
  AX: "EUR",
  AL: "ALL",
  DZ: "DZD",
  AS: "USD",
  AD: "EUR",
  AO: "AOA",
  AI: "USD",
  AQ: "USD",
  AG: "USD",
  AR: "USD",
  AM: "AMD",
  AW: "AWG",
  AT: "EUR",
  AZ: "AZN",
  BS: "USD",
  BD: "BDT",
  BB: "BBD",
  BE: "EUR",
  BZ: "BZD",
  BJ: "XOF",
  BM: "BMD",
  BT: "INR",
  BO: "BOB",
  BA: "BAM",
  BW: "BWP",
  BV: "NOK",
  BR: "BRL",
  IO: "USD",
  BN: "BND",
  BG: "BGN",
  BF: "XOF",
  BI: "BIF",
  KH: "KHR",
  CM: "XAF",
  CV: "CVE",
  KY: "KYD",
  CF: "XAF",
  TD: "XAF",
  CL: "CLP",
  CN: "CNY",
  CX: "AUD",
  CC: "AUD",
  CO: "COP",
  KM: "KMF",
  CG: "XAF",
  CD: "CDF",
  CK: "NZD",
  CR: "CRC",
  CI: "XOF",
  HR: "EUR",
  CY: "EUR",
  CZ: "CZK",
  DK: "DKK",
  DJ: "DJF",
  DM: "XCD",
  DO: "DOP",
  EC: "USD",
  EG: "EGP",
  SV: "USD",
  GQ: "XAF",
  EE: "EUR",
  ET: "ETB",
  FK: "FKP",
  FO: "DKK",
  FJ: "FJD",
  FI: "EUR",
  FR: "EUR",
  GF: "EUR",
  PF: "XPF",
  TF: "EUR",
  GA: "GEL",
  GM: "GMD",
  GE: "GEL",
  GI: "GIP",
  GR: "EUR",
  GL: "DKK",
  GD: "XCD",
  GP: "EUR",
  GU: "EUR",
  GT: "GTQ",
  GG: "GBP",
  GN: "GNF",
  GW: "XOF",
  GY: "GYD",
  HT: "HTG",
  HM: "AUD",
  HN: "HNL",
  HU: "HUF",
  IS: "ISK",
  IN: "INR",
  ID: "IDR",
  IM: "GBP",
  IL: "ILS",
  JD: "JOD",
  JM: "JMD",
  JP: "JPY",
  JE: "GBP",
  KZ: "KZT",
  KI: "AUD",
  KR: "KRW",
  KG: "KGS",
  LA: "LAK",
  LV: "EUR",
  LB: "LBP",
  LS: "LSL",
  LR: "LRD",
  LI: "CHF",
  LT: "EUR",
  LU: "EUR",
  MO: "MOP",
  MK: "MKD",
  MG: "MGA",
  MW: "MWK",
  MY: "MYR",
  MV: "MVR.",
  ML: "XOF",
  MT: "EUR",
  MH: "USD",
  MQ: "EUR",
  MU: "MUR",
  YT: "EUR",
  MX: "MXN",
  FM: "USD",
  MD: "MDL",
  MC: "EUR",
  MN: "MNT",
  ME: "EUR",
  MS: "XCD",
  MA: "MAD",
  MZ: "MZN",
  MM: "MMK",
  NA: "NAD",
  NR: "AUD",
  NP: "NPR",
  NL: "EUR",
  AN: "ANG",
  NC: "XPF",
  NZ: "NZD",
  NI: "NIO",
  NE: "XOF",
  NG: "NGN",
  NU: "NZD",
  NF: "AUD",
  MP: "USD",
  NO: "NOK",
  PK: "PKR",
  PW: "USD",
  PA: "PAB",
  PG: "PGK",
  PY: "PYG",
  PE: "PEN",
  PN: "NZD",
  PL: "PLN",
  PT: "EUR",
  PR: "USD",
  QA: "QAR",
  RE: "EUR",
  RO: "RON",
  RU: "RUB",
  RW: "RWF",
  SH: "SHP",
  KN: "XCD",
  LC: "XCD",
  PM: "EUR",
  VC: "XCD",
  WS: "WST",
  SM: "EUR",
  SA: "SAR",
  SN: "XOF",
  RS: "RSD",
  SC: "SCR",
  SL: "SLL",
  SG: "SGD",
  SK: "EUR",
  SI: "EUR",
  SB: "SBD",
  SO: "SOS",
  ZA: "ZAR",
  ES: "EUR",
  LK: "LKR",
  SD: "SDG",
  SR: "SRD",
  SJ: "NOK",
  SZ: "SZL",
  SE: "SEK",
  CH: "CHF",
  SY: "SYP",
  TW: "TWD",
  TJ: "TJS",
  TZ: "TZS",
  TH: "THB",
  TL: "USD",
  TG: "XOF",
  TK: "NZD",
  TO: "TOP",
  TT: "TTD",
  TR: "TRY",
  TC: "USD",
  TV: "AUD",
  UG: "UGX",
  UA: "UAH",
  AE: "AED",
  UM: "USD",
  UY: "UYU",
  UZ: "UZS",
  VU: "VUV",
  VN: "VND",
  VG: "USD",
  VI: "USD",
  WF: "XPF",
  EH: "MAD",
  YE: "YER",
  ZM: "ZMW",
  KD: "KWD"
};
const getCurrencySymbol = (countryCode) => {
  if (!countryCode)
    return "";
  return currency[countryCode].symbol || "";
};
const StripeMinimumChargeAmount = {
  USD: 1,
  AED: 2,
  AUD: 1,
  BGN: 1,
  BRL: 1,
  CAD: 1,
  CHF: 1,
  CZK: 15,
  DKK: 2.5,
  EUR: 1,
  GBP: 1,
  HKD: 4,
  HRK: 5,
  HUF: 175,
  INR: 1,
  JPY: 50,
  MXN: 10,
  MYR: 2,
  NOK: 3,
  NZD: 1,
  PLN: 2,
  RON: 2,
  SEK: 3,
  SGD: 1,
  THB: 10,
  ILS: 3,
  PHP: 50,
  ZAR: 10,
  PKR: 150,
  NPR: 100,
  TWD: 20,
  VUV: 70,
  JOD: 0.5,
  IDR: 1e4
};
function getStatusType(status) {
  switch (status) {
    case "paid":
      return "success";
    case "active":
      return "success";
    case "succeeded":
      return "success";
    case "pending":
      return "warning";
    case "processing":
      return "info";
    case "trialing":
      return "info";
    case "payment_processing":
      return "info";
    case "partially_paid":
      return "warning";
    case "unpaid":
      return "warning";
    case "canceled":
      return "warning";
    case "incomplete_expired":
      return "error";
    case "incomplete":
      return "error";
    case "past_due":
      return "error";
    case "failed":
      return "error";
    default:
      return "default";
  }
}
const statusSubscriptions = [
  {
    id: "all",
    value: "all",
    title: "All"
  },
  {
    id: "active",
    value: "active",
    title: "Active"
  },
  {
    id: "trialing",
    value: "trialing",
    title: "Trial"
  },
  {
    id: "unpaid",
    value: "unpaid",
    title: "Unpaid"
  },
  {
    id: "incomplete_expired",
    value: "incomplete_expired",
    title: "Failed"
  },
  {
    id: "canceled",
    value: "canceled",
    title: "Canceled"
  },
  {
    id: "incomplete",
    value: "incomplete",
    title: "Incomplete"
  }
];
const statusInvoices = [
  {
    id: "all",
    value: "all",
    title: "All"
  },
  {
    id: "draft",
    value: "draft",
    title: "Draft"
  },
  {
    id: "sent",
    value: "sent",
    title: "Sent"
  },
  {
    id: "paid",
    value: "paid",
    title: "Paid"
  },
  {
    id: "paymentProcessing",
    value: "paymentProcessing",
    title: "Payment Processing"
  },
  {
    id: "partiallyPaid",
    value: "partiallyPaid",
    title: "Partially Paid"
  },
  {
    id: "overdue",
    value: "overdue",
    title: "Overdue"
  }
];
const statusTransactions = [
  {
    id: "all",
    value: "all",
    title: "All"
  },
  {
    id: "succeeded",
    value: "succeeded",
    title: "Succeeded"
  },
  {
    id: "processing",
    value: "processing",
    title: "Processing"
  },
  {
    id: "refunded",
    value: "refunded",
    title: "Refunded"
  },
  {
    id: "failed",
    value: "failed",
    title: "Failed"
  },
  {
    id: "pending",
    value: "pending",
    title: "Pending"
  }
];
const sourceType = [
  {
    id: "all",
    value: "all",
    title: "All"
  },
  {
    id: "communities",
    value: "communities",
    title: "Communities"
  },
  {
    id: "membership",
    value: "membership",
    title: "Membership"
  }
];
var InvoiceTable_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$U = {
  key: 0,
  class: "flex items-center justify-center flex-col mt-4"
};
const _hoisted_2$R = ["src"];
const _hoisted_3$K = ["onClick"];
const _hoisted_4$t = { class: "flex justify-between" };
const _hoisted_5$m = { class: "flex justify-between mt-8" };
const _hoisted_6$j = { class: "flex" };
const _hoisted_7$d = { class: "ml-3" };
const _sfc_main$_ = defineComponent({
  __name: "InvoiceTable",
  props: {
    invoiceData: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const handleInvoice = async (id) => {
      var _a2;
      const link = await BillingService.getInvoiceById({
        locationId: LocationState.state.locationId,
        invoiceId: id,
        type: "invoice"
      });
      await Browser.open({ url: (_a2 = link == null ? void 0 : link.data) == null ? void 0 : _a2.url });
    };
    function formatDate(dateString) {
      return hooks(dateString).tz("UTC").format("DD/MM/YYYY");
    }
    return (_ctx, _cache) => {
      return props.invoiceData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1$U, [
        createElementVNode("img", {
          src: unref(LANDING_PAGE_IMAGE),
          alt: "arrow"
        }, null, 8, _hoisted_2$R),
        createVNode(unref(p), { class: "text-clientportal-font-primary font-sans" }, {
          default: withCtx(() => [
            createTextVNode("No Data Found")
          ]),
          _: 1
        })
      ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(props.invoiceData, (invoice) => {
        return openBlock(), createElementBlock("div", {
          key: invoice._id,
          onClick: ($event) => handleInvoice(invoice._id),
          class: "col-span-8 p-6 my-2 rounded-xl bg-clientportal-liteBackground"
        }, [
          createElementVNode("div", _hoisted_4$t, [
            createElementVNode("div", null, [
              createVNode(unref(p), { class: "text-clientportal-font-primary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(invoice.name), 1)
                ]),
                _: 2
              }, 1024),
              createVNode(unref(p$3), { class: "text-clientportal-font-secondary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode("Invoice No. : " + toDisplayString(invoice.invoiceNumber), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref($$1), {
              type: unref(getStatusType)(invoice.status),
              closable: false,
              size: "medium",
              round: true,
              bordered: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)(invoice.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          createElementVNode("div", _hoisted_5$m, [
            createElementVNode("div", _hoisted_6$j, [
              createElementVNode("div", null, [
                createVNode(unref(d), { class: "text-clientportal-font-secondary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode("Issue Date")
                  ]),
                  _: 1
                }),
                createVNode(unref(p$3), { class: "text-clientportal-font-primary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(formatDate(invoice.issueDate)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              createElementVNode("div", _hoisted_7$d, [
                createVNode(unref(d), { class: "text-clientportal-font-secondary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode("Due Date")
                  ]),
                  _: 1
                }),
                createVNode(unref(p$3), { class: "text-clientportal-font-primary font-sans" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(formatDate(invoice.dueDate)), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            createVNode(unref(p$2), { class: "text-clientportal-font-primary font-sans text-left mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(getCurrencySymbol)((invoice == null ? void 0 : invoice.currency.toUpperCase()) || "USD")) + " " + toDisplayString(invoice.total), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ], 8, _hoisted_3$K);
      }), 128));
    };
  }
});
var InvoiceTable = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["__scopeId", "data-v-5dd716f1"]]);
var TransactionTable_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$a = (n) => (pushScopeId("data-v-01ded30a"), n = n(), popScopeId(), n);
const _hoisted_1$T = {
  key: 0,
  class: "flex items-center justify-center flex-col mt-4"
};
const _hoisted_2$Q = ["src"];
const _hoisted_3$J = ["onClick"];
const _hoisted_4$s = { class: "flex justify-between" };
const _hoisted_5$l = /* @__PURE__ */ _withScopeId$a(() => /* @__PURE__ */ createElementVNode("span", { class: "text-clientportal-font-secondary font-sans" }, "Tid : ", -1));
const _hoisted_6$i = { class: "text-clientportal-font-primary font-sans" };
const _hoisted_7$c = { class: "flex justify-between mt-8" };
const _hoisted_8$a = { class: "flex items-center" };
const _sfc_main$Z = defineComponent({
  __name: "TransactionTable",
  props: {
    transactionData: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const props = __props;
    const handleRoutes = (queryValue, id) => {
      AppState.state.billingId = id;
      AppState.state.isSubscription = false;
      const currentPath = window.location.pathname;
      if (routerInstance2) {
        routerInstance2.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    function formatDate(dateString) {
      return hooks(dateString).tz("UTC").format("DD/MM/YYYY");
    }
    return (_ctx, _cache) => {
      return props.transactionData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1$T, [
        createElementVNode("img", {
          src: unref(LANDING_PAGE_IMAGE),
          alt: "arrow"
        }, null, 8, _hoisted_2$Q),
        createVNode(unref(p), { class: "text-clientportal-font-primary font-sans" }, {
          default: withCtx(() => [
            createTextVNode("No Data Found")
          ]),
          _: 1
        })
      ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(props.transactionData, (transaction) => {
        return openBlock(), createElementBlock("div", {
          key: transaction._id,
          onClick: ($event) => handleRoutes("SubscriptionDetail", transaction._id),
          class: "col-span-8 p-6 my-2 rounded-xl bg-clientportal-liteBackground"
        }, [
          createElementVNode("div", _hoisted_4$s, [
            createElementVNode("div", null, [
              createVNode(unref(p), { class: "text-clientportal-font-primary font-sans" }, {
                default: withCtx(() => [
                  _hoisted_5$l,
                  createTextVNode(" " + toDisplayString(transaction._id), 1)
                ]),
                _: 2
              }, 1024),
              createVNode(unref(d), { class: "text-clientportal-font-secondary font-sans truncate max-w-52" }, {
                default: withCtx(() => [
                  createTextVNode("Source Type : "),
                  createElementVNode("span", _hoisted_6$i, toDisplayString(transaction.entitySourceType), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref($$1), {
              type: unref(getStatusType)(transaction.status),
              closable: false,
              size: "medium",
              round: true,
              bordered: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)(transaction.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          createElementVNode("div", _hoisted_7$c, [
            createElementVNode("div", _hoisted_8$a, [
              createVNode(unref(d), { class: "text-clientportal-font-secondary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode("Transaction Date : ")
                ]),
                _: 1
              }),
              createVNode(unref(d), { class: "text-clientportal-font-primary ml-1 font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(formatDate(transaction.updatedAt)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref(p$2), { class: "text-clientportal-font-primary font-sans text-left mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(getCurrencySymbol)((transaction == null ? void 0 : transaction.currency.toUpperCase()) || "USD")) + " " + toDisplayString(transaction.amount), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ], 8, _hoisted_3$J);
      }), 128));
    };
  }
});
var TransactionTable = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["__scopeId", "data-v-01ded30a"]]);
var SubscriptionTable_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$S = {
  key: 0,
  class: "flex items-center justify-center flex-col mt-4"
};
const _hoisted_2$P = ["src"];
const _hoisted_3$I = ["onClick"];
const _hoisted_4$r = { class: "flex justify-between" };
const _hoisted_5$k = { class: "text-clientportal-font-primary font-sans" };
const _hoisted_6$h = { class: "flex justify-between mt-8" };
const _hoisted_7$b = { class: "flex items-center" };
const _sfc_main$Y = defineComponent({
  __name: "SubscriptionTable",
  props: {
    subscriptionData: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const props = __props;
    const handleRoutes = (queryValue, id) => {
      AppState.state.billingId = id;
      AppState.state.isSubscription = true;
      const currentPath = window.location.pathname;
      if (routerInstance2) {
        routerInstance2.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    function formatDate(dateString) {
      return hooks(dateString).tz("UTC").format("DD/MM/YYYY");
    }
    return (_ctx, _cache) => {
      return props.subscriptionData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1$S, [
        createElementVNode("img", {
          src: unref(LANDING_PAGE_IMAGE),
          alt: "arrow"
        }, null, 8, _hoisted_2$P),
        createVNode(unref(p), { class: "text-clientportal-font-primary font-sans" }, {
          default: withCtx(() => [
            createTextVNode("No Data Found")
          ]),
          _: 1
        })
      ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(props.subscriptionData, (subscription) => {
        return openBlock(), createElementBlock("div", {
          key: subscription._id,
          onClick: ($event) => handleRoutes("SubscriptionDetail", subscription._id),
          class: "col-span-8 p-6 my-2 rounded-xl bg-clientportal-liteBackground"
        }, [
          createElementVNode("div", _hoisted_4$r, [
            createElementVNode("div", null, [
              createVNode(unref(p), { class: "text-clientportal-font-primary font-sans truncate max-w-52" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(subscription.entitySourceName), 1)
                ]),
                _: 2
              }, 1024),
              createVNode(unref(d), { class: "text-clientportal-font-secondary font-sans truncate max-w-52" }, {
                default: withCtx(() => [
                  createTextVNode("Source Type : "),
                  createElementVNode("span", _hoisted_5$k, toDisplayString(subscription.entitySourceType), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref($$1), {
              type: unref(getStatusType)(subscription.status),
              closable: false,
              size: "medium",
              round: true,
              bordered: true
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)(subscription.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          createElementVNode("div", _hoisted_6$h, [
            createElementVNode("div", _hoisted_7$b, [
              createVNode(unref(d), { class: "text-clientportal-font-secondary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode("Created : ")
                ]),
                _: 1
              }),
              createVNode(unref(d), { class: "text-clientportal-font-primary ml-1 font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(formatDate(subscription.createdAt)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            createVNode(unref(p$2), { class: "text-clientportal-font-primary font-sans text-left mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(getCurrencySymbol)((subscription == null ? void 0 : subscription.currency.toUpperCase()) || "USD")) + " " + toDisplayString(subscription.amount), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ], 8, _hoisted_3$I);
      }), 128));
    };
  }
});
var SubscriptionTable = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["__scopeId", "data-v-67e00486"]]);
var BillingSubscription_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$9 = (n) => (pushScopeId("data-v-0525da62"), n = n(), popScopeId(), n);
const _hoisted_1$R = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_2$O = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_3$H = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_4$q = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_5$j = { class: "flex items-start justify-start gap-1" };
const _hoisted_6$g = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_7$a = { class: "w-full col-span-8 flex justify-between mb-4" };
const _hoisted_8$9 = { class: "items-center flex" };
const _hoisted_9$8 = { class: "col-span-2 mr-4" };
const _hoisted_10$5 = { class: "col-span-6" };
const _hoisted_11$5 = { class: "col-span-8 row-span-1 mt-4" };
const _hoisted_12$5 = { class: "py-6 px-4" };
const _hoisted_13$4 = { class: "flex justify-between" };
const _hoisted_14$1 = {
  key: 0,
  class: "bg-clientportal-liteBackground my-4 w-[94%] p-4 rounded-lg"
};
const _hoisted_15$1 = { class: "flex items-center justify-between" };
const _hoisted_16$1 = { class: "w-[80%] mr-4 border-solid border-x-0 border-t-0 border-b-1 border-gray-200" };
const _hoisted_17$1 = { class: "w-[80%] mr-4 border-solid border-x-0 border-t-0 border-b-1 border-gray-200" };
const _hoisted_18 = { class: "flex mt-3 mr-4 justify-end" };
const _hoisted_19 = {
  key: 0,
  class: "flex items-center justify-center h-[40vh]"
};
const _hoisted_20 = { key: 1 };
const _hoisted_21 = { class: "flex flex-col" };
const _hoisted_22 = /* @__PURE__ */ _withScopeId$9(() => /* @__PURE__ */ createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1));
const _hoisted_23 = { class: "p-0" };
const _hoisted_24 = { class: "flex justify-between items-center" };
const _sfc_main$X = defineComponent({
  __name: "BillingSubscription",
  setup(__props) {
    const boxRef = ref(null);
    const activeTab = ref("Subscriptions");
    const routerInstance2 = AppState.getRouterInstance();
    const showProfileDrawer = ref(false);
    const filterTitle = ref("");
    const filters = ref({
      checkedValueSubscriptionStatus: "all",
      checkedValueSubscriptionSource: "all",
      checkedValueTransactionStatus: "all",
      checkedValueTransactionSource: "all",
      checkedValueInvoiceStatus: "all",
      startAt: "",
      endAt: ""
    });
    const checkedValue = ref("");
    const drawerOptions = ref([]);
    const isLoading = ref(false);
    const showFilter = ref(false);
    const contactsData = ref();
    const subscriptionData = ref([]);
    const invoiceData = ref([]);
    const currentPageNumber = ref(1);
    const transactionData = ref([]);
    const transactionDataCount = ref(0);
    const subscriptionDataCount = ref(0);
    const invoiceDataCount = ref(0);
    const toDate = ref(null);
    const fromDate = ref(null);
    const originalFiltersOptions = [
      {
        id: "Status",
        title: "Status"
      },
      {
        id: "Source",
        title: "Source"
      },
      {
        id: "Calender",
        title: "Calender"
      }
    ];
    const isFutureDate = (date) => {
      return moment(date).isAfter(moment().format("YYYY-MM-DD"), "day");
    };
    const isDateDisabled = (date) => {
      const minDate = new Date(filters.value.startAt);
      const maxDate = new Date();
      return date < minDate || date > maxDate;
    };
    async function onChangeFrom(value) {
      fromDate.value = value;
      if (value === null) {
        filters.value.startAt = "";
        return;
      } else {
        filters.value.startAt = moment(value).format("YYYY-MM-DD");
      }
    }
    async function onChangeTo(value) {
      toDate.value = value;
      if (value === null) {
        filters.value.endAt = "";
        return;
      } else {
        filters.value.endAt = moment(value).format("YYYY-MM-DD");
      }
    }
    const filtersOptions = ref([...originalFiltersOptions]);
    function updateActiveTab(tab) {
      if (tab === "Invoices") {
        filtersOptions.value = filtersOptions.value.filter((filter) => filter.id !== "Source");
      } else {
        filtersOptions.value = [...originalFiltersOptions];
      }
      currentPageNumber.value = 1;
      activeTab.value = tab;
    }
    onMounted(async () => {
      isLoading.value = true;
      await getContactDetails();
      await getSubscriptionData();
      await getInvoiceData();
      await getTransactionData();
      isLoading.value = false;
    });
    const getContactDetails = async () => {
      const data = await UserService.getContactDetails({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId
      });
      contactsData.value = data.data;
    };
    const getSubscriptionData = async () => {
      const data = await BillingService.getSubscriptions({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId,
        status: filters.value.checkedValueSubscriptionStatus === "all" ? void 0 : filters.value.checkedValueSubscriptionStatus,
        entitySourceType: filters.value.checkedValueSubscriptionSource === "all" ? void 0 : filters.value.checkedValueSubscriptionSource,
        startAt: filters.value.startAt,
        endAt: filters.value.endAt,
        limit: 10,
        offset: (currentPageNumber.value - 1) * 10
      });
      subscriptionData.value = [...subscriptionData.value, ...data.data.data];
      subscriptionDataCount.value = data.data.totalCount;
    };
    const getTransactionData = async () => {
      const data = await BillingService.getTransactions({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId,
        status: filters.value.checkedValueTransactionStatus === "all" ? void 0 : filters.value.checkedValueTransactionStatus,
        entitySourceType: filters.value.checkedValueTransactionSource === "all" ? void 0 : filters.value.checkedValueTransactionSource,
        startAt: filters.value.startAt,
        endAt: filters.value.endAt,
        limit: 10,
        offset: (currentPageNumber.value - 1) * 10
      });
      transactionData.value = [...transactionData.value, ...data.data.data];
      transactionDataCount.value = data.data.totalCount;
    };
    const getInvoiceData = async () => {
      const data = await BillingService.getInvoices({
        contactId: UserState.state.userId,
        locationId: LocationState.state.locationId,
        status: filters.value.checkedValueInvoiceStatus === "all" ? void 0 : filters.value.checkedValueInvoiceStatus,
        startAt: filters.value.startAt,
        endAt: filters.value.endAt,
        limit: 10,
        offset: (currentPageNumber.value - 1) * 10
      });
      invoiceData.value = [...invoiceData.value, ...data.data.invoices];
      invoiceDataCount.value = data.data.total;
    };
    const handleChange = (e) => {
      checkedValue.value = e.target.value;
      if (activeTab.value === "Subscriptions") {
        if (filterTitle.value === "Status") {
          filters.value.checkedValueSubscriptionStatus = e.target.value;
        } else if (filterTitle.value === "Source") {
          filters.value.checkedValueSubscriptionSource = e.target.value;
        }
      } else if (activeTab.value === "Invoices") {
        if (filterTitle.value === "Status") {
          filters.value.checkedValueInvoiceStatus = e.target.value;
        }
      } else if (activeTab.value === "Transactions") {
        if (filterTitle.value === "Status") {
          filters.value.checkedValueTransactionStatus = e.target.value;
        } else if (filterTitle.value === "Source") {
          filters.value.checkedValueTransactionSource = e.target.value;
        }
      }
    };
    const handleRoutes = (queryValue) => {
      const currentPath = window.location.pathname;
      if (routerInstance2) {
        routerInstance2.push({
          path: `${currentPath}`,
          query: { activeScreen: queryValue }
        });
      }
    };
    const handleCheckedData = (value) => {
      if (activeTab.value === "Subscriptions") {
        if (filterTitle.value === "Status") {
          return filters.value.checkedValueSubscriptionStatus === value;
        } else if (filterTitle.value === "Source") {
          return filters.value.checkedValueSubscriptionSource === value;
        }
      } else if (activeTab.value === "Transactions") {
        if (filterTitle.value === "Status") {
          return filters.value.checkedValueTransactionStatus === value;
        } else if (filterTitle.value === "Source") {
          return filters.value.checkedValueTransactionSource === value;
        }
      } else {
        return filters.value.checkedValueInvoiceStatus === value;
      }
    };
    const handleFilters = (filter) => {
      filterTitle.value = filter;
      if (filter === "Status") {
        showProfileDrawer.value = true;
        if (activeTab.value === "Subscriptions") {
          drawerOptions.value = statusSubscriptions;
        } else if (activeTab.value === "Invoices") {
          drawerOptions.value = statusInvoices;
        } else if (activeTab.value === "Transactions") {
          drawerOptions.value = statusTransactions;
        }
      } else if (filter === "Source") {
        showProfileDrawer.value = true;
        if (activeTab.value === "Subscriptions") {
          drawerOptions.value = sourceType;
        } else if (activeTab.value === "Transactions") {
          drawerOptions.value = sourceType;
        }
      } else
        ;
    };
    async function handleScroll(event2) {
      const { scrollTop, scrollHeight, clientHeight } = event2.target;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        currentPageNumber.value += 1;
        if (activeTab.value === "Transactions" && transactionData.value.length !== transactionDataCount.value) {
          await getTransactionData();
        } else if (activeTab.value === "Invoices" && invoiceData.value.length !== invoiceDataCount.value) {
          await getInvoiceData();
        } else if (activeTab.value === "Subscriptions" && subscriptionData.value.length !== subscriptionDataCount.value) {
          await getSubscriptionData();
        }
      }
    }
    const handleApply = async () => {
      currentPageNumber.value = 1;
      if (activeTab.value === "Subscriptions") {
        subscriptionData.value = [];
        await getSubscriptionData();
      } else if (activeTab.value === "Invoices") {
        invoiceData.value = [];
        await getInvoiceData();
      } else if (activeTab.value === "Transactions") {
        transactionData.value = [];
        await getTransactionData();
      }
      showProfileDrawer.value = false;
    };
    const handleClear = async () => {
      filters.value.startAt = "";
      filters.value.endAt = "";
      toDate.value = null;
      fromDate.value = null;
      handleApply();
    };
    const tabs = [
      {
        name: "Subscriptions"
      },
      {
        name: "Invoices"
      },
      {
        name: "Transactions"
      }
    ];
    return (_ctx, _cache) => {
      var _a2;
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          onScroll: handleScroll,
          class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto"
        }, [
          createElementVNode("div", _hoisted_1$R, [
            createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_2$O, [
                  createElementVNode("div", _hoisted_3$H, [
                    createElementVNode("div", _hoisted_4$q, [
                      createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = ($event) => handleRoutes("SettingsMenu")),
                        class: "relative h-6 w-6 cursor-pointer"
                      }, [
                        createVNode(unref(render))
                      ])
                    ]),
                    createElementVNode("div", _hoisted_5$j, [
                      createElementVNode("div", _hoisted_6$g, [
                        createVNode(unref(p$2), { class: "text-fontPrimary" }, {
                          default: withCtx(() => [
                            createTextVNode(" Billing & Subscription ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          createElementVNode("div", {
            ref_key: "boxRef",
            ref: boxRef,
            class: "mt-[50px] py-6 grid grid-cols-8 row-span-1 px-4"
          }, [
            createVNode(unref(T), {
              ref: "loadingRef",
              to: boxRef.value
            }, null, 8, ["to"]),
            createElementVNode("div", _hoisted_7$a, [
              createVNode(unref(p), { class: "text-clientportal-font-primary font-sans font-semibold" }, {
                default: withCtx(() => [
                  createTextVNode("Billing Information")
                ]),
                _: 1
              })
            ]),
            createElementVNode("div", _hoisted_8$9, [
              createElementVNode("div", _hoisted_9$8, [
                createVNode(unref(I$1), {
                  class: "h-20 w-20",
                  size: "large",
                  src: (_a2 = unref(UserState).state) == null ? void 0 : _a2.avatar
                }, null, 8, ["src"])
              ]),
              createElementVNode("div", _hoisted_10$5, [
                createVNode(unref(p$2), { class: "text-clientportal-font-primary font-sans truncate max-w-[70vw]" }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createTextVNode(toDisplayString((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName), 1)
                    ];
                  }),
                  _: 1
                }),
                createVNode(unref(_), { class: "text-clientportal-font-secondary font-sans truncate max-w-[70vw]" }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createTextVNode(toDisplayString((_a3 = unref(UserState).state) == null ? void 0 : _a3.email), 1)
                    ];
                  }),
                  _: 1
                }),
                createVNode(unref(_), { class: "text-clientportal-font-secondary font-sans truncate max-w-[70vw]" }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createTextVNode(toDisplayString(((_a3 = contactsData.value) == null ? void 0 : _a3.phone) || "-"), 1)
                    ];
                  }),
                  _: 1
                })
              ])
            ]),
            createElementVNode("div", _hoisted_11$5, [
              createVNode(unref(_), { class: "text-clientportal-font-primary font-sans" }, {
                default: withCtx(() => [
                  createTextVNode(" Billing Address: ")
                ]),
                _: 1
              }),
              createVNode(unref(_$2), { class: "mt-2 text-clientportal-font-secondary font-sans truncate max-w-[70vw]" }, {
                default: withCtx(() => {
                  var _a3;
                  return [
                    createTextVNode(toDisplayString(((_a3 = contactsData.value) == null ? void 0 : _a3.address1) || "-"), 1)
                  ];
                }),
                _: 1
              })
            ])
          ], 512),
          createVNode(unref(p$1), {
            class: "!my-0 !px-4",
            titlePlacement: "center",
            dashed: false,
            vertical: false
          }),
          createElementVNode("div", _hoisted_12$5, [
            createVNode(unref(g$1), {
              type: "segment",
              animated: true,
              placement: "top",
              "onUpdate:value": updateActiveTab,
              defaultValue: void 0,
              value: activeTab.value,
              justifyContent: "center",
              size: "medium"
            }, {
              default: withCtx(() => [
                (openBlock(), createElementBlock(Fragment, null, renderList(tabs, (tab) => {
                  return createVNode(unref(l), {
                    key: tab.name,
                    name: tab.name,
                    tab: tab.name
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_13$4, [
                        createVNode(unref(p), { class: "text-clientportal-font-primary font-sans mb-5" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(tab.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        createVNode(unref(render$g), {
                          onClick: _cache[1] || (_cache[1] = ($event) => showFilter.value = !showFilter.value),
                          class: "w-6 h-6 text-clientportal-font-secondary"
                        })
                      ]),
                      createVNode(unref(h$1), {
                        class: "mb-2",
                        appear: false,
                        show: showFilter.value
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(filtersOptions.value, (option) => {
                            return openBlock(), createBlock(unref($$1), {
                              key: option.id,
                              class: "ml-2",
                              type: "primary",
                              closable: false,
                              size: "medium",
                              round: true,
                              bordered: true,
                              onClick: ($event) => handleFilters(option.id)
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(option.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]);
                          }), 128)),
                          filterTitle.value === "Calender" ? (openBlock(), createElementBlock("div", _hoisted_14$1, [
                            createElementVNode("div", _hoisted_15$1, [
                              createElementVNode("div", _hoisted_16$1, [
                                createVNode(unref(p$4), {
                                  id: "date-from",
                                  clearable: false,
                                  placeholder: "From",
                                  value: fromDate.value,
                                  class: "max-w-xs",
                                  format: "MMMM d, yyyy",
                                  isDateDisabled: isFutureDate,
                                  "onUpdate:value": onChangeFrom
                                }, null, 8, ["value", "isDateDisabled"])
                              ]),
                              createElementVNode("div", _hoisted_17$1, [
                                createVNode(unref(p$4), {
                                  id: "date-to",
                                  value: toDate.value,
                                  clearable: false,
                                  placeholder: "To",
                                  class: "max-w-xs",
                                  format: "MMMM d, yyyy",
                                  isDateDisabled,
                                  "onUpdate:value": onChangeTo
                                }, null, 8, ["value", "isDateDisabled"])
                              ])
                            ]),
                            createElementVNode("div", _hoisted_18, [
                              createVNode(unref(q), {
                                id: "clear-btn",
                                type: "default",
                                text: true,
                                class: "text-red-500 mr-4",
                                onClick: handleClear
                              }, {
                                default: withCtx(() => [
                                  createTextVNode("Clear")
                                ]),
                                _: 1
                              }),
                              createVNode(unref(q), {
                                id: "apply-btn",
                                type: "default",
                                text: true,
                                class: "text-blue-500",
                                onClick: handleApply
                              }, {
                                default: withCtx(() => [
                                  createTextVNode("Apply")
                                ]),
                                _: 1
                              })
                            ])
                          ])) : createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["show"]),
                      isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_19, [
                        createVNode(unref(_$3), { size: "medium" })
                      ])) : (openBlock(), createElementBlock("div", _hoisted_20, [
                        tab.name === "Subscriptions" ? (openBlock(), createBlock(SubscriptionTable, {
                          key: 0,
                          subscriptionData: subscriptionData.value
                        }, null, 8, ["subscriptionData"])) : createCommentVNode("", true),
                        tab.name === "Invoices" ? (openBlock(), createBlock(InvoiceTable, {
                          key: 1,
                          invoiceData: invoiceData.value
                        }, null, 8, ["invoiceData"])) : createCommentVNode("", true),
                        tab.name === "Transactions" ? (openBlock(), createBlock(TransactionTable, {
                          key: 2,
                          transactionData: transactionData.value
                        }, null, 8, ["transactionData"])) : createCommentVNode("", true)
                      ]))
                    ]),
                    _: 2
                  }, 1032, ["name", "tab"]);
                }), 64))
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ], 32),
        createVNode(unref(c$1), {
          class: "rounded-t-xl bg-white",
          show: showProfileDrawer.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showProfileDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: 600
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(K), {
              id: "image-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  createElementVNode("div", _hoisted_23, [
                    createElementVNode("div", _hoisted_24, [
                      createVNode(unref(p$2), { class: "text-lg font-semibold mb-4" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(filterTitle.value), 1)
                        ]),
                        _: 1
                      }),
                      createVNode(unref(q), {
                        id: "apply-btn",
                        text: true,
                        class: "text-base !font-semibold mb-4",
                        onClick: handleApply
                      }, {
                        default: withCtx(() => [
                          createTextVNode("Apply")
                        ]),
                        _: 1
                      })
                    ]),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(drawerOptions.value, (status) => {
                      return openBlock(), createElementBlock("div", {
                        key: status.value,
                        class: "mb-2"
                      }, [
                        createVNode(unref(c$2), {
                          name: "radio-btn",
                          class: "radio-container py-4",
                          checked: handleCheckedData(status.value),
                          id: status.id,
                          onChange: handleChange,
                          value: status.value
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(status.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["checked", "id", "value"]),
                        createVNode(unref(p$1), {
                          class: "",
                          titlePlacement: "center",
                          dashed: false,
                          vertical: false
                        })
                      ]);
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showProfileDrawer.value = !showProfileDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ], 64);
    };
  }
});
var BillingSubscription = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["__scopeId", "data-v-0525da62"]]);
var AuthPage_vue_vue_type_style_index_0_lang = "";
var AuthPage_vue_vue_type_style_index_1_scoped_true_lang = "";
const _withScopeId$8 = (n) => (pushScopeId("data-v-223b32ab"), n = n(), popScopeId(), n);
const _hoisted_1$Q = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$N = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$G = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$p = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$i = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$f = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$9 = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$8 = { class: "flex flex-col mt-36 items-center justify-center min-h-[20vh]" };
const _hoisted_9$7 = { class: "relative flex items-center justify-center" };
const _hoisted_10$4 = /* @__PURE__ */ _withScopeId$8(() => /* @__PURE__ */ createElementVNode("div", { class: "absolute rounded-full bg-blue-100 w-36 h-36" }, null, -1));
const _hoisted_11$4 = /* @__PURE__ */ _withScopeId$8(() => /* @__PURE__ */ createElementVNode("div", { class: "absolute rounded-full bg-blue-200 w-28 h-28" }, null, -1));
const _hoisted_12$4 = { class: "absolute rounded-full bg-blue-300 w-20 h-20 flex items-center justify-center" };
const _hoisted_13$3 = { class: "px-6" };
const _sfc_main$W = defineComponent({
  __name: "AuthPage",
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const otpCode = ref("");
    const otpData = ref();
    const notification = c();
    const buttonDisabled = ref(false);
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    onMounted(async () => {
      const TEN_MINUTES = 10 * 60 * 1e3;
      const LAST_CALL_TIMESTAMP_KEY = "lastBillingOtpCall";
      const lastCallTimestamp = localStorage.getItem(LAST_CALL_TIMESTAMP_KEY);
      if (!lastCallTimestamp || Date.now() - Number(lastCallTimestamp) > TEN_MINUTES) {
        await getBillingOtp();
        localStorage.setItem(LAST_CALL_TIMESTAMP_KEY, Date.now().toString());
      }
    });
    const getBillingOtp = async () => {
      var _a2;
      try {
        const { data } = await BillingService.verifyBillingOtp({
          email: UserState.state.email.trim(),
          locationId: LocationState.state.locationId,
          action: "BILLING",
          userId: UserState.state.userId,
          fullName: ((_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.fullName) || "User"
        });
        otpData.value = data;
      } catch (error) {
        notificationFailureAlert("Error", "Failed to get OTP");
      }
    };
    const isResendButtonDisabled = ref(false);
    const resendOtp = async () => {
      isResendButtonDisabled.value = true;
      await getBillingOtp();
      setTimeout(() => {
        isResendButtonDisabled.value = false;
      }, 3e4);
    };
    const handleRoutes = async (queryValue) => {
      var _a2;
      if ((_a2 = otpData.value) == null ? void 0 : _a2.token) {
        try {
          await BillingService.verifyBillingOtp({
            email: UserState.state.email.trim(),
            otp: Number(otpCode.value),
            locationId: LocationState.state.locationId,
            token: otpData.value.token,
            userId: UserState.state.userId
          });
          const currentPath = window.location.pathname;
          if (routerInstance2) {
            routerInstance2.push({
              path: `${currentPath}`,
              query: { activeScreen: queryValue }
            });
          }
          buttonDisabled.value = false;
        } catch (error) {
          notificationFailureAlert("Error", "Failed to verify OTP");
        }
      }
    };
    const handleBack = () => {
      var _a2, _b;
      if ((_b = (_a2 = window == null ? void 0 : window.history) == null ? void 0 : _a2.state) == null ? void 0 : _b.back) {
        routerInstance2.go(-1);
      } else {
        routerInstance2.push({ path: "/profile" });
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$Q, [
        createElementVNode("div", _hoisted_2$N, [
          createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$G, [
                createElementVNode("div", _hoisted_4$p, [
                  createElementVNode("div", _hoisted_5$i, [
                    createElementVNode("div", {
                      onClick: handleBack,
                      class: "relative h-6 w-6 cursor-pointer"
                    }, [
                      createVNode(unref(render))
                    ])
                  ]),
                  createElementVNode("div", _hoisted_6$f, [
                    createElementVNode("div", _hoisted_7$9, [
                      createVNode(unref(p$2), { class: "text-fontPrimary" }, {
                        default: withCtx(() => [
                          createTextVNode(" Authentication ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_8$8, [
          createElementVNode("div", _hoisted_9$7, [
            _hoisted_10$4,
            _hoisted_11$4,
            createElementVNode("div", _hoisted_12$4, [
              createVNode(unref(render$h), { class: "text-white w-8 h-8" })
            ])
          ]),
          createVNode(unref(p), { class: "mt-20 text-xl text-clientportal-font-primary font-semibold font-sans" }, {
            default: withCtx(() => [
              createTextVNode(" Authenticate Your Account ")
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_13$3, [
          createVNode(unref(_), { class: "text-clientportal-font-secondary font-sans" }, {
            default: withCtx(() => [
              createTextVNode("Confirmation code")
            ]),
            _: 1
          }),
          createVNode(unref(entry_esm), {
            class: "justify-center",
            ref: "otpInput",
            "input-classes": "otpStyle",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange
          }, null, 8, ["value"]),
          createVNode(unref(p$3), { class: "text-gray-900 mt-2 font-normal" }, {
            default: withCtx(() => [
              createTextVNode("Please check your email for the secure code. If you did not receive any email from us,"),
              createElementVNode("span", null, [
                createVNode(unref(q), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => [
                    createTextVNode(" tap here to resend. ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }),
          createVNode(unref(q), {
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-4 buttonBorder text-white",
            id: "signin-btn",
            size: "large",
            onClick: _cache[1] || (_cache[1] = ($event) => handleRoutes("BillingSubscription")),
            disabled: buttonDisabled.value
          }, {
            default: withCtx(() => [
              createTextVNode("Verify")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]);
    };
  }
});
var AuthPage = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["__scopeId", "data-v-223b32ab"]]);
var SubscriptionDetail_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$7 = (n) => (pushScopeId("data-v-bd460a0a"), n = n(), popScopeId(), n);
const _hoisted_1$P = { class: "flex flex-col h-screen w-full fixed bg-white z-[100] overflow-y-auto" };
const _hoisted_2$M = {
  id: "edit-info-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$F = { class: "relative z-50 inline-flex w-full bg-white" };
const _hoisted_4$o = { class: "relative z-50 flex items-center justify-center gap-[13px] bg-white" };
const _hoisted_5$h = { class: "relative z-50 flex items-start justify-center gap-2.5 bg-white" };
const _hoisted_6$e = { class: "flex items-start justify-start gap-1" };
const _hoisted_7$8 = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_8$7 = {
  key: 0,
  class: "px-6 flex items-center justify-center h-[90vh]"
};
const _hoisted_9$6 = {
  key: 1,
  class: "px-6"
};
const _hoisted_10$3 = { class: "p-6 mt-16 rounded-xl bg-clientportal-liteBackground flex justify-between items-center mb-4" };
const _hoisted_11$3 = { class: "text-right" };
const _hoisted_12$3 = { class: "mb-4" };
const _hoisted_13$2 = { class: "flex flex-col" };
const _hoisted_14 = /* @__PURE__ */ _withScopeId$7(() => /* @__PURE__ */ createElementVNode("div", { class: "mt-2 h-1 w-16 mb-4 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1));
const _hoisted_15 = { class: "p-0" };
const _hoisted_16 = { class: "flex justify-between items-center" };
const _hoisted_17 = { class: "text-clientportal-font-primary font-semibold" };
const _sfc_main$V = defineComponent({
  __name: "SubscriptionDetail",
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const userData = ref();
    const isSubscription = ref();
    const isLoading = ref(false);
    const showProfileDrawer = ref(false);
    onMounted(async () => {
      isLoading.value = true;
      const billingId = AppState.state.billingId;
      isSubscription.value = AppState.state.isSubscription;
      await getUserData(billingId);
      isLoading.value = false;
    });
    async function handleCancelSubscription() {
      await BillingService.cancelSubscription({
        locationId: LocationState.state.locationId,
        subscriptionId: userData.value._id
      });
      showProfileDrawer.value = false;
    }
    const getUserData = async (billingId) => {
      if (billingId && isSubscription.value) {
        const subscriptionData = await BillingService.getSubscriptionsById({
          locationId: LocationState.state.locationId,
          subscriptionId: billingId
        });
        userData.value = subscriptionData.data;
      } else {
        const transactionData = await BillingService.getTransactionsById({
          locationId: LocationState.state.locationId,
          transactionId: billingId
        });
        userData.value = transactionData.data;
      }
    };
    const details = computed(() => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A;
      const detailsArray = [
        {
          title: isSubscription.value ? "Next invoice on" : "Transaction Date",
          data: moment.unix(isSubscription.value ? (_b = (_a2 = userData == null ? void 0 : userData.value) == null ? void 0 : _a2.subscriptionSnapshot) == null ? void 0 : _b.current_period_end : (_d = (_c = userData == null ? void 0 : userData.value) == null ? void 0 : _c.chargeSnapshot) == null ? void 0 : _d.created).format("MMMM D, YYYY")
        },
        {
          title: isSubscription.value ? "Subscription ID" : "Transaction ID",
          data: (_e = userData.value) == null ? void 0 : _e._id
        },
        {
          title: "Internal Order Id",
          data: (_f = userData.value) == null ? void 0 : _f.entityId
        },
        {
          title: "Type",
          data: (_h = (_g = userData.value) == null ? void 0 : _g.entitySource) == null ? void 0 : _h.type
        },
        {
          title: "ID",
          data: (_j = (_i = userData.value) == null ? void 0 : _i.entitySource) == null ? void 0 : _j.id
        }
      ];
      if (!isSubscription.value) {
        detailsArray.push({
          title: "Payment Details",
          data: "XXXX XXXX XXXX " + ((_p = (_o = (_n = (_m = (_l = (_k = userData.value) == null ? void 0 : _k.chargeSnapshot) == null ? void 0 : _l.charges) == null ? void 0 : _m.data[0]) == null ? void 0 : _n.payment_method_details) == null ? void 0 : _o.card) == null ? void 0 : _p.last4) || "NA"
        }, {
          title: "Expiry Date",
          data: ((_q = userData.value) == null ? void 0 : _q.chargeSnapshot) ? ((_v = (_u = (_t = (_s = (_r = userData.value) == null ? void 0 : _r.chargeSnapshot) == null ? void 0 : _s.charges) == null ? void 0 : _t.data[0]) == null ? void 0 : _u.payment_method_details.card) == null ? void 0 : _v.exp_month) + "/" + ((_A = (_z = (_y = (_x = (_w = userData.value) == null ? void 0 : _w.chargeSnapshot) == null ? void 0 : _x.charges) == null ? void 0 : _y.data[0]) == null ? void 0 : _z.payment_method_details.card) == null ? void 0 : _A.exp_year) : "NA"
        });
      }
      return detailsArray;
    });
    return (_ctx, _cache) => {
      var _a2, _b;
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$P, [
          createElementVNode("div", _hoisted_2$M, [
            createVNode(unref($), { class: "relative z-50 h-full w-full !rounded-none bg-white" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_3$F, [
                  createElementVNode("div", _hoisted_4$o, [
                    createElementVNode("div", _hoisted_5$h, [
                      createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = () => {
                          if (unref(routerInstance2)) {
                            unref(routerInstance2).back();
                          }
                        }),
                        class: "relative h-6 w-6 cursor-pointer"
                      }, [
                        createVNode(unref(render))
                      ])
                    ]),
                    createElementVNode("div", _hoisted_6$e, [
                      createElementVNode("div", _hoisted_7$8, [
                        createVNode(unref(p$2), { class: "text-fontPrimary" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(isSubscription.value ? "Subscription" : "Transaction") + " details ", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_8$7, [
            createVNode(unref(_$3), { size: "medium" })
          ])) : (openBlock(), createElementBlock("div", _hoisted_9$6, [
            createElementVNode("div", _hoisted_10$3, [
              createElementVNode("div", null, [
                createVNode(unref(p), { class: "text-clientportal-font-primary font-sans" }, {
                  default: withCtx(() => {
                    var _a3, _b2;
                    return [
                      createTextVNode(toDisplayString((_b2 = (_a3 = userData.value) == null ? void 0 : _a3.entitySource) == null ? void 0 : _b2.name), 1)
                    ];
                  }),
                  _: 1
                }),
                isSubscription.value ? (openBlock(), createBlock(unref(p$3), {
                  key: 0,
                  class: "text-clientportal-font-secondary font-sans"
                }, {
                  default: withCtx(() => {
                    var _a3, _b2, _c;
                    return [
                      createTextVNode(" Billing " + toDisplayString((_c = (_b2 = (_a3 = userData.value) == null ? void 0 : _a3.subscriptionSnapshot) == null ? void 0 : _b2.plan) == null ? void 0 : _c.interval), 1)
                    ];
                  }),
                  _: 1
                })) : createCommentVNode("", true)
              ]),
              createElementVNode("div", _hoisted_11$3, [
                createVNode(unref(c$3), { class: "text-clientportal-font-primary font-sans text-left mb-2" }, {
                  default: withCtx(() => {
                    var _a3, _b2;
                    return [
                      createTextVNode(toDisplayString(unref(getCurrencySymbol)(((_a3 = userData.value) == null ? void 0 : _a3.currency.toUpperCase()) || "USD")) + " " + toDisplayString((_b2 = userData.value) == null ? void 0 : _b2.amount), 1)
                    ];
                  }),
                  _: 1
                }),
                createVNode(unref($$1), {
                  type: unref(getStatusType)((_a2 = userData.value) == null ? void 0 : _a2.status),
                  closable: false,
                  size: "medium",
                  round: true,
                  bordered: true
                }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createTextVNode(toDisplayString(unref(capitalizeLetterRemoveUnderscored)((_a3 = userData.value) == null ? void 0 : _a3.status)), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["type"])
              ])
            ]),
            createElementVNode("div", _hoisted_12$3, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(details.value, (detail) => {
                return openBlock(), createElementBlock("div", {
                  key: detail.title,
                  class: "flex justify-between mb-2"
                }, [
                  createVNode(unref(_$2), { class: "text-clientportal-font-secondary font-sans" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(detail.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref(_$2), { class: "text-clientportal-font-primary font-sans" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(detail.data), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]);
              }), 128))
            ]),
            isSubscription.value && ((_b = userData.value) == null ? void 0 : _b.status) === "active" ? (openBlock(), createBlock(unref(q), {
              key: 0,
              id: `cancel-subscription`,
              class: "w-full",
              type: "error",
              onClick: _cache[1] || (_cache[1] = () => showProfileDrawer.value = !showProfileDrawer.value)
            }, {
              default: withCtx(() => [
                createTextVNode(" Cancel subscription ")
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]))
        ]),
        createVNode(unref(c$1), {
          class: "rounded-t-xl bg-white",
          show: showProfileDrawer.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showProfileDrawer.value = $event),
          placement: "bottom",
          id: "image-drawer",
          height: 280
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(K), {
              id: "image-drawer-menu",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_13$2, [
                  _hoisted_14,
                  createElementVNode("div", _hoisted_15, [
                    createElementVNode("div", _hoisted_16, [
                      createVNode(unref(p$2), { class: "text-lg font-semibold mb-4" }, {
                        default: withCtx(() => [
                          createTextVNode("Cancel subscription")
                        ]),
                        _: 1
                      })
                    ]),
                    createElementVNode("div", null, [
                      createVNode(unref(_$2), { class: "text-clientportal-font-secondary font-sans" }, {
                        default: withCtx(() => {
                          var _a3, _b2;
                          return [
                            createElementVNode("span", _hoisted_17, "Your plan - " + toDisplayString((_b2 = (_a3 = userData.value) == null ? void 0 : _a3.entitySource) == null ? void 0 : _b2.name), 1),
                            createTextVNode(" will be cancelled immediately. You will not be charged again. ")
                          ];
                        }),
                        _: 1
                      }),
                      createVNode(unref(d), { class: "text-clientportal-font-secondary font-sans mt-2 font-semibold" }, {
                        default: withCtx(() => [
                          createTextVNode(" If you change your mind you can renew your subscription anytime. ")
                        ]),
                        _: 1
                      }),
                      createVNode(unref(q), {
                        id: `conform-cancel-subscription`,
                        class: "w-full mt-4",
                        type: "error",
                        onClick: handleCancelSubscription
                      }, {
                        default: withCtx(() => [
                          createTextVNode("Cancel subscription")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showProfileDrawer.value = !showProfileDrawer.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ], 64);
    };
  }
});
var SubscriptionDetail = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["__scopeId", "data-v-bd460a0a"]]);
var ProfileContainer_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$O = { key: 0 };
const _hoisted_2$L = { key: 1 };
const _hoisted_3$E = { key: 2 };
const _hoisted_4$n = { key: 3 };
const _hoisted_5$g = { key: 4 };
const _hoisted_6$d = { key: 5 };
const _hoisted_7$7 = { key: 6 };
const _hoisted_8$6 = { key: 7 };
const _hoisted_9$5 = { key: 8 };
const _sfc_main$U = defineComponent({
  __name: "ProfileContainer",
  setup(__props) {
    const activeEditScreen = ref("");
    const route = useRoute();
    const routerInstance2 = AppState.getRouterInstance();
    watchEffect(() => {
      var _a2, _b;
      if (!AppState.state.isMobile) {
        const currentPath = window.location.pathname;
        if (routerInstance2) {
          routerInstance2.push({ path: `${currentPath}/home` });
        }
      }
      activeEditScreen.value = ((_b = (_a2 = route.query) == null ? void 0 : _a2.activeScreen) == null ? void 0 : _b.toString()) || "Profile";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        "enter-from-class": "opacity-100 translate-x-2",
        "enter-active-class": "transition ease-out duration-100",
        "enter-to-class": "opacity-100 translate-x-0",
        "leave-from-class": "opacity-100 translate-x-0",
        "leave-to-class": "opacity-100 translate-x-2",
        "leave-active-class": "transition ease-in duration-100"
      }, {
        default: withCtx(() => [
          activeEditScreen.value ? (openBlock(), createElementBlock("div", {
            key: activeEditScreen.value,
            class: "activeEditScreen"
          }, [
            activeEditScreen.value === "EditBasicInfo" ? (openBlock(), createElementBlock("div", _hoisted_1$O, [
              createVNode(EditBasicInfo)
            ])) : activeEditScreen.value === "EditDetails" ? (openBlock(), createElementBlock("div", _hoisted_2$L, [
              createVNode(EditDetails)
            ])) : activeEditScreen.value === "EditAccount" ? (openBlock(), createElementBlock("div", _hoisted_3$E, [
              createVNode(EditAccount)
            ])) : activeEditScreen.value === "EditProfile" ? (openBlock(), createElementBlock("div", _hoisted_4$n, [
              createVNode(EditProfile)
            ])) : activeEditScreen.value === "SettingsMenu" ? (openBlock(), createElementBlock("div", _hoisted_5$g, [
              createVNode(SettingsMenu)
            ])) : activeEditScreen.value === "BillingSubscription" ? (openBlock(), createElementBlock("div", _hoisted_6$d, [
              createVNode(BillingSubscription)
            ])) : activeEditScreen.value === "AuthPage" ? (openBlock(), createElementBlock("div", _hoisted_7$7, [
              createVNode(AuthPage)
            ])) : activeEditScreen.value === "SubscriptionDetail" ? (openBlock(), createElementBlock("div", _hoisted_8$6, [
              createVNode(SubscriptionDetail)
            ])) : (openBlock(), createElementBlock("div", _hoisted_9$5, [
              createVNode(Profile)
            ]))
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      });
    };
  }
});
var ProfileContainer = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["__scopeId", "data-v-6c10c4e3"]]);
const onLoad = (callback, delay = 1) => {
  if (document.readyState === "complete") {
    setTimeout(() => callback(), delay);
  } else {
    window.addEventListener("load", function() {
      setTimeout(() => callback(), delay);
    });
  }
};
var ReCaptcha_vue_vue_type_style_index_0_lang = "";
const _sfc_main$T = defineComponent({
  __name: "ReCaptcha",
  props: {
    siteKey: {
      type: String,
      default: "6LeA0l8pAAAAAMjF87jhpIngHsYPUOsWzM9RwNac"
    }
  },
  emits: ["verify", "expired", "error"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const loadScript = () => {
      onLoad(() => {
        const scriptTag = document.createElement("script");
        scriptTag.type = "text/javascript";
        scriptTag.async = true;
        scriptTag.src = AppState.getConfig().reCaptchaDomain;
        document.head.appendChild(scriptTag);
      });
    };
    const onVerify = (event2) => {
      emit("verify", event2);
    };
    const onExpired = (event2) => {
      emit("expired", event2);
    };
    const onError = (event2) => {
      emit("error", event2);
    };
    return (_ctx, _cache) => {
      const _directive_visibility_observer = resolveDirective("visibility-observer");
      return withDirectives((openBlock(), createBlock(unref(Recaptcha), {
        onExpired,
        onVerify,
        onError,
        sitekey: __props.siteKey,
        class: "g-recaptcha mt-[22px] flex"
      }, null, 8, ["sitekey"])), [
        [_directive_visibility_observer, loadScript]
      ]);
    };
  }
});
var _imports_0 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDI4IiBoZWlnaHQ9IjkyNiIgdmlld0JveD0iMCAwIDQyOCA5MjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg0Mjh2OTI2SDB6Ii8+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGQ9Ik01NC43NzcgNzYuNzE1YTQuODEyIDQuODEyIDAgMSAxLTEuNzQtNi4zNjJtLS4yOSAyNS40MjYgMy4yMS0xLjYwN2E1LjggNS44IDAgMCAxIDEuMzE1LS40NzJsMy44MDMtLjg3NGMuODI1LS4xOSAxLjYtLjU1NiAyLjI3Mi0xLjA3M2wzLjM4My0yLjYwOGE1LjggNS44IDAgMCAwIDEuOTMzLTIuNjcxbDEuMzYtMy45MWEyLjA2NyAyLjA2NyAwIDAgMC0xLjMzNS0yLjY2NSAyLjIxNCAyLjIxNCAwIDAgMC0yLjYyMSAxLjA5M2wtMS45NjIgMy44MDRhMi45IDIuOSAwIDAgMS0xLjI4NiAxLjI2N2wtMi45ODUgMS40OTYgMS45LS45NTJjMS4wNy0uNTM3IDEuNTE2LTEuODE1Ljk5NC0yLjg1N2wtLjE5LS4zNzdjLS40MzItLjg2NS0xLjQxNi0xLjMxNi0yLjM4My0xLjA5M2wtMy4yOS43NTVhNyA3IDAgMCAwLTEuNTQ0LjU1NmMtMS4xODYuNTk0LTIuODQxIDIuNjUyLTIuODQxIDIuNjUybC0yLjg1IDMuMzEzbTExLjk2MS0xOS4xMDJhNC44MTIgNC44MTIgMCAxIDEtOC42MDUgNC4zMSA0LjgxMiA0LjgxMiAwIDAgMSA4LjYwNS00LjMxbS0xNy4xNCAyMS4wNDMgMy41NzIgNy4xM2MuMzQ1LjY4OS41MTcgMS4wMzMuNzgzIDEuMjI5LjIzNC4xNzIuNTE2LjI2Ni44MDYuMjY4LjMzLjAwMi42NzUtLjE3IDEuMzYzLS41MTVsLjk4NC0uNDkzYy42ODgtLjM0NSAxLjAzMy0uNTE3IDEuMjI4LS43ODMuMTczLS4yMzMuMjY3LS41MTYuMjY5LS44MDYuMDAyLS4zMy0uMTctLjY3NC0uNTE2LTEuMzYzbC0zLjU3Mi03LjEzYy0uMzQ0LS42ODktLjUxNy0xLjAzMy0uNzgyLTEuMjNhMS4zOCAxLjM4IDAgMCAwLS44MDctLjI2N2MtLjMzLS4wMDItLjY3NC4xNy0xLjM2My41MTVsLS45ODMuNDkzYy0uNjg5LjM0NC0xLjAzMy41MTctMS4yMjkuNzgzYTEuMzcgMS4zNyAwIDAgMC0uMjY4LjgwNmMtLjAwMi4zMy4xNy42NzQuNTE1IDEuMzYzIiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCNiKSI+PHBhdGggZD0iTTE5Ny43NzcgMTcwLjcxNWE0LjgxMyA0LjgxMyAwIDEgMS0xLjc0LTYuMzYybS0uMjg5IDI1LjQyNiAzLjIwOS0xLjYwN2MuNDE4LS4yMS44NTktLjM2OCAxLjMxNC0uNDcybDMuODA0LS44NzVhNS45IDUuOSAwIDAgMCAyLjI3Mi0xLjA3MmwzLjM4My0yLjYwOGE1LjggNS44IDAgMCAwIDEuOTM0LTIuNjcxbDEuMzU5LTMuOTA5YTIuMDY3IDIuMDY3IDAgMCAwLTEuMzM1LTIuNjY2IDIuMjEgMi4yMSAwIDAgMC0yLjYyMSAxLjA5M2wtMS45NjIgMy44MDRjLS4yODEuNTQ2LS43MzIuOTktMS4yODYgMS4yNjdsLTIuOTg1IDEuNDk2IDEuOS0uOTUyYzEuMDcxLS41MzcgMS41MTYtMS44MTUuOTk0LTIuODU3bC0uMTg5LS4zNzdjLS40MzMtLjg2NS0xLjQxNy0xLjMxNi0yLjM4NC0xLjA5M2wtMy4yOS43NTVhNyA3IDAgMCAwLTEuNTQ0LjU1NmMtMS4xODYuNTk0LTIuODQxIDIuNjUyLTIuODQxIDIuNjUybC0yLjg1IDMuMzEzbTExLjk2MS0xOS4xMDJhNC44MTIgNC44MTIgMCAxIDEtOC42MDUgNC4zMTEgNC44MTMgNC44MTMgMCAxIDEgOC42MDUtNC4zMTFtLTE3LjE0IDIxLjA0MyAzLjU3MiA3LjEzYy4zNDUuNjg5LjUxNyAxLjAzMy43ODMgMS4yMjkuMjM0LjE3Mi41MTYuMjY2LjgwNi4yNjguMzMxLjAwMi42NzUtLjE3IDEuMzYzLS41MTVsLjk4NC0uNDkzYy42ODgtLjM0NSAxLjAzMy0uNTE3IDEuMjI4LS43ODMuMTczLS4yMzQuMjY3LS41MTYuMjY5LS44MDYuMDAyLS4zMy0uMTcxLS42NzUtLjUxNi0xLjM2M2wtMy41NzEtNy4xM2MtLjM0NS0uNjg5LS41MTgtMS4wMzMtLjc4NC0xLjIyOWExLjM4IDEuMzggMCAwIDAtLjgwNi0uMjY4Yy0uMzMtLjAwMi0uNjc0LjE3LTEuMzYzLjUxNWwtLjk4My40OTNjLS42ODkuMzQ1LTEuMDMzLjUxNy0xLjIyOS43ODNhMS4zOCAxLjM4IDAgMCAwLS4yNjguODA2Yy0uMDAyLjMzLjE3LjY3NC41MTUgMS4zNjMiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI2MpIj48cGF0aCBkPSJNMjc3Ljc3NyAyNzUuNzE1YTQuODEzIDQuODEzIDAgMSAxLTEuNzQtNi4zNjJtLS4yODkgMjUuNDI2IDMuMjA5LTEuNjA3Yy40MTgtLjIxLjg1OS0uMzY4IDEuMzE0LS40NzJsMy44MDQtLjg3NWE1LjkgNS45IDAgMCAwIDIuMjcyLTEuMDcybDMuMzgzLTIuNjA4YTUuOCA1LjggMCAwIDAgMS45MzQtMi42NzFsMS4zNTktMy45MDlhMi4wNjcgMi4wNjcgMCAwIDAtMS4zMzUtMi42NjYgMi4yMSAyLjIxIDAgMCAwLTIuNjIxIDEuMDkzbC0xLjk2MiAzLjgwNGMtLjI4MS41NDYtLjczMi45OS0xLjI4NiAxLjI2N2wtMi45ODUgMS40OTYgMS45LS45NTJjMS4wNzEtLjUzNyAxLjUxNi0xLjgxNS45OTQtMi44NTdsLS4xODktLjM3N2MtLjQzMy0uODY1LTEuNDE3LTEuMzE2LTIuMzg0LTEuMDkzbC0zLjI5Ljc1NWE3IDcgMCAwIDAtMS41NDQuNTU2Yy0xLjE4Ni41OTQtMi44NDEgMi42NTItMi44NDEgMi42NTJsLTIuODUgMy4zMTNtMTEuOTYxLTE5LjEwMmE0LjgxMiA0LjgxMiAwIDEgMS04LjYwNSA0LjMxMSA0LjgxMyA0LjgxMyAwIDEgMSA4LjYwNS00LjMxMW0tMTcuMTQgMjEuMDQzIDMuNTcyIDcuMTNjLjM0NS42ODkuNTE3IDEuMDMzLjc4MyAxLjIyOS4yMzQuMTcyLjUxNi4yNjYuODA2LjI2OC4zMzEuMDAyLjY3NS0uMTcgMS4zNjMtLjUxNWwuOTg0LS40OTNjLjY4OC0uMzQ1IDEuMDMzLS41MTcgMS4yMjgtLjc4My4xNzMtLjIzNC4yNjctLjUxNi4yNjktLjgwNi4wMDItLjMzLS4xNzEtLjY3NS0uNTE2LTEuMzYzbC0zLjU3MS03LjEzYy0uMzQ1LS42ODktLjUxOC0xLjAzMy0uNzg0LTEuMjI5YTEuMzggMS4zOCAwIDAgMC0uODA2LS4yNjhjLS4zMy0uMDAyLS42NzQuMTctMS4zNjMuNTE1bC0uOTgzLjQ5M2MtLjY4OS4zNDUtMS4wMzMuNTE3LTEuMjI5Ljc4M2ExLjM4IDEuMzggMCAwIDAtLjI2OC44MDZjLS4wMDIuMzMuMTcuNjc0LjUxNSAxLjM2MyIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjZCkiPjxwYXRoIGQ9Ik03NC43NzcgNTMzLjcxNWE0LjgxMyA0LjgxMyAwIDEgMS0xLjc0LTYuMzYybS0uMjkgMjUuNDI2IDMuMjEtMS42MDdxLjYyOS0uMzE2IDEuMzE1LS40NzJsMy44MDMtLjg3NWE1LjkgNS45IDAgMCAwIDIuMjcyLTEuMDcybDMuMzgzLTIuNjA4YTUuOCA1LjggMCAwIDAgMS45MzMtMi42NzFsMS4zNi0zLjkwOWEyLjA2NyAyLjA2NyAwIDAgMC0xLjMzNS0yLjY2NiAyLjIxIDIuMjEgMCAwIDAtMi42MjEgMS4wOTNsLTEuOTYyIDMuODA0Yy0uMjguNTQ2LS43MzIuOTktMS4yODYgMS4yNjdsLTIuOTg1IDEuNDk2IDEuOS0uOTUyYzEuMDctLjUzNyAxLjUxNi0xLjgxNS45OTQtMi44NTdsLS4xOS0uMzc3Yy0uNDMyLS44NjUtMS40MTYtMS4zMTYtMi4zODMtMS4wOTNsLTMuMjkuNzU1YTcgNyAwIDAgMC0xLjU0NC41NTZjLTEuMTg2LjU5NC0yLjg0MSAyLjY1Mi0yLjg0MSAyLjY1MmwtMi44NSAzLjMxM20xMS45NjEtMTkuMTAyYTQuODEyIDQuODEyIDAgMSAxLTguNjA0IDQuMzEgNC44MTIgNC44MTIgMCAwIDEgOC42MDQtNC4zMW0tMTcuMTQgMjEuMDQzIDMuNTcyIDcuMTNjLjM0NS42ODkuNTE3IDEuMDMzLjc4MyAxLjIyOS4yMzQuMTcyLjUxNi4yNjYuODA2LjI2OC4zMy4wMDIuNjc1LS4xNyAxLjM2My0uNTE1bC45ODQtLjQ5M2MuNjg4LS4zNDUgMS4wMzMtLjUxNyAxLjIyOC0uNzgzLjE3My0uMjM0LjI2Ny0uNTE2LjI2OS0uODA2LjAwMi0uMzMtLjE3LS42NzUtLjUxNi0xLjM2M2wtMy41NzItNy4xM2MtLjM0NC0uNjg5LS41MTctMS4wMzMtLjc4Mi0xLjIyOWExLjM4IDEuMzggMCAwIDAtLjgwNy0uMjY4Yy0uMzMtLjAwMi0uNjc0LjE3LTEuMzYzLjUxNWwtLjk4My40OTNjLS42ODkuMzQ1LTEuMDMzLjUxNy0xLjIyOS43ODNhMS4zNyAxLjM3IDAgMCAwLS4yNjguODA2Yy0uMDAyLjMzLjE3LjY3NC41MTUgMS4zNjMiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI2UpIj48cGF0aCBkPSJNMjI4Ljc3NyA2ODIuNzE1YTQuODEzIDQuODEzIDAgMSAxLTEuNzQtNi4zNjJtLS4yODkgMjUuNDI2IDMuMjA5LTEuNjA3Yy40MTgtLjIxLjg1OS0uMzY4IDEuMzE0LS40NzJsMy44MDQtLjg3NWE1LjkgNS45IDAgMCAwIDIuMjcyLTEuMDcybDMuMzgzLTIuNjA4YTUuOCA1LjggMCAwIDAgMS45MzQtMi42NzFsMS4zNTktMy45MDlhMi4wNjcgMi4wNjcgMCAwIDAtMS4zMzUtMi42NjYgMi4yMSAyLjIxIDAgMCAwLTIuNjIxIDEuMDkzbC0xLjk2MiAzLjgwNGMtLjI4MS41NDYtLjczMi45OS0xLjI4NiAxLjI2N2wtMi45ODUgMS40OTYgMS45LS45NTJjMS4wNzEtLjUzNyAxLjUxNi0xLjgxNS45OTQtMi44NTdsLS4xODktLjM3N2MtLjQzMy0uODY1LTEuNDE3LTEuMzE2LTIuMzg0LTEuMDkzbC0zLjI5Ljc1NWE3IDcgMCAwIDAtMS41NDQuNTU2Yy0xLjE4Ni41OTQtMi44NDEgMi42NTItMi44NDEgMi42NTJsLTIuODUgMy4zMTNtMTEuOTYxLTE5LjEwMmE0LjgxMiA0LjgxMiAwIDEgMS04LjYwNSA0LjMxMSA0LjgxMyA0LjgxMyAwIDEgMSA4LjYwNS00LjMxMW0tMTcuMTQgMjEuMDQzIDMuNTcyIDcuMTNjLjM0NS42ODkuNTE3IDEuMDMzLjc4MyAxLjIyOS4yMzQuMTcyLjUxNi4yNjYuODA2LjI2OC4zMzEuMDAyLjY3NS0uMTcgMS4zNjMtLjUxNWwuOTg0LS40OTNjLjY4OC0uMzQ1IDEuMDMzLS41MTcgMS4yMjgtLjc4My4xNzMtLjIzNC4yNjctLjUxNi4yNjktLjgwNi4wMDItLjMzLS4xNzEtLjY3NS0uNTE2LTEuMzYzbC0zLjU3MS03LjEzYy0uMzQ1LS42ODktLjUxOC0xLjAzMy0uNzg0LTEuMjI5YTEuMzggMS4zOCAwIDAgMC0uODA2LS4yNjhjLS4zMy0uMDAyLS42NzQuMTctMS4zNjMuNTE1bC0uOTgzLjQ5M2MtLjY4OS4zNDUtMS4wMzMuNTE3LTEuMjI5Ljc4M2ExLjM4IDEuMzggMCAwIDAtLjI2OC44MDZjLS4wMDIuMzMuMTcuNjc0LjUxNSAxLjM2MyIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjZikiPjxwYXRoIGQ9Ik0yMzEuNzc3IDU5Ni43MTVhNC44MTMgNC44MTMgMCAxIDEtMS43NC02LjM2Mm0tLjI4OSAyNS40MjYgMy4yMDktMS42MDdjLjQxOC0uMjEuODU5LS4zNjggMS4zMTQtLjQ3MmwzLjgwNC0uODc1YTUuOSA1LjkgMCAwIDAgMi4yNzItMS4wNzJsMy4zODMtMi42MDhhNS44IDUuOCAwIDAgMCAxLjkzNC0yLjY3MWwxLjM1OS0zLjkwOWEyLjA2NyAyLjA2NyAwIDAgMC0xLjMzNS0yLjY2NiAyLjIxIDIuMjEgMCAwIDAtMi42MjEgMS4wOTNsLTEuOTYyIDMuODA0Yy0uMjgxLjU0Ni0uNzMyLjk5LTEuMjg2IDEuMjY3bC0yLjk4NSAxLjQ5NiAxLjktLjk1MmMxLjA3MS0uNTM3IDEuNTE2LTEuODE1Ljk5NC0yLjg1N2wtLjE4OS0uMzc3Yy0uNDMzLS44NjUtMS40MTctMS4zMTYtMi4zODQtMS4wOTNsLTMuMjkuNzU1YTcgNyAwIDAgMC0xLjU0NC41NTZjLTEuMTg2LjU5NC0yLjg0MSAyLjY1Mi0yLjg0MSAyLjY1MmwtMi44NSAzLjMxM20xMS45NjEtMTkuMTAyYTQuODEyIDQuODEyIDAgMSAxLTguNjA1IDQuMzExIDQuODEzIDQuODEzIDAgMSAxIDguNjA1LTQuMzExbS0xNy4xNCAyMS4wNDMgMy41NzIgNy4xM2MuMzQ1LjY4OS41MTcgMS4wMzMuNzgzIDEuMjI5LjIzNC4xNzIuNTE2LjI2Ni44MDYuMjY4LjMzMS4wMDIuNjc1LS4xNyAxLjM2My0uNTE1bC45ODQtLjQ5M2MuNjg4LS4zNDUgMS4wMzMtLjUxNyAxLjIyOC0uNzgzLjE3My0uMjM0LjI2Ny0uNTE2LjI2OS0uODA2LjAwMi0uMzMtLjE3MS0uNjc1LS41MTYtMS4zNjNsLTMuNTcxLTcuMTNjLS4zNDUtLjY4OS0uNTE4LTEuMDMzLS43ODQtMS4yMjlhMS4zOCAxLjM4IDAgMCAwLS44MDYtLjI2OGMtLjMzLS4wMDItLjY3NC4xNy0xLjM2My41MTVsLS45ODMuNDkzYy0uNjg5LjM0NS0xLjAzMy41MTctMS4yMjkuNzgzYTEuMzggMS4zOCAwIDAgMC0uMjY4LjgwNmMtLjAwMi4zMy4xNy42NzQuNTE1IDEuMzYzIiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCNnKSI+PHBhdGggZD0iTTMyNy43NzcgNDAxLjcxNWE0LjgxMyA0LjgxMyAwIDEgMS0xLjc0LTYuMzYybS0uMjg5IDI1LjQyNiAzLjIwOS0xLjYwN2MuNDE4LS4yMS44NTktLjM2OCAxLjMxNC0uNDcybDMuODA0LS44NzVhNS45IDUuOSAwIDAgMCAyLjI3Mi0xLjA3MmwzLjM4My0yLjYwOGE1LjggNS44IDAgMCAwIDEuOTM0LTIuNjcxbDEuMzU5LTMuOTA5YTIuMDY3IDIuMDY3IDAgMCAwLTEuMzM1LTIuNjY2IDIuMjEgMi4yMSAwIDAgMC0yLjYyMSAxLjA5M2wtMS45NjIgMy44MDRjLS4yODEuNTQ2LS43MzIuOTktMS4yODYgMS4yNjdsLTIuOTg1IDEuNDk2IDEuOS0uOTUyYzEuMDcxLS41MzcgMS41MTYtMS44MTUuOTk0LTIuODU3bC0uMTg5LS4zNzdjLS40MzMtLjg2NS0xLjQxNy0xLjMxNi0yLjM4NC0xLjA5M2wtMy4yOS43NTVhNyA3IDAgMCAwLTEuNTQ0LjU1NmMtMS4xODYuNTk0LTIuODQxIDIuNjUyLTIuODQxIDIuNjUybC0yLjg1IDMuMzEzbTExLjk2MS0xOS4xMDJhNC44MTIgNC44MTIgMCAxIDEtOC42MDUgNC4zMTEgNC44MTMgNC44MTMgMCAxIDEgOC42MDUtNC4zMTFtLTE3LjE0IDIxLjA0MyAzLjU3MiA3LjEzYy4zNDUuNjg5LjUxNyAxLjAzMy43ODMgMS4yMjkuMjM0LjE3Mi41MTYuMjY2LjgwNi4yNjguMzMxLjAwMi42NzUtLjE3IDEuMzYzLS41MTVsLjk4NC0uNDkzYy42ODgtLjM0NSAxLjAzMy0uNTE3IDEuMjI4LS43ODMuMTczLS4yMzQuMjY3LS41MTYuMjY5LS44MDYuMDAyLS4zMy0uMTcxLS42NzUtLjUxNi0xLjM2M2wtMy41NzEtNy4xM2MtLjM0NS0uNjg5LS41MTgtMS4wMzMtLjc4NC0xLjIyOWExLjM4IDEuMzggMCAwIDAtLjgwNi0uMjY4Yy0uMzMtLjAwMi0uNjc0LjE3LTEuMzYzLjUxNWwtLjk4My40OTNjLS42ODkuMzQ1LTEuMDMzLjUxNy0xLjIyOS43ODNhMS4zOCAxLjM4IDAgMCAwLS4yNjguODA2Yy0uMDAyLjMzLjE3LjY3NC41MTUgMS4zNjMiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI2gpIj48cGF0aCBkPSJNOTkuNzc3IDc3OC43MTVhNC44MTMgNC44MTMgMCAxIDEtMS43NC02LjM2Mm0tLjI5IDI1LjQyNiAzLjIxLTEuNjA3Yy40MTgtLjIxLjg1OS0uMzY4IDEuMzE0LS40NzJsMy44MDQtLjg3NWE1LjkgNS45IDAgMCAwIDIuMjcyLTEuMDcybDMuMzgzLTIuNjA4YTUuOCA1LjggMCAwIDAgMS45MzQtMi42NzFsMS4zNTktMy45MDlhMi4wNjcgMi4wNjcgMCAwIDAtMS4zMzUtMi42NjYgMi4yMSAyLjIxIDAgMCAwLTIuNjIxIDEuMDkzbC0xLjk2MiAzLjgwNGMtLjI4MS41NDYtLjczMi45OS0xLjI4NiAxLjI2N2wtMi45ODUgMS40OTYgMS45LS45NTJjMS4wNzEtLjUzNyAxLjUxNi0xLjgxNS45OTQtMi44NTdsLS4xODktLjM3N2MtLjQzMy0uODY1LTEuNDE3LTEuMzE2LTIuMzg0LTEuMDkzbC0zLjI5Ljc1NWE3IDcgMCAwIDAtMS41NDQuNTU2Yy0xLjE4Ni41OTQtMi44NDEgMi42NTItMi44NDEgMi42NTJsLTIuODUgMy4zMTNtMTEuOTYxLTE5LjEwMmE0LjgxMiA0LjgxMiAwIDEgMS04LjYwNSA0LjMxMSA0LjgxMyA0LjgxMyAwIDAgMSA4LjYwNS00LjMxMW0tMTcuMTQgMjEuMDQzIDMuNTcyIDcuMTNjLjM0NS42ODkuNTE3IDEuMDMzLjc4MyAxLjIyOS4yMzQuMTcyLjUxNi4yNjYuODA2LjI2OC4zMy4wMDIuNjc1LS4xNyAxLjM2My0uNTE1bC45ODQtLjQ5M2MuNjg4LS4zNDUgMS4wMzMtLjUxNyAxLjIyOC0uNzgzLjE3My0uMjM0LjI2Ny0uNTE2LjI2OS0uODA2LjAwMi0uMzMtLjE3LS42NzUtLjUxNi0xLjM2M2wtMy41NzItNy4xM2MtLjM0NC0uNjg5LS41MTctMS4wMzMtLjc4Mi0xLjIyOWExLjM4IDEuMzggMCAwIDAtLjgwNy0uMjY4Yy0uMzMtLjAwMi0uNjc0LjE3LTEuMzYzLjUxNWwtLjk4My40OTNjLS42ODkuMzQ1LTEuMDMzLjUxNy0xLjIyOS43ODNhMS4zNyAxLjM3IDAgMCAwLS4yNjguODA2Yy0uMDAyLjMzLjE3LjY3NC41MTUgMS4zNjMiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI2kpIj48cGF0aCBkPSJNMzM0Ljc3NyA0OTkuNzE1YTQuODEzIDQuODEzIDAgMSAxLTEuNzQtNi4zNjJtLS4yODkgMjUuNDI2IDMuMjA5LTEuNjA3Yy40MTgtLjIxLjg1OS0uMzY4IDEuMzE0LS40NzJsMy44MDQtLjg3NWE1LjkgNS45IDAgMCAwIDIuMjcyLTEuMDcybDMuMzgzLTIuNjA4YTUuOCA1LjggMCAwIDAgMS45MzQtMi42NzFsMS4zNTktMy45MDlhMi4wNjcgMi4wNjcgMCAwIDAtMS4zMzUtMi42NjYgMi4yMSAyLjIxIDAgMCAwLTIuNjIxIDEuMDkzbC0xLjk2MiAzLjgwNGMtLjI4MS41NDYtLjczMi45OS0xLjI4NiAxLjI2N2wtMi45ODUgMS40OTYgMS45LS45NTJjMS4wNzEtLjUzNyAxLjUxNi0xLjgxNS45OTQtMi44NTdsLS4xODktLjM3N2MtLjQzMy0uODY1LTEuNDE3LTEuMzE2LTIuMzg0LTEuMDkzbC0zLjI5Ljc1NWE3IDcgMCAwIDAtMS41NDQuNTU2Yy0xLjE4Ni41OTQtMi44NDEgMi42NTItMi44NDEgMi42NTJsLTIuODUgMy4zMTNtMTEuOTYxLTE5LjEwMmE0LjgxMiA0LjgxMiAwIDEgMS04LjYwNSA0LjMxMSA0LjgxMyA0LjgxMyAwIDEgMSA4LjYwNS00LjMxMW0tMTcuMTQgMjEuMDQzIDMuNTcyIDcuMTNjLjM0NS42ODkuNTE3IDEuMDMzLjc4MyAxLjIyOS4yMzQuMTcyLjUxNi4yNjYuODA2LjI2OC4zMzEuMDAyLjY3NS0uMTcgMS4zNjMtLjUxNWwuOTg0LS40OTNjLjY4OC0uMzQ1IDEuMDMzLS41MTcgMS4yMjgtLjc4My4xNzMtLjIzNC4yNjctLjUxNi4yNjktLjgwNi4wMDItLjMzLS4xNzEtLjY3NS0uNTE2LTEuMzYzbC0zLjU3MS03LjEzYy0uMzQ1LS42ODktLjUxOC0xLjAzMy0uNzg0LTEuMjI5YTEuMzggMS4zOCAwIDAgMC0uODA2LS4yNjhjLS4zMy0uMDAyLS42NzQuMTctMS4zNjMuNTE1bC0uOTgzLjQ5M2MtLjY4OS4zNDUtMS4wMzMuNTE3LTEuMjI5Ljc4M2ExLjM4IDEuMzggMCAwIDAtLjI2OC44MDZjLS4wMDIuMzMuMTcuNjc0LjUxNSAxLjM2MyIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjaikiPjxwYXRoIGQ9Ik0zNjMuNzc3IDM0MS43MTVhNC44MTMgNC44MTMgMCAxIDEtMS43NC02LjM2Mm0tLjI4OSAyNS40MjYgMy4yMDktMS42MDdjLjQxOC0uMjEuODU5LS4zNjggMS4zMTQtLjQ3MmwzLjgwNC0uODc1YTUuOSA1LjkgMCAwIDAgMi4yNzItMS4wNzJsMy4zODMtMi42MDhhNS44IDUuOCAwIDAgMCAxLjkzNC0yLjY3MWwxLjM1OS0zLjkwOWEyLjA2NyAyLjA2NyAwIDAgMC0xLjMzNS0yLjY2NiAyLjIxIDIuMjEgMCAwIDAtMi42MjEgMS4wOTNsLTEuOTYyIDMuODA0Yy0uMjgxLjU0Ni0uNzMyLjk5LTEuMjg2IDEuMjY3bC0yLjk4NSAxLjQ5NiAxLjktLjk1MmMxLjA3MS0uNTM3IDEuNTE2LTEuODE1Ljk5NC0yLjg1N2wtLjE4OS0uMzc3Yy0uNDMzLS44NjUtMS40MTctMS4zMTYtMi4zODQtMS4wOTNsLTMuMjkuNzU1YTcgNyAwIDAgMC0xLjU0NC41NTZjLTEuMTg2LjU5NC0yLjg0MSAyLjY1Mi0yLjg0MSAyLjY1MmwtMi44NSAzLjMxM20xMS45NjEtMTkuMTAyYTQuODEyIDQuODEyIDAgMSAxLTguNjA1IDQuMzExIDQuODEzIDQuODEzIDAgMSAxIDguNjA1LTQuMzExbS0xNy4xNCAyMS4wNDMgMy41NzIgNy4xM2MuMzQ1LjY4OS41MTcgMS4wMzMuNzgzIDEuMjI5LjIzNC4xNzIuNTE2LjI2Ni44MDYuMjY4LjMzMS4wMDIuNjc1LS4xNyAxLjM2My0uNTE1bC45ODQtLjQ5M2MuNjg4LS4zNDUgMS4wMzMtLjUxNyAxLjIyOC0uNzgzLjE3My0uMjM0LjI2Ny0uNTE2LjI2OS0uODA2LjAwMi0uMzMtLjE3MS0uNjc1LS41MTYtMS4zNjNsLTMuNTcxLTcuMTNjLS4zNDUtLjY4OS0uNTE4LTEuMDMzLS43ODQtMS4yMjlhMS4zOCAxLjM4IDAgMCAwLS44MDYtLjI2OGMtLjMzLS4wMDItLjY3NC4xNy0xLjM2My41MTVsLS45ODMuNDkzYy0uNjg5LjM0NS0xLjAzMy41MTctMS4yMjkuNzgzYTEuMzggMS4zOCAwIDAgMC0uMjY4LjgwNmMtLjAwMi4zMy4xNy42NzQuNTE1IDEuMzYzIiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCNrKSI+PHBhdGggZD0iTTUxLjc3NyAyNDYuNzE1YTQuODEzIDQuODEzIDAgMSAxLTEuNzQtNi4zNjJtLS4yOSAyNS40MjYgMy4yMS0xLjYwN2E1LjggNS44IDAgMCAxIDEuMzE1LS40NzJsMy44MDMtLjg3NWE1LjkgNS45IDAgMCAwIDIuMjcyLTEuMDcybDMuMzgzLTIuNjA4YTUuOCA1LjggMCAwIDAgMS45MzQtMi42NzFsMS4zNi0zLjkwOWEyLjA2NyAyLjA2NyAwIDAgMC0xLjMzNi0yLjY2NiAyLjIxIDIuMjEgMCAwIDAtMi42MjIgMS4wOTNsLTEuOTYxIDMuODA0Yy0uMjguNTQ2LS43MzIuOTktMS4yODYgMS4yNjdsLTIuOTg1IDEuNDk2IDEuOS0uOTUyYzEuMDctLjUzNyAxLjUxNi0xLjgxNS45OTQtMi44NTdsLS4xOS0uMzc3Yy0uNDMyLS44NjUtMS40MTYtMS4zMTYtMi4zODMtMS4wOTNsLTMuMjkuNzU1YTcgNyAwIDAgMC0xLjU0NC41NTZjLTEuMTg2LjU5NC0yLjg0MSAyLjY1Mi0yLjg0MSAyLjY1MmwtMi44NSAzLjMxM20xMS45NjEtMTkuMTAyYTQuODEyIDQuODEyIDAgMSAxLTguNjA0IDQuMzEgNC44MTIgNC44MTIgMCAwIDEgOC42MDQtNC4zMW0tMTcuMTQgMjEuMDQzIDMuNTcyIDcuMTNjLjM0NS42ODkuNTE3IDEuMDMzLjc4MyAxLjIyOS4yMzQuMTcyLjUxNi4yNjYuODA2LjI2OC4zMy4wMDIuNjc1LS4xNyAxLjM2My0uNTE1bC45ODQtLjQ5M2MuNjg4LS4zNDUgMS4wMzMtLjUxNyAxLjIyOC0uNzgzLjE3My0uMjM0LjI2Ny0uNTE2LjI2OS0uODA2LjAwMi0uMzMtLjE3LS42NzUtLjUxNi0xLjM2M2wtMy41NzItNy4xM2MtLjM0NC0uNjg5LS41MTctMS4wMzMtLjc4Mi0xLjIyOWExLjM4IDEuMzggMCAwIDAtLjgwNy0uMjY4Yy0uMzMtLjAwMi0uNjc0LjE3LTEuMzYzLjUxNWwtLjk4My40OTNjLS42ODkuMzQ1LTEuMDMzLjUxNy0xLjIyOS43ODNhMS4zNyAxLjM3IDAgMCAwLS4yNjguODA2Yy0uMDAyLjMzLjE3LjY3NC41MTUgMS4zNjMiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI2wpIj48cGF0aCBkPSJNMzQ1Ljc3NyA4MzQuNzE1YTQuODEzIDQuODEzIDAgMSAxLTEuNzQtNi4zNjJtLS4yODkgMjUuNDI2IDMuMjA5LTEuNjA3Yy40MTgtLjIxLjg1OS0uMzY4IDEuMzE0LS40NzJsMy44MDQtLjg3NWE1LjkgNS45IDAgMCAwIDIuMjcyLTEuMDcybDMuMzgzLTIuNjA4YTUuOCA1LjggMCAwIDAgMS45MzQtMi42NzFsMS4zNTktMy45MDlhMi4wNjcgMi4wNjcgMCAwIDAtMS4zMzUtMi42NjYgMi4yMSAyLjIxIDAgMCAwLTIuNjIxIDEuMDkzbC0xLjk2MiAzLjgwNGMtLjI4MS41NDYtLjczMi45OS0xLjI4NiAxLjI2N2wtMi45ODUgMS40OTYgMS45LS45NTJjMS4wNzEtLjUzNyAxLjUxNi0xLjgxNS45OTQtMi44NTdsLS4xODktLjM3N2MtLjQzMy0uODY1LTEuNDE3LTEuMzE2LTIuMzg0LTEuMDkzbC0zLjI5Ljc1NWE3IDcgMCAwIDAtMS41NDQuNTU2Yy0xLjE4Ni41OTQtMi44NDEgMi42NTItMi44NDEgMi42NTJsLTIuODUgMy4zMTNtMTEuOTYxLTE5LjEwMmE0LjgxMiA0LjgxMiAwIDEgMS04LjYwNSA0LjMxMSA0LjgxMyA0LjgxMyAwIDEgMSA4LjYwNS00LjMxMW0tMTcuMTQgMjEuMDQzIDMuNTcyIDcuMTNjLjM0NS42ODkuNTE3IDEuMDMzLjc4MyAxLjIyOS4yMzQuMTcyLjUxNi4yNjYuODA2LjI2OC4zMzEuMDAyLjY3NS0uMTcgMS4zNjMtLjUxNWwuOTg0LS40OTNjLjY4OC0uMzQ1IDEuMDMzLS41MTcgMS4yMjgtLjc4My4xNzMtLjIzNC4yNjctLjUxNi4yNjktLjgwNi4wMDItLjMzLS4xNzEtLjY3NS0uNTE2LTEuMzYzbC0zLjU3MS03LjEzYy0uMzQ1LS42ODktLjUxOC0xLjAzMy0uNzg0LTEuMjI5YTEuMzggMS4zOCAwIDAgMC0uODA2LS4yNjhjLS4zMy0uMDAyLS42NzQuMTctMS4zNjMuNTE1bC0uOTgzLjQ5M2MtLjY4OS4zNDUtMS4wMzMuNTE3LTEuMjI5Ljc4M2ExLjM4IDEuMzggMCAwIDAtLjI2OC44MDZjLS4wMDIuMzMuMTcuNjc0LjUxNSAxLjM2MyIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjbSkiPjxwYXRoIGQ9Im0yNDQuNTcyIDU0OS4zNTMtLjgzMy0yLjYyMWE1LjUgNS41IDAgMCAwLTUuNTQ0LTMuODI5bS05LjUxMi0xNC4wNTNhNS41IDUuNSAwIDAgMSAzLjA4NyA5LjcyMm02LjI0OSAxMi44NjJjLS43NzYtMi40NDMtMS4xNjMtMy42NjQtMS44NjgtNC41MDFhNS41IDUuNSAwIDAgMC0zLjczOC0xLjkzNmMtMS4wOS0uMDkzLTIuMzEyLjI5NS00Ljc1NCAxLjA3MWwtMy45MzIgMS4yNDhjLTIuNDQyLjc3Ni0zLjY2MyAxLjE2NC00LjUgMS44NjlhNS41IDUuNSAwIDAgMC0xLjkzNiAzLjczOGMtLjA5MyAxLjA5LjI5NSAyLjMxMSAxLjA3MSA0Ljc1M205LjI0NC0yMy4xMzNhNS41IDUuNSAwIDEgMS0xMC40ODYgMy4zMjggNS41IDUuNSAwIDAgMSAxMC40ODYtMy4zMjgiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI24pIj48cGF0aCBkPSJtNzIuMDQ0IDQ0MS44MDMgMS4yNi0yLjQ0NGE1LjUgNS41IDAgMCAwLTEuMjIyLTYuNjI1bTMuMTg2LTE2LjY2OGE1LjUgNS41IDAgMCAxLTQuNjc4IDkuMDY0bS00LjY1NiAxMy41MmMxLjE3NS0yLjI3NyAxLjc2My0zLjQxNiAxLjg1NC00LjUwNmE1LjUgNS41IDAgMCAwLTEuMjgtNC4wMWMtLjcwNi0uODM2LTEuODQ0LTEuNDIzLTQuMTIyLTIuNTk4bC0zLjY2Ni0xLjg5MmMtMi4yNzctMS4xNzUtMy40MTUtMS43NjMtNC41MDYtMS44NTVhNS41IDUuNSAwIDAgMC00LjAxIDEuMjgxYy0uODM1LjcwNi0xLjQyMyAxLjg0NC0yLjU5OCA0LjEyMm0yMi44OC05Ljg1NWE1LjUgNS41IDAgMSAxLTkuNzc2LTUuMDQ2IDUuNSA1LjUgMCAwIDEgOS43NzYgNS4wNDYiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI28pIj48cGF0aCBkPSJtMjk2LjYzOCAxOTguNTg0Ljg2OC0yLjYwOWE1LjUgNS41IDAgMCAwLTIuMjMxLTYuMzU3bS41NzQtMTYuOTZhNS41MDEgNS41MDEgMCAwIDEtMy4yMjIgOS42NzhtLTIuNTEyIDE0LjA3N2MuODA5LTIuNDMyIDEuMjE0LTMuNjQ4IDEuMTM2LTQuNzM5YTUuNSA1LjUgMCAwIDAtMS44ODQtMy43NjRjLS44MjctLjcxNy0yLjA0My0xLjEyMS00LjQ3NC0xLjkzMWwtMy45MTQtMS4zMDNjLTIuNDMxLS44MDktMy42NDctMS4yMTQtNC43MzgtMS4xMzZhNS41IDUuNSAwIDAgMC0zLjc2NSAxLjg4NGMtLjcxNi44MjctMS4xMjEgMi4wNDItMS45MyA0LjQ3NG0yMS4wODMtMTMuMjdhNS41IDUuNSAwIDEgMS0xMC40MzctMy40NzUgNS41IDUuNSAwIDAgMSAxMC40MzcgMy40NzUiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI3ApIj48cGF0aCBkPSJtMzUxLjMzNSAxMDEuNjg5IDEuMjItMi40NjVhNS41MDQgNS41MDQgMCAwIDAtMS4zMzUtNi42MDNtMi45MDMtMTYuNzJhNS41IDUuNSAwIDAgMS00LjUyMyA5LjE0Mm0tNC40MjcgMTMuNTk3YzEuMTM3LTIuMjk3IDEuNzA1LTMuNDQ1IDEuNzc4LTQuNTM3YTUuNSA1LjUgMCAwIDAtMS4zNDgtMy45ODdjLS43Mi0uODI0LTEuODY5LTEuMzkyLTQuMTY2LTIuNTI5bC0zLjY5Ny0xLjgzYy0yLjI5Ny0xLjEzNi0zLjQ0NS0xLjcwNC00LjUzNy0xLjc3N2E1LjUgNS41IDAgMCAwLTMuOTg4IDEuMzQ4Yy0uODIzLjcyLTEuMzkxIDEuODY5LTIuNTI4IDQuMTY2bTIyLjcxLTEwLjI0MmE1LjUgNS41IDAgMSAxLTkuODYtNC44OCA1LjUgNS41IDAgMCAxIDkuODYgNC44OCIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjcSkiPjxwYXRoIGQ9Im0yMTIuMjUgOTEuOTI0LjczNy0yLjY1YTUuNTA0IDUuNTA0IDAgMCAwLTIuNTQ4LTYuMjM3bS0uMjc2LTE2Ljk2OGE1LjUwMyA1LjUwMyAwIDAgMS0yLjczMyA5LjgyOG0tMS44MDQgMTQuMTg1Yy42ODctMi40NyAxLjAzLTMuNzA0Ljg5Ny00Ljc5YTUuNSA1LjUgMCAwIDAtMi4wNy0zLjY2NWMtLjg2Mi0uNjc0LTIuMDk2LTEuMDE3LTQuNTY1LTEuNzA0bC0zLjk3NC0xLjEwNWMtMi40NjktLjY4Ni0zLjcwNC0xLjAzLTQuNzktLjg5N2E1LjUgNS41IDAgMCAwLTMuNjY1IDIuMDdjLS42NzQuODYyLTEuMDE3IDIuMDk2LTEuNzA0IDQuNTY1bTIwLjM5Mi0xNC4zMWE1LjUgNS41IDAgMSAxLTEwLjU5OS0yLjk0OCA1LjUgNS41IDAgMCAxIDEwLjU5OSAyLjk0OCIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjcikiPjxwYXRoIGQ9Im0xMDguODYyIDE3OS4xNDUtMS4yMDktMi40N2E1LjUgNS41IDAgMCAwLTYuMDQ2LTIuOTcxbS0xMS40NzUtMTIuNTAzYTUuNTAxIDUuNTAxIDAgMCAxIDQuNDgzIDkuMTYzbTguMDcxIDExLjgwM2MtMS4xMjYtMi4zMDItMS42ODktMy40NTMtMi41MS00LjE3N2E1LjUgNS41IDAgMCAwLTMuOTgxLTEuMzY1Yy0xLjA5Mi4wNjgtMi4yNDMuNjMxLTQuNTQ1IDEuNzU4bC0zLjcwNSAxLjgxM2MtMi4zMDIgMS4xMjYtMy40NTMgMS42ODktNC4xNzcgMi41MDlhNS41IDUuNSAwIDAgMC0xLjM2NiAzLjk4MmMuMDY5IDEuMDkyLjYzMiAyLjI0MyAxLjc1OCA0LjU0NW01Ljc0My0yNC4yNDFhNS41IDUuNSAwIDEgMS05Ljg4IDQuODM1IDUuNSA1LjUgMCAwIDEgOS44OC00LjgzNSIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjcykiPjxwYXRoIGQ9Im0xNTUuODYyIDI0Mi4xNDUtMS4yMDktMi40N2E1LjUgNS41IDAgMCAwLTYuMDQ2LTIuOTcxbS0xMS40NzUtMTIuNTAzYTUuNTAxIDUuNTAxIDAgMCAxIDQuNDgzIDkuMTYzbTguMDcxIDExLjgwM2MtMS4xMjYtMi4zMDItMS42ODktMy40NTMtMi41MS00LjE3N2E1LjUgNS41IDAgMCAwLTMuOTgxLTEuMzY1Yy0xLjA5Mi4wNjgtMi4yNDMuNjMxLTQuNTQ1IDEuNzU4bC0zLjcwNSAxLjgxM2MtMi4zMDIgMS4xMjYtMy40NTMgMS42ODktNC4xNzcgMi41MDlhNS41IDUuNSAwIDAgMC0xLjM2NiAzLjk4MmMuMDY5IDEuMDkyLjYzMiAyLjI0MyAxLjc1OCA0LjU0NW01Ljc0My0yNC4yNDFhNS41IDUuNSAwIDEgMS05Ljg4MiA0LjgzNSA1LjUgNS41IDAgMCAxIDkuODgyLTQuODM1IiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCN0KSI+PHBhdGggZD0ibTE2OS4xNTggNzA0LjM0IDEuMS0yLjUyMWE1LjUgNS41IDAgMCAwLTEuNjUyLTYuNTMxbTIuMDk0LTE2Ljg0MWE1LjUwMyA1LjUwMyAwIDAgMS00LjA3OCA5LjM1bS0zLjc2NiAxMy43OTVjMS4wMjUtMi4zNDkgMS41MzctMy41MjQgMS41NTctNC42MTdhNS41IDUuNSAwIDAgMC0xLjUzOC0zLjkxOWMtLjc1OS0uNzg4LTEuOTM0LTEuMy00LjI4My0yLjMyNGwtMy43ODEtMS42NDljLTIuMzQ5LTEuMDI1LTMuNTIzLTEuNTM3LTQuNjE3LTEuNTU3YTUuNSA1LjUgMCAwIDAtMy45MTkgMS41MzhjLS43ODcuNzYtMS4zIDEuOTM0LTIuMzI0IDQuMjgzbTIyLjE4OS0xMS4zMjRhNS41IDUuNSAwIDEgMS0xMC4wODMtNC4zOTcgNS41IDUuNSAwIDAgMSAxMC4wODMgNC4zOTciIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI3UpIj48cGF0aCBkPSJtNjUuNjc5IDg3NS4wOTMgMS4wMi0yLjU1NGMuOTUtMi4zOC4xMjItNS4wMy0xLjg1NS02LjQ3N20xLjU2OS0xNi44OTdhNS41IDUuNSAwIDAgMS0zLjc4NSA5LjQ3Mm0tMy4zMzQgMTMuOTA1Yy45NS0yLjM4IDEuNDI2LTMuNTY5IDEuNDEzLTQuNjYzYTUuNSA1LjUgMCAwIDAtMS42Ni0zLjg2OWMtLjc4NC0uNzY0LTEuOTczLTEuMjM5LTQuMzUzLTIuMTlsLTMuODMtMS41M2MtMi4zOC0uOTUxLTMuNTctMS40MjYtNC42NjUtMS40MTJhNS41IDUuNSAwIDAgMC0zLjg2OCAxLjY1OWMtLjc2NC43ODQtMS4yNCAxLjk3NC0yLjE5IDQuMzUzbTIxLjgyNi0xMi4wMDlhNS41IDUuNSAwIDEgMS0xMC4yMTYtNC4wODMgNS41IDUuNSAwIDAgMSAxMC4yMTYgNC4wODMiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxwYXRoIGQ9Ik0xOTQuMjUgODY4Ljg3NXYtMi43NWE1LjUgNS41IDAgMCAwLTQuMTI1LTUuMzI3bS00LjgxMi0xNi4yNzNhNS41MDIgNS41MDIgMCAwIDEgMCAxMC4ybTIuMDYyIDE0LjE1YzAtMi41NjMgMC0zLjg0NC0uNDE5LTQuODU1YTUuNSA1LjUgMCAwIDAtMi45NzYtMi45NzZjLTEuMDExLS40MTktMi4yOTItLjQxOS00Ljg1NS0uNDE5SDE3NWMtMi41NjMgMC0zLjg0NCAwLTQuODU1LjQxOWE1LjUgNS41IDAgMCAwLTIuOTc2IDIuOTc2Yy0uNDE5IDEuMDExLS40MTkgMi4yOTItLjQxOSA0Ljg1NW0xNS44MTMtMTkuMjVhNS41IDUuNSAwIDEgMS0xMSAwIDUuNSA1LjUgMCAwIDEgMTEgMG0xMjEuNjg3LTU4Ljc1di0yLjc1YTUuNSA1LjUgMCAwIDAtNC4xMjUtNS4zMjdtLTQuODEyLTE2LjI3M2E1LjUwMiA1LjUwMiAwIDAgMSAwIDEwLjJtMi4wNjIgMTQuMTVjMC0yLjU2MyAwLTMuODQ0LS40MTktNC44NTVhNS41IDUuNSAwIDAgMC0yLjk3Ni0yLjk3NmMtMS4wMTEtLjQxOS0yLjI5Mi0uNDE5LTQuODU1LS40MTlIMjg1Yy0yLjU2MyAwLTMuODQ0IDAtNC44NTUuNDE5YTUuNSA1LjUgMCAwIDAtMi45NzYgMi45NzZjLS40MTkgMS4wMTEtLjQxOSAyLjI5Mi0uNDE5IDQuODU1bTE1LjgxMy0xOS4yNWE1LjUgNS41IDAgMSAxLTExIDAgNS41IDUuNSAwIDAgMSAxMSAwbTUwLjY4Ny0xMDUuNzV2LTIuNzVhNS41IDUuNSAwIDAgMC00LjEyNS01LjMyN20tNC44MTItMTYuMjczYTUuNTAyIDUuNTAyIDAgMCAxIDAgMTAuMm0yLjA2MiAxNC4xNWMwLTIuNTYzIDAtMy44NDQtLjQxOS00Ljg1NWE1LjUgNS41IDAgMCAwLTIuOTc2LTIuOTc2Yy0xLjAxMS0uNDE5LTIuMjkyLS40MTktNC44NTUtLjQxOUgzMjRjLTIuNTYzIDAtMy44NDQgMC00Ljg1NS40MTlhNS41IDUuNSAwIDAgMC0yLjk3NiAyLjk3NmMtLjQxOSAxLjAxMS0uNDE5IDIuMjkyLS40MTkgNC44NTVtMTUuODEzLTE5LjI1YTUuNSA1LjUgMCAxIDEtMTEgMCA1LjUgNS41IDAgMCAxIDExIDAiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMDgiLz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCN2KSI+PHBhdGggZD0ibTE2MC4yMzMgNjAzLjgyNiAxLjE0MS0yLjUwMmE1LjUgNS41IDAgMCAwLTEuNTQyLTYuNTU5bTIuMzc2LTE2LjgwM2E1LjUgNS41IDAgMCAxLTQuMjMzIDkuMjgxbS0zLjk5NyAxMy43MjljMS4wNjQtMi4zMzEgMS41OTYtMy40OTcgMS42MzQtNC41OTFhNS41IDUuNSAwIDAgMC0xLjQ3Mi0zLjk0M2MtLjc0Ni0uODAxLTEuOTEyLTEuMzMyLTQuMjQzLTIuMzk2bC0zLjc1My0xLjcxMmMtMi4zMzItMS4wNjQtMy40OTgtMS41OTYtNC41OTEtMS42MzRhNS41IDUuNSAwIDAgMC0zLjk0MyAxLjQ3MmMtLjgwMS43NDYtMS4zMzMgMS45MTItMi4zOTYgNC4yNDNtMjIuMzc2LTEwLjk1YTUuNSA1LjUgMCAxIDEtMTAuMDA4LTQuNTY1IDUuNSA1LjUgMCAwIDEgMTAuMDA4IDQuNTY1IiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCN3KSI+PHBhdGggZD0ibTgxLjM0IDY2NC42MzIgMS4xMS0yLjUxNmE1LjUgNS41IDAgMCAwLTEuNjIyLTYuNTM5bTIuMTY5LTE2LjgzMWE1LjUwMiA1LjUwMiAwIDAgMS00LjExOSA5LjMzMm0tMy44MjcgMTMuNzc3YzEuMDM1LTIuMzQ0IDEuNTUyLTMuNTE2IDEuNTc3LTQuNjFhNS41IDUuNSAwIDAgMC0xLjUyLTMuOTI1Yy0uNzU2LS43OTEtMS45MjktMS4zMDktNC4yNzMtMi4zNDRsLTMuNzc0LTEuNjY1Yy0yLjM0NC0xLjAzNS0zLjUxNi0xLjU1My00LjYxLTEuNTc4YTUuNSA1LjUgMCAwIDAtMy45MjUgMS41MjFjLS43OTEuNzU2LTEuMzA5IDEuOTI4LTIuMzQ0IDQuMjczbTIyLjI0LTExLjIyNmE1LjUgNS41IDAgMSAxLTEwLjA2NC00LjQ0MyA1LjUgNS41IDAgMCAxIDEwLjA2NCA0LjQ0MyIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjeCkiPjxwYXRoIGQ9Im0zNDEuMTcxIDI0NC4xMzUtLjAxMi0uMjQ4Yy0uMDg4LTEuNzE5LS4xMzItMi41NzktLjQwOS0zLjM0OGE1LjUgNS41IDAgMCAwLTEuMTA5LTEuODM5Yy0uNTUtLjYwNC0xLjI5LTEuMDQ0LTIuNzctMS45MjVsLTEuNjI0LS45NjdjLTEuMzIzLS43ODgtMS45ODUtMS4xODItMi4zMzctMS43NGEyLjc1IDIuNzUgMCAwIDEtLjQxOC0xLjY0OGMuMDQzLS42NTguNDM3LTEuMzIgMS4yMjUtMi42NDRsNi4wNDgtMTAuMTYxYy43ODgtMS4zMjMgMS4xODItMS45ODUgMS43NC0yLjMzN2EyLjc1IDIuNzUgMCAwIDEgMS42NDgtLjQxOGMuNjU4LjA0MyAxLjMyLjQzNyAyLjY0MyAxLjIyNWwuNDczLjI4MWMyLjY0NyAxLjU3NiAzLjk3IDIuMzY0IDQuNjc1IDMuNDgxLjYxOS45ODIuOTEyIDIuMTM1LjgzNiAzLjI5NC0uMDg3IDEuMzE4LS44NzUgMi42NDEtMi40NSA1LjI4OG0tOC4xNTkgMTMuNzA2IDguMTU5LTEzLjcwNm0tOC4xNTkgMTMuNzA2LjIyNC0uMTA3YzEuNTU0LS43NDMgMi4zMzEtMS4xMTQgMy4xMzgtMS4yMzdhNS41IDUuNSAwIDAgMSAyLjE0Ni4wOThjLjc5My4xOTYgMS41MzMuNjM2IDMuMDEyIDEuNTE3bDEuNjI1Ljk2N2MxLjMyMy43ODggMS45ODUgMS4xODEgMi42NDQgMS4yMjVhMi43NSAyLjc1IDAgMCAwIDEuNjQ3LS40MThjLjU1OC0uMzUyLjk1Mi0xLjAxNCAxLjc0LTIuMzM4bDYuMDQ5LTEwLjE2MWMuNzg3LTEuMzIzIDEuMTgxLTEuOTg1IDEuMjI0LTIuNjQ0YTIuNzUgMi43NSAwIDAgMC0uNDE3LTEuNjQ3Yy0uMzUzLS41NTgtMS4wMTQtLjk1Mi0yLjMzOC0xLjc0bC0uNDcyLS4yODFjLTIuNjQ3LTEuNTc2LTMuOTcxLTIuMzY0LTUuMjg4LTIuNDVhNS41IDUuNSAwIDAgMC0zLjI5NS44MzZjLTEuMTE3LjcwNC0xLjkwNSAyLjAyNy0zLjQ4IDQuNjc0IiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCN5KSI+PHBhdGggZD0ibTE5MS4yODkgMzI5LjI1Mi0uMDEzLS4yNDhjLS4wODgtMS43MTktLjEzMi0yLjU3OS0uNDA5LTMuMzQ3YTUuNSA1LjUgMCAwIDAtMS4xMDktMS44NGMtLjU1LS42MDQtMS4yOS0xLjA0NC0yLjc2OS0xLjkyNWwtMS42MjUtLjk2N2MtMS4zMjMtLjc4OC0xLjk4NS0xLjE4Mi0yLjMzNy0xLjc0YTIuNzUgMi43NSAwIDAgMS0uNDE4LTEuNjQ3Yy4wNDMtLjY1OS40MzctMS4zMjEgMS4yMjUtMi42NDRsNi4wNDgtMTAuMTYxYy43ODgtMS4zMjQgMS4xODItMS45ODYgMS43NC0yLjMzOGEyLjc1IDIuNzUgMCAwIDEgMS42NDgtLjQxOGMuNjU5LjA0NCAxLjMyLjQzNyAyLjY0NCAxLjIyNWwuNDcyLjI4MmMyLjY0NyAxLjU3NSAzLjk3MSAyLjM2MyA0LjY3NSAzLjQ4LjYxOS45ODIuOTEyIDIuMTM2LjgzNiAzLjI5NS0uMDg3IDEuMzE3LS44NzUgMi42NDEtMi40NSA1LjI4N20tOC4xNTggMTMuNzA2IDguMTU4LTEzLjcwNm0tOC4xNTggMTMuNzA2LjIyMy0uMTA3YzEuNTU0LS43NDIgMi4zMzEtMS4xMTQgMy4xMzgtMS4yMzdhNS41IDUuNSAwIDAgMSAyLjE0Ni4wOThjLjc5My4xOTYgMS41MzMuNjM2IDMuMDEyIDEuNTE3bDEuNjI1Ljk2N2MxLjMyMy43ODggMS45ODUgMS4xODIgMi42NDQgMS4yMjVhMi43NSAyLjc1IDAgMCAwIDEuNjQ3LS40MThjLjU1OS0uMzUyLjk1My0xLjAxNCAxLjc0LTIuMzM3bDYuMDQ5LTEwLjE2MWMuNzg3LTEuMzI0IDEuMTgxLTEuOTg2IDEuMjI1LTIuNjQ0YTIuNzYgMi43NiAwIDAgMC0uNDE4LTEuNjQ4Yy0uMzUyLS41NTgtMS4wMTQtLjk1Mi0yLjMzOC0xLjc0bC0uNDcyLS4yODFjLTIuNjQ3LTEuNTc2LTMuOTcxLTIuMzY0LTUuMjg4LTIuNDVhNS41IDUuNSAwIDAgMC0zLjI5NS44MzZjLTEuMTE3LjcwNC0xLjkwNSAyLjAyOC0zLjQ4IDQuNjc0IiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCN6KSI+PHBhdGggZD0ibTMzOS4yODkgMTU3LjI1Mi0uMDEzLS4yNDhjLS4wODgtMS43MTktLjEzMi0yLjU3OS0uNDA5LTMuMzQ3YTUuNSA1LjUgMCAwIDAtMS4xMDktMS44NGMtLjU1LS42MDQtMS4yOS0xLjA0NC0yLjc2OS0xLjkyNWwtMS42MjUtLjk2N2MtMS4zMjMtLjc4OC0xLjk4NS0xLjE4Mi0yLjMzNy0xLjc0YTIuNzUgMi43NSAwIDAgMS0uNDE4LTEuNjQ3Yy4wNDMtLjY1OS40MzctMS4zMjEgMS4yMjUtMi42NDRsNi4wNDgtMTAuMTYxYy43ODgtMS4zMjQgMS4xODItMS45ODYgMS43NC0yLjMzOGEyLjc1IDIuNzUgMCAwIDEgMS42NDgtLjQxOGMuNjU5LjA0NCAxLjMyLjQzNyAyLjY0NCAxLjIyNWwuNDcyLjI4MmMyLjY0NyAxLjU3NSAzLjk3MSAyLjM2MyA0LjY3NSAzLjQ4LjYxOS45ODIuOTEyIDIuMTM2LjgzNiAzLjI5NS0uMDg3IDEuMzE3LS44NzUgMi42NDEtMi40NSA1LjI4N20tOC4xNTggMTMuNzA2IDguMTU4LTEzLjcwNm0tOC4xNTggMTMuNzA2LjIyMy0uMTA3YzEuNTU0LS43NDIgMi4zMzEtMS4xMTQgMy4xMzgtMS4yMzdhNS41IDUuNSAwIDAgMSAyLjE0Ni4wOThjLjc5My4xOTYgMS41MzMuNjM2IDMuMDEyIDEuNTE3bDEuNjI1Ljk2N2MxLjMyMy43ODggMS45ODUgMS4xODIgMi42NDQgMS4yMjVhMi43NSAyLjc1IDAgMCAwIDEuNjQ3LS40MThjLjU1OS0uMzUyLjk1My0xLjAxNCAxLjc0LTIuMzM3bDYuMDQ5LTEwLjE2MWMuNzg3LTEuMzI0IDEuMTgxLTEuOTg2IDEuMjI1LTIuNjQ0YTIuNzYgMi43NiAwIDAgMC0uNDE4LTEuNjQ4Yy0uMzUyLS41NTgtMS4wMTQtLjk1Mi0yLjMzOC0xLjc0bC0uNDcyLS4yODFjLTIuNjQ3LTEuNTc2LTMuOTcxLTIuMzY0LTUuMjg4LTIuNDVhNS41IDUuNSAwIDAgMC0zLjI5NS44MzZjLTEuMTE3LjcwNC0xLjkwNSAyLjAyOC0zLjQ4IDQuNjc0IiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCNBKSI+PHBhdGggZD0ibTE0Ny4zOTggMTMwLjI1My0uMjItLjExNGMtMS41MjgtLjc5My0yLjI5My0xLjE4OS0zLjA5Ni0xLjMzOGE1LjUgNS41IDAgMCAwLTIuMTQ4LjAyN2MtLjc5OS4xNy0xLjU1Mi41ODYtMy4wNiAxLjQxOGwtMS42NTUuOTEzYy0xLjM0OS43NDUtMi4wMjMgMS4xMTctMi42ODMgMS4xMzhhMi43NCAyLjc0IDAgMCAxLTEuNjMyLS40NzFjLS41NDctLjM3LS45MTktMS4wNDUtMS42NjMtMi4zOTNsLTUuNzE0LTEwLjM1M2MtLjc0NC0xLjM0OS0xLjExNi0yLjAyMy0xLjEzOC0yLjY4M2EyLjc1IDIuNzUgMCAwIDEgLjQ3Mi0xLjYzM2MuMzctLjU0NiAxLjA0NC0uOTE4IDIuMzkzLTEuNjYybC40ODEtLjI2NmMyLjY5Ny0xLjQ4OCA0LjA0Ni0yLjIzMyA1LjM2NS0yLjI3NmE1LjUgNS41IDAgMCAxIDMuMjY2Ljk0M2MxLjA5My43NCAxLjgzNyAyLjA4OSAzLjMyNiA0Ljc4Nm03LjcwNiAxMy45NjQtNy43MDYtMTMuOTY0bTcuNzA2IDEzLjk2NC4wMjEtLjI0N2MuMTQ0LTEuNzE2LjIxNi0yLjU3My41MTgtMy4zMzJhNS41IDUuNSAwIDAgMSAxLjE2OC0xLjgwM2MuNTctLjU4NSAxLjMyNC0xLjAwMSAyLjgzMS0xLjgzM2wxLjY1NS0uOTE0YzEuMzQ5LS43NDQgMi4wMjMtMS4xMTYgMi4zOTMtMS42NjMuMzI2LS40OC40OTEtMS4wNTIuNDcyLTEuNjMyLS4wMjItLjY2LS4zOTQtMS4zMzQtMS4xMzgtMi42ODNsLTUuNzE0LTEwLjM1M2MtLjc0NC0xLjM0OS0xLjExNi0yLjAyMy0xLjY2Mi0yLjM5M2EyLjc1IDIuNzUgMCAwIDAtMS42MzMtLjQ3MmMtLjY2LjAyMi0xLjMzNC4zOTQtMi42ODMgMS4xMzhsLS40ODEuMjY2Yy0yLjY5NyAxLjQ4OS00LjA0NiAyLjIzMy00Ljc4NiAzLjMyNmE1LjUgNS41IDAgMCAwLS45NDMgMy4yNjZjLjA0MyAxLjMxOS43ODcgMi42NjggMi4yNzYgNS4zNjUiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI0IpIj48cGF0aCBkPSJtMzAwLjM5OCA2MDIuMjUzLS4yMi0uMTE0Yy0xLjUyOC0uNzkzLTIuMjkzLTEuMTg5LTMuMDk2LTEuMzM4YTUuNSA1LjUgMCAwIDAtMi4xNDguMDI3Yy0uNzk5LjE3LTEuNTUyLjU4Ni0zLjA2IDEuNDE4bC0xLjY1NS45MTNjLTEuMzQ5Ljc0NS0yLjAyMyAxLjExNy0yLjY4MyAxLjEzOGEyLjc0IDIuNzQgMCAwIDEtMS42MzItLjQ3MWMtLjU0Ny0uMzctLjkxOS0xLjA0NS0xLjY2My0yLjM5M2wtNS43MTQtMTAuMzUzYy0uNzQ0LTEuMzQ5LTEuMTE2LTIuMDIzLTEuMTM4LTIuNjgzYTIuNzUgMi43NSAwIDAgMSAuNDcyLTEuNjMzYy4zNy0uNTQ2IDEuMDQ0LS45MTggMi4zOTMtMS42NjJsLjQ4MS0uMjY2YzIuNjk3LTEuNDg4IDQuMDQ2LTIuMjMzIDUuMzY1LTIuMjc2YTUuNSA1LjUgMCAwIDEgMy4yNjYuOTQzYzEuMDkzLjc0IDEuODM3IDIuMDg5IDMuMzI2IDQuNzg2bTcuNzA2IDEzLjk2NC03LjcwNi0xMy45NjRtNy43MDYgMTMuOTY0LjAyMS0uMjQ3Yy4xNDQtMS43MTYuMjE2LTIuNTczLjUxOC0zLjMzMmE1LjUgNS41IDAgMCAxIDEuMTY4LTEuODAzYy41Ny0uNTg1IDEuMzI0LTEuMDAxIDIuODMxLTEuODMzbDEuNjU1LS45MTRjMS4zNDktLjc0NCAyLjAyMy0xLjExNiAyLjM5My0xLjY2My4zMjYtLjQ4LjQ5MS0xLjA1Mi40NzItMS42MzItLjAyMi0uNjYtLjM5NC0xLjMzNC0xLjEzOC0yLjY4M2wtNS43MTQtMTAuMzUzYy0uNzQ0LTEuMzQ5LTEuMTE2LTIuMDIzLTEuNjYyLTIuMzkzYTIuNzUgMi43NSAwIDAgMC0xLjYzMy0uNDcyYy0uNjYuMDIyLTEuMzM0LjM5NC0yLjY4MyAxLjEzOGwtLjQ4MS4yNjZjLTIuNjk3IDEuNDg5LTQuMDQ2IDIuMjMzLTQuNzg2IDMuMzI2YTUuNSA1LjUgMCAwIDAtLjk0MyAzLjI2NmMuMDQzIDEuMzE5Ljc4NyAyLjY2OCAyLjI3NiA1LjM2NSIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjQykiPjxwYXRoIGQ9Im0zNTUuMzk4IDc1NS4yNTMtLjIyLS4xMTRjLTEuNTI4LS43OTMtMi4yOTMtMS4xODktMy4wOTYtMS4zMzhhNS41IDUuNSAwIDAgMC0yLjE0OC4wMjdjLS43OTkuMTctMS41NTIuNTg2LTMuMDYgMS40MThsLTEuNjU1LjkxM2MtMS4zNDkuNzQ1LTIuMDIzIDEuMTE3LTIuNjgzIDEuMTM4YTIuNzQgMi43NCAwIDAgMS0xLjYzMi0uNDcxYy0uNTQ3LS4zNy0uOTE5LTEuMDQ1LTEuNjYzLTIuMzkzbC01LjcxNC0xMC4zNTNjLS43NDQtMS4zNDktMS4xMTYtMi4wMjMtMS4xMzgtMi42ODNhMi43NSAyLjc1IDAgMCAxIC40NzItMS42MzNjLjM3LS41NDYgMS4wNDQtLjkxOCAyLjM5My0xLjY2MmwuNDgxLS4yNjZjMi42OTctMS40ODggNC4wNDYtMi4yMzMgNS4zNjUtMi4yNzZhNS41IDUuNSAwIDAgMSAzLjI2Ni45NDNjMS4wOTMuNzQgMS44MzcgMi4wODkgMy4zMjYgNC43ODZtNy43MDYgMTMuOTY0LTcuNzA2LTEzLjk2NG03LjcwNiAxMy45NjQuMDIxLS4yNDdjLjE0NC0xLjcxNi4yMTYtMi41NzMuNTE4LTMuMzMyYTUuNSA1LjUgMCAwIDEgMS4xNjgtMS44MDNjLjU3LS41ODUgMS4zMjQtMS4wMDEgMi44MzEtMS44MzNsMS42NTUtLjkxNGMxLjM0OS0uNzQ0IDIuMDIzLTEuMTE2IDIuMzkzLTEuNjYzLjMyNi0uNDguNDkxLTEuMDUyLjQ3Mi0xLjYzMi0uMDIyLS42Ni0uMzk0LTEuMzM0LTEuMTM4LTIuNjgzbC01LjcxNC0xMC4zNTNjLS43NDQtMS4zNDktMS4xMTYtMi4wMjMtMS42NjItMi4zOTNhMi43NSAyLjc1IDAgMCAwLTEuNjMzLS40NzJjLS42Ni4wMjItMS4zMzQuMzk0LTIuNjgzIDEuMTM4bC0uNDgxLjI2NmMtMi42OTcgMS40ODktNC4wNDYgMi4yMzMtNC43ODYgMy4zMjZhNS41IDUuNSAwIDAgMC0uOTQzIDMuMjY2Yy4wNDMgMS4zMTkuNzg3IDIuNjY4IDIuMjc2IDUuMzY1IiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCNEKSI+PHBhdGggZD0ibTUzLjQ0OCA3NDYuODg3LjAyOC0uMjQ3Yy4xOTItMS43MTEuMjg4LTIuNTY2LjE0LTMuMzdhNS41IDUuNSAwIDAgMC0uNzk3LTEuOTk1Yy0uNDQ1LS42ODUtMS4xMDQtMS4yMzktMi40MjEtMi4zNDhsLTEuNDQ2LTEuMjE3Yy0xLjE3OS0uOTkyLTEuNzY4LTEuNDg4LTIuMDI1LTIuMDk2YTIuNzUgMi43NSAwIDAgMS0uMTQ1LTEuNjkzYy4xNS0uNjQzLjY0NS0xLjIzMyAxLjYzNy0yLjQxMWw3LjYxNS05LjA0N2MuOTkyLTEuMTc4IDEuNDg3LTEuNzY3IDIuMDk2LTIuMDI0YTIuNzUgMi43NSAwIDAgMSAxLjY5My0uMTQ2Yy42NDMuMTUgMS4yMzIuNjQ2IDIuNDEgMS42MzhsLjQyMS4zNTRjMi4zNTcgMS45ODMgMy41MzUgMi45NzUgNC4wNSA0LjE5MWE1LjUgNS41IDAgMCAxIC4yOSAzLjM4N2MtLjI5OSAxLjI4Ni0xLjI5IDIuNDY1LTMuMjc0IDQuODIxbS0xMC4yNzIgMTIuMjAzIDEwLjI3Mi0xMi4yMDNtLTEwLjI3MiAxMi4yMDMuMjM5LS4wN2MxLjY1My0uNDgxIDIuNDgtLjcyMSAzLjI5Ni0uNzExYTUuNSA1LjUgMCAwIDEgMi4xMDIuNDQ0Yy43NS4zMjEgMS40MS44NzYgMi43MjcgMS45ODVsMS40NDYgMS4yMTdjMS4xNzguOTkyIDEuNzY3IDEuNDg4IDIuNDEgMS42MzdhMi43NSAyLjc1IDAgMCAwIDEuNjk0LS4xNDVjLjYwOC0uMjU3IDEuMTA0LS44NDYgMi4wOTYtMi4wMjVsNy42MTUtOS4wNDZjLjk5Mi0xLjE3OSAxLjQ4Ny0xLjc2OCAxLjYzNy0yLjQxMWEyLjc1IDIuNzUgMCAwIDAtLjE0Ni0xLjY5M2MtLjI1Ny0uNjA4LS44NDYtMS4xMDQtMi4wMjQtMi4wOTZsLS40Mi0uMzU0Yy0yLjM1OC0xLjk4NC0zLjUzNi0yLjk3Ni00LjgyMi0zLjI3NWE1LjUgNS41IDAgMCAwLTMuMzg3LjI5MWMtMS4yMTYuNTE0LTIuMjA4IDEuNjkzLTQuMTkxIDQuMDQ5IiBzdHJva2U9IiMzNDQwNTQiIHN0cm9rZS13aWR0aD0iMS40MTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvZz48ZyBvcGFjaXR5PSIuMDgiIGNsaXAtcGF0aD0idXJsKCNFKSI+PHBhdGggZD0ibTY2LjI3OSAzNDUuNzE3LjAyNy0uMjQ3Yy4xOTItMS43MTEuMjg4LTIuNTY2LjE0LTMuMzY5YTUuNSA1LjUgMCAwIDAtLjc5Ny0xLjk5NmMtLjQ0NS0uNjg0LTEuMTA0LTEuMjM5LTIuNDIxLTIuMzQ4bC0xLjQ0Ni0xLjIxN2MtMS4xNzktLjk5Mi0xLjc2OC0xLjQ4OC0yLjAyNS0yLjA5NmEyLjc1IDIuNzUgMCAwIDEtLjE0NS0xLjY5M2MuMTUtLjY0My42NDUtMS4yMzIgMS42MzctMi40MTFsNy42MTUtOS4wNDdjLjk5Mi0xLjE3OCAxLjQ4Ny0xLjc2NyAyLjA5Ni0yLjAyNGEyLjc2IDIuNzYgMCAwIDEgMS42OTMtLjE0NmMuNjQzLjE1IDEuMjMyLjY0NiAyLjQxIDEuNjM4bC40MjEuMzU0YzIuMzU3IDEuOTgzIDMuNTM1IDIuOTc1IDQuMDUgNC4xOTJhNS41IDUuNSAwIDAgMSAuMjkgMy4zODZjLS4yOTkgMS4yODYtMS4yOSAyLjQ2NS0zLjI3NCA0LjgyMW0tMTAuMjcyIDEyLjIwMyAxMC4yNzItMTIuMjAzbS0xMC4yNzIgMTIuMjAzLjIzOS0uMDY5YzEuNjUzLS40ODEgMi40OC0uNzIyIDMuMjk2LS43MTJhNS41IDUuNSAwIDAgMSAyLjEwMi40NDRjLjc1LjMyMiAxLjQxLjg3NiAyLjcyNyAxLjk4NWwxLjQ0NiAxLjIxN2MxLjE3OC45OTIgMS43NjggMS40ODggMi40MSAxLjYzN2EyLjc1IDIuNzUgMCAwIDAgMS42OTQtLjE0NWMuNjA4LS4yNTcgMS4xMDQtLjg0NiAyLjA5Ni0yLjAyNWw3LjYxNS05LjA0NmMuOTkyLTEuMTc5IDEuNDg3LTEuNzY4IDEuNjM3LTIuNDExYTIuNzUgMi43NSAwIDAgMC0uMTQ2LTEuNjkzYy0uMjU3LS42MDgtLjg0Ni0xLjEwNC0yLjAyNC0yLjA5NmwtLjQyLS4zNTRjLTIuMzU3LTEuOTg0LTMuNTM2LTIuOTc2LTQuODIyLTMuMjc1YTUuNSA1LjUgMCAwIDAtMy4zODYuMjkxYy0xLjIxNy41MTQtMi4yMDkgMS42OTMtNC4xOTIgNC4wNDkiIHN0cm9rZT0iIzM0NDA1NCIgc3Ryb2tlLXdpZHRoPSIxLjQxNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxnIG9wYWNpdHk9Ii4wOCIgY2xpcC1wYXRoPSJ1cmwoI0YpIj48cGF0aCBkPSJtMTIyLjI3OSA0OTguNzE3LjAyNy0uMjQ3Yy4xOTItMS43MTEuMjg4LTIuNTY2LjEzOS0zLjM2OWE1LjUgNS41IDAgMCAwLS43OTYtMS45OTZjLS40NDUtLjY4NC0xLjEwNC0xLjIzOS0yLjQyMS0yLjM0OGwtMS40NDYtMS4yMTdjLTEuMTc5LS45OTItMS43NjgtMS40ODgtMi4wMjUtMi4wOTZhMi43NSAyLjc1IDAgMCAxLS4xNDUtMS42OTNjLjE0OS0uNjQzLjY0NS0xLjIzMiAxLjYzNy0yLjQxMWw3LjYxNS05LjA0N2MuOTkyLTEuMTc4IDEuNDg4LTEuNzY3IDIuMDk2LTIuMDI0YTIuNzUgMi43NSAwIDAgMSAxLjY5My0uMTQ2Yy42NDMuMTUgMS4yMzIuNjQ2IDIuNDEgMS42MzhsLjQyMS4zNTRjMi4zNTcgMS45ODMgMy41MzUgMi45NzUgNC4wNDkgNC4xOTJhNS41IDUuNSAwIDAgMSAuMjkxIDMuMzg2Yy0uMjk5IDEuMjg2LTEuMjkxIDIuNDY1LTMuMjc0IDQuODIxbS0xMC4yNzEgMTIuMjAzIDEwLjI3MS0xMi4yMDNtLTEwLjI3MSAxMi4yMDMuMjM4LS4wNjljMS42NTMtLjQ4MSAyLjQ4LS43MjIgMy4yOTYtLjcxMmE1LjUgNS41IDAgMCAxIDIuMTAyLjQ0NGMuNzUxLjMyMiAxLjQxLjg3NiAyLjcyNyAxLjk4NWwxLjQ0NiAxLjIxN2MxLjE3OC45OTIgMS43NjggMS40ODggMi40MTEgMS42MzdhMi43NSAyLjc1IDAgMCAwIDEuNjkzLS4xNDVjLjYwOC0uMjU3IDEuMTA0LS44NDYgMi4wOTYtMi4wMjVsNy42MTUtOS4wNDZjLjk5Mi0xLjE3OSAxLjQ4Ny0xLjc2OCAxLjYzNy0yLjQxMWEyLjc1IDIuNzUgMCAwIDAtLjE0Ni0xLjY5M2MtLjI1Ny0uNjA4LS44NDYtMS4xMDQtMi4wMjQtMi4wOTZsLS40MjEtLjM1NGMtMi4zNTYtMS45ODQtMy41MzUtMi45NzYtNC44MjEtMy4yNzVhNS41IDUuNSAwIDAgMC0zLjM4Ny4yOTFjLTEuMjE2LjUxNC0yLjIwOCAxLjY5My00LjE5MSA0LjA0OSIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGcgb3BhY2l0eT0iLjA4IiBjbGlwLXBhdGg9InVybCgjRykiPjxwYXRoIGQ9Im0xODYuOTA5IDc5MS41NTEtLjExNC0uMjJjLS43OTQtMS41MjgtMS4xOTItMi4yOTEtMS43NjMtMi44NzVhNS41IDUuNSAwIDAgMC0xLjc3My0xLjIxM2MtLjc1MS0uMzIxLTEuNjA3LS40MTQtMy4zMTktLjZsLTEuODc5LS4yMDVjLTEuNTMxLS4xNjctMi4yOTctLjI1LTIuODQ5LS42MTJhMi43NiAyLjc2IDAgMCAxLTEuMDY1LTEuMzI0Yy0uMjM0LS42MTgtLjE1LTEuMzgzLjAxNi0yLjkxNGwxLjI4MS0xMS43NTZjLjE2Ni0xLjUzMS4yNS0yLjI5Ni42MTEtMi44NDlhMi43NSAyLjc1IDAgMCAxIDEuMzI1LTEuMDY0Yy42MTctLjIzNSAxLjM4My0uMTUxIDIuOTE0LjAxNWwuNTQ3LjA2YzMuMDYyLjMzMyA0LjU5My41IDUuNjk4IDEuMjIzYTUuNSA1LjUgMCAwIDEgMi4xMjkgMi42NWMuNDY5IDEuMjM1LjMwMiAyLjc2Ni0uMDMyIDUuODI4bS0xLjcyNyAxNS44NTYgMS43MjctMTUuODU2bS0xLjcyNyAxNS44NTYuMTYtLjE5YzEuMTA0LTEuMzIxIDEuNjU3LTEuOTgxIDIuMzQtMi40MjlhNS41IDUuNSAwIDAgMSAxLjk5My0uODAyYy44MDItLjE1MiAxLjY1OC0uMDU4IDMuMzcuMTI4bDEuODc5LjIwNWMxLjUzMS4xNjYgMi4yOTcuMjUgMi45MTQuMDE2YTIuNzUgMi43NSAwIDAgMCAxLjMyNS0xLjA2NWMuMzYyLS41NTIuNDQ1LTEuMzE4LjYxMi0yLjg0OWwxLjI4LTExLjc1NmMuMTY3LTEuNTMxLjI1LTIuMjk2LjAxNi0yLjkxM2EyLjc1IDIuNzUgMCAwIDAtMS4wNjUtMS4zMjVjLS41NTItLjM2Mi0xLjMxOC0uNDQ1LTIuODQ5LS42MTJsLS41NDctLjA2Yy0zLjA2Mi0uMzMzLTQuNTkzLS41LTUuODI3LS4wMzFhNS41IDUuNSAwIDAgMC0yLjY1IDIuMTI5Yy0uNzIzIDEuMTA1LS44OSAyLjYzNi0xLjIyNCA1LjY5OCIgc3Ryb2tlPSIjMzQ0MDU0IiBzdHJva2Utd2lkdGg9IjEuNDE0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzMgNzQuNzggNjIuNTAzIDYwbDE0Ljc4IDI5LjUwNC0yOS41MDUgMTQuNzh6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImIiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0xNzUuOTk4IDE2OC43NzkgMjkuNTA1LTE0Ljc4IDE0Ljc4IDI5LjUwNS0yOS41MDUgMTQuNzh6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImMiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0yNTUuOTk4IDI3My43NzggMjkuNTA1LTE0Ljc4IDE0Ljc4IDI5LjUwNS0yOS41MDUgMTQuNzh6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9ImQiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im01Mi45OTkgNTMxLjc3NiAyOS41MDUtMTQuNzggMTQuNzggMjkuNTA1LTI5LjUwNSAxNC43OHoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iZSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTIwNi45OTcgNjgwLjc3NSAyOS41MDUtMTQuNzggMTQuNzggMjkuNTA1LTI5LjUwNSAxNC43OHoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iZiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTIwOS45OTggNTk0Ljc3NiAyOS41MDUtMTQuNzggMTQuNzggMjkuNTA1LTI5LjUwNSAxNC43OHoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTMwNS45OTcgMzk5Ljc3OCAyOS41MDUtMTQuNzggMTQuNzggMjkuNTA0LTI5LjUwNSAxNC43OHoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iaCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTc3Ljk5OCA3NzYuNzc0IDI5LjUwNS0xNC43OCAxNC43OCAyOS41MDUtMjkuNTA1IDE0Ljc4eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJpIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMzEyLjk5NyA0OTcuNzc3IDI5LjUwNS0xNC43OCAxNC43OCAyOS41MDUtMjkuNTA1IDE0Ljc4eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJqIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMzQxLjk5NyAzMzkuNzc4IDI5LjUwNS0xNC43OCAxNC43OCAyOS41MDUtMjkuNTA1IDE0Ljc4eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJrIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMzAgMjQ0Ljc3OCAyOS41MDQtMTQuNzggMTQuNzggMjkuNTA1LTI5LjUwNSAxNC43OHoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0ibCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTMyMy45OTYgODMyLjc3NCAyOS41MDUtMTQuNzggMTQuNzggMjkuNTA1LTI5LjUwNCAxNC43OHoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0ibSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTIwNy4wMDIgNTMwLjk5MiAzMS40NTItOS45ODkgOS45ODggMzEuNDUyLTMxLjQ1MiA5Ljk4OXoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0ibiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTU4LjQwNCA0MDIuMjc3IDI5LjMyNSAxNS4xMzQtMTUuMTM0IDI5LjMyNS0yOS4zMjUtMTUuMTM0eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJvIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMjc3LjA1NCAxNjEuNjMgMzEuMzEgMTAuNDI0LTEwLjQyMyAzMS4zMS0zMS4zMS0xMC40MjN6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9InAiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0zMzcuMDMyIDYyLjM5NiAyOS41NzcgMTQuNjM0LTE0LjYzNCAyOS41NzgtMjkuNTc4LTE0LjYzNXoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0icSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTE5MC44NDQgNTYuMDAxIDMxLjc5NCA4Ljg0MS04Ljg0MSAzMS43OTQtMzEuNzk0LTguODQxeiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtNjguOTk4IDE2Ni41MDIgMjkuNjQyLTE0LjUwNCAxNC41MDQgMjkuNjQyLTI5LjY0MiAxNC41MDR6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9InMiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0xMTUuOTk3IDIyOS41MDEgMjkuNjQyLTE0LjUwMyAxNC41MDQgMjkuNjQyLTI5LjY0MiAxNC41MDN6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9InQiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0xNTIuOTczIDY2NS43NjggMzAuMjQ4IDEzLjE5Mi0xMy4xOTEgMzAuMjQ4LTMwLjI0OS0xMy4xOTF6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9InUiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im00OC4yOTkgODM3LjA1NiAzMC42NDUgMTIuMjQzTDY2LjcgODc5Ljk0NCAzNi4wNTYgODY3Ljd6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9InYiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNDQuNjk3IDU2NS4wMDIgMTc0LjcyIDU3OC43bC0xMy42OTcgMzAuMDI0TDEzMSA1OTUuMDI2eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJ3Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJtNjUuMzI2IDYyNi4wMDIgMzAuMTkgMTMuMzI2LTEzLjMyNiAzMC4xOUw1MiA2NTYuMTkyeiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJ4Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMzQxLjc2IDIxMC44ODEgMjguMzU3IDE2Ljg4LTE2Ljg4IDI4LjM1Ni0yOC4zNTYtMTYuODh6Ii8+PC9jbGlwUGF0aD48Y2xpcFBhdGggaWQ9InkiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0xOTEuODc5IDI5NS45OTggMjguMzU2IDE2Ljg3OS0xNi44NzkgMjguMzU3LTI4LjM1Ny0xNi44OHoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0ieiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTMzOS44NzcgMTIzLjk5OSAyOC4zNTYgMTYuODc5LTE2Ljg3OSAyOC4zNTYtMjguMzU2LTE2Ljg3OXoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iQSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExOSAxMTIuOTQ0IDI4Ljg5Mi0xNS45NDUgMTUuOTQ0IDI4Ljg5My0yOC44OTIgMTUuOTQ0eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJCIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMjcxLjk5OCA1ODQuOTQyIDI4Ljg5My0xNS45NDQgMTUuOTQ0IDI4Ljg5Mi0yOC44OTIgMTUuOTQ1eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJDIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMzI2Ljk5OCA3MzcuOTQyIDI4Ljg5My0xNS45NDQgMTUuOTQ0IDI4Ljg5Mi0yOC44OTMgMTUuOTQ0eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJEIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtNTkuNDIyIDcxNC4xNjMgMjUuMjQ3IDIxLjI1LTIxLjI1MSAyNS4yNDgtMjUuMjQ3LTIxLjI1MXoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iRSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTcyLjI1IDMxMi45OTcgMjUuMjQ3IDIxLjI1LTIxLjI1IDI1LjI0N0w1MSAzMzguMjQ0eiIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJGIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMTI4LjI1IDQ2NS45OTUgMjUuMjQ3IDIxLjI1LTIxLjI1IDI1LjI0OEwxMDcgNDkxLjI0MnoiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iRyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTE3My42MjMgNzYxLjAwNCAzMi44MDYgMy41NzMtMy41NzIgMzIuODA2LTMyLjgwNi0zLjU3M3oiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";
var KollabLogo = "data:image/svg+xml;base64,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";
var AppLoader_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$6 = (n) => (pushScopeId("data-v-57863faa"), n = n(), popScopeId(), n);
const _hoisted_1$N = {
  key: 0,
  class: "flex flex-col w-full justify-center items-center"
};
const _hoisted_2$K = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("img", {
  class: "flex elementBackground h-full w-full object-cover",
  src: _imports_0
}, null, -1));
const _hoisted_3$D = { class: "flex flex-col items-center element" };
const _hoisted_4$m = ["src", "width", "height"];
const _hoisted_5$f = /* @__PURE__ */ _withScopeId$6(() => /* @__PURE__ */ createElementVNode("div", { class: "flex dot-typing" }, null, -1));
const __default__$8 = {
  name: "AppLoader"
};
const _sfc_main$S = defineComponent(__spreadProps(__spreadValues({}, __default__$8), {
  setup(__props) {
    var _a2;
    const appLogo = {
      src: ((_a2 = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _a2.appIconImage) || KollabLogo,
      width: 124,
      height: 123
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Re), null, {
        default: withCtx(() => [
          unref(isPwa)() ? (openBlock(), createElementBlock("div", _hoisted_1$N, [
            _hoisted_2$K,
            createElementVNode("div", _hoisted_3$D, [
              createElementVNode("img", {
                src: appLogo.src,
                width: appLogo.width,
                height: appLogo.height
              }, null, 8, _hoisted_4$m),
              _hoisted_5$f
            ])
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      });
    };
  }
}));
var AppLoader = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["__scopeId", "data-v-57863faa"]]);
var NotificationItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$5 = (n) => (pushScopeId("data-v-a6c12a96"), n = n(), popScopeId(), n);
const _hoisted_1$M = { class: "mx-2 flex h-[85px] w-full cursor-pointer flex-row items-center" };
const _hoisted_2$J = ["src"];
const _hoisted_3$C = { class: "ml-3 flex grow flex-col" };
const _hoisted_4$l = ["innerHTML"];
const _hoisted_5$e = /* @__PURE__ */ _withScopeId$5(() => /* @__PURE__ */ createElementVNode("div", { class: "h-3 w-3 rounded-full bg-blue-600" }, null, -1));
const _sfc_main$R = defineComponent({
  __name: "NotificationItem",
  props: {
    notification: {
      type: [Object],
      required: true
    }
  },
  emits: ["onItemClicked"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const notificationBodyRef = ref(null);
    function handleClick() {
      setAppLoading(true);
      emit("onItemClicked", props.notification);
    }
    onMounted(() => {
      var _a2;
      const notificationBodySpan = (_a2 = notificationBodyRef.value) == null ? void 0 : _a2.querySelectorAll("span");
      if (!notificationBodySpan)
        return;
      for (let i = 0; i < notificationBodySpan.length; i++) {
        const span = notificationBodySpan[i];
        const spanType = span.getAttribute("data-type");
        if (spanType === "contact" || spanType === "community-group" || spanType === "course") {
          span.classList.add("text-gray-800");
          span.classList.add("font-bold");
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(p$1), { class: "my-2" }),
        createElementVNode("div", {
          class: "rounded-lg pr-2 hover:bg-gray-100",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => handleClick(), ["stop"]))
        }, [
          createVNode(unref(p$5), {
            offset: [-12, 42.5],
            id: __props.notification._id,
            color: "bg-transparent",
            show: !__props.notification.isRead
          }, {
            content: withCtx(() => [
              createElementVNode("div", _hoisted_1$M, [
                createVNode(unref(p$5), {
                  offset: [-7, 40],
                  class: "custom-badge-sup",
                  color: "bg-transparent",
                  id: "avatar-badge",
                  show: true
                }, {
                  content: withCtx(() => [
                    __props.notification.avatarData.avatarUrl ? (openBlock(), createBlock(unref(I$1), {
                      key: 0,
                      size: 48,
                      src: __props.notification.avatarData.avatarUrl
                    }, null, 8, ["src"])) : (openBlock(), createBlock(unref(I$1), {
                      key: 1,
                      size: 48,
                      style: normalizeStyle({
                        "border-style": "solid",
                        "border-width": "0.5px",
                        "border-color": "rgb(156 163 175)"
                      }),
                      class: "flex items-center justify-center bg-gray-100 text-base font-medium text-gray-600"
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(d), { class: "text-lg" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(getShortName)(__props.notification.avatarData.name || "Deleted User")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  ]),
                  value: withCtx(() => [
                    __props.notification.avatarData.badgeUrl ? (openBlock(), createElementBlock("img", {
                      key: 0,
                      src: __props.notification.avatarData.badgeUrl,
                      class: "h-5 w-5"
                    }, null, 8, _hoisted_2$J)) : createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                createElementVNode("div", _hoisted_3$C, [
                  createElementVNode("div", {
                    ref_key: "notificationBodyRef",
                    ref: notificationBodyRef
                  }, [
                    createVNode(unref(d), { class: "notification-content mr-5 line-clamp-3 font-normal text-gray-600" }, {
                      default: withCtx(() => [
                        createElementVNode("div", {
                          innerHTML: __props.notification.body
                        }, null, 8, _hoisted_4$l)
                      ]),
                      _: 1
                    })
                  ], 512),
                  createVNode(unref(p$3), { class: "fw-600 text-primary-700" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.notification.relativeTime), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            value: withCtx(() => [
              _hoisted_5$e
            ]),
            _: 1
          }, 8, ["id", "show"])
        ])
      ], 64);
    };
  }
});
var NotificationItem = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["__scopeId", "data-v-a6c12a96"]]);
var NotificationList_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$L = {
  key: 0,
  id: "id_notificationList",
  class: "pb-2"
};
const _hoisted_2$I = { key: 1 };
const _hoisted_3$B = { class: "justify-top flex h-full flex-col items-center p-10" };
const _hoisted_4$k = { class: "rounded-[28px] bg-primary-50 p-2" };
const _hoisted_5$d = { class: "rounded-[28px] bg-primary-100 px-2 pb-[1px] pt-2" };
const _hoisted_6$c = { key: 2 };
const _hoisted_7$6 = { class: "flex flex-col items-center justify-center" };
const _sfc_main$Q = defineComponent({
  __name: "NotificationList",
  props: {
    markAllRead: Boolean,
    loadMoreNotifications: {
      type: Boolean,
      default: false
    },
    notificationVisibility: {
      type: String,
      default: "all"
    }
  },
  emits: ["item-clicked"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const isNotificationLoading = computed(() => {
      return NotificationState.state.isLoading;
    });
    onMounted(async () => {
      await NotificationState.getNotifications();
      await NotificationState.getUnreadNotificationsCount();
    });
    watch(() => props.markAllRead, async (newValue) => {
      if (newValue) {
        if (NotificationState.state.unReadNotificationCount > 0) {
          await NotificationState.markNotificationAsRead();
        }
      }
    });
    watch(() => props.loadMoreNotifications, async (newValue) => {
      if (newValue) {
        await loadNewNotifications();
      }
    });
    async function loadNewNotifications() {
      var _a2;
      try {
        await NotificationState.getNotifications(props.notificationVisibility === "unread" ? false : void 0, {
          previousId: (_a2 = notifications.value.at(-1)) == null ? void 0 : _a2._id,
          limit: 10,
          pageSort: "descending"
        });
      } catch (error) {
        console.error(error);
      }
    }
    const notifications = computed(() => {
      return NotificationState.state.notifications;
    });
    watch(() => props.notificationVisibility, async (newValue) => {
      if (newValue === "unread") {
        NotificationState.clearNotifications();
        await NotificationState.getNotifications(false);
      } else {
        NotificationState.clearNotifications();
        await NotificationState.getNotifications();
      }
    });
    async function handleItemClick(notification) {
      emit("item-clicked", notification);
      await NotificationState.markNotificationAsRead(notification._id);
      NotificationState.clearNotifications();
      await redirectToUrl(notification);
      await NotificationState.getNotifications();
    }
    async function redirectToUrl(notification) {
      if (notification.sourceApp === "COURSES") {
        let url = notification.redirectionUrl;
        url += `?source=communities`;
        if (notification.type === "COURSE_POST_COMMENT") {
          url += `&commentId=${notification.metaData.commentId}`;
        }
        window.open("/" + url, "_self");
      } else {
        externalPathRedirect(notification.redirectionUrl);
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        notifications.value.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_1$L, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(notifications.value, (notification) => {
            return openBlock(), createBlock(NotificationItem, {
              key: notification._id,
              notification,
              onOnItemClicked: handleItemClick
            }, null, 8, ["notification"]);
          }), 128))
        ])) : !isNotificationLoading.value ? (openBlock(), createElementBlock("div", _hoisted_2$I, [
          createElementVNode("div", _hoisted_3$B, [
            createElementVNode("div", _hoisted_4$k, [
              createElementVNode("div", _hoisted_5$d, [
                createVNode(unref(render$i), { class: "h-6 w-6 text-primary-600" })
              ])
            ]),
            createVNode(unref(p$2), { class: "mt-3.5 text-center text-gray-600" }, {
              default: withCtx(() => [
                createTextVNode(" No notifications yet ")
              ]),
              _: 1
            }),
            createVNode(unref(_$2), { class: "mt-1 text-center text-gray-600" }, {
              default: withCtx(() => [
                createTextVNode(" When you get notifications, they\u2019ll show up here ")
              ]),
              _: 1
            })
          ])
        ])) : createCommentVNode("", true),
        isNotificationLoading.value ? (openBlock(), createElementBlock("div", _hoisted_6$c, [
          createElementVNode("div", _hoisted_7$6, [
            (openBlock(), createElementBlock(Fragment, null, renderList(2, (i) => {
              return createElementVNode("div", {
                key: i,
                class: "w-full"
              }, [
                createElementVNode("div", {
                  class: normalizeClass(["mx-2 my-4 flex flex-row items-center", unref(AppState).state.isMobile ? "w-[87.5vw]" : "w-[405px]"])
                }, [
                  createVNode(unref(h$2), {
                    height: "48px",
                    circle: ""
                  }),
                  createElementVNode("div", {
                    class: normalizeClass(["ml-3 flex grow flex-col", unref(AppState).state.isMobile ? "mr-2" : "mr-10"])
                  }, [
                    createVNode(unref(h$2), { height: "68px" }),
                    createVNode(unref(h$2), {
                      class: "mt-1",
                      text: true,
                      style: { "width": "20%" }
                    })
                  ], 2)
                ], 2)
              ]);
            }), 64))
          ])
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
var NotificationList = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["__scopeId", "data-v-0042db9f"]]);
var NotificationWeb_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$K = { class: "z-20 font-semibold text-gray-500" };
const _hoisted_2$H = {
  key: 0,
  class: "absolute right-0 top-0 h-2.5 w-2.5 rounded-full bg-red-500"
};
const _hoisted_3$A = { class: "p-0" };
const _hoisted_4$j = {
  key: 0,
  class: "flex flex-row justify-between py-3.5"
};
const _hoisted_5$c = {
  id: "post-action-dropdown-trigger",
  class: "flex h-7 w-7 items-center justify-center rounded-full hover:bg-gray-200"
};
const _hoisted_6$b = { class: "px-2" };
const _sfc_main$P = defineComponent({
  __name: "NotificationWeb",
  props: {
    app_launcher_is_open: Boolean,
    profile_card_is_open: Boolean,
    notification_list_is_open: Boolean,
    mark_all_read: Boolean,
    position: {
      type: String,
      required: true
    }
  },
  emits: ["update:notification-list-is-open"],
  setup(__props, { emit: __emit }) {
    onMounted(async () => {
      await NotificationState.getNotifications();
      await NotificationState.getUnreadNotificationsCount();
    });
    const emit = __emit;
    const props = __props;
    const markAllRead = ref(false);
    const notificationWebListRef = ref(null);
    const ignoreElNotificationIconRef = ref();
    const notificationVisibility = ref("all");
    const loadMoreNotifications = ref(false);
    const notificationListCloseEvent = [
      () => {
        emit("update:notification-list-is-open");
      },
      { ignore: [ignoreElNotificationIconRef, ".n-dropdown-option-body"] }
    ];
    watch(() => props.notification_list_is_open, (newValue) => {
      var _a2;
      if (newValue) {
        nextTick(() => {
          var _a3;
          (_a3 = notificationWebListRef.value) == null ? void 0 : _a3.addEventListener("scroll", handleScroll);
        });
      } else {
        (_a2 = notificationWebListRef.value) == null ? void 0 : _a2.removeEventListener("scroll", handleScroll);
      }
    });
    const toggleNotificationList = () => {
      notificationVisibility.value = "all";
      emit("update:notification-list-is-open");
    };
    async function handleScroll(event2) {
      const scrollPending = event2.target.scrollHeight - event2.target.scrollTop - notificationWebListRef.value.offsetHeight;
      if (scrollPending < 20 && !NotificationState.state.isLoading) {
        loadMoreNotifications.value = true;
      } else {
        loadMoreNotifications.value = false;
      }
      event2.stopPropagation();
    }
    const unreadNotificationCount = computed(() => {
      return NotificationState.state.unReadNotificationCount;
    });
    const PostActionOption = computed(() => {
      const menuList = [
        {
          label: "Mark all as read",
          key: "markAllRead",
          class: "rounded-2xl",
          icon() {
            return h(o(render$l), null, {});
          }
        }
      ];
      return menuList;
    });
    const notificationCounterOffset = computed(() => {
      if (NotificationState.state.unReadNotificationCount < 10) {
        return [0, 0];
      } else {
        return [2, -2];
      }
    });
    async function handlePostAction(val) {
      switch (val) {
        case "markAllRead":
          markAllRead.value = true;
          break;
      }
    }
    return (_ctx, _cache) => {
      const _directive_on_click_outside = resolveDirective("on-click-outside");
      return openBlock(), createElementBlock("div", _hoisted_1$K, [
        !unref(AppState).state.isMobile ? (openBlock(), createElementBlock("div", {
          key: 0,
          onClick: toggleNotificationList,
          id: "pg-afcp-navbar__navigation-page-app-launcher-btn",
          class: normalizeClass(["flex h-10 w-10 cursor-pointer items-center justify-center rounded-full", [
            !__props.profile_card_is_open && !__props.app_launcher_is_open && __props.notification_list_is_open ? "bg-gray-300" : "hover:bg-gray-200"
          ]]),
          ref_key: "ignoreElNotificationIconRef",
          ref: ignoreElNotificationIconRef
        }, [
          createVNode(unref(p$5), {
            offset: notificationCounterOffset.value,
            show: !unref(AppState).state.isMobile && unreadNotificationCount.value > 0,
            id: "unread-notification-count-badge"
          }, {
            content: withCtx(() => [
              createVNode(unref(render$j), { class: "h-5 w-5 text-gray-500 topNavIconColor" }),
              unref(AppState).state.isMobile && unreadNotificationCount.value > 0 ? (openBlock(), createElementBlock("div", _hoisted_2$H)) : createCommentVNode("", true)
            ]),
            value: withCtx(() => [
              createElementVNode("div", _hoisted_3$A, toDisplayString(unreadNotificationCount.value > 9 ? "9+" : unreadNotificationCount.value), 1)
            ]),
            _: 1
          }, 8, ["offset", "show"])
        ], 2)) : createCommentVNode("", true),
        createElementVNode("div", null, [
          createVNode(Transition, {
            "enter-from-class": "opacity-0 translate-y-1",
            "enter-active-class": "transition ease-out duration-200",
            "enter-to-class": "opacity-100 translate-y-0",
            "leave-from-class": "opacity-100 translate-y-0",
            "leave-to-class": "opacity-0 translate-y-1",
            "leave-active-class": "transition ease-in duration-150"
          }, {
            default: withCtx(() => [
              !__props.profile_card_is_open && !__props.app_launcher_is_open && __props.notification_list_is_open ? withDirectives((openBlock(), createElementBlock("div", {
                key: 0,
                ref_key: "notificationWebListRef",
                ref: notificationWebListRef,
                class: normalizeClass(__props.position === "end" ? "notification-height absolute right-0 z-10 mt-4 flex w-full flex-auto flex-col overflow-y-auto rounded bg-white px-4 shadow-lg ring-1 ring-gray-900/5 md:mr-4 md:w-[437px]" : "notification-height absolute  -right-80 z-10 mt-4 flex w-full flex-auto flex-col overflow-y-auto rounded bg-white px-4 shadow-lg ring-1 ring-gray-900/5 md:mr-4 md:w-[437px]")
              }, [
                !unref(AppState).state.isMobile ? (openBlock(), createElementBlock("div", _hoisted_4$j, [
                  createVNode(unref(p$2), { class: "fw-600 text-xl text-gray-900" }, {
                    default: withCtx(() => [
                      createTextVNode("Notifications")
                    ]),
                    _: 1
                  }),
                  createVNode(unref(g$2), {
                    options: PostActionOption.value,
                    onSelect: handlePostAction,
                    placement: "bottom-end",
                    id: "post-action-dropdown",
                    class: "w-20 rounded-3xl"
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_5$c, [
                        createVNode(unref(render$k), { class: "w-4 text-gray-500" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["options"])
                ])) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_6$b, [
                  createVNode(unref(q), {
                    bordered: false,
                    focusable: false,
                    type: notificationVisibility.value === "all" ? "tertiary" : "default",
                    quaternary: true,
                    tertiary: true,
                    id: "btn-all",
                    onClick: _cache[0] || (_cache[0] = ($event) => notificationVisibility.value = "all"),
                    class: "mr-2"
                  }, {
                    default: withCtx(() => [
                      createTextVNode("All")
                    ]),
                    _: 1
                  }, 8, ["type"]),
                  createVNode(unref(q), {
                    quaternary: true,
                    focusable: false,
                    bordered: false,
                    tertiary: true,
                    type: notificationVisibility.value === "unread" ? "tertiary" : "default",
                    id: "btn-unread",
                    size: "medium",
                    onClick: _cache[1] || (_cache[1] = ($event) => notificationVisibility.value = "unread")
                  }, {
                    default: withCtx(() => [
                      createTextVNode(" Unread ")
                    ]),
                    _: 1
                  }, 8, ["type"])
                ]),
                createVNode(NotificationList, {
                  "mark-all-read": markAllRead.value,
                  notificationVisibility: notificationVisibility.value,
                  loadMoreNotifications: loadMoreNotifications.value,
                  onItemClicked: toggleNotificationList
                }, null, 8, ["mark-all-read", "notificationVisibility", "loadMoreNotifications"])
              ], 2)), [
                [_directive_on_click_outside, notificationListCloseEvent]
              ]) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
var NotificationWeb = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["__scopeId", "data-v-3833c7ee"]]);
var AppSwitcher_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$J = { class: "z-20 font-semibold text-gray-500" };
const _hoisted_2$G = { class: "w-screen max-w-xs flex-auto overflow-hidden rounded bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5 lg:max-w-xs" };
const _hoisted_3$z = { class: "grid grid-cols-1 gap-x-1 gap-y-1 p-4 lg:grid-cols-2" };
const _hoisted_4$i = ["onClick"];
const _hoisted_5$b = { class: "flex flex-col items-center justify-center" };
const _hoisted_6$a = {
  key: 0,
  class: "inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20"
};
const _sfc_main$O = defineComponent({
  __name: "AppSwitcher",
  props: {
    app_launcher_is_open: Boolean,
    profile_card_is_open: Boolean,
    position: {
      type: String,
      required: true
    },
    isUserAdmin: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:app-launcher-is-open"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const toggleAppLauncher = () => {
      if (props.isUserAdmin) {
        return null;
      } else {
        emit("update:app-launcher-is-open");
      }
    };
    const ignoreElAppRef = ref();
    const launcherCloseEvent = [
      () => {
        emit("update:app-launcher-is-open");
      },
      { ignore: [ignoreElAppRef] }
    ];
    const CHILD_APPS = computed(() => {
      var _a2, _b, _c, _d, _e, _f;
      return [
        {
          name: "Communities",
          icon: render$m,
          route: "communities/",
          isVisible: ((_b = (_a2 = LocationState.state) == null ? void 0 : _a2.locationPermissions) == null ? void 0 : _b.communitiesEnabled) === true
        },
        {
          name: "Courses",
          icon: render$n,
          route: "courses/library-v2",
          isVisible: ((_d = (_c = LocationState.state) == null ? void 0 : _c.locationPermissions) == null ? void 0 : _d.membershipEnabled) === true
        },
        {
          name: "Affiliates",
          icon: render$o,
          route: "affiliate",
          isVisible: ((_f = (_e = LocationState.state) == null ? void 0 : _e.locationPermissions) == null ? void 0 : _f.affiliateManagerEnabled) === true
        }
      ];
    });
    const permissionsCard = computed(() => {
      return CHILD_APPS.value.filter((card) => card.isVisible);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$J, [
        createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event) => permissionsCard.value.length > 0 ? toggleAppLauncher() : null),
          id: "pg-afcp-navbar__navigation-page-app-launcher-btn",
          class: normalizeClass(["flex h-10 w-10 cursor-pointer items-center justify-center rounded-full", [
            !__props.profile_card_is_open && __props.app_launcher_is_open ? "bg-gray-300" : "hover:bg-gray-200",
            permissionsCard.value.length == 0 && " cursor-not-allowed text-gray-300 "
          ]]),
          ref_key: "ignoreElAppRef",
          ref: ignoreElAppRef
        }, [
          createVNode(unref(render$p), { class: "h-5 w-5 topNavIconColor" })
        ], 2),
        createElementVNode("div", null, [
          createVNode(Transition, {
            "enter-from-class": "opacity-0 translate-y-1",
            "enter-active-class": "transition ease-out duration-200",
            "enter-to-class": "opacity-100 translate-y-0",
            "leave-from-class": "opacity-100 translate-y-0",
            "leave-to-class": "opacity-0 translate-y-1",
            "leave-active-class": "transition ease-in duration-150"
          }, {
            default: withCtx(() => [
              !__props.profile_card_is_open && __props.app_launcher_is_open ? withDirectives((openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(__props.position === "end" ? "absolute -right-16 z-10 mt-4 flex w-72 px-4" : "absolute -right-56 z-10 mt-4 flex w-72 px-4")
              }, [
                createElementVNode("div", _hoisted_2$G, [
                  createElementVNode("div", _hoisted_3$z, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(permissionsCard.value, (item) => {
                      return openBlock(), createElementBlock("div", {
                        key: item.name,
                        class: "group relative flex items-start justify-center gap-x-1 rounded-lg p-4 hover:bg-gray-50"
                      }, [
                        createElementVNode("div", {
                          id: "pg-afcp-navbar__navigation-page-communities-btn",
                          class: "flex cursor-pointer flex-col items-center justify-center",
                          onClick: ($event) => unref(externalPathRedirect)(item.route, "")
                        }, [
                          (openBlock(), createBlock(resolveDynamicComponent(item.icon), {
                            onClick: toggleAppLauncher,
                            class: "h-5 w-5"
                          })),
                          createElementVNode("div", _hoisted_5$b, [
                            createTextVNode(toDisplayString(item.name) + " ", 1),
                            item.tag ? (openBlock(), createElementBlock("span", _hoisted_6$a, toDisplayString(item.tag), 1)) : createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_4$i)
                      ]);
                    }), 128))
                  ])
                ])
              ], 2)), [
                [unref(vOnClickOutside), launcherCloseEvent]
              ]) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
var AppSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["__scopeId", "data-v-ee41d2a6"]]);
var ProfileCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$4 = (n) => (pushScopeId("data-v-71a2472e"), n = n(), popScopeId(), n);
const _hoisted_1$I = { class: "w-screen max-w-xs flex-auto overflow-hidden rounded bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5 lg:max-w-xs" };
const _hoisted_2$F = { class: "flex h-full min-h-[240px] flex-col justify-between" };
const _hoisted_3$y = { class: "mt-6 flex w-full flex-col items-center" };
const _hoisted_4$h = { class: "profileNameEllipse pt-5 text-center font-bold text-gray-700" };
const _hoisted_5$a = { class: "my-4" };
const _hoisted_6$9 = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("span", { class: "font-semibold" }, "View or Edit Profile", -1));
const _hoisted_7$5 = /* @__PURE__ */ _withScopeId$4(() => /* @__PURE__ */ createElementVNode("div", { class: "divide-y divide-solid divide-slate-100" }, [
  /* @__PURE__ */ createElementVNode("div"),
  /* @__PURE__ */ createElementVNode("div")
], -1));
const _hoisted_8$5 = { class: "flex flex-col" };
const _sfc_main$N = defineComponent({
  __name: "ProfileCard",
  props: {
    app_launcher_is_open: Boolean,
    profile_card_is_open: Boolean,
    position: {
      type: String,
      required: true
    },
    isUserAdmin: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:profile-card-is-open", "logout"],
  setup(__props, { emit: __emit }) {
    const isOpen = ref(false);
    const emit = __emit;
    const props = __props;
    const ignoreElACRef = ref();
    const accountCloseEvent = [
      () => {
        emit("update:profile-card-is-open");
      },
      { ignore: [ignoreElACRef] }
    ];
    const handleLogout = async () => {
      emit("logout");
      isOpen.value = false;
      emit("update:profile-card-is-open");
    };
    const toggleMenu = () => {
      if (props.isUserAdmin) {
        return null;
      } else {
        emit("update:profile-card-is-open");
      }
    };
    return (_ctx, _cache) => {
      var _a2, _b;
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass([
            "flex h-10 w-10 items-center justify-center rounded-full",
            __props.profile_card_is_open && !__props.app_launcher_is_open ? "bg-gray-300" : "hover:bg-gray-200"
          ])
        }, [
          ((_a2 = unref(UserState).state) == null ? void 0 : _a2.avatar) ? (openBlock(), createBlock(unref(I$1), {
            key: 0,
            id: "pg-afcp-navbar__navigation-page-img-avatar-profile-btn",
            class: "z-20 cursor-pointer text-base",
            size: 32,
            onClick: toggleMenu,
            src: (_b = unref(UserState).state) == null ? void 0 : _b.avatar,
            ref_key: "ignoreElACRef",
            ref: ignoreElACRef
          }, null, 8, ["src"])) : (openBlock(), createBlock(unref(I$1), {
            key: 1,
            id: "pg-afcp-navbar__navigation-page-txt-avatar-profile-btn",
            class: "z-20 cursor-pointer bg-gray-100 font-medium text-gray-600 text-base",
            size: 32,
            onClick: toggleMenu,
            ref_key: "ignoreElACRef",
            ref: ignoreElACRef
          }, {
            default: withCtx(() => {
              var _a3;
              return [
                createTextVNode(toDisplayString(unref(formatNameForAvatar)((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName)), 1)
              ];
            }),
            _: 1
          }, 512))
        ], 2),
        createElementVNode("div", null, [
          createVNode(Transition, {
            "enter-from-class": "opacity-0 translate-y-1",
            "enter-active-class": "transition ease-out duration-200",
            "enter-to-class": "opacity-100 translate-y-0",
            "leave-from-class": "opacity-100 translate-y-0",
            "leave-to-class": "opacity-0 translate-y-1",
            "leave-active-class": "transition ease-in duration-150"
          }, {
            default: withCtx(() => {
              var _a3, _b2, _c;
              return [
                __props.profile_card_is_open && !__props.app_launcher_is_open ? withDirectives((openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(__props.position === "end" ? "absolute -right-4 z-10 mt-8 flex w-56 px-4" : "absolute -right-24 z-10 mt-8 flex w-56 px-4")
                }, [
                  createElementVNode("div", _hoisted_1$I, [
                    createElementVNode("div", _hoisted_2$F, [
                      createElementVNode("div", _hoisted_3$y, [
                        ((_a3 = unref(UserState).state) == null ? void 0 : _a3.avatar) ? (openBlock(), createBlock(unref(I$1), {
                          key: 0,
                          class: "avatar-size",
                          size: "large",
                          src: (_b2 = unref(UserState).state) == null ? void 0 : _b2.avatar
                        }, null, 8, ["src"])) : (openBlock(), createBlock(unref(I$1), {
                          key: 1,
                          class: "bg-gray-100 text-2xl font-medium text-gray-600 avatar-size",
                          size: "large"
                        }, {
                          default: withCtx(() => {
                            var _a4;
                            return [
                              createTextVNode(toDisplayString(unref(formatNameForAvatar)((_a4 = unref(UserState).state) == null ? void 0 : _a4.fullName)), 1)
                            ];
                          }),
                          _: 1
                        })),
                        createElementVNode("div", _hoisted_4$h, toDisplayString(unref(capitalizeFirstLetterName)((_c = unref(UserState).state) == null ? void 0 : _c.fullName)), 1),
                        createElementVNode("div", _hoisted_5$a, [
                          createVNode(unref(q), {
                            id: "pg-afcp-navbar__edit-profile",
                            onClick: _cache[0] || (_cache[0] = () => unref(externalPathRedirect)("account", "activeTab=Profile", true))
                          }, {
                            default: withCtx(() => [
                              _hoisted_6$9
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _hoisted_7$5,
                      createElementVNode("div", _hoisted_8$5, [
                        createElementVNode("a", {
                          id: "pg-afcp-common__navbar-account-btn",
                          class: "block cursor-pointer px-4 py-2 font-medium text-gray-700 no-underline hover:bg-gray-50 hover:text-gray-900",
                          onClick: _cache[1] || (_cache[1] = () => unref(externalPathRedirect)("account", "activeTab=Account", true))
                        }, " Account "),
                        createElementVNode("a", {
                          id: "pg-afcp-common__navbar-logout-btn",
                          class: "block cursor-pointer px-4 py-2 font-medium text-gray-700 no-underline hover:bg-gray-50 hover:text-gray-900",
                          onClick: handleLogout
                        }, " Logout ")
                      ])
                    ])
                  ])
                ], 2)), [
                  [unref(vOnClickOutside), accountCloseEvent]
                ]) : createCommentVNode("", true)
              ];
            }),
            _: 1
          })
        ])
      ], 64);
    };
  }
});
var ProfileCard = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["__scopeId", "data-v-71a2472e"]]);
var NavBar_vue_vue_type_style_index_0_scoped_true_lang = "";
var NavBar_vue_vue_type_style_index_1_lang = "";
const _hoisted_1$H = { class: "left-0 right-0 top-0 z-50 h-16 items-center nav-container flex justify-between" };
const _hoisted_2$E = ["src"];
const _hoisted_3$x = { class: "ml-4 h-6" };
const _hoisted_4$g = { key: 1 };
const _hoisted_5$9 = { key: 0 };
const _hoisted_6$8 = { class: "relative" };
const __default__$7 = {
  name: "NavBar"
};
const _sfc_main$M = defineComponent(__spreadProps(__spreadValues({}, __default__$7), {
  props: {
    routes: {
      type: Object
    },
    scrollHeight: {
      type: Number,
      default: 0
    },
    isLeftIcon: {
      type: Boolean,
      default: true
    },
    isHome: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    backgroundImage: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "end"
    },
    opacityImg: {
      type: Number,
      default: 1
    },
    isUserAdmin: {
      type: Boolean,
      default: false
    }
  },
  emits: ["toggle", "logout"],
  setup(__props, { emit: __emit }) {
    const slots = useSlots();
    const route = useRoute();
    const emit = __emit;
    const notification = c();
    const handleToggle = (item) => {
      emit("toggle", item);
    };
    const profile_card_is_open = ref(false);
    const app_launcher_is_open = ref(false);
    const notification_list_is_open = ref(false);
    function handleAdminError() {
      notification.create({
        type: "error",
        title: "An error occurred...",
        content: `This user is not the part of client-portal`,
        duration: 5e3
      });
    }
    function toggleProfileCard() {
      app_launcher_is_open.value = false;
      notification_list_is_open.value = false;
      profile_card_is_open.value = !profile_card_is_open.value;
    }
    function toggleNotificationList() {
      profile_card_is_open.value = false;
      app_launcher_is_open.value = false;
      notification_list_is_open.value = !notification_list_is_open.value;
    }
    function toggleAppLauncher() {
      notification_list_is_open.value = false;
      profile_card_is_open.value = false;
      app_launcher_is_open.value = !app_launcher_is_open.value;
    }
    function receiveLogoutUser(logoutUser2) {
      emit("logout", logoutUser2);
    }
    return (_ctx, _cache) => {
      var _a2, _b, _c, _d, _e, _f;
      return openBlock(), createElementBlock("div", _hoisted_1$H, [
        __props.backgroundImage ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: __props.backgroundImage,
          style: normalizeStyle({ opacity: __props.opacityImg }),
          class: normalizeClass(`absolute object-fill h-16 w-full`)
        }, null, 12, _hoisted_2$E)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3$x, [
          __props.isLeftIcon ? (openBlock(), createBlock(unref(I$1), {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event) => __props.isUserAdmin ? handleAdminError() : unref(externalPathRedirect)("home", "")),
            class: normalizeClass(__props.isHome ? __props.scrollHeight > 0 ? "h-6 w-6 bg-gray-100 cursor-pointer z-10" : "hidden" : "h-6 w-6 bg-gray-100 cursor-pointer z-10"),
            src: ((_b = (_a2 = unref(LocationState).state) == null ? void 0 : _a2.branding) == null ? void 0 : _b.logo) ? (_c = unref(LocationState).state) == null ? void 0 : _c.branding.logo : unref(GROUP_BRANDING_NAVBAR)
          }, null, 8, ["class", "src"])) : createCommentVNode("", true),
          ((_d = unref(slots)) == null ? void 0 : _d["filter-left"]) ? (openBlock(), createElementBlock("div", _hoisted_4$g, [
            renderSlot(_ctx.$slots, "filter-left", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ]),
        createVNode(unref(f$1), { class: "absolute flex w-full justify-center" }, {
          default: withCtx(() => [
            createVNode(unref(B$1), null, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.routes, (item) => {
                  var _a3;
                  return openBlock(), createBlock(unref(q), {
                    key: item.name,
                    onClick: () => handleToggle(item),
                    ghost: "",
                    disabled: __props.disabled,
                    id: `pg-afcp-navbar__navigation-page-${item.name.toLowerCase().replace("/", "-")}-btn`,
                    active: ((_a3 = unref(route)) == null ? void 0 : _a3.name) == item.routeName,
                    class: normalizeClass(item.current ? "!bg-gray-200 !text-black" : "")
                  }, {
                    default: withCtx(() => [
                      createElementVNode("span", null, toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled", "id", "active", "class"]);
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createElementVNode("div", {
          class: normalizeClass(`flex w-full items-center gap-4 ml-4 justify-${__props.position}`)
        }, [
          ((_e = unref(slots)) == null ? void 0 : _e["filter-right"]) ? (openBlock(), createElementBlock("div", _hoisted_5$9, [
            renderSlot(_ctx.$slots, "filter-right", {}, void 0, true)
          ])) : createCommentVNode("", true),
          createElementVNode("div", {
            id: "app-launcher",
            class: "flex z-20 h-10 w-10 cursor-pointer items-center justify-center rounded-full text-gray-500 hover:bg-gray-200",
            onClick: _cache[1] || (_cache[1] = ($event) => __props.isUserAdmin ? handleAdminError() : unref(externalPathRedirect)("home", ""))
          }, [
            createVNode(unref(render$q), { class: "h-5 w-5 topNavIconColor" })
          ]),
          createVNode(unref(q), {
            id: "btn-app",
            onClick: _cache[2] || (_cache[2] = ($event) => __props.isUserAdmin && handleAdminError()),
            text: true
          }, {
            default: withCtx(() => [
              createVNode(AppSwitcher, {
                "onUpdate:appLauncherIsOpen": toggleAppLauncher,
                profile_card_is_open: profile_card_is_open.value,
                app_launcher_is_open: app_launcher_is_open.value,
                position: __props.position,
                isUserAdmin: __props.isUserAdmin
              }, null, 8, ["profile_card_is_open", "app_launcher_is_open", "position", "isUserAdmin"])
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_6$8, [
            ((_f = unref(UserState).state) == null ? void 0 : _f.fullName) ? (openBlock(), createBlock(NotificationWeb, {
              key: 0,
              "onUpdate:notificationListIsOpen": toggleNotificationList,
              profile_card_is_open: profile_card_is_open.value,
              app_launcher_is_open: app_launcher_is_open.value,
              notification_list_is_open: notification_list_is_open.value,
              position: __props.position
            }, null, 8, ["profile_card_is_open", "app_launcher_is_open", "notification_list_is_open", "position"])) : createCommentVNode("", true)
          ]),
          createVNode(unref(q), {
            id: "btn-profile",
            onClick: _cache[3] || (_cache[3] = ($event) => __props.isUserAdmin && handleAdminError()),
            text: true,
            class: "mr-4"
          }, {
            default: withCtx(() => {
              var _a3;
              return [
                ((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName) ? (openBlock(), createBlock(ProfileCard, {
                  key: 0,
                  "onUpdate:profileCardIsOpen": toggleProfileCard,
                  profile_card_is_open: profile_card_is_open.value,
                  app_launcher_is_open: app_launcher_is_open.value,
                  onLogout: receiveLogoutUser,
                  position: __props.position,
                  isUserAdmin: __props.isUserAdmin
                }, null, 8, ["profile_card_is_open", "app_launcher_is_open", "position", "isUserAdmin"])) : createCommentVNode("", true)
              ];
            }),
            _: 1
          })
        ], 2)
      ]);
    };
  }
}));
var NavBar = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["__scopeId", "data-v-441c8e0a"]]);
NavBar.install = (Vue) => {
  Vue.component(NavBar.name, NavBar);
};
var BrandingComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$G = { class: "colorGradient relative col-span-3 row-span-2 flex flex-col w-[100vw] items-center justify-center border-solid md:row-span-1" };
const _hoisted_2$D = ["src"];
const _hoisted_3$w = { class: "centerPosition flex items-center flex-col" };
const _sfc_main$L = defineComponent({
  __name: "BrandingComponent",
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const handleToggle = () => {
      if (routerInstance2) {
        routerInstance2.push({ name: "/account?activeTab=Profile" });
      }
    };
    return (_ctx, _cache) => {
      var _a2, _b, _c, _d, _e, _f, _g, _h;
      return openBlock(), createElementBlock("div", _hoisted_1$G, [
        createElementVNode("img", {
          class: normalizeClass(((_b = (_a2 = unref(LocationState).state) == null ? void 0 : _a2.branding) == null ? void 0 : _b.portalBannerImage) ? "h-full w-full object-cover opacity-70" : "hidden"),
          src: (_c = unref(LocationState).state) == null ? void 0 : _c.branding.portalBannerImage
        }, null, 10, _hoisted_2$D),
        createElementVNode("div", _hoisted_3$w, [
          ((_e = (_d = unref(LocationState).state) == null ? void 0 : _d.branding) == null ? void 0 : _e.logo) ? (openBlock(), createBlock(unref(I$1), {
            key: 0,
            onClick: _cache[0] || (_cache[0] = () => handleToggle()),
            class: "h-24 w-24 md:h-32 md:w-32",
            src: ((_g = (_f = unref(LocationState).state) == null ? void 0 : _f.branding) == null ? void 0 : _g.logo) ? (_h = unref(LocationState).state) == null ? void 0 : _h.branding.logo : null
          }, null, 8, ["src"])) : createCommentVNode("", true),
          createVNode(unref(c$4), { class: "text-2xl text-white md:text-4xl" }, {
            default: withCtx(() => {
              var _a3, _b2;
              return [
                createTextVNode(toDisplayString(((_b2 = (_a3 = unref(LocationState).state) == null ? void 0 : _a3.branding) == null ? void 0 : _b2.portalBannerText) || "Client Portal"), 1)
              ];
            }),
            _: 1
          })
        ])
      ]);
    };
  }
});
var BrandingComponent = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["__scopeId", "data-v-18672f26"]]);
const _hoisted_1$F = { class: "col-span-3 mt-8 px-4" };
const _hoisted_2$C = { class: "grid grid-cols-4 gap-y-[47px]" };
const _hoisted_3$v = ["onClick"];
const _sfc_main$K = defineComponent({
  __name: "MobileActionButtons",
  setup(__props) {
    const cards = inject("analyticsCards");
    AppState.getRouterInstance();
    const isSecure = ref(false);
    onBeforeMount(async () => {
      await UserState.getUserDetails();
      isSecure.value = await isTokenExpired();
    });
    async function isTokenExpired() {
      var _a2;
      const expiryDate = await ((_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.billingTokenExpiry);
      if (!expiryDate) {
        return true;
      }
      return Date.now() - new Date(expiryDate).getTime() > 0;
    }
    const handleRoutes = (queryValue) => {
      if (isSecure.value && queryValue === "BillingSubscription") {
        queryValue = "AuthPage";
      }
      externalPathRedirect("profile", `activeScreen=${queryValue}`);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$F, [
        createVNode(unref(p), { class: "mb-4 text-gray-900" }, {
          default: withCtx(() => [
            createTextVNode("Quick Links")
          ]),
          _: 1
        }),
        createElementVNode("div", _hoisted_2$C, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(cards), (card) => {
            return openBlock(), createElementBlock("div", {
              onClick: () => {
                unref(setAppLoading)(true);
                card.route === "profile?activeTab=BillingSubscription" ? handleRoutes("BillingSubscription") : unref(externalPathRedirect)(card.routeCards, "");
              },
              class: "h-[92px] min-w-[76px] text-center col-span-1",
              key: card.titleCards
            }, [
              createVNode(unref(I$1), { class: "h-16 min-w-16 bg-gray-100" }, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(card.icon), { class: "h-[29px] w-[29px] text-gray-500" }))
                ]),
                _: 2
              }, 1024),
              createVNode(unref(p$3), { class: "truncate text-gray-400" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(card.titleCards), 1)
                ]),
                _: 2
              }, 1024)
            ], 8, _hoisted_3$v);
          }), 128))
        ])
      ]);
    };
  }
});
var MobileAnalyticsCards_vue_vue_type_style_index_0_scoped_true_lang = "";
var MobileAnalyticsCards_vue_vue_type_style_index_1_lang = "";
const _hoisted_1$E = ["src"];
const _hoisted_2$B = { class: "flex justify-center" };
const _sfc_main$J = defineComponent({
  __name: "MobileAnalyticsCards",
  setup(__props) {
    const analyticsCards = inject("analyticsCards");
    const filteredAnalyticsCards = computed(() => {
      return analyticsCards.value.filter((card) => card.isVisibleAnalytics);
    });
    onMounted(() => {
      window.addEventListener("resize", updateScreenSize);
    });
    const widthScreen = ref(window.innerWidth);
    const updateScreenSize = () => {
      widthScreen.value = window.innerWidth;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(p), { class: "mb-4 ml-4 text-gray-900 mt-6" }, {
          default: withCtx(() => [
            createTextVNode("Insights")
          ]),
          _: 1
        }),
        createElementVNode("div", {
          id: "mobileAnalyticalCards",
          class: normalizeClass(["ml-4 col-span-3", unref(isPwa)() ? "pb-16" : ""])
        }, [
          createVNode(unref(z), {
            autoPlay: false,
            spaceBetweenItems: 0,
            loop: false,
            draggable: true,
            direction: "horizontal",
            transitionStyle: {
              transitionTimingFunction: "linear",
              transitionDuration: "0.3s"
            },
            touchable: true,
            mousewheel: true,
            itemsPerView: filteredAnalyticsCards.value.length == 1 ? 1 : "auto"
          }, {
            customRender: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(filteredAnalyticsCards.value, (card) => {
                return openBlock(), createElementBlock("div", {
                  class: "shadow-left-right mr-4 w-auto",
                  key: card.titleAnalytics
                }, [
                  createVNode(unref($), { class: "w-[70vw] pb-2 pt-3 rounded-b-none text-center shadow-none xs:w-[284px]" }, {
                    default: withCtx(() => [
                      createVNode(unref(p$2), { class: "text-gray-900" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(card.titleAnalytics), 1)
                        ]),
                        _: 2
                      }, 1024),
                      createVNode(unref(_$1), { class: "mb-6 mt-2 h-6 text-gray-400" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(card.descriptionAnalytics), 1)
                        ]),
                        _: 2
                      }, 1024),
                      createElementVNode("img", {
                        class: "h-20 my-0 mx-auto",
                        src: card.svgIcon
                      }, null, 8, _hoisted_1$E),
                      createVNode(unref(c$4), { class: "text-black" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(card.data), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(unref($), { class: "mb-9 mt-[2px] w-[70vw] rounded-t-none shadow-md xs:w-[284px]" }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_2$B, [
                        createVNode(unref(q), {
                          id: "earning-btn",
                          class: "text-base text-primary-500",
                          text: true,
                          onClick: () => {
                            unref(setAppLoading)(true);
                            unref(externalPathRedirect)(card.route, card.path || "", false);
                          }
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(card.button), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]);
              }), 128))
            ]),
            _: 1
          }, 8, ["itemsPerView"])
        ], 2)
      ], 64);
    };
  }
});
var MobileAnalyticsCards = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["__scopeId", "data-v-6898a485"]]);
var MobileCards_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$D = { class: "col-span-3 mt-[23px] px-4" };
const _hoisted_2$A = { class: "h-[120px]" };
const _hoisted_3$u = ["onClick"];
const _hoisted_4$f = { class: "pl-4 pt-4" };
const _hoisted_5$8 = { class: "w-auto" };
const _hoisted_6$7 = ["src"];
const _sfc_main$I = defineComponent({
  __name: "MobileCards",
  setup(__props) {
    const childApps = inject("analyticsCards");
    const filteredAnalyticsCards = computed(() => {
      return childApps.value.filter((card) => card.isVisibleAnalytics);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$D, [
        createVNode(unref(p), { class: "mb-4 text-gray-900" }, {
          default: withCtx(() => [
            createTextVNode("Explore")
          ]),
          _: 1
        }),
        createElementVNode("div", _hoisted_2$A, [
          createVNode(unref(z), {
            autoPlay: true,
            showDots: true,
            draggable: true,
            dotType: "line",
            direction: "horizontal",
            spaceBetweenItems: 13,
            transitionStyle: {
              transitionTimingFunction: "linear",
              transitionDuration: "0.3s"
            },
            touchable: true,
            mousewheel: true
          }, {
            customRender: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(filteredAnalyticsCards.value, (child) => {
                return openBlock(), createElementBlock("div", {
                  key: child.titleChildApps
                }, [
                  createElementVNode("div", {
                    onClick: () => {
                      unref(setAppLoading)(true);
                      unref(externalPathRedirect)(child.route, "");
                    },
                    class: normalizeClass(`flex h-[120px] w-full justify-between rounded-xl ${child.backgroundColorClass}`)
                  }, [
                    createElementVNode("div", _hoisted_4$f, [
                      createVNode(unref(p), { class: "text-sm text-white xs:text-base" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(child.titleChildApps), 1)
                        ]),
                        _: 2
                      }, 1024),
                      createVNode(unref(_$2), { class: "text-xs text-white xs:text-sm" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(child.descriptionChildApps), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    createElementVNode("div", _hoisted_5$8, [
                      createElementVNode("img", {
                        class: "h-full",
                        src: child.coverImage
                      }, null, 8, _hoisted_6$7)
                    ])
                  ], 10, _hoisted_3$u)
                ]);
              }), 128))
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
var MobileCards = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["__scopeId", "data-v-4ba4d090"]]);
var MobileDashboard_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$C = { class: "grid h-screen grid-cols-3 grid-rows-5" };
const _hoisted_2$z = { class: "col-span-3 grid grid-cols-3 pb-6" };
const _sfc_main$H = defineComponent({
  __name: "MobileDashboard",
  emits: ["logout"],
  setup(__props, { emit: __emit }) {
    ref(false);
    ref(false);
    const scrollHeight = ref(0);
    const emit = __emit;
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    function handleScroll(e) {
      scrollHeight.value = document.documentElement.scrollTop;
    }
    function receiveLogoutUser() {
      emit("logout", logoutUser());
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createVNode(unref(NavBar), {
          class: normalizeClass(scrollHeight.value > 0 ? null : "main"),
          isHome: true,
          scrollHeight: scrollHeight.value,
          onLogout: receiveLogoutUser
        }, null, 8, ["class", "scrollHeight"]),
        createElementVNode("div", _hoisted_1$C, [
          createVNode(BrandingComponent),
          createElementVNode("div", _hoisted_2$z, [
            createVNode(MobileCards),
            createVNode(_sfc_main$K),
            createVNode(MobileAnalyticsCards)
          ])
        ])
      ]);
    };
  }
});
var MobileDashboard = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["__scopeId", "data-v-4342dd05"]]);
var MobileBrandingComponent_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$B = ["src"];
const _hoisted_2$y = {
  key: 1,
  class: "rounded-2xl h-[221px] w-full object-cover colorGradient"
};
const _hoisted_3$t = { class: "bottom-[35px] py-2 pl-3 flex items-center gap-4 border border-solid border-gray-100 bg-white w-[78vw] rounded-xl relative" };
const _hoisted_4$e = { class: "flex flex-col" };
const _sfc_main$G = defineComponent({
  __name: "MobileBrandingComponent",
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const handleToggle = () => {
      if (routerInstance2) {
        routerInstance2.push({ name: "/account?activeTab=Profile" });
      }
    };
    return (_ctx, _cache) => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["flex flex-col col-span-3 row-span-1 items-center pb-6 justify-start pt-3 px-4", ((_b = (_a2 = unref(LocationState).state) == null ? void 0 : _a2.branding) == null ? void 0 : _b.portalBannerImage) ? "" : "h-[296px]"])
      }, [
        ((_d = (_c = unref(LocationState).state) == null ? void 0 : _c.branding) == null ? void 0 : _d.portalBannerImage) ? (openBlock(), createElementBlock("img", {
          key: 0,
          class: "rounded-2xl h-[221px] w-full object-cover opacity-70",
          src: (_e = unref(LocationState).state) == null ? void 0 : _e.branding.portalBannerImage
        }, null, 8, _hoisted_1$B)) : (openBlock(), createElementBlock("div", _hoisted_2$y)),
        createElementVNode("div", _hoisted_3$t, [
          createVNode(unref(I$1), {
            size: "large",
            objectFit: "fill",
            round: false,
            onClick: _cache[0] || (_cache[0] = () => handleToggle()),
            class: normalizeClass(["w-[57px] h-[53px]", !((_g = (_f = unref(LocationState).state) == null ? void 0 : _f.branding) == null ? void 0 : _g.logo) ? "colorGradient" : ""]),
            src: ((_i = (_h = unref(LocationState).state) == null ? void 0 : _h.branding) == null ? void 0 : _i.logo) ? (_j = unref(LocationState).state) == null ? void 0 : _j.branding.logo : unref(GROUP_BRANDING_ICON)
          }, null, 8, ["class", "src"]),
          createElementVNode("div", _hoisted_4$e, [
            createVNode(unref(p), { class: "text-gray-900" }, {
              default: withCtx(() => {
                var _a3, _b2;
                return [
                  createTextVNode(toDisplayString(((_b2 = (_a3 = unref(LocationState).state) == null ? void 0 : _a3.branding) == null ? void 0 : _b2.portalBannerText) || "Client Portal"), 1)
                ];
              }),
              _: 1
            }),
            createVNode(unref(_$1), { class: "overflow-ellipsis overflow-hidden whitespace-nowrap max-w-[57vw] text-gray-400" }, {
              default: withCtx(() => {
                var _a3, _b2;
                return [
                  createTextVNode(toDisplayString(((_b2 = (_a3 = unref(LocationState).state) == null ? void 0 : _a3.branding) == null ? void 0 : _b2.portalDescription) || "Client Portal Description"), 1)
                ];
              }),
              _: 1
            })
          ])
        ])
      ], 2);
    };
  }
});
var MobileBrandingComponent = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["__scopeId", "data-v-5d95a64d"]]);
var MobilePwaTopNavBar_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$A = { class: "col-span-3 flex flex-col items-center justify-start left-0 right-0 top-0 fixed z-50" };
const _hoisted_2$x = { class: "pt-[9px] pb-2 pl-8 flex items-center gap-4 border-b border-solid border-x-0 border-t-0 border-gray-200 bg-white w-full" };
const _hoisted_3$s = { class: "flex flex-col" };
const _sfc_main$F = defineComponent({
  __name: "MobilePwaTopNavBar",
  setup(__props) {
    return (_ctx, _cache) => {
      var _a2, _b, _c, _d, _e;
      return openBlock(), createElementBlock("div", _hoisted_1$A, [
        createElementVNode("div", _hoisted_2$x, [
          createVNode(unref(I$1), {
            size: "large",
            objectFit: "fill",
            round: false,
            class: normalizeClass(["w-[32px] h-[32px]", !((_b = (_a2 = unref(LocationState).state) == null ? void 0 : _a2.branding) == null ? void 0 : _b.logo) ? "colorGradient" : ""]),
            src: ((_d = (_c = unref(LocationState).state) == null ? void 0 : _c.branding) == null ? void 0 : _d.logo) ? (_e = unref(LocationState).state) == null ? void 0 : _e.branding.logo : unref(GROUP_BRANDING_ICON)
          }, null, 8, ["class", "src"]),
          createElementVNode("div", _hoisted_3$s, [
            createVNode(unref(p), { class: "text-gray-900" }, {
              default: withCtx(() => {
                var _a3, _b2;
                return [
                  createTextVNode(toDisplayString(((_b2 = (_a3 = unref(LocationState).state) == null ? void 0 : _a3.branding) == null ? void 0 : _b2.portalBannerText) || "Client Portal"), 1)
                ];
              }),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
});
var MobilePwaDashboard$1 = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["__scopeId", "data-v-549102b8"]]);
var MobilePwaDashboard_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$z = {
  key: 0,
  class: "fixed flex h-screen w-full items-center justify-center bg-white"
};
const _hoisted_2$w = {
  key: 1,
  id: "touchScreen"
};
const _hoisted_3$r = { class: "grid h-screen grid-cols-3 grid-rows-5 shortScreen" };
const _hoisted_4$d = { class: "mt-24 col-span-3 grid grid-cols-3 pb-6" };
const _sfc_main$E = defineComponent({
  __name: "MobilePwaDashboard",
  emits: ["logout"],
  setup(__props, { emit: __emit }) {
    ref(false);
    ref(false);
    const scrollHeight = ref(0);
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    function handleScroll(e) {
      scrollHeight.value = document.documentElement.scrollTop;
    }
    return (_ctx, _cache) => {
      return unref(isAppLoading)() ? (openBlock(), createElementBlock("div", _hoisted_1$z, [
        createVNode(unref(Re), null, {
          default: withCtx(() => [
            unref(isPwa)() ? (openBlock(), createBlock(AppLoader, { key: 0 })) : (openBlock(), createBlock(unref(_$3), {
              key: 1,
              size: "large",
              show: unref(isAppLoading)() && !unref(isPwa)()
            }, null, 8, ["show"]))
          ]),
          _: 1
        })
      ])) : (openBlock(), createElementBlock("div", _hoisted_2$w, [
        createElementVNode("div", _hoisted_3$r, [
          createVNode(MobileBrandingComponent),
          scrollHeight.value > 200 ? (openBlock(), createBlock(MobilePwaDashboard$1, { key: 0 })) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_4$d, [
            createVNode(MobileCards),
            createVNode(_sfc_main$K),
            createVNode(MobileAnalyticsCards)
          ])
        ])
      ]));
    };
  }
});
var MobilePwaDashboard = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["__scopeId", "data-v-6c2c8b03"]]);
var ActionButtons_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$y = { class: "flex items-center" };
const _hoisted_2$v = { class: "hl-text-md-regular ml-4 w-[360px] text-gray-700" };
const _hoisted_3$q = { class: "flex items-center" };
const _hoisted_4$c = ["src"];
const _sfc_main$D = defineComponent({
  __name: "ActionButtons",
  setup(__props) {
    const cards = inject("analyticsCards");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref($), { class: "col-span-1 row-span-2 max-h-[796px] overflow-scroll border-solid xl:max-h-[754px]" }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(cards), (card) => {
            return openBlock(), createElementBlock("div", {
              key: card.title
            }, [
              createVNode(unref($), {
                class: "main !mb-5 cursor-pointer bg-primary-25",
                onClick: ($event) => unref(externalPathRedirect)(card.routeCards, "")
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_1$y, [
                    createVNode(unref(I$1), { class: "h-10 min-w-[40px] bg-white" }, {
                      default: withCtx(() => [
                        (openBlock(), createBlock(resolveDynamicComponent(card.icon), { class: "h-6 w-6 text-primary-400" }))
                      ]),
                      _: 2
                    }, 1024),
                    createElementVNode("div", _hoisted_2$v, [
                      createElementVNode("div", _hoisted_3$q, [
                        createVNode(unref(p), { class: "text-gray-600" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(card.titleCards), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      createVNode(unref(p$3), { class: "text-gray-400" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(card.descriptionCards), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    createElementVNode("img", {
                      src: unref(ARROW_ICON),
                      alt: "arrow"
                    }, null, 8, _hoisted_4$c)
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]);
          }), 128))
        ]),
        _: 1
      });
    };
  }
});
var ActionButtons = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["__scopeId", "data-v-5f2ec79d"]]);
var AnalyticsCards_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$x = { class: "name col-span-2 grid grid-cols-2 gap-10 pb-10" };
const _hoisted_2$u = { key: 0 };
const _sfc_main$C = defineComponent({
  __name: "AnalyticsCards",
  setup(__props) {
    const analyticsCards = inject("analyticsCards");
    const filteredAnalyticsCards = computed(() => {
      return analyticsCards.value.filter((card) => card.isVisibleAnalytics);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$x, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(filteredAnalyticsCards.value, (card) => {
          return openBlock(), createElementBlock("div", {
            key: card.titleAnalytics
          }, [
            card.isVisible ? (openBlock(), createElementBlock("div", _hoisted_2$u, [
              createVNode(unref(Z), {
                id: card.button,
                title: card.titleAnalytics,
                class: "mb-9"
              }, {
                icon: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(card.icon), { class: "!h-9 !w-9 !text-primary-600" }))
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(card.data) + " ", 1),
                  createVNode(unref(q), {
                    class: "mt-8 block text-xl font-medium",
                    id: "btn",
                    text: true,
                    onClick: ($event) => unref(externalPathRedirect)(card.route, card.path || "", false)
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(card.button), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["id", "title"])
            ])) : createCommentVNode("", true)
          ]);
        }), 128))
      ]);
    };
  }
});
var AnalyticsCards = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["__scopeId", "data-v-38cdb0ea"]]);
var ProfileDetails_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$w = { class: "flex space-x-7" };
const _hoisted_2$t = { class: "col-span-1" };
const _hoisted_3$p = { class: "col-span-5" };
const _hoisted_4$b = { key: 2 };
const _hoisted_5$7 = { key: 3 };
const _hoisted_6$6 = { class: "flex items-center space-x-7" };
const _hoisted_7$4 = { key: 0 };
const _hoisted_8$4 = {
  key: 1,
  class: "flex h-10 items-center"
};
const _hoisted_9$4 = { class: "grid grid-cols-2 gap-4 xl:grid-cols-3" };
const _hoisted_10$2 = { key: 0 };
const _hoisted_11$2 = ["src"];
const _hoisted_12$2 = { key: 1 };
const _sfc_main$B = defineComponent({
  __name: "ProfileDetails",
  setup(__props) {
    const profileInfo = computed(() => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i;
      return [
        [
          {
            icon: render$2,
            value: ((_a2 = UserState.state) == null ? void 0 : _a2.timeZone) || "-",
            slug: "timeZone",
            isSocialMedia: false
          },
          {
            icon: render$7,
            value: ((_b = UserState.state) == null ? void 0 : _b.location) || "-",
            slug: "location",
            isSocialMedia: false
          },
          {
            icon: render$8,
            value: ((_c = UserState.state) == null ? void 0 : _c.socials.email) || "-",
            slug: "email",
            isSocialMedia: false
          },
          {
            icon: render$9,
            value: ((_d = UserState.state) == null ? void 0 : _d.socials.phoneNumber) || "-",
            slug: "phoneNumber",
            isSocialMedia: false
          }
        ],
        [
          {
            icon: FACEBOOK_ICON,
            value: ((_e = UserState.state) == null ? void 0 : _e.socials.facebook) || "-",
            slug: "facebook",
            isSocialMedia: true
          },
          {
            icon: INSTAGRAM_ICON,
            value: ((_f = UserState.state) == null ? void 0 : _f.socials.instagram) || "-",
            slug: "instagram",
            isSocialMedia: true
          },
          {
            icon: LINKEDIN_ICON,
            value: ((_g = UserState.state) == null ? void 0 : _g.socials.linkedin) || "-",
            slug: "linkedin",
            isSocialMedia: true
          },
          {
            icon: TWITTER_ICON,
            value: ((_h = UserState.state) == null ? void 0 : _h.socials.twitter) || "-",
            slug: "twitter",
            isSocialMedia: true
          },
          {
            icon: YOUTUBE_ICON,
            value: ((_i = UserState.state) == null ? void 0 : _i.socials.youtube) || "-",
            slug: "youtube",
            isSocialMedia: true
          }
        ]
      ];
    });
    const redirectProfile = () => {
      externalPathRedirect("account", "activeTab=Profile", true);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref($), { class: "col-span-2" }, {
        default: withCtx(() => {
          var _a2, _b, _c, _d;
          return [
            createElementVNode("div", _hoisted_1$w, [
              createElementVNode("div", _hoisted_2$t, [
                ((_a2 = unref(UserState).state) == null ? void 0 : _a2.avatar) ? (openBlock(), createBlock(unref(I$1), {
                  key: 0,
                  class: "h-24 w-24",
                  size: "large",
                  src: (_b = unref(UserState).state) == null ? void 0 : _b.avatar
                }, null, 8, ["src"])) : (openBlock(), createBlock(unref(I$1), {
                  key: 1,
                  class: "h-24 w-24 bg-gray-100 text-4xl font-medium text-gray-600",
                  size: "large"
                }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createTextVNode(toDisplayString(unref(formatNameForAvatar)((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName)), 1)
                    ];
                  }),
                  _: 1
                }))
              ]),
              createElementVNode("div", _hoisted_3$p, [
                createVNode(unref(p$2), { class: "text-gray-900" }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createTextVNode("Welcome, " + toDisplayString((_a3 = unref(UserState).state) == null ? void 0 : _a3.fullName), 1)
                    ];
                  }),
                  _: 1
                }),
                ((_c = unref(UserState).state) == null ? void 0 : _c.title) ? (openBlock(), createBlock(unref(_$2), {
                  key: 0,
                  class: "my-2 text-gray-500"
                }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createTextVNode(toDisplayString((_a3 = unref(UserState).state) == null ? void 0 : _a3.title), 1)
                    ];
                  }),
                  _: 1
                })) : (openBlock(), createBlock(unref(_$2), {
                  key: 1,
                  class: "my-2 text-gray-500"
                }, {
                  default: withCtx(() => [
                    createTextVNode(" Add a "),
                    createElementVNode("b", {
                      class: "cursor-pointer hover:text-primary-400",
                      onClick: redirectProfile
                    }, "title"),
                    createTextVNode(" to your profile ")
                  ]),
                  _: 1
                })),
                ((_d = unref(UserState).state) == null ? void 0 : _d.bio) ? (openBlock(), createElementBlock("div", _hoisted_4$b, [
                  createVNode(unref(p$3), { class: "inline text-gray-500" }, {
                    default: withCtx(() => [
                      createTextVNode("Description: ")
                    ]),
                    _: 1
                  }),
                  createVNode(unref(_$1), { class: "inline text-gray-400" }, {
                    default: withCtx(() => {
                      var _a3;
                      return [
                        createTextVNode(toDisplayString((_a3 = unref(UserState).state) == null ? void 0 : _a3.bio), 1)
                      ];
                    }),
                    _: 1
                  })
                ])) : (openBlock(), createElementBlock("div", _hoisted_5$7, [
                  createVNode(unref(_$2), { class: "inline text-gray-500" }, {
                    default: withCtx(() => [
                      createTextVNode("Add a "),
                      createElementVNode("b", {
                        class: "cursor-pointer hover:text-primary-400",
                        onClick: redirectProfile
                      }, "description"),
                      createTextVNode(" to your profile")
                    ]),
                    _: 1
                  })
                ]))
              ])
            ]),
            createVNode(unref(_$2), { class: "-mb-2 mt-6 text-gray-500" }, {
              default: withCtx(() => [
                createTextVNode("Your profile is "),
                createElementVNode("b", null, toDisplayString(unref(getProgress)(unref(UserState).state)) + "%", 1),
                createTextVNode(" complete")
              ]),
              _: 1
            }),
            createElementVNode("div", _hoisted_6$6, [
              createVNode(unref(x), {
                percentage: unref(getProgress)(unref(UserState).state),
                type: "line",
                indicatorPlacement: "outside",
                showIndicator: false
              }, null, 8, ["percentage"]),
              unref(getProgress)(unref(UserState).state) < 100 ? (openBlock(), createElementBlock("div", _hoisted_7$4, [
                createVNode(unref(q), {
                  id: "btn",
                  type: "primary",
                  onClick: redirectProfile
                }, {
                  default: withCtx(() => [
                    createTextVNode("Complete profile")
                  ]),
                  _: 1
                })
              ])) : (openBlock(), createElementBlock("div", _hoisted_8$4, [
                createVNode(unref(render$r), { class: "mr-2 !h-5 !w-5 text-primary-600" }),
                createVNode(unref(q), {
                  id: "btn",
                  text: true,
                  class: "text-sm font-semibold"
                }, {
                  default: withCtx(() => [
                    createTextVNode("Profile Complete")
                  ]),
                  _: 1
                })
              ]))
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(profileInfo.value, (items, index2) => {
              return openBlock(), createElementBlock("div", { key: index2 }, [
                createVNode(unref(p$1)),
                createElementVNode("div", _hoisted_9$4, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(items, (item) => {
                    return openBlock(), createElementBlock("div", {
                      key: item.slug,
                      class: "col-span-1 flex"
                    }, [
                      item.isSocialMedia ? (openBlock(), createElementBlock("div", _hoisted_10$2, [
                        createElementVNode("img", {
                          src: item.icon
                        }, null, 8, _hoisted_11$2)
                      ])) : (openBlock(), createElementBlock("div", _hoisted_12$2, [
                        (openBlock(), createBlock(resolveDynamicComponent(item.icon), { class: "h-5 w-5 text-gray-500" }))
                      ])),
                      createElementVNode("div", null, [
                        createVNode(unref(d), { class: "ml-2 w-52 truncate text-gray-500 xl:w-48" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(getShortenedURL)(item.value)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]);
                  }), 128))
                ])
              ]);
            }), 128))
          ];
        }),
        _: 1
      });
    };
  }
});
var ProfileDetails = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["__scopeId", "data-v-16fe06f5"]]);
var WebDashboard_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$v = { class: "grid h-screen grid-cols-3 grid-rows-2 gap-10" };
const _hoisted_2$s = { class: "col-span-3 grid grid-cols-3 gap-8 px-10 xl:px-44 2xl:px-[420px]" };
const _sfc_main$A = defineComponent({
  __name: "WebDashboard",
  emits: ["logout"],
  setup(__props, { emit: __emit }) {
    const scrollHeight = ref(0);
    const emit = __emit;
    onMounted(async () => {
      window.addEventListener("scroll", handleScroll);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    function handleScroll(e) {
      scrollHeight.value = document.documentElement.scrollTop;
    }
    function receiveLogoutUser() {
      emit("logout", logoutUser());
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createVNode(unref(NavBar), {
          class: normalizeClass(scrollHeight.value > 0 ? null : "main"),
          onLogout: receiveLogoutUser,
          isHome: true,
          scrollHeight: scrollHeight.value
        }, null, 8, ["class", "scrollHeight"]),
        createElementVNode("div", _hoisted_1$v, [
          createVNode(BrandingComponent),
          createElementVNode("div", _hoisted_2$s, [
            createVNode(ProfileDetails),
            createVNode(ActionButtons),
            createVNode(AnalyticsCards)
          ])
        ])
      ]);
    };
  }
});
var WebDashboard = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-63006f2a"]]);
var DashBoard_index_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$u = { key: 0 };
const _hoisted_2$r = { key: 1 };
const _hoisted_3$o = { key: 0 };
const _hoisted_4$a = { key: 1 };
const __default__$6 = {
  name: "DashBoard"
};
const _sfc_main$z = defineComponent(__spreadProps(__spreadValues({}, __default__$6), {
  setup(__props) {
    ref(null);
    const isLoading = ref(false);
    onMounted(async () => {
      var _a2, _b;
      await Promise.all([
        LocationState.getBrandingDetails(),
        UserState.getUserDetails()
      ]);
      if (!((_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.analytics)) {
        isLoading.value = true;
      }
      const fetchData = async () => {
        var _a3, _b2;
        try {
          await UserState.getUserAnalytics((_a3 = UserState.state) == null ? void 0 : _a3.userId, (_b2 = LocationState.state) == null ? void 0 : _b2.locationId);
        } catch (error) {
          console.error("Error fetching user analytics:", error);
        } finally {
          isLoading.value = false;
        }
      };
      watch(() => {
        var _a3;
        return (_a3 = UserState.state) == null ? void 0 : _a3.userId;
      }, (newUserId) => {
        if (newUserId) {
          fetchData();
        }
      });
      if ((_b = UserState.state) == null ? void 0 : _b.userId) {
        fetchData();
      }
    });
    const analyticsCards = computed(() => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
      if (!((_a2 = UserState == null ? void 0 : UserState.state) == null ? void 0 : _a2.analytics))
        return [];
      const data = (_b = UserState == null ? void 0 : UserState.state) == null ? void 0 : _b.analytics;
      return [
        {
          titleAnalytics: "Groups Joined",
          titleCards: "Join a Group",
          titleChildApps: "Communities",
          descriptionAnalytics: "View your joined community groups",
          descriptionCards: "Collaborate with members",
          descriptionChildApps: "Engage in community groups",
          button: "View joined groups",
          icon: render$m,
          isVisible: ((_d = (_c = LocationState.state) == null ? void 0 : _c.locationPermissions) == null ? void 0 : _d.communitiesEnabled) === true,
          route: "communities/",
          routeCards: "communities/",
          data: ((_e = data.groups) == null ? void 0 : _e.joinedGroups) || 0,
          svgIcon: GROUPS_CONNECTIONS,
          coverImage: COMMUNITIES_PEOPLE,
          isVisibleAnalytics: true,
          backgroundColorClass: "redGradient"
        },
        {
          titleAnalytics: "Courses  Completed",
          titleCards: "Take course",
          titleChildApps: "Courses",
          descriptionAnalytics: "Track progress of your courses",
          descriptionCards: "Elevate  your skills by taking a course",
          descriptionChildApps: "Explore available courses",
          button: "Resume learning",
          icon: render$n,
          isVisible: ((_g = (_f = LocationState.state) == null ? void 0 : _f.locationPermissions) == null ? void 0 : _g.membershipEnabled) === true,
          route: "courses/library-v2",
          routeCards: "courses/library-v2",
          path: "courses=my",
          data: ((_h = data == null ? void 0 : data.course) == null ? void 0 : _h.coursesCompleted) || "0",
          svgIcon: COURSES_CAP,
          coverImage: GROUP_BOOK,
          isVisibleAnalytics: true,
          backgroundColorClass: "grayGradient"
        },
        {
          titleAnalytics: "Total Affiliate Earning",
          titleCards: "Affiliate Earnings",
          titleChildApps: "Affiliates",
          descriptionAnalytics: "Increase your earnings through affiliate commissions",
          descriptionCards: "Track all your affiliate earnings",
          descriptionChildApps: "Earn affiliate commissions",
          button: "Start earning ",
          icon: render$s,
          isVisible: !isPwa() && ((_j = (_i = LocationState.state) == null ? void 0 : _i.locationPermissions) == null ? void 0 : _j.affiliateManagerEnabled) === true,
          route: "affiliate/campaign",
          routeCards: "affiliate/commission",
          data: (((_k = LocationState.state) == null ? void 0 : _k.currencySymbol) || "") + " " + (((_l = data.affiliates) == null ? void 0 : _l.earnings) || 0),
          description: "Track all your affiliate earnings",
          svgIcon: MONEY_BAG,
          coverImage: TEAM_MEETING,
          isVisibleAnalytics: true,
          backgroundColorClass: "blueGradient"
        },
        {
          titleAnalytics: "Billing Details",
          titleCards: "Billing & Subscription",
          titleChildApps: "Billing",
          descriptionAnalytics: "View your Billing & Subscription details",
          descriptionCards: "View Billing Details",
          descriptionChildApps: "View Billing Details",
          button: "View Billing Details",
          icon: render$e,
          isVisible: ((_n = (_m = LocationState.state) == null ? void 0 : _m.locationPermissions) == null ? void 0 : _n.subscriptionsEnabled) !== false,
          route: isPwa() ? "profile?activeTab=BillingSubscription" : "account?activeTab=BillingSubscription",
          routeCards: isPwa() ? "profile?activeTab=BillingSubscription" : "account?activeTab=BillingSubscription",
          data: ((_o = data.groups) == null ? void 0 : _o.joinedGroups) || 0,
          svgIcon: MONEY_BAG,
          coverImage: COMMUNITIES_PEOPLE,
          isVisibleAnalytics: false,
          backgroundColorClass: "orangeGradient"
        }
      ].filter((item) => item.isVisible);
    });
    provide("analyticsCards", analyticsCards);
    return (_ctx, _cache) => {
      return isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_1$u, [
        createVNode(unref(_$3), {
          size: "large",
          class: "flex h-screen w-full items-center justify-center"
        })
      ])) : (openBlock(), createElementBlock("div", _hoisted_2$r, [
        unref(isPwa)() ? (openBlock(), createElementBlock("div", _hoisted_3$o, [
          createVNode(MobilePwaDashboard)
        ])) : (openBlock(), createElementBlock("div", _hoisted_4$a, [
          unref(AppState).state.isMobile ? (openBlock(), createBlock(MobileDashboard, { key: 0 })) : (openBlock(), createBlock(WebDashboard, { key: 1 }))
        ]))
      ]));
    };
  }
}));
var DashBoard = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["__scopeId", "data-v-a9c17fc2"]]);
DashBoard.install = (Vue) => {
  Vue.component(DashBoard.name, DashBoard);
};
const getErrorMessage = (error) => {
  var _a2, _b;
  const message = (_b = (_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.message;
  if (message) {
    return typeof message === "string" ? message : typeof message[0] === "string" ? message[0] : "Something went wrong";
  }
  return "Something went wrong";
};
const _hoisted_1$t = { class: "centered h-full w-full" };
const _hoisted_2$q = { class: "centered h-full w-full" };
const _hoisted_3$n = { class: "align-start m-0 flex w-full" };
const _hoisted_4$9 = {
  key: 0,
  class: "w-full text-rose-600"
};
const _sfc_main$y = defineComponent({
  __name: "ForgotPassword",
  emits: ["changeScreen"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const errorMessage = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const resetPasswordDisabled = ref(false);
    const rules = {
      email: {
        required: true,
        validator: async (_2, value) => {
          return await create$6().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["input", "blur"]
      },
      username: {
        required: true,
        message: "Please enter your name",
        trigger: ["input"]
      },
      password: {
        required: true,
        min: 8,
        message: "Please enter a password of mininum 8 character",
        trigger: ["input"]
      }
    };
    const formValue = ref({
      email: "",
      password: "",
      username: ""
    });
    const formRef = ref();
    async function validateForm() {
      return new Promise((resolve) => {
        formRef.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.log("error", e);
          resolve(false);
        });
      });
    }
    const handleValidateClick = async (e) => {
      loading.value = true;
      e.preventDefault();
      errorMessage.value = null;
      await formRef.value.getForm().restoreValidation();
      const result = await validateForm();
      if (!result) {
        loading.value = false;
        return;
      }
      try {
        const { data } = await UserService.forgotPassword({
          locationId: AppState.state.locationData.locationId,
          email: formValue.value.email.trim(),
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          loading.value = false;
          emit("changeScreen", {
            email: formValue.value.email,
            multiUser: data == null ? void 0 : data.multiple_users,
            resetPassword: true,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else {
          loading.value = false;
          emit("changeScreen", {
            page: Screens.LOGIN
          });
        }
      } catch (error) {
        if (error.response.status === 429) {
          resetPasswordDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      resetPasswordDisabled.value = false;
    };
    const onError = (response) => {
      resetPasswordDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      resetPasswordDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$t, [
        createElementVNode("div", _hoisted_2$q, [
          createVNode(unref(B), {
            id: "forgot-password-form",
            ref_key: "formRef",
            ref: formRef,
            class: "flex flex-col items-center w-full",
            model: formValue.value,
            rules
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_3$n, [
                createVNode(unref(Q), { id: "text-only-header" })
              ]),
              createVNode(unref(V), {
                class: "w-full form-item",
                path: "email"
              }, {
                default: withCtx(() => [
                  createVNode(unref(P), {
                    size: "large",
                    id: "forgot-password-form-email",
                    modelValue: formValue.value.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.email = $event),
                    placeholder: "Email"
                  }, {
                    prefix: withCtx(() => [
                      createVNode(unref(render$8), { class: "h-5 w-5 pr-1 mr-2" })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_4$9, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
              showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$T, {
                key: 1,
                class: "flex w-full justify-center",
                onExpired,
                onVerify,
                onError
              })) : createCommentVNode("", true),
              createVNode(unref(q), {
                id: "forgot-password-form-btn",
                style: normalizeStyle(unref(AppState).state.authButtonStyle),
                disabled: loading.value || resetPasswordDisabled.value,
                onClick: handleValidateClick,
                loading: loading.value,
                class: "w-full mt-8"
              }, {
                default: withCtx(() => [
                  createTextVNode(" Reset Password ")
                ]),
                _: 1
              }, 8, ["style", "disabled", "loading"]),
              createElementVNode("div", null, [
                createTextVNode(" Already have an account? "),
                createElementVNode("span", null, [
                  createVNode(unref(q), {
                    id: "open-login-button",
                    class: "ml-2 my-2 cursor-pointer no-underline",
                    text: true,
                    onClick: _cache[1] || (_cache[1] = ($event) => emit("changeScreen", {
                      page: unref(Screens).LOGIN
                    }))
                  }, {
                    default: withCtx(() => [
                      createTextVNode(" Login ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]);
    };
  }
});
const _hoisted_1$s = { class: "centered h-full w-full" };
const _hoisted_2$p = { class: "centered h-full w-full" };
const _hoisted_3$m = {
  id: "sign-up-form",
  class: "flex flex-col items-center w-full"
};
const _hoisted_4$8 = { class: "align-start m-0 flex w-full" };
const _hoisted_5$6 = /* @__PURE__ */ createElementVNode("div", { class: "text-center my-8" }, " If the entered email is correct, you will receive a reset password link in the email. Please ensure to check the spam folder as well. ", -1);
const _hoisted_6$5 = { class: "footer flex w-full justify-between" };
const _hoisted_7$3 = {
  key: 0,
  class: "m-2 flex items-center"
};
const _hoisted_8$3 = /* @__PURE__ */ createElementVNode("span", { class: "copyright mr-1 mt-0.5" }, "\xA9", -1);
const _hoisted_9$3 = {
  key: 1,
  class: "m-2 flex items-center"
};
const _sfc_main$x = defineComponent({
  __name: "ProceedToLogin",
  emits: ["changeScreen"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    history.pushState({}, "", "");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$s, [
        createElementVNode("div", _hoisted_2$p, [
          createElementVNode("div", _hoisted_3$m, [
            createElementVNode("div", _hoisted_4$8, [
              createVNode(unref(Q), { id: "text-only-header" })
            ]),
            _hoisted_5$6,
            createVNode(unref(q), {
              id: "open-login-button",
              class: "my-2 w-full cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event) => emit("changeScreen", {
                page: unref(Screens).LOGIN
              }))
            }, {
              default: withCtx(() => [
                createTextVNode(" Proceed to Login ")
              ]),
              _: 1
            })
          ])
        ]),
        createElementVNode("div", _hoisted_6$5, [
          unref(AppState).state.locationData.branding.copyRight && unref(AppState).state.locationData.branding.copyRight.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_7$3, [
            _hoisted_8$3,
            createElementVNode("div", null, toDisplayString(unref(AppState).state.locationData.branding.copyRight), 1)
          ])) : createCommentVNode("", true),
          unref(AppState).state.locationData.branding.supportEmail && unref(AppState).state.locationData.branding.supportEmail.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_9$3, [
            createVNode(unref(render$8), { class: "mr-2 h-4 w-4" }),
            createTextVNode(toDisplayString(unref(AppState).state.locationData.branding.supportEmail), 1)
          ])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
var LoginMultiUser_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$3 = (n) => (pushScopeId("data-v-04f604d1"), n = n(), popScopeId(), n);
const _hoisted_1$r = { class: "flex flex-col" };
const _hoisted_2$o = /* @__PURE__ */ _withScopeId$3(() => /* @__PURE__ */ createElementVNode("div", { class: "align-center m-0 flex w-full" }, null, -1));
const _hoisted_3$l = { class: "max-h-72 w-full user-list-scrollbar" };
const _hoisted_4$7 = ["onClick"];
const _hoisted_5$5 = { class: "flex flex-row items-center gap-3 p-3" };
const _hoisted_6$4 = {
  key: 0,
  class: "w-full text-rose-600"
};
const _sfc_main$w = defineComponent({
  __name: "LoginMultiUser",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    password: {
      type: String,
      default: ""
    },
    otp: {
      type: []
    },
    token: {
      type: String
    },
    users: {
      default: []
    },
    resetPassword: {
      default: false
    },
    idToken: {
      type: String
    },
    fullName: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const selectedCheckbox = ref("");
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const loginDisabled = ref(false);
    const errorMessage = ref();
    const loading = ref();
    const props = __props;
    const handleCheckBoxUpdate = (item) => {
      const value = item.userId;
      if (selectedCheckbox.value === value) {
        selectedCheckbox.value = "";
      } else {
        selectedCheckbox.value = value;
      }
    };
    const handleLogin = async () => {
      var _a2;
      loading.value = true;
      let response;
      try {
        errorMessage.value = null;
        if (!selectedCheckbox.value) {
          errorMessage.value = "Select at least one user";
          loading.value = false;
          return;
        }
        if ((props == null ? void 0 : props.otp) && props.token) {
          const { data } = await UserService.loginWithSecureEmail({
            email: props.email,
            otp: Number(props.otp),
            token: props.token,
            userId: selectedCheckbox.value,
            locationId: AppState.state.locationData.locationId,
            captchaToken: reCaptchaToken.value
          });
          response = data;
        } else if (props.idToken) {
          const { data } = await UserService.loginWithSocialID({
            email: props.email,
            authProvider: "Google",
            idToken: props.idToken,
            fullName: props.fullName,
            userId: selectedCheckbox.value,
            locationId: AppState.state.locationData.locationId
          });
          response = data;
        } else if (props.resetPassword && props.email) {
          const { data } = await UserService.forgotPassword({
            locationId: AppState.state.locationData.locationId,
            email: props.email.trim(),
            userId: selectedCheckbox.value,
            captchaToken: reCaptchaToken.value
          });
          response = data;
          if (data.success) {
            emit("changeScreen", {
              email: props.email,
              page: Screens.PROCEED_TO_LOGIN
            });
          }
        } else {
          const { data } = await UserService.login({
            email: props.email,
            password: props.password,
            userId: selectedCheckbox.value,
            locationId: AppState.state.locationData.locationId,
            captchaToken: reCaptchaToken.value
          });
          response = data;
        }
        if (response) {
          await postLogin(response);
          if (!response.isPasswordVerified) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: response.passwordResetToken,
              contactId: response.contactId,
              page: Screens.SET_PASSWORD
            });
          } else {
            emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
              eventType: LoginEvents.LOGIN_SUCCESSFUL
            }, response));
          }
        }
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          loginDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      loginDisabled.value = false;
    };
    const onError = (response) => {
      loginDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      loginDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$r, [
        _hoisted_2$o,
        createElementVNode("div", _hoisted_3$l, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.users, (item) => {
            return openBlock(), createElementBlock("div", {
              key: item.userId,
              style: normalizeStyle([
                selectedCheckbox.value === item.userId ? { border: "2px solid #004EEB" } : {}
              ]),
              class: "mb-4 max-w-2xl cursor-pointer hover:border-blue-400 border-solid border-1px rounded-lg border-gray-200 user_account_card",
              onClick: () => handleCheckBoxUpdate(item)
            }, [
              createElementVNode("div", _hoisted_5$5, [
                (item == null ? void 0 : item.avatarUrl) ? (openBlock(), createBlock(unref(I$1), {
                  key: 0,
                  size: "large",
                  src: item.avatarUrl
                }, null, 8, ["src"])) : (openBlock(), createBlock(unref(I$1), {
                  key: 1,
                  size: "large",
                  class: "flex items-center justify-center bg-gray-100 text-md font-medium text-gray-600"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(d), null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(getShortName)(item.fullName || "Deleted User")), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)),
                createElementVNode("div", null, [
                  createVNode(unref(d), { class: "text-gray-700 font-semibold" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.fullName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (item == null ? void 0 : item.lastLogin) ? (openBlock(), createBlock(unref(d), {
                    key: 0,
                    class: "text-gray-600 font-light"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(" Last Login: " + toDisplayString(unref(timestampFormat)(item == null ? void 0 : item.lastLogin)), 1)
                    ]),
                    _: 2
                  }, 1024)) : createCommentVNode("", true)
                ])
              ])
            ], 12, _hoisted_4$7);
          }), 128))
        ]),
        createVNode(unref(_$2), { class: "mt-2 text-sm text-gray-600 flex al" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(`Select which account you want to ${props.resetPassword ? "reset password" : "login"} `), 1)
          ]),
          _: 1
        }),
        errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_6$4, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
        showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$T, {
          key: 1,
          class: "flex w-full justify-center",
          onExpired,
          onVerify,
          onError
        })) : createCommentVNode("", true),
        createVNode(unref(q), {
          id: "btn-select-acc-id",
          onClick: handleLogin,
          style: normalizeStyle(unref(AppState).state.authButtonStyle),
          loading: loading.value,
          disabled: loading.value || loginDisabled.value,
          class: "w-full mt-6"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(props.resetPassword ? "Reset Password" : `${props.title}`), 1)
          ]),
          _: 1
        }, 8, ["style", "loading", "disabled"])
      ]);
    };
  }
});
var LoginMultiUser = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["__scopeId", "data-v-04f604d1"]]);
var LoginOtpInput_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$q = { class: "form-group mt-4" };
const _hoisted_2$n = { class: "flex flex-row justify-center text-center" };
const _hoisted_3$k = { class: "flex" };
const _hoisted_4$6 = {
  key: 0,
  class: "w-full text-rose-600"
};
const _sfc_main$v = defineComponent({
  __name: "LoginOtpInput",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    password: {
      type: String
    },
    username: {
      type: String
    },
    locationId: {
      type: String
    },
    defaultOtp: {
      type: Number,
      default: null
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const errorMessage = ref();
    const route = useRoute();
    const otpCode = ref("");
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const verifyDisabled = ref(false);
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    const handleOnComplete = async () => {
      var _a2, _b, _c;
      loading.value = true;
      try {
        if (!Number(otpCode.value)) {
          errorMessage.value = "Secure code must be a numeric value and must be of 6 digits";
          loading.value = false;
          return false;
        }
        errorMessage.value = null;
        const { data } = props.password ? await UserService.signUp({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: AppState.state.locationData.locationId,
          redirectUrl: (_a2 = route == null ? void 0 : route.query) == null ? void 0 : _a2.redirectUrl,
          password: props.password.trim() || null,
          username: props.username.trim() || null,
          captchaToken: reCaptchaToken.value
        }) : await UserService.loginWithSecureEmail({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: AppState.state.locationData.locationId,
          redirectUrl: (_b = route == null ? void 0 : route.query) == null ? void 0 : _b.redirectUrl,
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            email: props.email,
            otp: Number(otpCode.value),
            token: props.token,
            multiUser: data == null ? void 0 : data.multiple_users,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else if (data.token) {
          await postLogin(data);
          if (!data.isPasswordVerified && (data == null ? void 0 : data.passwordResetToken)) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: data.passwordResetToken,
              contactId: data.contactId,
              page: Screens.SET_PASSWORD
            });
          } else {
            await postLogin(data);
            emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
              eventType: LoginEvents.LOGIN_SUCCESSFUL
            }, data));
          }
          loading.value = false;
        }
        showRecaptcha.value = false;
        loading.value = false;
      } catch (error) {
        if (((_c = error == null ? void 0 : error.response) == null ? void 0 : _c.status) === 429) {
          verifyDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
          if (errorMessage.value == "User not found") {
            emit("changeScreen", {
              email: props.email,
              page: Screens.SIGN_UP
            });
          }
        }
        loading.value = false;
      }
    };
    const isResendButtonDisabled = ref(false);
    async function resendOtp() {
      var _a2;
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          locationId: AppState.state.locationData.locationId,
          captchaToken: reCaptchaToken.value
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: props.email,
          token: data.token
        });
        isResendButtonDisabled.value = true;
        setTimeout(() => isResendButtonDisabled.value = false, 3e4);
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          verifyDisabled.value = true;
          isResendButtonDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          errorMessage.value = getErrorMessage(error);
          showRecaptcha.value = false;
        }
      }
    }
    watch(otpCode, () => errorMessage.value = null);
    history.pushState({}, "", "");
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      verifyDisabled.value = false;
    };
    const onError = (response) => {
      verifyDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      verifyDisabled.value = true;
    };
    return (_ctx, _cache) => {
      const _component_UITextMdNormal = resolveComponent("UITextMdNormal");
      const _component_UITextSmRegular = resolveComponent("UITextSmRegular");
      return openBlock(), createElementBlock("div", _hoisted_1$q, [
        createVNode(_component_UITextMdNormal, { class: "my-2 text-gray-700" }, {
          default: withCtx(() => [
            createTextVNode("Secure code")
          ]),
          _: 1
        }),
        createElementVNode("div", _hoisted_2$n, [
          createVNode(unref(entry_esm), {
            ref: "otpInput",
            "input-classes": "otp-input",
            class: "text-3xl",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange
          }, null, 8, ["value"])
        ]),
        createElementVNode("div", _hoisted_3$k, [
          createVNode(_component_UITextSmRegular, { class: "text-gray-700" }, {
            default: withCtx(() => [
              createTextVNode("Please check your email for the secure code. If you did not receive any email from us, "),
              createElementVNode("span", null, [
                createVNode(unref(q), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => [
                    createTextVNode(" tap here to resend. ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_4$6, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
        showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$T, {
          key: 1,
          class: "flex w-full justify-center",
          onExpired,
          onVerify,
          onError
        })) : createCommentVNode("", true),
        createVNode(unref(q), {
          id: "login-secure-form-btn",
          onClick: handleOnComplete,
          disabled: loading.value || verifyDisabled.value,
          loading: loading.value,
          style: normalizeStyle(unref(AppState).state.authButtonStyle),
          class: "w-full mt-4 mb-2"
        }, {
          default: withCtx(() => [
            createTextVNode("Verify Secure Code ")
          ]),
          _: 1
        }, 8, ["disabled", "loading", "style"]),
        createElementVNode("div", null, [
          createVNode(unref(q), {
            id: "open-signup-button",
            class: "cursor-pointer no-underline w-full justify-center",
            text: true,
            onClick: _cache[1] || (_cache[1] = ($event) => emit("changeScreen", {
              page: unref(Screens).LOGIN
            }))
          }, {
            default: withCtx(() => [
              createTextVNode(" Login with Password ")
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
});
var SignInWithGoogle_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$p = ["src"];
const _hoisted_2$m = { class: "flex w-full items-center justify-center" };
const _hoisted_3$j = {
  key: 0,
  class: "flex h-[40px] mt-6 w-full items-center justify-center border border-solid border-gray-300 bg-white px-0 text-white hover:bg-gray-50 rounded-md cursor-pointer"
};
const _sfc_main$u = defineComponent({
  __name: "SignInWithGoogle",
  props: {
    loginType: {
      type: String,
      required: true
    }
  },
  emits: [
    "changeScreen",
    LoginEvents.LOGIN_CALLBACK,
    "onClick",
    "updateLoader"
  ],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const ssoApp = ref(`${AppState.getConfig().CLIENT_PORTAL_SSO_URL}/login?origin=${window.location.origin}`);
    onMounted(() => {
      window.addEventListener("message", async function(event2) {
        var _a2, _b, _c, _d;
        if (event2.origin === AppState.getConfig().CLIENT_PORTAL_SSO_URL && ((_a2 = event2 == null ? void 0 : event2.data) == null ? void 0 : _a2.credential)) {
          emit("updateLoader", true);
          const dataFromPopup = (_b = event2 == null ? void 0 : event2.data) == null ? void 0 : _b.credential;
          const { data } = await UserService.loginWithSocialID({
            authProvider: "Google",
            idToken: dataFromPopup,
            locationId: (_c = AppState.state.locationData) == null ? void 0 : _c.locationId
          });
          if (data == null ? void 0 : data.multiple_users) {
            emit("changeScreen", {
              email: data == null ? void 0 : data.email,
              fullName: data == null ? void 0 : data.displayName,
              authProvider: "Google",
              idToken: dataFromPopup,
              locationId: (_d = AppState.state.locationData) == null ? void 0 : _d.locationId,
              page: Screens.SELECT_USER_MULTI_USER,
              multiUser: data == null ? void 0 : data.multiple_users
            });
          } else if (data.token) {
            await postLogin(data);
            if (!data.isPasswordVerified && (data == null ? void 0 : data.passwordResetToken)) {
              emit("changeScreen", {
                email: data == null ? void 0 : data.email,
                passwordResetToken: data.passwordResetToken,
                contactId: data.contactId,
                page: Screens.SET_PASSWORD
              });
            } else {
              emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
                eventType: LoginEvents.LOGIN_SUCCESSFUL
              }, data));
            }
          }
        }
      });
    });
    const isLoading = ref(true);
    return (_ctx, _cache) => {
      const _component_UITextSmRegular = resolveComponent("UITextSmRegular");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          id: "google-one-tap1",
          class: normalizeClass(["flex items-center justify-center h-[50px] mt-6 -mx-4", isLoading.value ? "hidden" : "block"]),
          style: { "width": "calc(100% + 32px)" }
        }, [
          createElementVNode("iframe", {
            src: ssoApp.value,
            id: "google-one-tap",
            width: "100%",
            height: "44",
            style: { "border": "none" },
            allow: "identity-credentials-get",
            onLoad: _cache[0] || (_cache[0] = () => isLoading.value = false)
          }, null, 40, _hoisted_1$p)
        ], 2),
        createElementVNode("div", _hoisted_2$m, [
          isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_3$j, [
            createVNode(unref(_$3), { size: 16 })
          ])) : createCommentVNode("", true)
        ]),
        createVNode(unref(p$1), null, {
          default: withCtx(() => [
            createVNode(_component_UITextSmRegular, {
              class: "text-gray-600 divider-text",
              style: {}
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.loginType === "SIGN_IN" ? "Or, sign in with your email" : "Or, sign up with your email"), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
var SignInWithGoogle = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-51744d38"]]);
var LoginWithEmailPassword_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$o = {
  key: 0,
  class: "w-full pt-4 mx-2 text-rose-600 justify-center items-center"
};
const _hoisted_2$l = { class: "my-2 w-full flex items-end justify-end" };
const __default__$5 = {
  name: "LoginWithEmailPassword"
};
const _sfc_main$t = defineComponent(__spreadProps(__spreadValues({}, __default__$5), {
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const errorMessage = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const loginDisabled = ref(false);
    const rules = {
      email: {
        required: true,
        validator: (_2, value) => {
          errorMessage.value = null;
          return create$6().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["input", "blur"]
      },
      password: {
        required: true,
        min: 8,
        validator: (_2, value) => {
          errorMessage.value = null;
        },
        message: "Please enter a password of mininum 8 characters",
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      email: "",
      password: ""
    });
    const formRef = ref();
    async function validateForm() {
      return new Promise((resolve) => {
        formRef.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.log("error", e);
          resolve(false);
        });
      });
    }
    async function handleValidateClick(e) {
      var _a2;
      e.preventDefault();
      loading.value = true;
      errorMessage.value = null;
      const result = await validateForm();
      if (!result) {
        loading.value = false;
        return;
      }
      try {
        const { data } = await UserService.login({
          email: formValue.value.email.trim(),
          password: formValue.value.password.trim(),
          locationId: AppState.state.locationData.locationId,
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", __spreadProps(__spreadValues({}, formValue.value), {
            page: Screens.SELECT_USER_MULTI_USER,
            multiUser: data == null ? void 0 : data.multiple_users
          }));
          loading.value = false;
        } else if (data.token) {
          await postLogin(data);
          emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
            eventType: LoginEvents.LOGIN_SUCCESSFUL
          }, data));
          loading.value = false;
        }
        showRecaptcha.value = false;
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          loginDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    }
    watch(formValue.value, () => errorMessage.value = null);
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      loginDisabled.value = false;
    };
    const onError = (response) => {
      loginDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      loginDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !unref(AppState).state.isSSODisabled ? (openBlock(), createBlock(SignInWithGoogle, {
          key: 0,
          loginType: "SIGN_IN",
          onUpdateLoader: _cache[0] || (_cache[0] = (val) => loading.value = val),
          onChangeScreen: _cache[1] || (_cache[1] = (val) => emit("changeScreen", val)),
          onLoginCallback: _cache[2] || (_cache[2] = (val) => emit(unref(LoginEvents).LOGIN_CALLBACK, val))
        })) : createCommentVNode("", true),
        createVNode(unref(B), {
          id: "login-page-email-form",
          ref_key: "formRef",
          ref: formRef,
          class: "flex flex-col items-center",
          model: formValue.value,
          rules,
          onKeyup: withKeys(handleValidateClick, ["enter"])
        }, {
          default: withCtx(() => [
            createVNode(unref(V), {
              class: "w-full form-item",
              path: "email"
            }, {
              default: withCtx(() => [
                createVNode(unref(P), {
                  size: "large",
                  id: "sign-in-form-email",
                  modelValue: formValue.value.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => formValue.value.email = $event),
                  placeholder: "Email"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$8), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            createVNode(unref(V), {
              class: "w-full form-item",
              path: "password"
            }, {
              default: withCtx(() => [
                createVNode(unref(P), {
                  id: "sign-in-form-password",
                  type: "password",
                  modelValue: formValue.value.password,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => formValue.value.password = $event),
                  placeholder: "Password",
                  "show-password-on": "click"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$t), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$o, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
            showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$T, {
              key: 1,
              class: "flex w-full justify-center",
              onExpired,
              onVerify,
              onError
            })) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_2$l, [
              createVNode(unref(q), {
                id: "open-forgot-password-button",
                class: "ml-2 my-2 cursor-pointer no-underline",
                text: true,
                onClick: _cache[5] || (_cache[5] = ($event) => emit("changeScreen", {
                  page: unref(Screens).FORGOT_PASSWORD
                }))
              }, {
                default: withCtx(() => [
                  createTextVNode(" Forgot Password ? ")
                ]),
                _: 1
              })
            ]),
            createVNode(unref(q), {
              id: "login--button",
              onClick: handleValidateClick,
              class: "w-full mv-2",
              style: normalizeStyle(unref(AppState).state.authButtonStyle),
              disabled: loading.value || loginDisabled.value,
              loading: loading.value,
              keyboard: true
            }, {
              default: withCtx(() => [
                createTextVNode("Login")
              ]),
              _: 1
            }, 8, ["style", "disabled", "loading"]),
            createVNode(unref(q), {
              id: "sec-log-btn-login-page",
              class: "my-2 w-full cursor-pointer",
              style: normalizeStyle(unref(AppState).state.secondaryButtonStyle),
              onClick: _cache[6] || (_cache[6] = () => emit("changeScreen", {
                page: unref(Screens).LOGIN_WITH_SECURE_CODE
              }))
            }, {
              default: withCtx(() => [
                createTextVNode(" Login with secure code ")
              ]),
              _: 1
            }, 8, ["style"]),
            createElementVNode("div", null, [
              createTextVNode(" New User? "),
              createElementVNode("span", null, [
                createVNode(unref(q), {
                  id: "open-signup-button",
                  class: "ml-2 my-2 cursor-pointer no-underline",
                  text: true,
                  onClick: _cache[7] || (_cache[7] = ($event) => emit("changeScreen", {
                    page: unref(Screens).SIGN_UP
                  }))
                }, {
                  default: withCtx(() => [
                    createTextVNode(" Sign Up ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ], 64);
    };
  }
}));
var LoginWithEmailPassword = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["__scopeId", "data-v-6ec5bdc3"]]);
var LoginWithSecureCode_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$n = {
  key: 0,
  class: "w-full text-rose-600 py-2"
};
const _sfc_main$s = defineComponent({
  __name: "LoginWithSecureCode",
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const errorMessage = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const loginDisabled = ref(false);
    const rules = {
      email: {
        required: true,
        validator: (_2, value) => {
          errorMessage.value = null;
          return create$6().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      email: ""
    });
    const formRef = ref();
    async function validateForm() {
      return new Promise((resolve) => {
        formRef.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.log("error", e);
          resolve(false);
        });
      });
    }
    const handleValidateClick = async () => {
      var _a2;
      loading.value = true;
      const result = await validateForm();
      if (!result) {
        loading.value = false;
        return;
      }
      try {
        errorMessage.value = null;
        const { data } = await UserService.loginWithSecureEmail({
          email: formValue.value.email.trim(),
          locationId: AppState.state.locationData.locationId,
          action: "SIGN_IN",
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.token) {
          emit("changeScreen", {
            email: formValue.value.email,
            otp: String(data == null ? void 0 : data.otp),
            token: data.token,
            page: Screens.VERIFY_SECURE_CODE
          });
          loading.value = false;
        }
        showRecaptcha.value = false;
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          loginDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      loginDisabled.value = false;
    };
    const onError = (response) => {
      loginDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      loginDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !unref(AppState).state.isSSODisabled ? (openBlock(), createBlock(SignInWithGoogle, {
          key: 0,
          loginType: "SIGN_IN",
          onUpdateLoader: _cache[0] || (_cache[0] = (val) => loading.value = val),
          onChangeScreen: _cache[1] || (_cache[1] = (val) => emit("changeScreen", val)),
          onLoginCallback: _cache[2] || (_cache[2] = (val) => emit(unref(LoginEvents).LOGIN_CALLBACK, val))
        })) : createCommentVNode("", true),
        createVNode(unref(B), {
          ref_key: "formRef",
          ref: formRef,
          id: "login-secure-form",
          class: "flex flex-col items-center",
          model: formValue.value,
          rules,
          onKeyup: withKeys(handleValidateClick, ["enter"])
        }, {
          default: withCtx(() => [
            createVNode(unref(V), {
              class: "w-full form-item",
              path: "email"
            }, {
              default: withCtx(() => [
                createVNode(unref(P), {
                  id: "sign-up-form-email",
                  modelValue: formValue.value.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => formValue.value.email = $event),
                  placeholder: "Email"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$8), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$n, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
            showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$T, {
              key: 1,
              class: "flex w-full justify-center",
              onExpired,
              onVerify,
              onError
            })) : createCommentVNode("", true),
            createVNode(unref(q), {
              id: "login-secure-form-btn",
              onClick: handleValidateClick,
              disabled: loading.value || loginDisabled.value,
              loading: loading.value,
              style: normalizeStyle(unref(AppState).state.authButtonStyle),
              class: "w-full mt-8"
            }, {
              default: withCtx(() => [
                createTextVNode("Generate Secure Code")
              ]),
              _: 1
            }, 8, ["disabled", "loading", "style"]),
            createVNode(unref(q), {
              id: "open-signup-button",
              class: "my-2 w-full cursor-pointer",
              style: normalizeStyle(unref(AppState).state.secondaryButtonStyle),
              onClick: _cache[4] || (_cache[4] = ($event) => emit("changeScreen", {
                page: unref(Screens).LOGIN
              }))
            }, {
              default: withCtx(() => [
                createTextVNode(" Login with Password ")
              ]),
              _: 1
            }, 8, ["style"]),
            createElementVNode("div", null, [
              createTextVNode(" New User? "),
              createElementVNode("span", null, [
                createVNode(unref(q), {
                  id: "open-signup-button",
                  class: "ml-2 my-2 cursor-pointer no-underline",
                  text: true,
                  onClick: _cache[5] || (_cache[5] = ($event) => emit("changeScreen", {
                    page: unref(Screens).SIGN_UP
                  }))
                }, {
                  default: withCtx(() => [
                    createTextVNode(" Sign Up ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ], 64);
    };
  }
});
var LoginWithSecureCode = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-4863eac8"]]);
var SetPassword_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$m = {
  key: 0,
  class: "w-full text-rose-600 py-2"
};
const _sfc_main$r = defineComponent({
  __name: "SetPassword",
  props: {
    passwordResetToken: {
      type: String,
      required: true
    },
    contactId: {
      type: String,
      required: true
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    const errorMessage = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const setPasswordDisabled = ref(false);
    const rules = {
      newPassword: {
        required: true,
        min: 8,
        message: "Please enter a password of mininum 8 characters",
        trigger: ["input", "blur"]
      },
      confirmPassword: {
        required: true,
        validator: (_2, value) => {
          return create$6().required().oneOf([formValue.value.newPassword], "Passwords must match").validate(value);
        },
        message: "Passwords must match",
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      newPassword: "",
      confirmPassword: ""
    });
    const formRef = ref();
    async function validateForm() {
      return new Promise((resolve) => {
        formRef.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.log("error", e);
          resolve(false);
        });
      });
    }
    const handleValidateClick = async () => {
      var _a2;
      const isValidated = await validateForm();
      if (!isValidated) {
        return false;
      }
      try {
        loading.value = true;
        errorMessage.value = null;
        const { data } = await UserService.setPassword({
          newPassword: formValue.value.newPassword.trim(),
          confirmPassword: formValue.value.confirmPassword.trim(),
          locationId: AppState.state.locationData.locationId,
          passwordResetToken: props.passwordResetToken,
          contactId: props.contactId,
          captchaToken: reCaptchaToken.value
        });
        emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
          eventType: LoginEvents.LOGIN_SUCCESSFUL
        }, data));
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          setPasswordDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      setPasswordDisabled.value = false;
    };
    const onError = (response) => {
      setPasswordDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      setPasswordDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(B), {
        ref_key: "formRef",
        ref: formRef,
        id: "set-password-form",
        class: "flex flex-col items-center",
        model: formValue.value,
        rules,
        onKeyup: withKeys(handleValidateClick, ["enter"])
      }, {
        default: withCtx(() => [
          createVNode(unref(V), {
            class: "w-full form-item",
            path: "newPassword"
          }, {
            default: withCtx(() => [
              createVNode(unref(P), {
                id: "set-password-form-new-password",
                type: "password",
                modelValue: formValue.value.newPassword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.newPassword = $event),
                placeholder: "New Password",
                "show-password-on": "click"
              }, {
                prefix: withCtx(() => [
                  createVNode(unref(render$t), { class: "h-5 w-5 pr-1 mr-2" })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          createVNode(unref(V), {
            class: "w-full form-item",
            path: "confirmPassword"
          }, {
            default: withCtx(() => [
              createVNode(unref(P), {
                id: "set-password-form-confirm-password",
                type: "password",
                modelValue: formValue.value.confirmPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => formValue.value.confirmPassword = $event),
                placeholder: "Confirm Password",
                "show-password-on": "click"
              }, {
                prefix: withCtx(() => [
                  createVNode(unref(render$t), { class: "h-5 w-5 pr-1 mr-2" })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$m, toDisplayString(errorMessage.value), 1)) : (openBlock(), createBlock(unref(f), {
            key: 1,
            class: "text-gray-700 w-full pt-4"
          }, {
            default: withCtx(() => [
              createTextVNode(" Set your secure password ")
            ]),
            _: 1
          })),
          showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$T, {
            key: 2,
            class: "flex w-full justify-center",
            onExpired,
            onVerify,
            onError
          })) : createCommentVNode("", true),
          createVNode(unref(q), {
            id: "set-password-form-btn",
            onClick: handleValidateClick,
            disabled: loading.value,
            loading: loading.value,
            style: normalizeStyle(unref(AppState).state.authButtonStyle),
            class: "w-full mt-8"
          }, {
            default: withCtx(() => [
              createTextVNode("Set Password")
            ]),
            _: 1
          }, 8, ["disabled", "loading", "style"])
        ]),
        _: 1
      }, 8, ["model"]);
    };
  }
});
var SetPassword = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["__scopeId", "data-v-2baef3f8"]]);
var SignUp_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$l = {
  key: 0,
  class: "w-full text-rose-600"
};
const _hoisted_2$k = { class: "my-2" };
const __default__$4 = {
  name: "SignUp"
};
const _sfc_main$q = defineComponent(__spreadProps(__spreadValues({}, __default__$4), {
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const rules = {
      email: {
        required: true,
        validator: (_2, value) => {
          return create$6().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["input", "blur"]
      },
      username: {
        required: true,
        message: "Please enter your name",
        trigger: ["input"]
      },
      password: {
        required: true,
        min: 8,
        message: "Please enter a password of minimum 8 character",
        trigger: ["input"]
      }
    };
    const formValue = ref({
      email: "",
      password: "",
      username: ""
    });
    const formRef = ref();
    const loading = ref(false);
    const showRecaptcha = ref(false);
    const reCaptchaToken = ref(void 0);
    const signUpDisabled = ref(false);
    const errorMessage = ref();
    const otpToken = ref();
    async function validateForm() {
      return new Promise((resolve) => {
        formRef.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.log("error", e);
          resolve(false);
        });
      });
    }
    const handleValidateClick = async (e) => {
      var _a2;
      const isValidated = await validateForm();
      if (!isValidated) {
        return false;
      }
      try {
        loading.value = true;
        errorMessage.value = null;
        const { data } = await UserService.loginWithSecureEmail({
          email: formValue.value.email.trim(),
          fullName: formValue.value.username.trim(),
          locationId: AppState.state.locationData.locationId,
          captchaToken: reCaptchaToken.value
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: formValue.value.email,
          token: data.token,
          password: formValue.value.password.trim(),
          username: formValue.value.username.trim(),
          locationId: AppState.state.locationData.locationId
        });
        loading.value = false;
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          signUpDisabled.value = true;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          errorMessage.value = getErrorMessage(error);
          if (errorMessage.value === "User already exist") {
            emit("changeScreen", {
              page: Screens.VERIFY_SECURE_CODE,
              email: formValue.value.email,
              token: otpToken.value,
              password: formValue.value.password.trim(),
              username: formValue.value.username.trim(),
              locationId: AppState.state.locationData.locationId
            });
          }
        }
        loading.value = false;
      }
    };
    const onVerify = (response) => {
      reCaptchaToken.value = response;
      signUpDisabled.value = false;
    };
    const onError = (response) => {
      signUpDisabled.value = true;
    };
    const onExpired = (response) => {
      reCaptchaToken.value = void 0;
      signUpDisabled.value = true;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        !unref(AppState).state.isSSODisabled ? (openBlock(), createBlock(SignInWithGoogle, {
          key: 0,
          loginType: "SIGN_UP",
          onUpdateLoader: _cache[0] || (_cache[0] = (val) => loading.value = val),
          onChangeScreen: _cache[1] || (_cache[1] = (val) => emit("changeScreen", val)),
          onLoginCallback: _cache[2] || (_cache[2] = (val) => emit(unref(LoginEvents).LOGIN_CALLBACK, val))
        })) : createCommentVNode("", true),
        createVNode(unref(B), {
          id: "sign-up-form",
          ref_key: "formRef",
          ref: formRef,
          class: "flex flex-col items-center",
          model: formValue.value,
          rules,
          onKeyup: withKeys(handleValidateClick, ["enter"])
        }, {
          default: withCtx(() => [
            createVNode(unref(V), {
              class: "w-full form-item",
              path: "username"
            }, {
              default: withCtx(() => [
                createVNode(unref(P), {
                  id: "sign-up-form-username",
                  maxlength: 50,
                  modelValue: formValue.value.username,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => formValue.value.username = $event),
                  placeholder: "Full name"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$3), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            createVNode(unref(V), {
              class: "w-full form-item",
              path: "email"
            }, {
              default: withCtx(() => [
                createVNode(unref(P), {
                  id: "sign-up-form-email",
                  modelValue: formValue.value.email,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => formValue.value.email = $event),
                  placeholder: "Email"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$8), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            createVNode(unref(V), {
              class: "w-full form-item",
              path: "password"
            }, {
              default: withCtx(() => [
                createVNode(unref(P), {
                  id: "sign-up-form-password",
                  type: "password",
                  modelValue: formValue.value.password,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => formValue.value.password = $event),
                  placeholder: "Password"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$t), { class: "h-5 w-5 pr-1 mr-2" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            errorMessage.value ? (openBlock(), createElementBlock("div", _hoisted_1$l, toDisplayString(errorMessage.value), 1)) : createCommentVNode("", true),
            showRecaptcha.value ? (openBlock(), createBlock(_sfc_main$T, {
              key: 1,
              class: "flex w-full justify-center",
              onExpired,
              onVerify,
              onError
            })) : createCommentVNode("", true),
            createVNode(unref(q), {
              id: "sign-up--button",
              onClick: handleValidateClick,
              class: "w-full mt-8",
              style: normalizeStyle(unref(AppState).state.authButtonStyle),
              loading: loading.value,
              disabled: loading.value || signUpDisabled.value
            }, {
              default: withCtx(() => [
                createTextVNode("Sign Up")
              ]),
              _: 1
            }, 8, ["style", "loading", "disabled"]),
            createElementVNode("div", _hoisted_2$k, [
              createTextVNode(" Already have an account? "),
              createElementVNode("span", null, [
                createVNode(unref(q), {
                  id: "open-signup-button",
                  class: "ml-2 cursor-pointer no-underline",
                  text: true,
                  onClick: _cache[6] || (_cache[6] = ($event) => emit("changeScreen", {
                    page: unref(Screens).LOGIN
                  }))
                }, {
                  default: withCtx(() => [
                    createTextVNode(" Login ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ], 64);
    };
  }
}));
var SignUp = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["__scopeId", "data-v-24119b8c"]]);
var LoginPage_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$k = { class: "max-w-md pb-6 px-8 login-page-width text-gray-900" };
const __default__$3 = {
  name: "LoginPage"
};
const _sfc_main$p = defineComponent(__spreadProps(__spreadValues({}, __default__$3), {
  props: {
    page: {
      type: String,
      required: true
    },
    locationData: {
      required: true
    },
    isTitleEnabled: {
      type: Boolean,
      default: false
    },
    isSSODisabled: {
      type: Boolean,
      default: false
    },
    NODE_ENV: String
  },
  emits: [
    LoginEvents.CHANGE_SCREEN,
    LoginEvents.LOGIN_CALLBACK
  ],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const props = __props;
    onMounted(() => {
      AppState.state.locationData = props.locationData;
      if (props == null ? void 0 : props.isTitleEnabled) {
        AppState.state.isTitleEnabled = props.isTitleEnabled;
      }
      AppState.state.isSSODisabled = props.isSSODisabled;
      AppState.state.NODE_ENV = props.NODE_ENV;
    });
    const screen = ref({
      email: history.state.email || "",
      username: "",
      password: "",
      token: history.state.token || "",
      otp: history.state.otp || "",
      page: props.page || Screens.LOGIN,
      multiUser: history.state.multiUser || [],
      resetPassword: history.state.resetPassword || false,
      passwordResetToken: history.state.passwordResetToken || "",
      contactId: history.state.contactId || "",
      fullName: "",
      idToken: ""
    });
    async function callback(event2) {
      emit(LoginEvents.LOGIN_CALLBACK, event2);
      if (event2.eventType == LoginEvents.LOGIN_SUCCESSFUL) {
        console.log("get user details");
        await UserState.getUserDetails();
      }
    }
    function onChangeScreen(val) {
      screen.value = __spreadValues(__spreadValues({}, screen), val);
      emit(LoginEvents.CHANGE_SCREEN, screen);
    }
    const title = computed(() => {
      if (screen.value.page === Screens.SIGN_UP) {
        return "Sign Up";
      }
      if (screen.value.page === Screens.VERIFY_SECURE_CODE) {
        return "Enter OTP";
      }
      if (screen.value.page === Screens.SELECT_USER_MULTI_USER) {
        return "Select User";
      }
      if (screen.value.page === Screens.FORGOT_PASSWORD) {
        return "Reset Password";
      }
      return "Login";
    });
    return (_ctx, _cache) => {
      var _a2, _b;
      return openBlock(), createElementBlock(Fragment, null, [
        renderSlot(_ctx.$slots, "header"),
        createElementVNode("div", _hoisted_1$k, [
          unref(AppState).state.isTitleEnabled ? (openBlock(), createBlock(unref(c$4), {
            key: 0,
            class: "font-semibold text-3xl mb-2"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(title.value), 1)
            ]),
            _: 1
          })) : createCommentVNode("", true),
          screen.value.page === unref(Screens).LOGIN ? (openBlock(), createBlock(LoginWithEmailPassword, {
            key: 1,
            onChangeScreen,
            onLoginCallback: callback
          })) : screen.value.page === unref(Screens).LOGIN_WITH_SECURE_CODE ? (openBlock(), createBlock(LoginWithSecureCode, {
            key: 2,
            onChangeScreen,
            onLoginCallback: callback
          })) : screen.value.page === unref(Screens).VERIFY_SECURE_CODE ? (openBlock(), createBlock(_sfc_main$v, {
            key: 3,
            email: screen.value.email,
            token: screen.value.token,
            password: screen.value.password,
            username: screen.value.username,
            defaultOtp: screen.value.otp,
            onChangeScreen,
            onLoginCallback: callback
          }, null, 8, ["email", "token", "password", "username", "defaultOtp"])) : createCommentVNode("", true),
          screen.value.page === unref(Screens).SELECT_USER_MULTI_USER ? (openBlock(), createBlock(LoginMultiUser, {
            key: 4,
            email: screen.value.email,
            password: screen.value.password,
            users: screen.value.multiUser,
            otp: screen.value.otp,
            token: screen.value.token,
            "reset-password": screen.value.resetPassword,
            idToken: (_a2 = screen.value) == null ? void 0 : _a2.idToken,
            fullName: (_b = screen.value) == null ? void 0 : _b.fullName,
            onChangeScreen,
            onLoginCallback: callback
          }, null, 8, ["email", "password", "users", "otp", "token", "reset-password", "idToken", "fullName"])) : createCommentVNode("", true),
          screen.value.page === unref(Screens).SET_PASSWORD ? (openBlock(), createBlock(SetPassword, {
            key: 5,
            email: screen.value.email,
            contactId: screen.value.contactId,
            passwordResetToken: screen.value.passwordResetToken,
            onChangeScreen,
            onLoginCallback: callback
          }, null, 8, ["email", "contactId", "passwordResetToken"])) : createCommentVNode("", true),
          screen.value.page === unref(Screens).FORGOT_PASSWORD ? (openBlock(), createBlock(_sfc_main$y, {
            key: 6,
            onChangeScreen,
            onLoginCallback: callback
          })) : createCommentVNode("", true),
          screen.value.page === unref(Screens).PROCEED_TO_LOGIN ? (openBlock(), createBlock(_sfc_main$x, {
            key: 7,
            onChangeScreen,
            onLoginCallback: callback
          })) : createCommentVNode("", true),
          screen.value.page === unref(Screens).SIGN_UP ? (openBlock(), createBlock(SignUp, {
            key: 8,
            onChangeScreen,
            onLoginCallback: callback
          })) : createCommentVNode("", true)
        ])
      ], 64);
    };
  }
}));
var LoginModal_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$2 = (n) => (pushScopeId("data-v-ce8d94aa"), n = n(), popScopeId(), n);
const _hoisted_1$j = { class: "w-full" };
const _hoisted_2$j = {
  class: "",
  id: "info-container"
};
const _hoisted_3$i = { class: "relative h-40 w-full" };
const _hoisted_4$5 = ["src"];
const _hoisted_5$4 = { class: "absolute bottom-10 left-1/2 z-10 -translate-x-1/2 translate-y-2/3 transform" };
const _hoisted_6$3 = ["src"];
const _hoisted_7$2 = { class: "mt-20 flex justify-center" };
const _hoisted_8$2 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("span", { class: "font-semibold" }, "Admin Name", -1));
const _hoisted_9$2 = /* @__PURE__ */ _withScopeId$2(() => /* @__PURE__ */ createElementVNode("span", { class: "font-semibold" }, " Group Name", -1));
const _sfc_main$o = defineComponent({
  __name: "LoginModal",
  props: {
    show: Boolean,
    locationData: Object,
    NODE_ENV: {
      type: String,
      default: "staging"
    }
  },
  emits: ["update:confirmed", "update:show"],
  setup(__props, { emit: __emit }) {
    const logoUrl = computed(() => {
      return DEFAULT_GROUP_LOGO;
    });
    const coverUrl = computed(() => {
      return DEFAULT_GROUP_COVER_IMAGE;
    });
    const props = __props;
    const emit = __emit;
    const showModal = ref(false);
    onMounted(() => {
      AppState.state.NODE_ENV = props.NODE_ENV;
      showModal.value = props.show;
    });
    watch(() => props.show, (showModalVal) => showModal.value = showModalVal);
    function closeModal() {
      showModal.value = false;
      emit("update:show", false);
    }
    function callback() {
      closeModal();
    }
    function changeScreen(event2) {
      console.log(event2.value.page);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(k), {
        show: showModal.value,
        "onUpdate:show": [
          _cache[0] || (_cache[0] = ($event) => showModal.value = $event),
          closeModal
        ],
        "class-name": "fixed top-0 h-full  rounded-none md:rounded-xl  md:h-auto sm:top-8 2xl:top-16 left-0 right-0 flex justify-center custom-modal-width p-0"
      }, {
        header: withCtx(() => [
          createVNode(unref(z$1), {
            type: "custom",
            onClose: closeModal,
            id: "modal-header"
          }, {
            customHeader: withCtx(() => [
              createElementVNode("div", _hoisted_1$j, [
                createElementVNode("div", _hoisted_2$j, [
                  createElementVNode("div", _hoisted_3$i, [
                    createElementVNode("img", {
                      src: coverUrl.value || unref(DEFAULT_GROUP_COVER_IMAGE),
                      id: "cover-image",
                      class: "max-h-[120px] w-full object-cover sm:rounded-t-xl"
                    }, null, 8, _hoisted_4$5),
                    createElementVNode("div", _hoisted_5$4, [
                      createElementVNode("img", {
                        class: "info-logo h-32 w-32 rounded-full border bg-white shadow-md",
                        src: logoUrl.value,
                        alt: "Group Logo"
                      }, null, 8, _hoisted_6$3)
                    ])
                  ])
                ])
              ]),
              createElementVNode("div", _hoisted_7$2, [
                createVNode(unref(_$2), { class: "text-gray-600 font-normal text-sm" }, {
                  default: withCtx(() => [
                    _hoisted_8$2,
                    createTextVNode(" Invited you to join "),
                    _hoisted_9$2
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createVNode(_sfc_main$p, {
            page: "LOGIN_WITH_SECURE_CODE",
            locationData: __props.locationData,
            onLoginCallback: callback,
            onChangeScreen: changeScreen,
            NODE_ENV: "development"
          }, null, 8, ["locationData"])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
var LoginModal = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["__scopeId", "data-v-ce8d94aa"]]);
LoginModal.install = (Vue) => {
  Vue.component(LoginModal.name, LoginModal);
};
_sfc_main$p.install = (Vue) => {
  Vue.component(_sfc_main$p.name, _sfc_main$p);
};
const _sfc_main$n = {};
const _hoisted_1$i = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "h-[24px] w-[24px]"
};
const _hoisted_2$i = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M17 14.5v-3.005c0-.18 0-.27-.027-.349a.5.5 0 00-.116-.187c-.058-.06-.139-.1-.3-.18L12 8.5m-8 1v6.807c0 .372 0 .558.058.72a1 1 0 00.244.381c.124.12.293.198.631.353l6.4 2.934c.246.112.368.168.496.19.113.02.229.02.342 0 .128-.022.25-.078.496-.19l6.4-2.934c.338-.155.507-.232.63-.353a1 1 0 00.245-.38c.058-.163.058-.35.058-.721V9.5m-18-1l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 01.184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 01-.184 0c-.069-.012-.135-.045-.266-.11L2 8.5z"
}, null, -1);
const _hoisted_3$h = [
  _hoisted_2$i
];
function _sfc_render$d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$i, _hoisted_3$h);
}
var AllCoursesIcon = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$d]]);
const _sfc_main$m = {};
const _hoisted_1$h = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$h = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M14 21h-4m8-13A6 6 0 106 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.795 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8z"
}, null, -1);
const _hoisted_3$g = [
  _hoisted_2$h
];
function _sfc_render$c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$h, _hoisted_3$g);
}
var BellIcon = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$c]]);
const _sfc_main$l = {};
const _hoisted_1$g = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "black",
  "aria-hidden": "true",
  class: "h-[24px] w-[24px]"
};
const _hoisted_2$g = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M17 14.5v-3.005c0-.18 0-.27-.027-.349a.5.5 0 00-.116-.187c-.058-.06-.139-.1-.3-.18L12 8.5m-8 1v6.807c0 .372 0 .558.058.72a1 1 0 00.244.381c.124.12.293.198.631.353l6.4 2.934c.246.112.368.168.496.19.113.02.229.02.342 0 .128-.022.25-.078.496-.19l6.4-2.934c.338-.155.507-.232.63-.353a1 1 0 00.245-.38c.058-.163.058-.35.058-.721V9.5m-18-1l9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 01.184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821c-.131.066-.197.099-.266.111a.501.501 0 01-.184 0c-.069-.012-.135-.045-.266-.11L2 8.5z"
}, null, -1);
const _hoisted_3$f = [
  _hoisted_2$g
];
function _sfc_render$b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$g, _hoisted_3$f);
}
var FillAllCoursesIcon = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$b]]);
const _sfc_main$k = {};
const _hoisted_1$f = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$f = /* @__PURE__ */ createElementVNode("path", {
  d: "M18 8C18 6.4087 17.3678 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88257 2.63214 7.75735 3.75736C6.63213 4.88258 5.99999 6.4087 5.99999 8C5.99999 11.0902 5.22046 13.206 4.34965 14.6054C3.61512 15.7859 3.24785 16.3761 3.26131 16.5408C3.27622 16.7231 3.31485 16.7926 3.46176 16.9016C3.59445 17 4.19258 17 5.38884 17H18.6111C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7238 16.7231 20.7387 16.5408C20.7521 16.3761 20.3849 15.7859 19.6503 14.6054C18.7795 13.206 18 11.0902 18 8Z",
  fill: "none"
}, null, -1);
const _hoisted_3$e = /* @__PURE__ */ createElementVNode("path", {
  d: "M14 21H9.99999M18 8C18 6.4087 17.3678 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88257 2.63214 7.75735 3.75736C6.63213 4.88258 5.99999 6.4087 5.99999 8C5.99999 11.0902 5.22046 13.206 4.34965 14.6054C3.61512 15.7859 3.24785 16.3761 3.26131 16.5408C3.27622 16.7231 3.31485 16.7926 3.46176 16.9016C3.59445 17 4.19258 17 5.38884 17H18.6111C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7238 16.7231 20.7387 16.5408C20.7521 16.3761 20.3849 15.7859 19.6503 14.6054C18.7795 13.206 18 11.0902 18 8Z",
  stroke: "black",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_4$4 = [
  _hoisted_2$f,
  _hoisted_3$e
];
function _sfc_render$a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$f, _hoisted_4$4);
}
var FillBellIcon = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$a]]);
const _sfc_main$j = {};
const _hoisted_1$e = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$e = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 00-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 00-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 00.218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 00-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275z"
}, null, -1);
const _hoisted_3$d = [
  _hoisted_2$e
];
function _sfc_render$9(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$e, _hoisted_3$d);
}
var FillHomeIcon = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$9]]);
const _sfc_main$i = {};
const _hoisted_1$d = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$d = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M7.135 11.189L3.33 4.381c-.437-.783-.656-1.175-.619-1.495a1 1 0 01.41-.697C3.38 2 3.83 2 4.726 2h2.235c.333 0 .5 0 .65.048a1 1 0 01.357.205c.118.104.202.248.372.535L12 9l3.659-6.212c.169-.287.254-.43.37-.535a1 1 0 01.359-.205c.15-.048.316-.048.65-.048h2.234c.897 0 1.345 0 1.607.189a1 1 0 01.41.697c.036.32-.183.712-.62 1.495l-3.805 6.808M10.5 14l1.5-1v5m-1.25 0h2.5m3.346-7.096a6.5 6.5 0 11-9.192 9.192 6.5 6.5 0 019.192-9.192z"
}, null, -1);
const _hoisted_3$c = [
  _hoisted_2$d
];
function _sfc_render$8(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$d, _hoisted_3$c);
}
var FillLeaderBoardIcon = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$8]]);
const _sfc_main$h = {};
const _hoisted_1$c = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$c = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M20 19v-3H7a3 3 0 00-3 3m4.8 3h8c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C18.48 2 17.92 2 16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 22 7.12 22 8.8 22z"
}, null, -1);
const _hoisted_3$b = [
  _hoisted_2$c
];
function _sfc_render$7(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_3$b);
}
var FillLearningIcon = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$7]]);
const _sfc_main$g = {};
const _hoisted_1$b = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$b = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6.094 11.229A8.01 8.01 0 016 10c0-4.418 3.605-8 8.053-8 4.447 0 8.052 3.582 8.052 8 0 .998-.184 1.954-.52 2.835-.07.182-.105.274-.12.345a.897.897 0 00-.024.194c-.002.073.008.153.028.314l.403 3.27c.043.355.065.532.006.66a.5.5 0 01-.257.252c-.13.055-.306.03-.66-.022l-3.184-.467c-.167-.024-.25-.037-.326-.036a.898.898 0 00-.2.021c-.074.016-.169.051-.358.122a8.174 8.174 0 01-4.07.42M7.632 22C10.597 22 13 19.538 13 16.5S10.597 11 7.632 11c-2.965 0-5.369 2.462-5.369 5.5 0 .61.097 1.198.277 1.747.075.232.113.348.126.427.013.083.015.13.01.213-.005.08-.025.17-.065.351L2 22l2.995-.409c.163-.022.245-.034.316-.033.076 0 .115.005.19.02.07.013.173.05.381.123a5.246 5.246 0 001.75.299z"
}, null, -1);
const _hoisted_3$a = [
  _hoisted_2$b
];
function _sfc_render$6(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$a);
}
var FillMessageChatIcon = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$6]]);
const _sfc_main$f = {};
const _hoisted_1$a = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "black",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$a = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 15c-3.17 0-5.99 1.53-7.784 3.906-.386.511-.58.767-.573 1.112.005.267.172.604.382.769.272.213.649.213 1.402.213h13.146c.753 0 1.13 0 1.402-.213.21-.165.377-.502.382-.769.006-.345-.187-.6-.573-1.112C17.989 16.531 15.17 15 12 15zM12 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
}, null, -1);
const _hoisted_3$9 = [
  _hoisted_2$a
];
function _sfc_render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_3$9);
}
var FillProfileIcon = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$5]]);
const _sfc_main$e = {};
const _hoisted_1$9 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$9 = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 00-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 00-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 00.218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 00-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275z"
}, null, -1);
const _hoisted_3$8 = [
  _hoisted_2$9
];
function _sfc_render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$9, _hoisted_3$8);
}
var HomeIcon = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$4]]);
const _sfc_main$d = {};
const _hoisted_1$8 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$8 = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M7.135 11.189L3.33 4.381c-.437-.783-.656-1.175-.619-1.495a1 1 0 01.41-.697C3.38 2 3.83 2 4.726 2h2.235c.333 0 .5 0 .65.048a1 1 0 01.357.205c.118.104.202.248.372.535L12 9l3.659-6.212c.169-.287.254-.43.37-.535a1 1 0 01.359-.205c.15-.048.316-.048.65-.048h2.234c.897 0 1.345 0 1.607.189a1 1 0 01.41.697c.036.32-.183.712-.62 1.495l-3.805 6.808M10.5 14l1.5-1v5m-1.25 0h2.5m3.346-7.096a6.5 6.5 0 11-9.192 9.192 6.5 6.5 0 019.192-9.192z"
}, null, -1);
const _hoisted_3$7 = [
  _hoisted_2$8
];
function _sfc_render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$8, _hoisted_3$7);
}
var LeaderBoardIcon = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$3]]);
const _sfc_main$c = {};
const _hoisted_1$7 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$7 = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M20 19v-3H7a3 3 0 00-3 3m4.8 3h8c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C18.48 2 17.92 2 16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 22 7.12 22 8.8 22z"
}, null, -1);
const _hoisted_3$6 = [
  _hoisted_2$7
];
function _sfc_render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$7, _hoisted_3$6);
}
var LearningIcon = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$2]]);
const _sfc_main$b = {};
const _hoisted_1$6 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$6 = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6.094 11.229A8.01 8.01 0 016 10c0-4.418 3.605-8 8.053-8 4.447 0 8.052 3.582 8.052 8 0 .998-.184 1.954-.52 2.835-.07.182-.105.274-.12.345a.897.897 0 00-.024.194c-.002.073.008.153.028.314l.403 3.27c.043.355.065.532.006.66a.5.5 0 01-.257.252c-.13.055-.306.03-.66-.022l-3.184-.467c-.167-.024-.25-.037-.326-.036a.898.898 0 00-.2.021c-.074.016-.169.051-.358.122a8.174 8.174 0 01-4.07.42M7.632 22C10.597 22 13 19.538 13 16.5S10.597 11 7.632 11c-2.965 0-5.369 2.462-5.369 5.5 0 .61.097 1.198.277 1.747.075.232.113.348.126.427.013.083.015.13.01.213-.005.08-.025.17-.065.351L2 22l2.995-.409c.163-.022.245-.034.316-.033.076 0 .115.005.19.02.07.013.173.05.381.123a5.246 5.246 0 001.75.299z"
}, null, -1);
const _hoisted_3$5 = [
  _hoisted_2$6
];
function _sfc_render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$6, _hoisted_3$5);
}
var MessageChatIcon = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$1]]);
const _sfc_main$a = {};
const _hoisted_1$5 = {
  "data-v-05a08b96": "",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true",
  class: "nav-item-color h-[24px] w-[24px]"
};
const _hoisted_2$5 = /* @__PURE__ */ createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 15c-3.17 0-5.99 1.53-7.784 3.906-.386.511-.58.767-.573 1.112.005.267.172.604.382.769.272.213.649.213 1.402.213h13.146c.753 0 1.13 0 1.402-.213.21-.165.377-.502.382-.769.006-.345-.187-.6-.573-1.112C17.989 16.531 15.17 15 12 15zM12 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
}, null, -1);
const _hoisted_3$4 = [
  _hoisted_2$5
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$5, _hoisted_3$4);
}
var ProfileIcon = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render]]);
var NavigationItemType;
(function(NavigationItemType2) {
  NavigationItemType2["APP_ROUTE"] = "app_route";
  NavigationItemType2["REDIRECTION"] = "redirection";
  NavigationItemType2["APP_ACTION"] = "app_action";
})(NavigationItemType || (NavigationItemType = {}));
var CommonComponent;
(function(CommonComponent2) {
  CommonComponent2["DASHBOARD"] = "LandingPage";
  CommonComponent2["MOBILE_NOTIFICATIONS"] = "NotificationMobileView";
  CommonComponent2["MOBILE_PROFILE"] = "ProfileContainer";
})(CommonComponent || (CommonComponent = {}));
var BottomNavigation_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId$1 = (n) => (pushScopeId("data-v-51f69944"), n = n(), popScopeId(), n);
const _hoisted_1$4 = {
  key: 0,
  class: "flex flex-col w-full"
};
const _hoisted_2$4 = { class: "inline-flex w-full items-end justify-center bg-white border-t-[0.75px] border-solid border-x-0 border-b-0 border-gray-200" };
const _hoisted_3$3 = ["onClick"];
const _hoisted_4$3 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createElementVNode("div", { class: "h-[1px] w-full bg-white" }, null, -1));
const _hoisted_5$3 = { class: "relative h-[24px] w-[24px] mb-[2px] mt-[7px]" };
const __default__$2 = {
  name: "BottomNavBar"
};
const _sfc_main$9 = defineComponent(__spreadProps(__spreadValues({}, __default__$2), {
  props: {
    navigationItems: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    const routerInstance2 = AppState.getRouterInstance();
    const route = useRoute();
    const props = __props;
    const tabWidth = ref(0);
    const isLoading = ref(true);
    let attemptCount = 0;
    const MAX_ATTEMPTS = 5;
    onMounted(async () => {
      getElementWidth();
      setIcons();
      isLoading.value = false;
      await getNotifications();
      window.addEventListener("resize", getElementWidth);
    });
    const getElementWidth = () => {
      const element = document.getElementById("mobile-bottom-navigation");
      if (element) {
        tabWidth.value = element.offsetWidth;
        return;
      }
      if (attemptCount < MAX_ATTEMPTS) {
        attemptCount++;
        setTimeout(getElementWidth, 200);
      }
    };
    const navigationItemsWithIcons = ref([]);
    function setIcons() {
      var _a2;
      navigationItemsWithIcons.value = (_a2 = props.navigationItems) == null ? void 0 : _a2.map((item) => {
        if (item.name === "Home") {
          return __spreadProps(__spreadValues({}, item), {
            icon: () => h(HomeIcon),
            selectedIcon: () => h(FillHomeIcon)
          });
        }
        if (item.name === "Notifications") {
          return __spreadProps(__spreadValues({}, item), {
            icon: () => h(BellIcon),
            selectedIcon: () => h(FillBellIcon)
          });
        }
        if (item.name === "Profile") {
          return __spreadProps(__spreadValues({}, item), {
            icon: () => h(ProfileIcon),
            selectedIcon: () => h(FillProfileIcon)
          });
        }
        if (item.name === "Discussion") {
          return __spreadProps(__spreadValues({}, item), {
            icon: () => h(MessageChatIcon),
            selectedIcon: () => h(FillMessageChatIcon)
          });
        }
        if (item.name === "All Courses") {
          return __spreadProps(__spreadValues({}, item), {
            icon: () => h(AllCoursesIcon),
            selectedIcon: () => h(FillAllCoursesIcon)
          });
        }
        if (item.name === "My Courses" || item.name === "Learning") {
          return __spreadProps(__spreadValues({}, item), {
            icon: () => h(LearningIcon),
            selectedIcon: () => h(FillLearningIcon)
          });
        }
        if (item.name === "Leaderboard") {
          return __spreadProps(__spreadValues({}, item), {
            icon: () => h(LeaderBoardIcon),
            selectedIcon: () => h(FillLeaderBoardIcon)
          });
        }
        return item;
      });
    }
    watch(() => {
      var _a2;
      return (_a2 = NotificationState == null ? void 0 : NotificationState.state) == null ? void 0 : _a2.unReadNotificationCount;
    }, () => {
      for (const item of props.navigationItems) {
        if (item.routeName.includes("NotificationMobileView")) {
          if (unreadNotificationCount.value > 0) {
            item.showBadge = true;
          } else {
            item.showBadge = false;
          }
        }
      }
      setIcons();
    });
    const unreadNotificationCount = computed(() => {
      return NotificationState.state.unReadNotificationCount;
    });
    const getNotifications = async () => {
      if (props.navigationItems) {
        for (const item of props.navigationItems) {
          if (item.routeName.includes("NotificationMobileView")) {
            await NotificationState.getNotifications();
            await NotificationState.getUnreadNotificationsCount();
            if (unreadNotificationCount.value > 0) {
              item.showBadge = true;
            }
          }
        }
      }
    };
    const handleToggle = (item) => {
      try {
        switch (item.type) {
          case NavigationItemType.APP_ROUTE: {
            if (routerInstance2) {
              routerInstance2.push({ name: item.routeName[0] });
            }
            break;
          }
          case NavigationItemType.REDIRECTION: {
            window.location.replace(item.redirectionUrl);
            break;
          }
          case NavigationItemType.APP_ACTION: {
            if (item.action)
              item.action();
            break;
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    const selectedNavigationIndex = computed(() => {
      var _a2;
      const selectedIndex = (_a2 = navigationItemsWithIcons == null ? void 0 : navigationItemsWithIcons.value.filter((i) => i == null ? void 0 : i.showOnMobile)) == null ? void 0 : _a2.findIndex((item) => item.routeName && item.routeName.includes(route.name));
      return selectedIndex === -1 ? 0 : selectedIndex;
    });
    const selectedIndicatorPosition = computed(() => {
      const itemWidth = tabWidth.value;
      return selectedNavigationIndex.value * itemWidth;
    });
    return (_ctx, _cache) => {
      var _a2;
      return !isLoading.value ? (openBlock(), createElementBlock("div", _hoisted_1$4, [
        createElementVNode("div", {
          class: "h-[2px] rounded-xl bg-gray-900 absolute top-0 left-0 transition-transform duration-300 ease-in-out",
          style: normalizeStyle({
            transform: `translateX(${selectedIndicatorPosition.value + 4}px)`,
            width: `${tabWidth.value ? tabWidth.value - 8 : 0}px`
          })
        }, null, 4),
        createElementVNode("div", _hoisted_2$4, [
          (openBlock(true), createElementBlock(Fragment, null, renderList((_a2 = navigationItemsWithIcons.value) == null ? void 0 : _a2.filter((i) => i == null ? void 0 : i.showOnMobile), (item) => {
            var _a3, _b;
            return openBlock(), createElementBlock("div", {
              key: item.name,
              id: `mobile-bottom-navigation`,
              class: normalizeClass([
                "inline-flex shrink grow basis-0 cursor-pointer flex-col items-center",
                item.routeName.includes((_a3 = unref(route)) == null ? void 0 : _a3.name) ? "text-black" : "text-gray-400"
              ]),
              onClick: () => handleToggle(item)
            }, [
              _hoisted_4$3,
              createElementVNode("div", _hoisted_5$3, [
                createVNode(unref(p$5), {
                  dot: true,
                  max: void 0,
                  showZero: false,
                  show: (item == null ? void 0 : item.showBadge) ? true : false,
                  type: "default",
                  id: item.name
                }, {
                  content: withCtx(() => [
                    item.routeName.includes(unref(route).name) ? (openBlock(), createBlock(resolveDynamicComponent(item.selectedIcon), {
                      key: 0,
                      class: "h-[24px] w-[24px]"
                    })) : (openBlock(), createBlock(resolveDynamicComponent(item.icon), {
                      key: 1,
                      class: "h-[24px] w-[24px] nav-item-color"
                    }))
                  ]),
                  _: 2
                }, 1032, ["show", "id"])
              ]),
              createElementVNode("div", {
                class: normalizeClass([
                  "text-center text-[8px] font-normal",
                  item.routeName.includes((_b = unref(route)) == null ? void 0 : _b.name) ? "text-gray-900" : "nav-item-color"
                ])
              }, toDisplayString(item.name), 3)
            ], 10, _hoisted_3$3);
          }), 128))
        ])
      ])) : createCommentVNode("", true);
    };
  }
}));
var BottomNavBar = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["__scopeId", "data-v-51f69944"]]);
BottomNavBar.install = (Vue) => {
  Vue.component(BottomNavBar.name, BottomNavBar);
};
var NotificationMobile_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId = (n) => (pushScopeId("data-v-59c2f009"), n = n(), popScopeId(), n);
const _hoisted_1$3 = { class: "mt-8 flex w-full items-center justify-center bg-gray-50" };
const _hoisted_2$3 = {
  id: "notifications-navbar",
  class: "fixed left-0 right-0 top-0 z-50 w-full bg-white"
};
const _hoisted_3$2 = { class: "inline-flex h-7 w-full items-center justify-start bg-white" };
const _hoisted_4$2 = { class: "flex items-start justify-center gap-[13px] bg-white" };
const _hoisted_5$2 = { class: "flex items-start justify-start gap-1" };
const _hoisted_6$2 = { class: "inline-flex flex-col items-start justify-start" };
const _hoisted_7$1 = { class: "flex grow items-center justify-end" };
const _hoisted_8$1 = { class: "flex w-6 items-start justify-start gap-4" };
const _hoisted_9$1 = {
  class: "relative h-6 w-6 cursor-pointer",
  onClick: () => {
  }
};
const _hoisted_10$1 = { class: "inline-flex h-7 items-start justify-start gap-2" };
const _hoisted_11$1 = {
  key: 1,
  class: "mt-0 flex w-[260px] flex-col justify-center overflow-hidden pb-72 font-sans"
};
const _hoisted_12$1 = { class: "flex flex-col" };
const _hoisted_13$1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "mt-2 h-1 w-16 rounded-md border border-solid bg-gray-200 border-gray-200 self-center" }, null, -1));
const __default__$1 = {
  name: "NotificationMobileView"
};
const _sfc_main$8 = defineComponent(__spreadProps(__spreadValues({}, __default__$1), {
  setup(__props) {
    const showLoginModal = ref(false);
    const showNotificationOptions = ref(false);
    const markAllRead = ref(false);
    const notificationVisibility = ref("all");
    ref("LOGIN");
    const loadMoreNotifications = ref(false);
    const notificationMobileListRef = ref(null);
    onMounted(async () => {
      var _a2, _b;
      if (!((_a2 = UserState.state) == null ? void 0 : _a2.fullName))
        showLoginModal.value = true;
      (_b = notificationMobileListRef.value) == null ? void 0 : _b.addEventListener("scroll", handleScroll);
      await NotificationState.getNotifications();
      await NotificationState.getUnreadNotificationsCount();
    });
    const routerInstance2 = AppState.getRouterInstance();
    watchEffect(() => {
      if (!AppState.state.isMobile) {
        routerInstance2.push({ path: "/home" });
      }
    });
    const menuList = ref([
      {
        label: "Mark all as read",
        key: "markAllRead",
        class: "rounded-2xl",
        icon() {
          return h(o(render$l), null, {});
        }
      }
    ]);
    const NotificationOptions = computed(() => {
      const tempMenuList = [];
      menuList.value.forEach((value, index2) => {
        tempMenuList.push(value);
        if (index2 < menuList.value.length - 1)
          tempMenuList.push({
            key: "divider-1",
            type: "divider",
            props: {}
          });
      });
      return tempMenuList;
    });
    async function handleScroll(event2) {
      const scrollPending = event2.target.scrollHeight - event2.target.scrollTop - notificationMobileListRef.value.offsetHeight;
      if (scrollPending < 20 && !NotificationState.state.isLoading) {
        loadMoreNotifications.value = true;
      } else {
        loadMoreNotifications.value = false;
      }
      event2.stopPropagation();
    }
    function handleAction(val) {
      switch (val) {
        case "markAllRead":
          markAllRead.value = true;
          break;
      }
      showNotificationOptions.value = false;
    }
    return (_ctx, _cache) => {
      var _a2;
      const _directive_swipe = resolveDirective("swipe");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$3, [
          createElementVNode("div", _hoisted_2$3, [
            createVNode(unref($), { class: "h-full w-full !rounded-none bg-white" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_3$2, [
                  createElementVNode("div", _hoisted_4$2, [
                    createElementVNode("div", _hoisted_5$2, [
                      createElementVNode("div", _hoisted_6$2, [
                        createVNode(unref(p$2), { class: "text-slate-700" }, {
                          default: withCtx(() => [
                            createTextVNode(" Notifications ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  createElementVNode("div", _hoisted_7$1, [
                    createElementVNode("div", _hoisted_8$1, [
                      createElementVNode("div", _hoisted_9$1, [
                        createVNode(unref(render$a), {
                          onClick: _cache[0] || (_cache[0] = ($event) => showNotificationOptions.value = !showNotificationOptions.value)
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          createElementVNode("div", {
            class: "notification-area grid w-full overflow-y-scroll rounded bg-white px-4 pb-8 pt-8 shadow-lg ring-1 ring-gray-900/5",
            ref_key: "notificationMobileListRef",
            ref: notificationMobileListRef
          }, [
            createElementVNode("div", _hoisted_10$1, [
              createElementVNode("div", {
                class: normalizeClass([
                  "flex cursor-pointer items-center justify-start rounded-2xl px-3 py-1",
                  notificationVisibility.value === "all" ? "bg-blue-50" : "bg-gray-100"
                ]),
                onClick: _cache[1] || (_cache[1] = ($event) => notificationVisibility.value = "all")
              }, [
                createElementVNode("div", {
                  class: normalizeClass([
                    "text-center text-sm font-medium leading-tight",
                    notificationVisibility.value === "all" ? "text-blue-700" : "text-zinc-700"
                  ])
                }, " All ", 2)
              ], 2),
              createElementVNode("div", {
                class: normalizeClass([
                  "flex cursor-pointer items-center justify-start rounded-2xl px-3 py-1",
                  notificationVisibility.value === "unread" ? "bg-blue-50" : "bg-gray-100"
                ]),
                onClick: _cache[2] || (_cache[2] = ($event) => notificationVisibility.value = "unread")
              }, [
                createElementVNode("div", {
                  class: normalizeClass([
                    "text-center text-sm font-normal leading-tight tracking-tight",
                    notificationVisibility.value === "unread" ? "text-blue-700" : "text-zinc-700"
                  ])
                }, " Unread ", 2)
              ], 2)
            ]),
            ((_a2 = unref(UserState).state) == null ? void 0 : _a2.fullName) ? (openBlock(), createBlock(NotificationList, {
              key: 0,
              "mark-all-read": markAllRead.value,
              notificationVisibility: notificationVisibility.value,
              loadMoreNotifications: loadMoreNotifications.value
            }, null, 8, ["mark-all-read", "notificationVisibility", "loadMoreNotifications"])) : (openBlock(), createElementBlock("div", _hoisted_11$1, [
              createVNode(unref(D), {
                class: "h-full w-full overflow-hidden",
                id: "empty-notifications-message",
                title: "Login to check notifications",
                description: "No notifications!"
              })
            ]))
          ], 512)
        ]),
        createVNode(unref(c$1), {
          class: "rounded-t-xl p-0",
          show: showNotificationOptions.value,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event) => showNotificationOptions.value = $event),
          placement: "bottom",
          height: menuList.value.length * 109 - (menuList.value.length - 1) * 10,
          id: "notification-options-drawer"
        }, {
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(unref(K), {
              id: "notification-options-drawer-menu",
              class: "p-0",
              closable: false
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_12$1, [
                  _hoisted_13$1,
                  createVNode(unref(d$1), {
                    id: "notification-options-menu-mobile",
                    class: "pb-9",
                    options: NotificationOptions.value,
                    "on-update:value": handleAction
                  }, null, 8, ["options"])
                ])
              ]),
              _: 1
            })), [
              [_directive_swipe, {
                direction: "down",
                callback: () => showNotificationOptions.value = !showNotificationOptions.value
              }]
            ])
          ]),
          _: 1
        }, 8, ["show", "height"])
      ], 64);
    };
  }
}));
var NotificationMobileView = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-59c2f009"]]);
NotificationMobileView.install = (Vue) => {
  Vue.component(NotificationMobileView.name, NotificationMobileView);
};
const KeyboardPlugin = registerPlugin("KeyboardEvents");
async function checkUserConsent(data) {
  var _a2;
  try {
    window.localStorage.setItem("cat", window.btoa(JSON.stringify(data)));
    await UserState.getUserDetails();
    api.remove("cat");
    window.localStorage.removeItem("cat");
    if ((_a2 = UserState.state) == null ? void 0 : _a2.termsConsent) {
      return true;
    }
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
}
var LoginMultiUserPwa_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$2 = { class: "max-h-48 overflow-auto" };
const _hoisted_2$2 = { class: "flex items-center -ml-2" };
const _sfc_main$7 = defineComponent({
  __name: "LoginMultiUserPwa",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    password: {
      type: String,
      default: ""
    },
    otp: {
      type: []
    },
    token: {
      type: String
    },
    users: {
      default: []
    },
    resetPassword: {
      default: false
    },
    loginOtp: {
      default: false
    },
    idToken: {
      type: String
    },
    fullName: {
      type: String
    },
    locationId: {
      type: String,
      required: true
    },
    domain: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const notification = c();
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const selectedValue = ref("");
    const loginDisabled = ref(false);
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const handleLogin = async () => {
      var _a2, _b, _c, _d;
      buttonDisable.value = true;
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      let response;
      try {
        if (!selectedValue.value) {
          notificationFailureAlert("Select at least one user", "Try Again");
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
          return;
        }
        if (props.loginOtp || props.resetPassword) {
          const { data } = await UserService.loginWithSecureEmail({
            email: props.email,
            otp: Number(props.otp),
            token: props.token,
            userId: selectedValue.value,
            locationId: props.locationId
          });
          response = data;
        } else {
          const { data } = await UserService.login({
            email: props.email,
            password: props.password,
            userId: selectedValue.value,
            locationId: props.locationId
          });
          response = data;
        }
        if (response) {
          await postLogin(response);
          if (!response.isPasswordVerified || props.resetPassword) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: response.passwordResetToken,
              contactId: response.contactId,
              userId: response.userId,
              token: response.token,
              isPasswordVerified: response.isPasswordVerified,
              data: response,
              page: Screens.SET_PASSWORD
            });
          } else {
            if (props.email.toLowerCase().trim() == TEST_EMAIL_ID) {
              await checkUserConsent(response);
              emit("changeScreen", {
                domain: props.domain,
                data: response,
                page: Screens.TERMS_CONSENT
              });
            } else {
              if (await checkUserConsent(response)) {
                await postLogin(response);
                emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
                  eventType: LoginEvents.LOGIN_SUCCESSFUL,
                  domain: props.domain
                }, response));
              } else {
                emit("changeScreen", {
                  domain: props.domain,
                  data: response,
                  page: Screens.TERMS_CONSENT
                });
              }
            }
          }
        }
      } catch (error) {
        if (((_c = error == null ? void 0 : error.response) == null ? void 0 : _c.status) === 429) {
          loginDisabled.value = true;
        } else {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(T), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(p$2), { class: "text-gray-700 text-center mb-2" }, {
            default: withCtx(() => [
              createTextVNode("Select User")
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_1$2, [
            createVNode(unref(g), {
              value: selectedValue.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event) => selectedValue.value = $event),
              name: "radiobuttongroup1",
              class: "w-full radio-container"
            }, {
              default: withCtx(() => [
                createVNode(unref(y), { vertical: "" }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(__props.users, (item) => {
                      return openBlock(), createBlock(unref(V$1), {
                        value: item.userId,
                        "onUpdate:value": ($event) => item.userId = $event,
                        key: item.userId,
                        disabled: false,
                        compact: void 0,
                        class: "w-full my-1 py-1"
                      }, {
                        content: withCtx(() => [
                          createElementVNode("div", _hoisted_2$2, [
                            item.avatarUrl ? (openBlock(), createBlock(unref(I$1), {
                              key: 0,
                              class: "h-12 w-12",
                              objectFit: "cover",
                              src: item.avatarUrl
                            }, null, 8, ["src"])) : (openBlock(), createBlock(unref(I$1), {
                              key: 1,
                              class: "h-12 w-12",
                              objectFit: "cover"
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(unref(formatNameForAvatar)(item.fullName)), 1)
                              ]),
                              _: 2
                            }, 1024)),
                            createElementVNode("div", null, [
                              createVNode(unref(d), { class: "ml-2 text-gray-700" }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(item.fullName), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (item == null ? void 0 : item.lastLogin) ? (openBlock(), createBlock(unref(_$1), {
                                key: 0,
                                class: "ml-2 mt-[6px] text-gray-500"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode("Last Login: " + toDisplayString(unref(timestampFormat)(item.lastLogin)), 1)
                                ]),
                                _: 2
                              }, 1024)) : createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value"]);
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          createVNode(unref(q), {
            onClick: handleLogin,
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-8 buttonBorder",
            id: "next-domain-btn",
            size: "large",
            disabled: selectedValue.value === "" || buttonDisable.value
          }, {
            default: withCtx(() => [
              createTextVNode("Login")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 64);
    };
  }
});
var LoginMultiUserPwa = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-a5ae22a4"]]);
var LoginPagePwa_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$6 = defineComponent({
  __name: "LoginPagePwa",
  props: {
    locationId: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    domain: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const notification = c();
    const loadingRef = ref(null);
    const showRecaptcha = ref(false);
    const buttonDisable = ref(false);
    const reCaptchaToken = ref(void 0);
    const props = __props;
    const rules = {
      email: {
        required: true,
        validator: (_2, value) => {
          return create$6().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["input", "blur"]
      },
      password: {
        required: true,
        min: 8,
        message: "Please enter a password of mininum 8 characters",
        trigger: ["input", "blur"]
      }
    };
    const formValue = ref({
      password: ""
    });
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const formRef = ref();
    async function validateForm() {
      return new Promise((resolve) => {
        formRef.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.log("error", e);
          resolve(false);
        });
      });
    }
    const handleValidateResetPassword = async () => {
      var _a2, _b, _c, _d;
      buttonDisable.value = true;
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email.trim(),
          locationId: props.locationId,
          action: "RESET_PASSWORD"
        });
        if (data == null ? void 0 : data.token) {
          emit("changeScreen", {
            email: props.email,
            otp: String(data == null ? void 0 : data.otp),
            token: data.token,
            page: Screens.SET_PASSWORD_WITH_SECURE_CODE
          });
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
        }
      } catch (error) {
        if (((_c = error == null ? void 0 : error.response) == null ? void 0 : _c.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    const handleValidateSendOtp = async () => {
      var _a2, _b, _c;
      buttonDisable.value = true;
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email.trim(),
          locationId: props.locationId,
          action: "SIGN_IN"
        });
        if (data == null ? void 0 : data.token) {
          emit("changeScreen", {
            email: props.email,
            otp: String(data == null ? void 0 : data.otp),
            token: data.token,
            page: Screens.VERIFY_SECURE_CODE
          });
        }
      } catch (error) {
        if (((_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_c = loadingRef.value) == null ? void 0 : _c.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    async function handleValidateClick(e) {
      var _a2, _b, _c, _d, _e, _f, _g;
      e.preventDefault();
      buttonDisable.value = true;
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      const result = await validateForm();
      if (!result) {
        (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
        buttonDisable.value = false;
        return;
      }
      try {
        const { data } = await UserService.login({
          email: props.email.trim(),
          password: formValue.value.password.trim(),
          locationId: props.locationId,
          captchaToken: reCaptchaToken.value
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", __spreadProps(__spreadValues({}, formValue.value), {
            email: props.email,
            page: Screens.SELECT_USER_MULTI_USER,
            multiUser: data == null ? void 0 : data.multiple_users
          }));
          (_c = loadingRef.value) == null ? void 0 : _c.stopLoadBar();
          buttonDisable.value = false;
        } else if (data.token) {
          if (props.email.toLowerCase().trim() == TEST_EMAIL_ID) {
            await checkUserConsent(data);
            emit("changeScreen", {
              domain: props.domain,
              data,
              page: Screens.TERMS_CONSENT
            });
          } else {
            if (await checkUserConsent(data)) {
              await postLogin(data);
              emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
                eventType: LoginEvents.LOGIN_SUCCESSFUL,
                domain: props.domain
              }, data));
            } else {
              emit("changeScreen", {
                domain: props.domain,
                data,
                page: Screens.TERMS_CONSENT
              });
            }
          }
          (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
          buttonDisable.value = false;
        }
        showRecaptcha.value = false;
      } catch (error) {
        if (((_e = error == null ? void 0 : error.response) == null ? void 0 : _e.status) === 429) {
          (_f = loadingRef.value) == null ? void 0 : _f.stopLoadBar();
          buttonDisable.value = false;
          showRecaptcha.value = true;
        } else {
          showRecaptcha.value = false;
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_g = loadingRef.value) == null ? void 0 : _g.stopLoadBar();
        buttonDisable.value = false;
      }
    }
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(T), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(B), {
            id: "login-page-email-form",
            ref_key: "formRef",
            ref: formRef,
            model: formValue.value,
            rules
          }, {
            default: withCtx(() => [
              createVNode(unref(_), { class: "text-gray-600" }, {
                default: withCtx(() => [
                  createTextVNode("Email")
                ]),
                _: 1
              }),
              createVNode(unref(P), {
                value: __props.email,
                disabled: true,
                size: "large",
                placeholder: "",
                id: "domain-form-email"
              }, null, 8, ["value"]),
              createVNode(unref(_), { class: "text-gray-600 mt-2" }, {
                default: withCtx(() => [
                  createTextVNode("Password")
                ]),
                _: 1
              }),
              createVNode(unref(P), {
                modelValue: formValue.value.password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.password = $event),
                size: "large",
                placeholder: "",
                type: "password",
                "show-password-on": "click",
                id: "form-password"
              }, null, 8, ["modelValue"]),
              createVNode(unref(d), {
                onClick: handleValidateResetPassword,
                class: "float-right w-fit text-gray-600 cursor-pointer mt-4"
              }, {
                default: withCtx(() => [
                  createTextVNode("Forgot password?")
                ]),
                _: 1
              }),
              createVNode(unref(q), {
                onClick: handleValidateClick,
                type: "primary",
                class: "!bg-black w-full row-span-1 mt-4 h-12 buttonBorder text-white",
                id: "signin-btn",
                size: "large",
                disabled: buttonDisable.value
              }, {
                default: withCtx(() => [
                  createTextVNode("Sign In")
                ]),
                _: 1
              }, 8, ["disabled"]),
              createVNode(unref(d), { class: "text-center text-gray-400 my-4" }, {
                default: withCtx(() => [
                  createTextVNode("or")
                ]),
                _: 1
              }),
              createVNode(unref(q), {
                type: "default",
                class: "w-full row-span-1 h-12 buttonBorder",
                id: "code-btn",
                size: "large",
                onClick: handleValidateSendOtp,
                disabled: buttonDisable.value
              }, {
                default: withCtx(() => [
                  createTextVNode("Sign in with secure code")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ], 64);
    };
  }
});
var LoginPagePwa = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-5cab91a6"]]);
var SetPasswordPwa_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$5 = defineComponent({
  __name: "SetPasswordPwa",
  props: {
    passwordResetToken: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    contactId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    locationId: {
      type: String,
      required: true
    },
    isPasswordVerified: {
      type: Boolean,
      default: true
    },
    domain: {
      type: String
    },
    data: {
      type: Object,
      required: true
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const notification = c();
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const rules = {
      newPassword: {
        required: true,
        min: 8,
        message: "Please enter a password of mininum 8 characters",
        trigger: ["input", "blur"]
      },
      confirmPassword: {
        required: true,
        validator: (_2, value) => {
          return create$6().required().oneOf([formValue.value.newPassword], "Passwords must match").validate(value);
        },
        message: "Passwords must match",
        trigger: ["input", "blur"]
      }
    };
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const formValue = ref({
      newPassword: "",
      confirmPassword: ""
    });
    const formRef = ref();
    const emit = __emit;
    const handleValidateClick = async () => {
      var _a2;
      buttonDisable.value = true;
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      formRef.value.getForm().validate().then(async () => {
        if (props.isPasswordVerified) {
          await UserService.resetPassword({
            userId: props.userId,
            token: props.token,
            password: formValue.value.newPassword.trim(),
            locationId: props.locationId
          });
          emit("changeScreen", {
            page: Screens.LOGIN
          });
        } else {
          await UserService.setPassword({
            newPassword: formValue.value.newPassword.trim(),
            confirmPassword: formValue.value.confirmPassword.trim(),
            locationId: props.locationId,
            passwordResetToken: props.passwordResetToken,
            contactId: props.contactId
          });
          if (await checkUserConsent(props.data)) {
            await postLogin(props.data);
            emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
              eventType: LoginEvents.LOGIN_SUCCESSFUL,
              domain: props.domain
            }, props.data));
          } else {
            emit("changeScreen", {
              domain: props.domain,
              data: props.data,
              page: Screens.TERMS_CONSENT
            });
          }
        }
      }).catch((error) => {
        var _a3;
        notificationFailureAlert(getErrorMessage(error), "Try Again");
        (_a3 = loadingRef.value) == null ? void 0 : _a3.stopLoadBar();
        buttonDisable.value = false;
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(T), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(B), {
            id: "reset-password-page",
            ref_key: "formRef",
            ref: formRef,
            model: formValue.value,
            rules
          }, {
            default: withCtx(() => [
              createVNode(unref(_), { class: "text-gray-600 mt-2" }, {
                default: withCtx(() => [
                  createTextVNode("New Password")
                ]),
                _: 1
              }),
              createVNode(unref(V), {
                class: "block min-h-0",
                path: "newPassword"
              }, {
                default: withCtx(() => [
                  createVNode(unref(P), {
                    modelValue: formValue.value.newPassword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.newPassword = $event),
                    size: "large",
                    placeholder: "",
                    "show-password-on": "click",
                    type: "password",
                    id: "form-password"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              createVNode(unref(_), { class: "text-gray-600 mt-2" }, {
                default: withCtx(() => [
                  createTextVNode("Confirm Password")
                ]),
                _: 1
              }),
              createVNode(unref(V), {
                class: "block min-h-0",
                path: "confirmPassword"
              }, {
                default: withCtx(() => [
                  createVNode(unref(P), {
                    modelValue: formValue.value.confirmPassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => formValue.value.confirmPassword = $event),
                    size: "large",
                    placeholder: "",
                    "show-password-on": "click",
                    type: "password",
                    id: "form-password"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              createVNode(unref(q), {
                type: "primary",
                class: "!bg-black w-full h-12 row-span-1 mt-4 buttonBorder text-white",
                id: "signin-btn",
                size: "large",
                onClick: handleValidateClick,
                disabled: buttonDisable.value
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(props.isPasswordVerified ? "Reset password" : "Set password"), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              createVNode(unref(p$3), { class: "text-center text-gray-400 my-4" }, {
                default: withCtx(() => [
                  createTextVNode("or")
                ]),
                _: 1
              }),
              createVNode(unref(q), {
                type: "default",
                class: "w-full row-span-1 h-12 text-gray-900",
                id: "code-btn",
                size: "large",
                disabled: buttonDisable.value,
                onClick: _cache[2] || (_cache[2] = () => emit("changeScreen", {
                  page: unref(Screens).LOGIN
                }))
              }, {
                default: withCtx(() => [
                  createTextVNode("Back to login")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ], 64);
    };
  }
});
var SetPasswordPwa = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["__scopeId", "data-v-bba54828"]]);
const _sfc_main$4 = defineComponent({
  __name: "SetPasswordWithSecureCodePwa",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    password: {
      type: String
    },
    username: {
      type: String
    },
    locationId: {
      type: String
    },
    defaultOtp: {
      type: Number,
      default: null
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const otpCode = ref("");
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const notification = c();
    const isResendButtonDisabled = ref(false);
    const route = useRoute();
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const handleOnComplete = async () => {
      var _a2, _b, _c, _d, _e, _f, _g;
      buttonDisable.value = true;
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      try {
        if (!Number(otpCode.value)) {
          notificationFailureAlert("Secure code must be a numeric value and must be of 6 digits", "Try Again");
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
          return false;
        }
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: props.locationId,
          redirectUrl: (_c = route == null ? void 0 : route.query) == null ? void 0 : _c.redirectUrl
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            email: props.email,
            otp: Number(otpCode.value),
            token: props.token,
            multiUser: data == null ? void 0 : data.multiple_users,
            resetPassword: true,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else if (data.token) {
          emit("changeScreen", {
            email: props.email,
            token: props.token,
            passwordResetToken: data.passwordResetToken,
            contactId: data.contactId,
            userId: data.userId,
            page: Screens.SET_PASSWORD
          });
          (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
          buttonDisable.value = false;
        }
        (_e = loadingRef.value) == null ? void 0 : _e.stopLoadBar();
        buttonDisable.value = false;
      } catch (error) {
        if (((_f = error == null ? void 0 : error.response) == null ? void 0 : _f.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_g = loadingRef.value) == null ? void 0 : _g.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    async function resendOtp() {
      var _a2;
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          locationId: props.locationId
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: props.email,
          token: data.token
        });
        isResendButtonDisabled.value = true;
        setTimeout(() => isResendButtonDisabled.value = false, 3e4);
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          isResendButtonDisabled.value = true;
        } else {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
      }
    }
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(T), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(_), { class: "text-gray-500" }, {
            default: withCtx(() => [
              createTextVNode("Secure code")
            ]),
            _: 1
          }),
          createVNode(unref(entry_esm), {
            class: "justify-center",
            ref: "otpInput",
            "input-classes": "otpStyle",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange,
            onOnComplete: handleOnComplete
          }, null, 8, ["value"]),
          createVNode(unref(p$3), { class: "text-gray-900 mt-2 font-normal" }, {
            default: withCtx(() => [
              createTextVNode("Please check your email for the secure code. If you did not receive any email from us,,"),
              createElementVNode("span", null, [
                createVNode(unref(q), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => [
                    createTextVNode(" tap here to resend. ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }),
          createVNode(unref(q), {
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-4 buttonBorder text-white",
            id: "signin-btn",
            size: "large",
            onClick: handleOnComplete,
            disabled: buttonDisable.value
          }, {
            default: withCtx(() => [
              createTextVNode("Verify")
            ]),
            _: 1
          }, 8, ["disabled"]),
          createVNode(unref(p$3), { class: "text-center text-gray-400 my-4" }, {
            default: withCtx(() => [
              createTextVNode("or")
            ]),
            _: 1
          }),
          createVNode(unref(q), {
            type: "default",
            class: "w-full h-12 row-span-1 buttonBorder",
            id: "code-btn",
            size: "large",
            disabled: buttonDisable.value,
            onClick: _cache[1] || (_cache[1] = () => emit("changeScreen", {
              page: unref(Screens).LOGIN
            }))
          }, {
            default: withCtx(() => [
              createTextVNode("Sign in with password")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 64);
    };
  }
});
const _hoisted_1$1 = { class: "flex flex-col justify-center h-full mt-5" };
const _hoisted_2$1 = { class: "flex flex-col justify-center mt-5" };
const _hoisted_3$1 = /* @__PURE__ */ createElementVNode("b", null, "I agree", -1);
const _hoisted_4$1 = ["href"];
const _hoisted_5$1 = ["href"];
const _hoisted_6$1 = ["href"];
const _sfc_main$3 = defineComponent({
  __name: "TermsAndConditionsPwa",
  props: {
    domain: {
      type: String
    },
    data: {
      type: Object,
      required: true
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const loadingRef = ref(null);
    const notification = c();
    const buttonDisable = ref(false);
    const emit = __emit;
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    async function handleUserConsent(e) {
      var _a2, _b, _c, _d;
      buttonDisable.value = true;
      e.preventDefault();
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      try {
        window.localStorage.setItem("cat", window.btoa(JSON.stringify(props.data)));
        await UserState.updateUserProfile({
          termsConsent: true,
          locationId: (_b = LocationState.state) == null ? void 0 : _b.locationId,
          userId: (_c = UserState.state) == null ? void 0 : _c.userId
        });
        await postLogin(props.data);
        emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
          eventType: LoginEvents.LOGIN_SUCCESSFUL,
          domain: props.domain
        }, props.data));
      } catch (error) {
        window.localStorage.removeItem("cat");
        notificationFailureAlert("Something went wrong", "Try Again!");
      } finally {
        (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
        buttonDisable.value = false;
      }
    }
    const handleBack = () => {
      emit("changeScreen", {
        page: Screens.LOGIN
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(T), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", _hoisted_1$1, [
          createVNode(unref(render), {
            onClick: handleBack,
            class: "w-8 h-8 -ml-2 cursor-pointer"
          }),
          createElementVNode("div", _hoisted_2$1, [
            createVNode(unref(p), { class: "mb-4 text-2xl font-bold" }, {
              default: withCtx(() => {
                var _a2, _b, _c, _d;
                return [
                  createTextVNode("Agree to " + toDisplayString(((_b = (_a2 = unref(BrandedAppState)) == null ? void 0 : _a2.state) == null ? void 0 : _b.appName) ? ((_d = (_c = unref(BrandedAppState)) == null ? void 0 : _c.state) == null ? void 0 : _d.appName) + "'s" : "Kollab's") + " terms and policies", 1)
                ];
              }),
              _: 1
            }),
            createVNode(unref(p), { class: "mb-4" }, {
              default: withCtx(() => {
                var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
                return [
                  createTextVNode("By tapping "),
                  _hoisted_3$1,
                  createTextVNode(", you agree to " + toDisplayString(((_b = (_a2 = unref(BrandedAppState)) == null ? void 0 : _a2.state) == null ? void 0 : _b.appName) ? ((_d = (_c = unref(BrandedAppState)) == null ? void 0 : _c.state) == null ? void 0 : _d.appName) + "'s" : "Kollab's") + " ", 1),
                  createElementVNode("a", {
                    class: "no-underline text-primary-500",
                    href: ((_f = (_e = unref(BrandedAppState)) == null ? void 0 : _e.state) == null ? void 0 : _f.termsConditionsUrl) ? (_h = (_g = unref(BrandedAppState)) == null ? void 0 : _g.state) == null ? void 0 : _h.termsConditionsUrl : "https://www.leadconnectorhq.com/terms2",
                    target: "_blank"
                  }, "terms of services", 8, _hoisted_4$1),
                  createTextVNode(" and "),
                  createElementVNode("a", {
                    class: "no-underline text-primary-500",
                    href: ((_j = (_i = unref(BrandedAppState)) == null ? void 0 : _i.state) == null ? void 0 : _j.privacyPolicyUrl) ? (_l = (_k = unref(BrandedAppState)) == null ? void 0 : _k.state) == null ? void 0 : _l.privacyPolicyUrl : "https://www.leadconnectorhq.com/privacy-policy",
                    target: "_blank"
                  }, "Privacy Policy", 8, _hoisted_5$1)
                ];
              }),
              _: 1
            }),
            createVNode(unref(p), { class: "mb-4" }, {
              default: withCtx(() => {
                var _a2, _b, _c, _d;
                return [
                  createTextVNode("The "),
                  createElementVNode("a", {
                    class: "no-underline text-primary-500",
                    href: ((_b = (_a2 = unref(BrandedAppState)) == null ? void 0 : _a2.state) == null ? void 0 : _b.privacyPolicyUrl) ? (_d = (_c = unref(BrandedAppState)) == null ? void 0 : _c.state) == null ? void 0 : _d.privacyPolicyUrl : "https://www.leadconnectorhq.com/privacy-policy",
                    target: "_blank"
                  }, "Privacy Policy", 8, _hoisted_6$1),
                  createTextVNode(" describes the ways we can use the information we collect when you create an account. ")
                ];
              }),
              _: 1
            }),
            createVNode(unref(q), {
              onClick: handleUserConsent,
              class: "w-full self-center",
              type: "primary",
              id: "agree-btn",
              size: "large",
              disabled: buttonDisable.value
            }, {
              default: withCtx(() => [
                createTextVNode("I Agree ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ], 64);
    };
  }
});
var VerifySecureCodePwa_vue_vue_type_style_index_0_scoped_true_lang = "";
const _sfc_main$2 = defineComponent({
  __name: "VerifySecureCodePwa",
  props: {
    title: {
      type: String,
      default: "Login"
    },
    email: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    password: {
      type: String
    },
    username: {
      type: String
    },
    locationId: {
      type: String
    },
    defaultOtp: {
      type: Number,
      default: null
    },
    domain: {
      type: String
    }
  },
  emits: ["changeScreen", LoginEvents.LOGIN_CALLBACK],
  setup(__props, { emit: __emit }) {
    const otpCode = ref("");
    const isResendButtonDisabled = ref(false);
    const loadingRef = ref(null);
    const buttonDisable = ref(false);
    const notification = c();
    const emit = __emit;
    const route = useRoute();
    const props = __props;
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    const handleOnComplete = async () => {
      var _a2, _b, _c, _d, _e, _f, _g;
      buttonDisable.value = true;
      (_a2 = loadingRef.value) == null ? void 0 : _a2.startLoadBar();
      try {
        if (!Number(otpCode.value)) {
          notificationFailureAlert("Secure code must be a numeric value and must be of 6 digits", "Try Again");
          (_b = loadingRef.value) == null ? void 0 : _b.stopLoadBar();
          buttonDisable.value = false;
          return false;
        }
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          otp: Number(otpCode.value),
          token: props.token,
          locationId: props.locationId,
          redirectUrl: (_c = route == null ? void 0 : route.query) == null ? void 0 : _c.redirectUrl
        });
        if (data == null ? void 0 : data.multiple_users) {
          emit("changeScreen", {
            email: props.email,
            otp: Number(otpCode.value),
            token: props.token,
            multiUser: data == null ? void 0 : data.multiple_users,
            loginOtp: true,
            page: Screens.SELECT_USER_MULTI_USER
          });
        } else if (data.token) {
          await postLogin(data);
          if (!data.isPasswordVerified && (data == null ? void 0 : data.passwordResetToken)) {
            emit("changeScreen", {
              email: props.email,
              passwordResetToken: data.passwordResetToken,
              contactId: data.contactId,
              isPasswordVerified: data.isPasswordVerified,
              data,
              page: Screens.SET_PASSWORD
            });
          } else {
            if (props.email.toLowerCase().trim() == TEST_EMAIL_ID) {
              await checkUserConsent(data);
              emit("changeScreen", {
                email: props.email,
                domain: props.domain,
                data,
                page: Screens.TERMS_CONSENT
              });
            } else {
              if (await checkUserConsent(data)) {
                await postLogin(data);
                emit(LoginEvents.LOGIN_CALLBACK, __spreadValues({
                  eventType: LoginEvents.LOGIN_SUCCESSFUL,
                  domain: props.domain
                }, data));
              } else {
                emit("changeScreen", {
                  email: props.email,
                  domain: props.domain,
                  data,
                  page: Screens.TERMS_CONSENT
                });
              }
            }
          }
          (_d = loadingRef.value) == null ? void 0 : _d.stopLoadBar();
          buttonDisable.value = false;
        }
        (_e = loadingRef.value) == null ? void 0 : _e.stopLoadBar();
        buttonDisable.value = false;
      } catch (error) {
        if (((_f = error == null ? void 0 : error.response) == null ? void 0 : _f.status) !== 429) {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
        (_g = loadingRef.value) == null ? void 0 : _g.stopLoadBar();
        buttonDisable.value = false;
      }
    };
    async function resendOtp() {
      var _a2;
      try {
        const { data } = await UserService.loginWithSecureEmail({
          email: props.email,
          locationId: props.locationId
        });
        emit("changeScreen", {
          page: Screens.VERIFY_SECURE_CODE,
          email: props.email,
          token: data.token,
          action: "RESET_PASSWORD"
        });
        isResendButtonDisabled.value = true;
        setTimeout(() => isResendButtonDisabled.value = false, 3e4);
      } catch (error) {
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 429) {
          isResendButtonDisabled.value = true;
        } else {
          notificationFailureAlert(getErrorMessage(error), "Try Again");
        }
      }
    }
    const handleOnChange = (value) => {
      otpCode.value = value;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(T), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", null, [
          createVNode(unref(_), { class: "text-gray-500" }, {
            default: withCtx(() => [
              createTextVNode("Secure code")
            ]),
            _: 1
          }),
          createVNode(unref(entry_esm), {
            class: "justify-center",
            ref: "otpInput",
            "input-classes": "otpStyle",
            value: otpCode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event) => otpCode.value = $event),
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "input-type": "tel",
            placeholder: ["0", "0", "0", "0", "0", "0"],
            onOnChange: handleOnChange,
            onOnComplete: handleOnComplete
          }, null, 8, ["value"]),
          createVNode(unref(d), { class: "text-gray-900 font-normal" }, {
            default: withCtx(() => [
              createTextVNode("Please check your email for the secure code. If you did not receive any email from us, "),
              createElementVNode("span", null, [
                createVNode(unref(q), {
                  id: "resend-otp--button",
                  class: "underline-offset-4",
                  onClick: resendOtp,
                  disabled: isResendButtonDisabled.value,
                  text: true
                }, {
                  default: withCtx(() => [
                    createTextVNode(" tap here to resend. ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }),
          createVNode(unref(q), {
            onClick: handleOnComplete,
            type: "primary",
            class: "!bg-black h-12 w-full row-span-1 mt-4 buttonBorder text-white",
            id: "signin-btn",
            size: "large",
            disabled: buttonDisable.value
          }, {
            default: withCtx(() => [
              createTextVNode("Verify")
            ]),
            _: 1
          }, 8, ["disabled"]),
          createVNode(unref(p$3), { class: "text-center text-gray-400 my-4" }, {
            default: withCtx(() => [
              createTextVNode("or")
            ]),
            _: 1
          }),
          createVNode(unref(q), {
            type: "default",
            class: "w-full h-12 row-span-1 text-gray-900",
            id: "code-btn",
            size: "large",
            disabled: buttonDisable.value,
            onClick: _cache[1] || (_cache[1] = () => emit("changeScreen", {
              page: unref(Screens).LOGIN
            }))
          }, {
            default: withCtx(() => [
              createTextVNode("Back to login")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 64);
    };
  }
});
var VerifySecureCodePwa = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-58a0c90c"]]);
var PwaLogin_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1 = {
  id: "touchScreen",
  class: "fixed max-w-3xl p-6 h-[90vh] grid grid-rows-6"
};
const _hoisted_2 = { class: "flex items-center flex-col" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 0,
  class: "p-1"
};
const _hoisted_5 = { class: "flex" };
const _hoisted_6 = { class: "w-full" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "max-h-48 overflow-auto" };
const _hoisted_9 = { class: "flex items-center -ml-2" };
const _hoisted_10 = { class: "w-full h-full" };
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col px-4 min-h-screen"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  key: 0,
  class: "py-4 px-6"
};
const __default__ = {
  name: "PwaLogin"
};
const _sfc_main$1 = defineComponent(__spreadProps(__spreadValues({}, __default__), {
  props: {
    NODE_ENV: String
  },
  emits: [
    LoginEvents.CHANGE_SCREEN,
    LoginEvents.LOGIN_CALLBACK
  ],
  setup(__props, { emit: __emit }) {
    var _a2, _b, _c, _d;
    const emit = __emit;
    const props = __props;
    const showModal = ref(false);
    const show = ref(false);
    ref(null);
    const isDomainError = ref(false);
    const currPage = ref("signIn");
    const selectedValue = ref("");
    const notification = c();
    const loadingRef = ref(null);
    const loading = ref(false);
    const errorMessage = ref();
    const optionsDomains = ref([]);
    const screen = ref({
      email: history.state.email || "",
      username: "",
      password: "",
      token: history.state.token || "",
      otp: history.state.otp || "",
      page: Screens.LOGIN,
      multiUser: history.state.multiUser || [],
      resetPassword: history.state.resetPassword || false,
      loginOtp: history.state.loginOtp || false,
      passwordResetToken: history.state.passwordResetToken || "",
      contactId: "",
      fullName: "",
      idToken: "",
      isPasswordVerified: ""
    });
    const handlePopstate = (event2) => {
      history.pushState(null, null, window.location.pathname);
    };
    onMounted(() => {
      window.addEventListener("popstate", handlePopstate, false);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("popstate", handlePopstate, false);
    });
    const rules = {
      email: {
        required: true,
        validator: (_2, value) => {
          errorMessage.value = null;
          return create$6().email().required().validate(value);
        },
        message: "Please enter a valid  email",
        trigger: ["blur"]
      }
    };
    const formValue = ref({
      email: "",
      password: "",
      domainName: "",
      domain: "",
      portalImage: "",
      locationId: ""
    });
    watch(formValue.value, () => isDomainError.value = false);
    const formRef = ref();
    function notificationFailureAlert(title, content) {
      notification.error({
        title,
        content,
        duration: 5e3
      });
    }
    async function validateForm() {
      return new Promise((resolve) => {
        formRef.value.getForm().validate().then(() => resolve(true)).catch((e) => {
          console.log("error", e);
          resolve(false);
        });
      });
    }
    function handleClose() {
      currPage.value = "signIn";
    }
    function handleLoginClose() {
      screen.value.page = Screens.LOGIN;
    }
    async function handleValidateClick(e) {
      var _a3, _b2, _c2, _d2, _e;
      if (Capacitor.getPlatform() === "ios") {
        await KeyboardPlugin.hideKeyboard();
      }
      e.preventDefault();
      (_a3 = loadingRef.value) == null ? void 0 : _a3.startLoadBar();
      const result = await validateForm();
      if (!result) {
        (_b2 = loadingRef.value) == null ? void 0 : _b2.stopLoadBar();
        return;
      }
      const suffixDomain = props.NODE_ENV === "production" ? ".app" : ".staging";
      try {
        let { data } = await UserService.getUserDomains({
          email: formValue.value.email.trim()
        });
        if (formValue.value.email.toLowerCase().trim() == TEST_EMAIL_ID && TEST_LOCATION_ID) {
          data = data == null ? void 0 : data.filter((val) => val.locationId === TEST_LOCATION_ID);
        } else {
          const brandedAppLocationId = (_c2 = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _c2.locationId;
          if (brandedAppLocationId) {
            data = data == null ? void 0 : data.filter((val) => val.locationId === brandedAppLocationId);
          }
        }
        if ((data == null ? void 0 : data.length) === 1) {
          const listDomains = data.map((val) => {
            return {
              domain: (val == null ? void 0 : val.customDomain) || val.subDomain + suffixDomain + ".clientclub.net",
              label: (val == null ? void 0 : val.portalBannerText) || "Client Portal",
              portalImage: (val == null ? void 0 : val.logo) || GROUP_MOBILE_ICON,
              locationId: (val == null ? void 0 : val.locationId) || ""
            };
          });
          formValue.value.domainName = listDomains[0].label;
          formValue.value.domain = listDomains[0].domain;
          formValue.value.portalImage = listDomains[0].portalImage;
          formValue.value.locationId = listDomains[0].locationId;
          show.value = true;
        } else if ((data == null ? void 0 : data.length) > 1) {
          const listDomains = data.map((val) => {
            return {
              domain: (val == null ? void 0 : val.customDomain) || val.subDomain + suffixDomain + ".clientclub.net",
              label: (val == null ? void 0 : val.portalBannerText) || "Client Portal",
              portalImage: (val == null ? void 0 : val.logo) || GROUP_MOBILE_ICON,
              locationId: (val == null ? void 0 : val.locationId) || ""
            };
          });
          currPage.value = "welcomePage";
          optionsDomains.value = listDomains;
        } else {
          notificationFailureAlert("Uh oh! Your email isn't registered with any business", "Try Again");
        }
      } catch (error) {
        (_d2 = loadingRef.value) == null ? void 0 : _d2.stopLoadBar();
        throw error;
      } finally {
        (_e = loadingRef.value) == null ? void 0 : _e.stopLoadBar();
      }
    }
    const styleName = computed(() => {
      if (screen.value.page === Screens.LOGIN) {
        return "siteContainerLogin";
      }
      if (screen.value.page === Screens.LOGIN_WITH_SECURE_CODE) {
        return "siteContainerSecureCode";
      }
      if (screen.value.page === Screens.FORGOT_PASSWORD) {
        return "siteContainerForgotPassword";
      }
      if (screen.value.page === Screens.VERIFY_SECURE_CODE || screen.value.page === Screens.SET_PASSWORD_WITH_SECURE_CODE) {
        return "siteContainerVerifyCode";
      }
      if (screen.value.page === Screens.SET_PASSWORD) {
        return "siteContainerSetPassword";
      }
      if (screen.value.page === Screens.SELECT_USER_MULTI_USER) {
        return "siteContainerMultiUser";
      }
      return "siteContainer";
    });
    const childApps = [
      {
        title: ((_a2 = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _a2.appCarouselDescription1) || "Getting started is easy! Enter your email and we will connect your account.",
        image: (BrandedAppState == null ? void 0 : BrandedAppState.state.appCarouselImage1) || FRAME1
      },
      {
        title: ((_b = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _b.appCarouselDescription2) || "Connect with other people in a community on topics and shared interests",
        image: (BrandedAppState == null ? void 0 : BrandedAppState.state.appCarouselImage2) || FRAME2
      },
      {
        title: ((_c = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _c.appCarouselDescription3) || "Watch courses, take quizzes and view resources",
        image: (BrandedAppState == null ? void 0 : BrandedAppState.state.appCarouselImage3) || FRAME3
      },
      {
        title: ((_d = BrandedAppState == null ? void 0 : BrandedAppState.state) == null ? void 0 : _d.appCarouselDescription4) || "Communicate effortlessly with business on-the-go",
        image: (BrandedAppState == null ? void 0 : BrandedAppState.state.appCarouselImage4) || FRAME4
      }
    ];
    function callback(event2) {
      emit(LoginEvents.LOGIN_CALLBACK, event2);
    }
    function onChangeScreen(val) {
      screen.value = __spreadValues(__spreadValues({}, screen), val);
      emit(LoginEvents.CHANGE_SCREEN, screen);
    }
    function onSignIn() {
      showModal.value = true;
    }
    function handleHeight() {
      if (currPage.value === "signIn") {
        return 180;
      } else {
        return 420;
      }
    }
    function handleLocationPage() {
      const selected = optionsDomains.value.filter((val) => val.domain == selectedValue.value);
      formValue.value.domainName = selected[0].label;
      formValue.value.domain = selected[0].domain;
      formValue.value.portalImage = selected[0].portalImage;
      formValue.value.locationId = selected[0].locationId;
      showModal.value = false;
      show.value = true;
    }
    KeyboardPlugin.addListener("keyboardWillHide", () => {
      console.log("Keyboard will hide");
      handleKeyboardWillHide();
    });
    function handleKeyboardWillHide() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
          left: 0
        });
      }, 50);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(T), {
          ref_key: "loadingRef",
          ref: loadingRef
        }, null, 512),
        createElementVNode("div", _hoisted_1, [
          createVNode(unref(z), {
            autoPlay: true,
            showDots: true,
            draggable: true,
            dotType: "line",
            direction: "horizontal",
            spaceBetweenItems: 13,
            transitionStyle: {
              transitionTimingFunction: "linear",
              transitionDuration: "0.3s"
            },
            touchable: true,
            mousewheel: true,
            classNames: "row-span-5"
          }, {
            customRender: withCtx(() => [
              (openBlock(), createElementBlock(Fragment, null, renderList(childApps, (child) => {
                return createElementVNode("div", {
                  key: child.title
                }, [
                  createElementVNode("div", _hoisted_2, [
                    createVNode(unref(p$2), { class: "text-gray-700 text-lg font-semibold text-center mt-10 mb-16" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(child.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createElementVNode("div", null, [
                      createElementVNode("img", {
                        class: "w-full h-[380px] object-contain",
                        src: child.image
                      }, null, 8, _hoisted_3)
                    ])
                  ])
                ]);
              }), 64))
            ]),
            _: 1
          }),
          createVNode(unref(q), {
            onClick: onSignIn,
            type: "primary",
            class: "!bg-black w-full h-12 row-span-1 mt-12 buttonBorder",
            id: "download-certificate-btn",
            size: "large"
          }, {
            default: withCtx(() => [
              createTextVNode("Sign In")
            ]),
            _: 1
          }),
          createVNode(unref(c$1), {
            class: "p-0",
            show: showModal.value,
            "onUpdate:show": _cache[2] || (_cache[2] = ($event) => showModal.value = $event),
            placement: "bottom",
            id: "post-signup-drawer",
            height: handleHeight(),
            "on-after-leave": handleClose,
            "auto-focus": false
          }, {
            default: withCtx(() => [
              createVNode(unref(K), {
                id: "post-options-drawer-menu",
                class: "p-0",
                closable: false
              }, {
                default: withCtx(() => [
                  currPage.value == "signIn" ? (openBlock(), createElementBlock("div", _hoisted_4, [
                    createVNode(unref(B), {
                      id: "login-page-email-form",
                      ref_key: "formRef",
                      ref: formRef,
                      model: formValue.value,
                      rules
                    }, {
                      default: withCtx(() => [
                        createElementVNode("div", _hoisted_5, [
                          createElementVNode("div", _hoisted_6, [
                            createVNode(unref(_), { class: "text-gray-600" }, {
                              default: withCtx(() => [
                                createTextVNode("Email")
                              ]),
                              _: 1
                            }),
                            createVNode(unref(V), {
                              class: "block",
                              path: "email"
                            }, {
                              default: withCtx(() => [
                                createVNode(unref(P), {
                                  modelValue: formValue.value.email,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formValue.value.email = $event),
                                  size: "large",
                                  placeholder: "",
                                  id: "domain-form-email"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            createVNode(unref(p$3), { class: "text-gray-400 -mt-[2px]" }, {
                              default: withCtx(() => [
                                createTextVNode("Enter your email address")
                              ]),
                              _: 1
                            })
                          ]),
                          createVNode(unref(q), {
                            onClick: handleValidateClick,
                            id: "proceed-button",
                            type: "primary",
                            class: "!bg-black h-12 w-12 ml-4 mt-4 rounded-xl buttonBorder",
                            loading: loading.value
                          }, {
                            default: withCtx(() => [
                              !loading.value ? (openBlock(), createBlock(unref(render$u), {
                                key: 0,
                                class: "w-7 h-7"
                              })) : createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])) : createCommentVNode("", true),
                  currPage.value == "welcomePage" ? (openBlock(), createElementBlock("div", _hoisted_7, [
                    createVNode(unref(p$2), { class: "text-gray-600 text-center mb-2" }, {
                      default: withCtx(() => [
                        createTextVNode("Welcome")
                      ]),
                      _: 1
                    }),
                    createVNode(unref(d), { class: "text-gray-400 text-center mb-6" }, {
                      default: withCtx(() => [
                        createTextVNode("Select the website you would like to add. You can always sign in to more later")
                      ]),
                      _: 1
                    }),
                    createElementVNode("div", _hoisted_8, [
                      createVNode(unref(g), {
                        value: selectedValue.value,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event) => selectedValue.value = $event),
                        name: "radiobuttongroup1",
                        class: "w-full radio-container"
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(y), { vertical: "" }, {
                            default: withCtx(() => [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(optionsDomains.value, (item) => {
                                return openBlock(), createBlock(unref(V$1), {
                                  value: item.domain,
                                  "onUpdate:value": ($event) => item.domain = $event,
                                  key: item.domain,
                                  disabled: false,
                                  compact: void 0,
                                  class: "w-full my-1 py-1"
                                }, {
                                  content: withCtx(() => [
                                    createElementVNode("div", _hoisted_9, [
                                      createVNode(unref(I$1), {
                                        class: "h-12 w-12",
                                        objectFit: "cover",
                                        src: item.portalImage
                                      }, null, 8, ["src"]),
                                      createElementVNode("div", null, [
                                        createVNode(unref(d), { class: "ml-2 text-gray-700" }, {
                                          default: withCtx(() => [
                                            createTextVNode(toDisplayString(item.label), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        createVNode(unref(_$1), { class: "ml-2 mt-[6px] truncate max-w-[50vw] text-gray-500" }, {
                                          default: withCtx(() => [
                                            createTextVNode(toDisplayString(item.domain), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value"]);
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    createVNode(unref(q), {
                      onClick: handleLocationPage,
                      type: "primary",
                      class: "!bg-black w-full h-12 row-span-1 mt-4 buttonBorder",
                      id: "next-domain-btn",
                      size: "large",
                      disabled: selectedValue.value === ""
                    }, {
                      default: withCtx(() => [
                        createTextVNode("Next")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])) : createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show", "height"]),
          createVNode(unref(c$1), {
            show: show.value,
            "onUpdate:show": _cache[3] || (_cache[3] = ($event) => show.value = $event),
            width: "100vw",
            "on-after-leave": handleLoginClose,
            placement: "right",
            id: "drawer"
          }, {
            default: withCtx(() => [
              createVNode(unref(K), {
                class: "signIn",
                id: "drawer-component"
              }, {
                default: withCtx(() => {
                  var _a3;
                  return [
                    createElementVNode("div", _hoisted_10, [
                      createElementVNode("div", {
                        class: normalizeClass([
                          "w-full",
                          screen.value.page === unref(Screens).TERMS_CONSENT ? "bg-white" : "bg-gray-900"
                        ])
                      }, [
                        screen.value.page === unref(Screens).TERMS_CONSENT ? (openBlock(), createElementBlock("div", _hoisted_11, [
                          createVNode(_sfc_main$3, {
                            onChangeScreen,
                            email: screen.value.email,
                            onLoginCallback: callback,
                            domain: screen.value.domain,
                            data: screen.value.data
                          }, null, 8, ["email", "domain", "data"])
                        ])) : screen.value.page !== unref(Screens).SET_PASSWORD_WITH_SECURE_CODE && screen.value.page !== unref(Screens).VERIFY_SECURE_CODE ? (openBlock(), createElementBlock("div", {
                          key: 1,
                          class: normalizeClass(`flex justify-center items-center flex-col ${styleName.value}`)
                        }, [
                          createVNode(unref(I$1), {
                            size: "medium",
                            objectFit: "cover",
                            round: false,
                            style: void 0,
                            src: formValue.value.portalImage,
                            class: "w-24 h-24 rounded-lg"
                          }, null, 8, ["src"]),
                          createVNode(unref(p$2), { class: "text-white mt-6 text-xl font-semibold" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(formValue.value.domainName), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(unref(_$2), { class: "text-white" }, {
                            default: withCtx(() => [
                              createTextVNode("Login")
                            ]),
                            _: 1
                          })
                        ], 2)) : (openBlock(), createElementBlock("div", {
                          key: 2,
                          class: normalizeClass(`flex justify-center items-center flex-col ${styleName.value}`)
                        }, [
                          createElementVNode("img", {
                            class: "ml-4",
                            src: unref(MAIL_MOBILE_ICON)
                          }, null, 8, _hoisted_12),
                          createVNode(unref(d), { class: "text-white mt-6 mb-2 font-semibold" }, {
                            default: withCtx(() => [
                              createTextVNode("Check your email")
                            ]),
                            _: 1
                          }),
                          createVNode(unref(d), { class: "text-white mt-6 mb-2 font-medium" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(formValue.value.email), 1)
                            ]),
                            _: 1
                          })
                        ], 2))
                      ], 2),
                      screen.value.page !== unref(Screens).TERMS_CONSENT ? (openBlock(), createElementBlock("div", _hoisted_13, [
                        screen.value.page === unref(Screens).LOGIN ? (openBlock(), createBlock(LoginPagePwa, {
                          key: 0,
                          onChangeScreen,
                          onLoginCallback: callback,
                          locationId: formValue.value.locationId,
                          email: formValue.value.email,
                          domain: formValue.value.domain
                        }, null, 8, ["locationId", "email", "domain"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).VERIFY_SECURE_CODE ? (openBlock(), createBlock(VerifySecureCodePwa, {
                          key: 1,
                          onChangeScreen,
                          onLoginCallback: callback,
                          email: screen.value.email,
                          locationId: formValue.value.locationId,
                          token: screen.value.token,
                          domain: formValue.value.domain
                        }, null, 8, ["email", "locationId", "token", "domain"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).SET_PASSWORD_WITH_SECURE_CODE ? (openBlock(), createBlock(_sfc_main$4, {
                          key: 2,
                          onChangeScreen,
                          onLoginCallback: callback,
                          email: screen.value.email,
                          locationId: formValue.value.locationId,
                          token: screen.value.token
                        }, null, 8, ["email", "locationId", "token"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).SET_PASSWORD ? (openBlock(), createBlock(SetPasswordPwa, {
                          key: 3,
                          onChangeScreen,
                          onLoginCallback: callback,
                          locationId: formValue.value.locationId,
                          passwordResetToken: screen.value.passwordResetToken,
                          userId: screen.value.userId,
                          domain: formValue.value.domain,
                          contactId: screen.value.contactId,
                          isPasswordVerified: screen.value.isPasswordVerified,
                          token: screen.value.token,
                          data: screen.value.data
                        }, null, 8, ["locationId", "passwordResetToken", "userId", "domain", "contactId", "isPasswordVerified", "token", "data"])) : createCommentVNode("", true),
                        screen.value.page === unref(Screens).SELECT_USER_MULTI_USER ? (openBlock(), createBlock(LoginMultiUserPwa, {
                          key: 4,
                          onChangeScreen,
                          onLoginCallback: callback,
                          email: screen.value.email,
                          otp: screen.value.otp,
                          users: screen.value.multiUser,
                          token: screen.value.token,
                          resetPassword: screen.value.resetPassword,
                          loginOtp: screen.value.loginOtp,
                          idToken: (_a3 = screen.value) == null ? void 0 : _a3.idToken,
                          locationId: formValue.value.locationId,
                          domain: formValue.value.domain
                        }, null, 8, ["email", "otp", "users", "token", "resetPassword", "loginOtp", "idToken", "locationId", "domain"])) : createCommentVNode("", true)
                      ])) : createCommentVNode("", true)
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ], 64);
    };
  }
}));
var PwaLogin = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-ed007e40"]]);
PwaLogin.install = (Vue) => {
  Vue.component(PwaLogin.name, PwaLogin);
};
const _sfc_main = defineComponent({
  __name: "SafeArea",
  setup(__props) {
    const statusbarBackground = ref(null);
    onMounted(async () => {
      if (Capacitor.getPlatform() === "ios") {
        SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
          if (statusbarBackground.value) {
            statusbarBackground.value.style.height = `${statusBarHeight + 5}px`;
          }
        });
        const safeAreaData = await SafeArea.getSafeAreaInsets();
        const { insets } = safeAreaData;
        for (const [key, value] of Object.entries(insets)) {
          document.documentElement.style.setProperty(`--safe-area-inset-${key}`, `${value}px`);
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        unref(Capacitor).getPlatform() === "ios" ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fixed w-full",
          id: "statusbar-background",
          ref_key: "statusbarBackground",
          ref: statusbarBackground
        }, null, 512)) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default")
      ], 64);
    };
  }
});
const SwipeDirective = {
  mounted(el, binding) {
    let startX = 0;
    let startY = 0;
    const getDirection = (deltaX, deltaY) => {
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        return deltaX > 0 ? "right" : "left";
      } else {
        return deltaY > 0 ? "down" : "up";
      }
    };
    const handleTouchEnd = (event2) => {
      const deltaX = event2.changedTouches[0].clientX - startX;
      const deltaY = event2.changedTouches[0].clientY - startY;
      const direction = getDirection(deltaX, deltaY);
      if (direction === binding.value.direction && binding.value.callback) {
        binding.value.callback();
      }
    };
    const handleMouseUp = (event2) => {
      const deltaX = event2.clientX - startX;
      const deltaY = event2.clientY - startY;
      const direction = getDirection(deltaX, deltaY);
      if (direction === binding.value.direction && binding.value.callback) {
        binding.value.callback();
      }
    };
    el.addEventListener("touchstart", (event2) => {
      startX = event2.touches[0].clientX;
      startY = event2.touches[0].clientY;
    });
    el.addEventListener("touchend", handleTouchEnd);
    el.addEventListener("mousedown", (event2) => {
      startX = event2.clientX;
      startY = event2.clientY;
    });
    el.addEventListener("mouseup", handleMouseUp);
  },
  unmounted(el) {
    el.removeEventListener("touchstart", () => {
    });
    el.removeEventListener("touchend", () => {
    });
    el.removeEventListener("mousedown", () => {
    });
    el.removeEventListener("mouseup", () => {
    });
  }
};
const renderIcon = (icon) => {
  return () => {
    return h(icon, {
      class: "h-4 w-4"
    }, {});
  };
};
const components = {
  LoginModal,
  LoginPage: _sfc_main$p,
  NavBar,
  Recaptcha: _sfc_main$T,
  BottomNavBar,
  DashBoard,
  NotificationMobileView,
  ProfileContainer,
  PwaLogin,
  AppLoader,
  SafeArea: _sfc_main
};
let firebaseAppInstance = null;
async function initializeApp(environment, routerInstance2) {
  if (Capacitor.isNativePlatform()) {
    const BrandedLocationPlugin = registerPlugin("BrandedLocation");
    try {
      const brandedLocationId = await BrandedLocationPlugin.getBrandedLocation();
      if (brandedLocationId) {
        BrandedAppState.state.locationId = brandedLocationId.value;
        await BrandedAppState.getBrandedAppDetails(brandedLocationId.value);
      }
    } catch (error) {
      console.error("Error getting branded location id", error);
    }
  }
  const cookie = await api.get("cat");
  AppState.state.NODE_ENV = environment;
  if (routerInstance2) {
    AppState.setRouterInstance(routerInstance2);
  }
  firebaseAppInstance = firebase$1.initializeApp(config[environment].firebase);
  await Promise.all([
    LocationState.getBrandingDetails(),
    UserState.getUserDetails()
  ]);
  initializeServices(LocationState.state.locationId);
  if (cookie) {
    requestNotificationPermission();
  }
}
function getFirebaseAppInstance() {
  return firebaseAppInstance;
}
function install(Vue) {
  for (const component in components) {
    Vue.component(components[component].name, components[component]);
  }
}
var index = { install };
export { AppLoader, BottomNavBar, DashBoard, GAEventTypes, KeyboardPlugin, LoginModal, _sfc_main$p as LoginPage, NavBar, NavigationItemType, NotificationMobileView, ProfileContainer, PwaLogin, _sfc_main$T as Recaptcha, _sfc_main as SafeArea, StripeMinimumChargeAmount, SwipeDirective, currency, currencyCode, index as default, enableAnalytics, getCurrencySymbol, getFirebaseAppInstance, getHostName, getLocationId, getToken, initializeApp, isAppLoading, isMobileOs, isPwa, isWebKit, logoutUser$1 as logoutUser, renderIcon, sendNotificationToken, setAppLoading, trackCustomGAEvents };
